/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
};

export type Act = {
  __typename?: 'Act';
  _count?: Maybe<ActCount>;
  areVisualsUsed: Scalars['Boolean']['output'];
  areVisualsUsedNew?: Maybe<Scalars['String']['output']>;
  artworkDimensions?: Maybe<Scalars['String']['output']>;
  artworkMaterial?: Maybe<Scalars['String']['output']>;
  artworkSize?: Maybe<Scalars['String']['output']>;
  artworkStand?: Maybe<Scalars['String']['output']>;
  attachments: Array<ActAttachment>;
  category: Scalars['String']['output'];
  competition: Competition;
  competitionId: Scalars['String']['output'];
  completedPercent: Scalars['Float']['output'];
  contactStatus?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['String']['output'];
  decor?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  djEquipment?: Maybe<Scalars['String']['output']>;
  djSoftware?: Maybe<Scalars['String']['output']>;
  extraInformation?: Maybe<Scalars['String']['output']>;
  extraLightingInformation?: Maybe<Scalars['String']['output']>;
  extraMaterial?: Maybe<Scalars['String']['output']>;
  extraMusicInstruments: Array<Scalars['String']['output']>;
  extraVisualsInformation?: Maybe<Scalars['String']['output']>;
  feedbackNotes?: Maybe<Scalars['String']['output']>;
  feedbackSeen: Scalars['Boolean']['output'];
  feedbackUpload?: Maybe<Scalars['String']['output']>;
  filmVideoFormat?: Maybe<Scalars['String']['output']>;
  finalPosition?: Maybe<Scalars['Int']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  hasFeedback: Scalars['Boolean']['output'];
  hasGivenLivestreamConsent: Scalars['Boolean']['output'];
  hasIntroSong: Scalars['Boolean']['output'];
  hasPendingFeedback: Scalars['Boolean']['output'];
  hasSelfProducedTracks: Scalars['Boolean']['output'];
  hasSentFilm: Scalars['Boolean']['output'];
  hasSentMaterials: Scalars['Boolean']['output'];
  hasSentMusic: Scalars['Boolean']['output'];
  hasSentVisuals: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  invitations: Array<ActInvitation>;
  isComplete: Scalars['Boolean']['output'];
  isEditableAfterCompetitionClosed: Scalars['Boolean']['output'];
  isFirstSelection: Scalars['Boolean']['output'];
  isMissingInfo: Scalars['Boolean']['output'];
  isReadonly: Scalars['Boolean']['output'];
  isSecondSelection: Scalars['Boolean']['output'];
  isSupervisor: Scalars['Boolean']['output'];
  lengthOfDjSet?: Maybe<Scalars['String']['output']>;
  lengthOfFilmSet?: Maybe<Scalars['String']['output']>;
  lengthOfSet?: Maybe<Scalars['String']['output']>;
  lightingAtEnd?: Maybe<Scalars['String']['output']>;
  lightingInstructions?: Maybe<Scalars['String']['output']>;
  lightingSettings?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  memberCount: Scalars['Int']['output'];
  members: UsersResponse;
  microphoneCount?: Maybe<Scalars['String']['output']>;
  motivation?: Maybe<Scalars['String']['output']>;
  musicInstructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfArtworksPieces?: Maybe<Scalars['String']['output']>;
  originalAct?: Maybe<Act>;
  originalActId?: Maybe<Scalars['String']['output']>;
  ownDjEquipment?: Maybe<Scalars['String']['output']>;
  ownMusicInstruments?: Maybe<Scalars['String']['output']>;
  preliminaryPosition?: Maybe<Scalars['Int']['output']>;
  presentationText?: Maybe<Scalars['String']['output']>;
  requiresDjLaptop: Scalars['Boolean']['output'];
  requiresMusic: Scalars['Boolean']['output'];
  requiresMusicNew?: Maybe<Scalars['String']['output']>;
  selfDescription?: Maybe<Scalars['String']['output']>;
  status: ActStatus;
  updatedAt: Scalars['DateTime']['output'];
  visualsVideoFormat?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};


export type ActMembersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type ActAttachment = {
  __typename?: 'ActAttachment';
  actId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  file: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: ActAttachmentType;
  updatedAt: Scalars['DateTime']['output'];
  uploader: User;
  uploaderId: Scalars['String']['output'];
};

export type ActAttachmentCreateInput = {
  act: ActCreateNestedOneWithoutAttachmentsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: ActAttachmentType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploader: UserCreateNestedOneWithoutAttachmentsInput;
};

export type ActAttachmentCreateManyActInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: ActAttachmentType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploaderId: Scalars['String']['input'];
};

export type ActAttachmentCreateManyActInputEnvelope = {
  data: Array<ActAttachmentCreateManyActInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActAttachmentCreateManyUploaderInput = {
  actId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: ActAttachmentType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActAttachmentCreateManyUploaderInputEnvelope = {
  data: Array<ActAttachmentCreateManyUploaderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActAttachmentCreateNestedManyWithoutActInput = {
  connect?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActAttachmentCreateOrConnectWithoutActInput>>;
  create?: InputMaybe<Array<ActAttachmentCreateWithoutActInput>>;
  createMany?: InputMaybe<ActAttachmentCreateManyActInputEnvelope>;
};

export type ActAttachmentCreateNestedManyWithoutUploaderInput = {
  connect?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActAttachmentCreateOrConnectWithoutUploaderInput>>;
  create?: InputMaybe<Array<ActAttachmentCreateWithoutUploaderInput>>;
  createMany?: InputMaybe<ActAttachmentCreateManyUploaderInputEnvelope>;
};

export type ActAttachmentCreateOrConnectWithoutActInput = {
  create: ActAttachmentCreateWithoutActInput;
  where: ActAttachmentWhereUniqueInput;
};

export type ActAttachmentCreateOrConnectWithoutUploaderInput = {
  create: ActAttachmentCreateWithoutUploaderInput;
  where: ActAttachmentWhereUniqueInput;
};

export type ActAttachmentCreateWithoutActInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: ActAttachmentType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploader: UserCreateNestedOneWithoutAttachmentsInput;
};

export type ActAttachmentCreateWithoutUploaderInput = {
  act: ActCreateNestedOneWithoutAttachmentsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: ActAttachmentType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActAttachmentListRelationFilter = {
  every?: InputMaybe<ActAttachmentWhereInput>;
  none?: InputMaybe<ActAttachmentWhereInput>;
  some?: InputMaybe<ActAttachmentWhereInput>;
};

export type ActAttachmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActAttachmentOrderByWithRelationInput = {
  act?: InputMaybe<ActOrderByWithRelationInput>;
  actId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  file?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  uploader?: InputMaybe<UserOrderByWithRelationInput>;
  uploaderId?: InputMaybe<SortOrder>;
};

export enum ActAttachmentScalarFieldEnum {
  ActId = 'actId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  File = 'file',
  Id = 'id',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UploaderId = 'uploaderId'
}

export type ActAttachmentScalarWhereInput = {
  AND?: InputMaybe<Array<ActAttachmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActAttachmentScalarWhereInput>>;
  OR?: InputMaybe<Array<ActAttachmentScalarWhereInput>>;
  actId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  file?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumActAttachmentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uploaderId?: InputMaybe<UuidFilter>;
};

export enum ActAttachmentType {
  Anders = 'ANDERS',
  Audio = 'AUDIO',
  Foto = 'FOTO',
  Powerpoint = 'POWERPOINT',
  Tekst = 'TEKST',
  Video = 'VIDEO'
}

export type ActAttachmentUpdateInput = {
  act?: InputMaybe<ActUpdateOneRequiredWithoutAttachmentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActAttachmentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploader?: InputMaybe<UserUpdateOneRequiredWithoutAttachmentsNestedInput>;
};

export type ActAttachmentUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActAttachmentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActAttachmentUpdateManyWithWhereWithoutActInput = {
  data: ActAttachmentUpdateManyMutationInput;
  where: ActAttachmentScalarWhereInput;
};

export type ActAttachmentUpdateManyWithWhereWithoutUploaderInput = {
  data: ActAttachmentUpdateManyMutationInput;
  where: ActAttachmentScalarWhereInput;
};

export type ActAttachmentUpdateManyWithoutActNestedInput = {
  connect?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActAttachmentCreateOrConnectWithoutActInput>>;
  create?: InputMaybe<Array<ActAttachmentCreateWithoutActInput>>;
  createMany?: InputMaybe<ActAttachmentCreateManyActInputEnvelope>;
  delete?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActAttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ActAttachmentUpdateWithWhereUniqueWithoutActInput>>;
  updateMany?: InputMaybe<Array<ActAttachmentUpdateManyWithWhereWithoutActInput>>;
  upsert?: InputMaybe<Array<ActAttachmentUpsertWithWhereUniqueWithoutActInput>>;
};

export type ActAttachmentUpdateManyWithoutUploaderNestedInput = {
  connect?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActAttachmentCreateOrConnectWithoutUploaderInput>>;
  create?: InputMaybe<Array<ActAttachmentCreateWithoutUploaderInput>>;
  createMany?: InputMaybe<ActAttachmentCreateManyUploaderInputEnvelope>;
  delete?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActAttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ActAttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ActAttachmentUpdateWithWhereUniqueWithoutUploaderInput>>;
  updateMany?: InputMaybe<Array<ActAttachmentUpdateManyWithWhereWithoutUploaderInput>>;
  upsert?: InputMaybe<Array<ActAttachmentUpsertWithWhereUniqueWithoutUploaderInput>>;
};

export type ActAttachmentUpdateWithWhereUniqueWithoutActInput = {
  data: ActAttachmentUpdateWithoutActInput;
  where: ActAttachmentWhereUniqueInput;
};

export type ActAttachmentUpdateWithWhereUniqueWithoutUploaderInput = {
  data: ActAttachmentUpdateWithoutUploaderInput;
  where: ActAttachmentWhereUniqueInput;
};

export type ActAttachmentUpdateWithoutActInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActAttachmentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploader?: InputMaybe<UserUpdateOneRequiredWithoutAttachmentsNestedInput>;
};

export type ActAttachmentUpdateWithoutUploaderInput = {
  act?: InputMaybe<ActUpdateOneRequiredWithoutAttachmentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActAttachmentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActAttachmentUpsertWithWhereUniqueWithoutActInput = {
  create: ActAttachmentCreateWithoutActInput;
  update: ActAttachmentUpdateWithoutActInput;
  where: ActAttachmentWhereUniqueInput;
};

export type ActAttachmentUpsertWithWhereUniqueWithoutUploaderInput = {
  create: ActAttachmentCreateWithoutUploaderInput;
  update: ActAttachmentUpdateWithoutUploaderInput;
  where: ActAttachmentWhereUniqueInput;
};

export type ActAttachmentWhereInput = {
  AND?: InputMaybe<Array<ActAttachmentWhereInput>>;
  NOT?: InputMaybe<Array<ActAttachmentWhereInput>>;
  OR?: InputMaybe<Array<ActAttachmentWhereInput>>;
  act?: InputMaybe<ActRelationFilter>;
  actId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  file?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumActAttachmentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uploader?: InputMaybe<UserRelationFilter>;
  uploaderId?: InputMaybe<UuidFilter>;
};

export type ActAttachmentWhereUniqueInput = {
  AND?: InputMaybe<Array<ActAttachmentWhereInput>>;
  NOT?: InputMaybe<Array<ActAttachmentWhereInput>>;
  OR?: InputMaybe<Array<ActAttachmentWhereInput>>;
  act?: InputMaybe<ActRelationFilter>;
  actId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  file?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumActAttachmentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uploader?: InputMaybe<UserRelationFilter>;
  uploaderId?: InputMaybe<UuidFilter>;
};

export type ActAttachmentsResponse = {
  __typename?: 'ActAttachmentsResponse';
  count: Scalars['Int']['output'];
  items: Array<ActAttachment>;
};

export type ActCount = {
  __typename?: 'ActCount';
  attachments: Scalars['Int']['output'];
  copiedActs: Scalars['Int']['output'];
  invitations: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  notification: Scalars['Int']['output'];
};


export type ActCountAttachmentsArgs = {
  where?: InputMaybe<ActAttachmentWhereInput>;
};


export type ActCountCopiedActsArgs = {
  where?: InputMaybe<ActWhereInput>;
};


export type ActCountInvitationsArgs = {
  where?: InputMaybe<ActInvitationWhereInput>;
};


export type ActCountMembersArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type ActCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};

export type ActCreateInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateManyCompetitionInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creatorId: Scalars['String']['input'];
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalActId?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateManyCompetitionInputEnvelope = {
  data: Array<ActCreateManyCompetitionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActCreateManyCreatorInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  competitionId: Scalars['String']['input'];
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalActId?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateManyCreatorInputEnvelope = {
  data: Array<ActCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActCreateManyOriginalActInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  competitionId: Scalars['String']['input'];
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creatorId: Scalars['String']['input'];
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateManyOriginalActInputEnvelope = {
  data: Array<ActCreateManyOriginalActInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActCreateNestedManyWithoutCompetitionInput = {
  connect?: InputMaybe<Array<ActWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActCreateOrConnectWithoutCompetitionInput>>;
  create?: InputMaybe<Array<ActCreateWithoutCompetitionInput>>;
  createMany?: InputMaybe<ActCreateManyCompetitionInputEnvelope>;
};

export type ActCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<ActWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ActCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ActCreateManyCreatorInputEnvelope>;
};

export type ActCreateNestedManyWithoutMembersInput = {
  connect?: InputMaybe<Array<ActWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActCreateOrConnectWithoutMembersInput>>;
  create?: InputMaybe<Array<ActCreateWithoutMembersInput>>;
};

export type ActCreateNestedManyWithoutOriginalActInput = {
  connect?: InputMaybe<Array<ActWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActCreateOrConnectWithoutOriginalActInput>>;
  create?: InputMaybe<Array<ActCreateWithoutOriginalActInput>>;
  createMany?: InputMaybe<ActCreateManyOriginalActInputEnvelope>;
};

export type ActCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<ActCreateWithoutAttachmentsInput>;
};

export type ActCreateNestedOneWithoutCopiedActsInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutCopiedActsInput>;
  create?: InputMaybe<ActCreateWithoutCopiedActsInput>;
};

export type ActCreateNestedOneWithoutInvitationsInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutInvitationsInput>;
  create?: InputMaybe<ActCreateWithoutInvitationsInput>;
};

export type ActCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<ActCreateWithoutNotificationInput>;
};

export type ActCreateOrConnectWithoutAttachmentsInput = {
  create: ActCreateWithoutAttachmentsInput;
  where: ActWhereUniqueInput;
};

export type ActCreateOrConnectWithoutCompetitionInput = {
  create: ActCreateWithoutCompetitionInput;
  where: ActWhereUniqueInput;
};

export type ActCreateOrConnectWithoutCopiedActsInput = {
  create: ActCreateWithoutCopiedActsInput;
  where: ActWhereUniqueInput;
};

export type ActCreateOrConnectWithoutCreatorInput = {
  create: ActCreateWithoutCreatorInput;
  where: ActWhereUniqueInput;
};

export type ActCreateOrConnectWithoutInvitationsInput = {
  create: ActCreateWithoutInvitationsInput;
  where: ActWhereUniqueInput;
};

export type ActCreateOrConnectWithoutMembersInput = {
  create: ActCreateWithoutMembersInput;
  where: ActWhereUniqueInput;
};

export type ActCreateOrConnectWithoutNotificationInput = {
  create: ActCreateWithoutNotificationInput;
  where: ActWhereUniqueInput;
};

export type ActCreateOrConnectWithoutOriginalActInput = {
  create: ActCreateWithoutOriginalActInput;
  where: ActWhereUniqueInput;
};

export type ActCreateWithoutAttachmentsInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateWithoutCompetitionInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateWithoutCopiedActsInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateWithoutCreatorInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateWithoutInvitationsInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateWithoutMembersInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateWithoutNotificationInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActCreateNestedOneWithoutCopiedActsInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActCreateWithoutOriginalActInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutActInput>;
  category: Scalars['String']['input'];
  competition: CompetitionCreateNestedOneWithoutActsInput;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActCreateNestedManyWithoutOriginalActInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutCreatedActsInput;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationCreateNestedManyWithoutActInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutActsInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutActInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActInvitation = {
  __typename?: 'ActInvitation';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  act: InvitationAct;
  actId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ActInvitationActIdEmailCompoundUniqueInput = {
  actId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type ActInvitationCreateManyActInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ActInvitationCreateManyActInputEnvelope = {
  data: Array<ActInvitationCreateManyActInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActInvitationCreateManyUserInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  actId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActInvitationCreateManyUserInputEnvelope = {
  data: Array<ActInvitationCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActInvitationCreateNestedManyWithoutActInput = {
  connect?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActInvitationCreateOrConnectWithoutActInput>>;
  create?: InputMaybe<Array<ActInvitationCreateWithoutActInput>>;
  createMany?: InputMaybe<ActInvitationCreateManyActInputEnvelope>;
};

export type ActInvitationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActInvitationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ActInvitationCreateWithoutUserInput>>;
  createMany?: InputMaybe<ActInvitationCreateManyUserInputEnvelope>;
};

export type ActInvitationCreateOrConnectWithoutActInput = {
  create: ActInvitationCreateWithoutActInput;
  where: ActInvitationWhereUniqueInput;
};

export type ActInvitationCreateOrConnectWithoutUserInput = {
  create: ActInvitationCreateWithoutUserInput;
  where: ActInvitationWhereUniqueInput;
};

export type ActInvitationCreateWithoutActInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutActInvitationInput>;
};

export type ActInvitationCreateWithoutUserInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  act: ActCreateNestedOneWithoutInvitationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActInvitationListRelationFilter = {
  every?: InputMaybe<ActInvitationWhereInput>;
  none?: InputMaybe<ActInvitationWhereInput>;
  some?: InputMaybe<ActInvitationWhereInput>;
};

export type ActInvitationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActInvitationScalarWhereInput = {
  AND?: InputMaybe<Array<ActInvitationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActInvitationScalarWhereInput>>;
  OR?: InputMaybe<Array<ActInvitationScalarWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  actId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ActInvitationUpdateManyMutationInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActInvitationUpdateManyWithWhereWithoutActInput = {
  data: ActInvitationUpdateManyMutationInput;
  where: ActInvitationScalarWhereInput;
};

export type ActInvitationUpdateManyWithWhereWithoutUserInput = {
  data: ActInvitationUpdateManyMutationInput;
  where: ActInvitationScalarWhereInput;
};

export type ActInvitationUpdateManyWithoutActNestedInput = {
  connect?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActInvitationCreateOrConnectWithoutActInput>>;
  create?: InputMaybe<Array<ActInvitationCreateWithoutActInput>>;
  createMany?: InputMaybe<ActInvitationCreateManyActInputEnvelope>;
  delete?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActInvitationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  set?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  update?: InputMaybe<Array<ActInvitationUpdateWithWhereUniqueWithoutActInput>>;
  updateMany?: InputMaybe<Array<ActInvitationUpdateManyWithWhereWithoutActInput>>;
  upsert?: InputMaybe<Array<ActInvitationUpsertWithWhereUniqueWithoutActInput>>;
};

export type ActInvitationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActInvitationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ActInvitationCreateWithoutUserInput>>;
  createMany?: InputMaybe<ActInvitationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActInvitationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  set?: InputMaybe<Array<ActInvitationWhereUniqueInput>>;
  update?: InputMaybe<Array<ActInvitationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ActInvitationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ActInvitationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ActInvitationUpdateWithWhereUniqueWithoutActInput = {
  data: ActInvitationUpdateWithoutActInput;
  where: ActInvitationWhereUniqueInput;
};

export type ActInvitationUpdateWithWhereUniqueWithoutUserInput = {
  data: ActInvitationUpdateWithoutUserInput;
  where: ActInvitationWhereUniqueInput;
};

export type ActInvitationUpdateWithoutActInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneWithoutActInvitationNestedInput>;
};

export type ActInvitationUpdateWithoutUserInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  act?: InputMaybe<ActUpdateOneRequiredWithoutInvitationsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActInvitationUpsertWithWhereUniqueWithoutActInput = {
  create: ActInvitationCreateWithoutActInput;
  update: ActInvitationUpdateWithoutActInput;
  where: ActInvitationWhereUniqueInput;
};

export type ActInvitationUpsertWithWhereUniqueWithoutUserInput = {
  create: ActInvitationCreateWithoutUserInput;
  update: ActInvitationUpdateWithoutUserInput;
  where: ActInvitationWhereUniqueInput;
};

export type ActInvitationWhereInput = {
  AND?: InputMaybe<Array<ActInvitationWhereInput>>;
  NOT?: InputMaybe<Array<ActInvitationWhereInput>>;
  OR?: InputMaybe<Array<ActInvitationWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  act?: InputMaybe<ActRelationFilter>;
  actId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ActInvitationWhereUniqueInput = {
  AND?: InputMaybe<Array<ActInvitationWhereInput>>;
  NOT?: InputMaybe<Array<ActInvitationWhereInput>>;
  OR?: InputMaybe<Array<ActInvitationWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  act?: InputMaybe<ActRelationFilter>;
  actId?: InputMaybe<UuidFilter>;
  actId_email?: InputMaybe<ActInvitationActIdEmailCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ActListRelationFilter = {
  every?: InputMaybe<ActWhereInput>;
  none?: InputMaybe<ActWhereInput>;
  some?: InputMaybe<ActWhereInput>;
};

export type ActNullableRelationFilter = {
  is?: InputMaybe<ActWhereInput>;
  isNot?: InputMaybe<ActWhereInput>;
};

export type ActOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActOrderByWithRelationInput = {
  areVisualsUsed?: InputMaybe<SortOrder>;
  areVisualsUsedNew?: InputMaybe<SortOrderInput>;
  artworkDimensions?: InputMaybe<SortOrderInput>;
  artworkMaterial?: InputMaybe<SortOrderInput>;
  artworkSize?: InputMaybe<SortOrderInput>;
  artworkStand?: InputMaybe<SortOrderInput>;
  attachments?: InputMaybe<ActAttachmentOrderByRelationAggregateInput>;
  category?: InputMaybe<SortOrder>;
  competition?: InputMaybe<CompetitionOrderByWithRelationInput>;
  competitionId?: InputMaybe<SortOrder>;
  contactStatus?: InputMaybe<SortOrderInput>;
  contentType?: InputMaybe<SortOrderInput>;
  copiedActs?: InputMaybe<ActOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  creator?: InputMaybe<UserOrderByWithRelationInput>;
  creatorId?: InputMaybe<SortOrder>;
  decor?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  djEquipment?: InputMaybe<SortOrderInput>;
  djSoftware?: InputMaybe<SortOrderInput>;
  extraInformation?: InputMaybe<SortOrderInput>;
  extraLightingInformation?: InputMaybe<SortOrderInput>;
  extraMaterial?: InputMaybe<SortOrderInput>;
  extraMusicInstruments?: InputMaybe<SortOrder>;
  extraVisualsInformation?: InputMaybe<SortOrderInput>;
  feedbackNotes?: InputMaybe<SortOrderInput>;
  feedbackSeen?: InputMaybe<SortOrder>;
  feedbackUpload?: InputMaybe<SortOrderInput>;
  filmVideoFormat?: InputMaybe<SortOrderInput>;
  finalPosition?: InputMaybe<SortOrderInput>;
  genre?: InputMaybe<SortOrderInput>;
  hasGivenLivestreamConsent?: InputMaybe<SortOrder>;
  hasIntroSong?: InputMaybe<SortOrder>;
  hasSelfProducedTracks?: InputMaybe<SortOrder>;
  hasSentFilm?: InputMaybe<SortOrder>;
  hasSentMaterials?: InputMaybe<SortOrder>;
  hasSentMusic?: InputMaybe<SortOrder>;
  hasSentVisuals?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invitations?: InputMaybe<ActInvitationOrderByRelationAggregateInput>;
  isComplete?: InputMaybe<SortOrder>;
  isEditableAfterCompetitionClosed?: InputMaybe<SortOrder>;
  isFirstSelection?: InputMaybe<SortOrder>;
  isReadonly?: InputMaybe<SortOrder>;
  isSecondSelection?: InputMaybe<SortOrder>;
  isSupervisor?: InputMaybe<SortOrder>;
  lengthOfDjSet?: InputMaybe<SortOrderInput>;
  lengthOfFilmSet?: InputMaybe<SortOrderInput>;
  lengthOfSet?: InputMaybe<SortOrderInput>;
  lightingAtEnd?: InputMaybe<SortOrderInput>;
  lightingInstructions?: InputMaybe<SortOrderInput>;
  lightingSettings?: InputMaybe<SortOrderInput>;
  link?: InputMaybe<SortOrderInput>;
  memberCount?: InputMaybe<SortOrder>;
  members?: InputMaybe<UserOrderByRelationAggregateInput>;
  microphoneCount?: InputMaybe<SortOrderInput>;
  motivation?: InputMaybe<SortOrderInput>;
  musicInstructions?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  notes?: InputMaybe<SortOrderInput>;
  notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  numberOfArtworksPieces?: InputMaybe<SortOrderInput>;
  originalAct?: InputMaybe<ActOrderByWithRelationInput>;
  originalActId?: InputMaybe<SortOrderInput>;
  ownDjEquipment?: InputMaybe<SortOrderInput>;
  ownMusicInstruments?: InputMaybe<SortOrderInput>;
  preliminaryPosition?: InputMaybe<SortOrderInput>;
  presentationText?: InputMaybe<SortOrderInput>;
  requiresDjLaptop?: InputMaybe<SortOrder>;
  requiresMusic?: InputMaybe<SortOrder>;
  requiresMusicNew?: InputMaybe<SortOrderInput>;
  selfDescription?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visualsVideoFormat?: InputMaybe<SortOrderInput>;
  workTitle?: InputMaybe<SortOrderInput>;
};

export type ActRelationFilter = {
  is?: InputMaybe<ActWhereInput>;
  isNot?: InputMaybe<ActWhereInput>;
};

export enum ActScalarFieldEnum {
  AreVisualsUsed = 'areVisualsUsed',
  AreVisualsUsedNew = 'areVisualsUsedNew',
  ArtworkDimensions = 'artworkDimensions',
  ArtworkMaterial = 'artworkMaterial',
  ArtworkSize = 'artworkSize',
  ArtworkStand = 'artworkStand',
  Category = 'category',
  CompetitionId = 'competitionId',
  ContactStatus = 'contactStatus',
  ContentType = 'contentType',
  CreatedAt = 'createdAt',
  CreatorId = 'creatorId',
  Decor = 'decor',
  Description = 'description',
  DjEquipment = 'djEquipment',
  DjSoftware = 'djSoftware',
  ExtraInformation = 'extraInformation',
  ExtraLightingInformation = 'extraLightingInformation',
  ExtraMaterial = 'extraMaterial',
  ExtraMusicInstruments = 'extraMusicInstruments',
  ExtraVisualsInformation = 'extraVisualsInformation',
  FeedbackNotes = 'feedbackNotes',
  FeedbackSeen = 'feedbackSeen',
  FeedbackUpload = 'feedbackUpload',
  FilmVideoFormat = 'filmVideoFormat',
  FinalPosition = 'finalPosition',
  Genre = 'genre',
  HasGivenLivestreamConsent = 'hasGivenLivestreamConsent',
  HasIntroSong = 'hasIntroSong',
  HasSelfProducedTracks = 'hasSelfProducedTracks',
  HasSentFilm = 'hasSentFilm',
  HasSentMaterials = 'hasSentMaterials',
  HasSentMusic = 'hasSentMusic',
  HasSentVisuals = 'hasSentVisuals',
  Id = 'id',
  IsComplete = 'isComplete',
  IsEditableAfterCompetitionClosed = 'isEditableAfterCompetitionClosed',
  IsFirstSelection = 'isFirstSelection',
  IsReadonly = 'isReadonly',
  IsSecondSelection = 'isSecondSelection',
  IsSupervisor = 'isSupervisor',
  LengthOfDjSet = 'lengthOfDjSet',
  LengthOfFilmSet = 'lengthOfFilmSet',
  LengthOfSet = 'lengthOfSet',
  LightingAtEnd = 'lightingAtEnd',
  LightingInstructions = 'lightingInstructions',
  LightingSettings = 'lightingSettings',
  Link = 'link',
  MemberCount = 'memberCount',
  MicrophoneCount = 'microphoneCount',
  Motivation = 'motivation',
  MusicInstructions = 'musicInstructions',
  Name = 'name',
  Notes = 'notes',
  NumberOfArtworksPieces = 'numberOfArtworksPieces',
  OriginalActId = 'originalActId',
  OwnDjEquipment = 'ownDjEquipment',
  OwnMusicInstruments = 'ownMusicInstruments',
  PreliminaryPosition = 'preliminaryPosition',
  PresentationText = 'presentationText',
  RequiresDjLaptop = 'requiresDjLaptop',
  RequiresMusic = 'requiresMusic',
  RequiresMusicNew = 'requiresMusicNew',
  SelfDescription = 'selfDescription',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  VisualsVideoFormat = 'visualsVideoFormat',
  WorkTitle = 'workTitle'
}

export type ActScalarWhereInput = {
  AND?: InputMaybe<Array<ActScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActScalarWhereInput>>;
  OR?: InputMaybe<Array<ActScalarWhereInput>>;
  areVisualsUsed?: InputMaybe<BoolFilter>;
  areVisualsUsedNew?: InputMaybe<StringNullableFilter>;
  artworkDimensions?: InputMaybe<StringNullableFilter>;
  artworkMaterial?: InputMaybe<StringNullableFilter>;
  artworkSize?: InputMaybe<StringNullableFilter>;
  artworkStand?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  contactStatus?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<UuidFilter>;
  decor?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  djEquipment?: InputMaybe<StringNullableFilter>;
  djSoftware?: InputMaybe<StringNullableFilter>;
  extraInformation?: InputMaybe<StringNullableFilter>;
  extraLightingInformation?: InputMaybe<StringNullableFilter>;
  extraMaterial?: InputMaybe<StringNullableFilter>;
  extraMusicInstruments?: InputMaybe<StringNullableListFilter>;
  extraVisualsInformation?: InputMaybe<StringNullableFilter>;
  feedbackNotes?: InputMaybe<StringNullableFilter>;
  feedbackSeen?: InputMaybe<BoolFilter>;
  feedbackUpload?: InputMaybe<StringNullableFilter>;
  filmVideoFormat?: InputMaybe<StringNullableFilter>;
  finalPosition?: InputMaybe<IntNullableFilter>;
  genre?: InputMaybe<StringNullableFilter>;
  hasGivenLivestreamConsent?: InputMaybe<BoolFilter>;
  hasIntroSong?: InputMaybe<BoolFilter>;
  hasSelfProducedTracks?: InputMaybe<BoolFilter>;
  hasSentFilm?: InputMaybe<BoolFilter>;
  hasSentMaterials?: InputMaybe<BoolFilter>;
  hasSentMusic?: InputMaybe<BoolFilter>;
  hasSentVisuals?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  isComplete?: InputMaybe<BoolFilter>;
  isEditableAfterCompetitionClosed?: InputMaybe<BoolFilter>;
  isFirstSelection?: InputMaybe<BoolFilter>;
  isReadonly?: InputMaybe<BoolFilter>;
  isSecondSelection?: InputMaybe<BoolFilter>;
  isSupervisor?: InputMaybe<BoolFilter>;
  lengthOfDjSet?: InputMaybe<StringNullableFilter>;
  lengthOfFilmSet?: InputMaybe<StringNullableFilter>;
  lengthOfSet?: InputMaybe<StringNullableFilter>;
  lightingAtEnd?: InputMaybe<StringNullableFilter>;
  lightingInstructions?: InputMaybe<StringNullableFilter>;
  lightingSettings?: InputMaybe<StringNullableFilter>;
  link?: InputMaybe<StringNullableFilter>;
  memberCount?: InputMaybe<IntFilter>;
  microphoneCount?: InputMaybe<StringNullableFilter>;
  motivation?: InputMaybe<StringNullableFilter>;
  musicInstructions?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  numberOfArtworksPieces?: InputMaybe<StringNullableFilter>;
  originalActId?: InputMaybe<UuidNullableFilter>;
  ownDjEquipment?: InputMaybe<StringNullableFilter>;
  ownMusicInstruments?: InputMaybe<StringNullableFilter>;
  preliminaryPosition?: InputMaybe<IntNullableFilter>;
  presentationText?: InputMaybe<StringNullableFilter>;
  requiresDjLaptop?: InputMaybe<BoolFilter>;
  requiresMusic?: InputMaybe<BoolFilter>;
  requiresMusicNew?: InputMaybe<StringNullableFilter>;
  selfDescription?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumActStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visualsVideoFormat?: InputMaybe<StringNullableFilter>;
  workTitle?: InputMaybe<StringNullableFilter>;
};

export enum ActStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  RejectedPreRound = 'REJECTED_PRE_ROUND',
  WaitingList = 'WAITING_LIST'
}

export type ActUpdateManyMutationInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpdateManyWithWhereWithoutCreatorInput = {
  data: ActUpdateManyMutationInput;
  where: ActScalarWhereInput;
};

export type ActUpdateManyWithWhereWithoutMembersInput = {
  data: ActUpdateManyMutationInput;
  where: ActScalarWhereInput;
};

export type ActUpdateManyWithWhereWithoutOriginalActInput = {
  data: ActUpdateManyMutationInput;
  where: ActScalarWhereInput;
};

export type ActUpdateManyWithoutCreatorNestedInput = {
  connect?: InputMaybe<Array<ActWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ActCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ActCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<ActWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActWhereUniqueInput>>;
  set?: InputMaybe<Array<ActWhereUniqueInput>>;
  update?: InputMaybe<Array<ActUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<ActUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<ActUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type ActUpdateManyWithoutMembersNestedInput = {
  connect?: InputMaybe<Array<ActWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActCreateOrConnectWithoutMembersInput>>;
  create?: InputMaybe<Array<ActCreateWithoutMembersInput>>;
  delete?: InputMaybe<Array<ActWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActWhereUniqueInput>>;
  set?: InputMaybe<Array<ActWhereUniqueInput>>;
  update?: InputMaybe<Array<ActUpdateWithWhereUniqueWithoutMembersInput>>;
  updateMany?: InputMaybe<Array<ActUpdateManyWithWhereWithoutMembersInput>>;
  upsert?: InputMaybe<Array<ActUpsertWithWhereUniqueWithoutMembersInput>>;
};

export type ActUpdateManyWithoutOriginalActNestedInput = {
  connect?: InputMaybe<Array<ActWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActCreateOrConnectWithoutOriginalActInput>>;
  create?: InputMaybe<Array<ActCreateWithoutOriginalActInput>>;
  createMany?: InputMaybe<ActCreateManyOriginalActInputEnvelope>;
  delete?: InputMaybe<Array<ActWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActWhereUniqueInput>>;
  set?: InputMaybe<Array<ActWhereUniqueInput>>;
  update?: InputMaybe<Array<ActUpdateWithWhereUniqueWithoutOriginalActInput>>;
  updateMany?: InputMaybe<Array<ActUpdateManyWithWhereWithoutOriginalActInput>>;
  upsert?: InputMaybe<Array<ActUpsertWithWhereUniqueWithoutOriginalActInput>>;
};

export type ActUpdateOneRequiredWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<ActCreateWithoutAttachmentsInput>;
  update?: InputMaybe<ActUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<ActUpsertWithoutAttachmentsInput>;
};

export type ActUpdateOneRequiredWithoutInvitationsNestedInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutInvitationsInput>;
  create?: InputMaybe<ActCreateWithoutInvitationsInput>;
  update?: InputMaybe<ActUpdateToOneWithWhereWithoutInvitationsInput>;
  upsert?: InputMaybe<ActUpsertWithoutInvitationsInput>;
};

export type ActUpdateOneWithoutCopiedActsNestedInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutCopiedActsInput>;
  create?: InputMaybe<ActCreateWithoutCopiedActsInput>;
  delete?: InputMaybe<ActWhereInput>;
  disconnect?: InputMaybe<ActWhereInput>;
  update?: InputMaybe<ActUpdateToOneWithWhereWithoutCopiedActsInput>;
  upsert?: InputMaybe<ActUpsertWithoutCopiedActsInput>;
};

export type ActUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<ActWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<ActCreateWithoutNotificationInput>;
  delete?: InputMaybe<ActWhereInput>;
  disconnect?: InputMaybe<ActWhereInput>;
  update?: InputMaybe<ActUpdateToOneWithWhereWithoutNotificationInput>;
  upsert?: InputMaybe<ActUpsertWithoutNotificationInput>;
};

export type ActUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: ActUpdateWithoutAttachmentsInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActUpdateToOneWithWhereWithoutCopiedActsInput = {
  data: ActUpdateWithoutCopiedActsInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActUpdateToOneWithWhereWithoutInvitationsInput = {
  data: ActUpdateWithoutInvitationsInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActUpdateToOneWithWhereWithoutNotificationInput = {
  data: ActUpdateWithoutNotificationInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActUpdateWithWhereUniqueWithoutCreatorInput = {
  data: ActUpdateWithoutCreatorInput;
  where: ActWhereUniqueInput;
};

export type ActUpdateWithWhereUniqueWithoutMembersInput = {
  data: ActUpdateWithoutMembersInput;
  where: ActWhereUniqueInput;
};

export type ActUpdateWithWhereUniqueWithoutOriginalActInput = {
  data: ActUpdateWithoutOriginalActInput;
  where: ActWhereUniqueInput;
};

export type ActUpdateWithoutAttachmentsInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  competition?: InputMaybe<CompetitionUpdateOneRequiredWithoutActsNestedInput>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActUpdateManyWithoutOriginalActNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutCreatedActsNestedInput>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationUpdateManyWithoutActNestedInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserUpdateManyWithoutActsNestedInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutActNestedInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActUpdateOneWithoutCopiedActsNestedInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpdateWithoutCopiedActsInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutActNestedInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  competition?: InputMaybe<CompetitionUpdateOneRequiredWithoutActsNestedInput>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutCreatedActsNestedInput>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationUpdateManyWithoutActNestedInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserUpdateManyWithoutActsNestedInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutActNestedInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActUpdateOneWithoutCopiedActsNestedInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpdateWithoutCreatorInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutActNestedInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  competition?: InputMaybe<CompetitionUpdateOneRequiredWithoutActsNestedInput>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActUpdateManyWithoutOriginalActNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationUpdateManyWithoutActNestedInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserUpdateManyWithoutActsNestedInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutActNestedInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActUpdateOneWithoutCopiedActsNestedInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpdateWithoutInvitationsInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutActNestedInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  competition?: InputMaybe<CompetitionUpdateOneRequiredWithoutActsNestedInput>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActUpdateManyWithoutOriginalActNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutCreatedActsNestedInput>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserUpdateManyWithoutActsNestedInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutActNestedInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActUpdateOneWithoutCopiedActsNestedInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpdateWithoutMembersInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutActNestedInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  competition?: InputMaybe<CompetitionUpdateOneRequiredWithoutActsNestedInput>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActUpdateManyWithoutOriginalActNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutCreatedActsNestedInput>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationUpdateManyWithoutActNestedInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutActNestedInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActUpdateOneWithoutCopiedActsNestedInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpdateWithoutNotificationInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutActNestedInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  competition?: InputMaybe<CompetitionUpdateOneRequiredWithoutActsNestedInput>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActUpdateManyWithoutOriginalActNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutCreatedActsNestedInput>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationUpdateManyWithoutActNestedInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserUpdateManyWithoutActsNestedInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  originalAct?: InputMaybe<ActUpdateOneWithoutCopiedActsNestedInput>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpdateWithoutOriginalActInput = {
  areVisualsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutActNestedInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  competition?: InputMaybe<CompetitionUpdateOneRequiredWithoutActsNestedInput>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copiedActs?: InputMaybe<ActUpdateManyWithoutOriginalActNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutCreatedActsNestedInput>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationUpdateManyWithoutActNestedInput>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<UserUpdateManyWithoutActsNestedInput>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutActNestedInput>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Int']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusic?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ActUpsertWithWhereUniqueWithoutCreatorInput = {
  create: ActCreateWithoutCreatorInput;
  update: ActUpdateWithoutCreatorInput;
  where: ActWhereUniqueInput;
};

export type ActUpsertWithWhereUniqueWithoutMembersInput = {
  create: ActCreateWithoutMembersInput;
  update: ActUpdateWithoutMembersInput;
  where: ActWhereUniqueInput;
};

export type ActUpsertWithWhereUniqueWithoutOriginalActInput = {
  create: ActCreateWithoutOriginalActInput;
  update: ActUpdateWithoutOriginalActInput;
  where: ActWhereUniqueInput;
};

export type ActUpsertWithoutAttachmentsInput = {
  create: ActCreateWithoutAttachmentsInput;
  update: ActUpdateWithoutAttachmentsInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActUpsertWithoutCopiedActsInput = {
  create: ActCreateWithoutCopiedActsInput;
  update: ActUpdateWithoutCopiedActsInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActUpsertWithoutInvitationsInput = {
  create: ActCreateWithoutInvitationsInput;
  update: ActUpdateWithoutInvitationsInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActUpsertWithoutNotificationInput = {
  create: ActCreateWithoutNotificationInput;
  update: ActUpdateWithoutNotificationInput;
  where?: InputMaybe<ActWhereInput>;
};

export type ActWhereInput = {
  AND?: InputMaybe<Array<ActWhereInput>>;
  NOT?: InputMaybe<Array<ActWhereInput>>;
  OR?: InputMaybe<Array<ActWhereInput>>;
  areVisualsUsed?: InputMaybe<BoolFilter>;
  areVisualsUsedNew?: InputMaybe<StringNullableFilter>;
  artworkDimensions?: InputMaybe<StringNullableFilter>;
  artworkMaterial?: InputMaybe<StringNullableFilter>;
  artworkSize?: InputMaybe<StringNullableFilter>;
  artworkStand?: InputMaybe<StringNullableFilter>;
  attachments?: InputMaybe<ActAttachmentListRelationFilter>;
  category?: InputMaybe<StringFilter>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  contactStatus?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<StringNullableFilter>;
  copiedActs?: InputMaybe<ActListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserRelationFilter>;
  creatorId?: InputMaybe<UuidFilter>;
  decor?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  djEquipment?: InputMaybe<StringNullableFilter>;
  djSoftware?: InputMaybe<StringNullableFilter>;
  extraInformation?: InputMaybe<StringNullableFilter>;
  extraLightingInformation?: InputMaybe<StringNullableFilter>;
  extraMaterial?: InputMaybe<StringNullableFilter>;
  extraMusicInstruments?: InputMaybe<StringNullableListFilter>;
  extraVisualsInformation?: InputMaybe<StringNullableFilter>;
  feedbackNotes?: InputMaybe<StringNullableFilter>;
  feedbackSeen?: InputMaybe<BoolFilter>;
  feedbackUpload?: InputMaybe<StringNullableFilter>;
  filmVideoFormat?: InputMaybe<StringNullableFilter>;
  finalPosition?: InputMaybe<IntNullableFilter>;
  genre?: InputMaybe<StringNullableFilter>;
  hasGivenLivestreamConsent?: InputMaybe<BoolFilter>;
  hasIntroSong?: InputMaybe<BoolFilter>;
  hasSelfProducedTracks?: InputMaybe<BoolFilter>;
  hasSentFilm?: InputMaybe<BoolFilter>;
  hasSentMaterials?: InputMaybe<BoolFilter>;
  hasSentMusic?: InputMaybe<BoolFilter>;
  hasSentVisuals?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  invitations?: InputMaybe<ActInvitationListRelationFilter>;
  isComplete?: InputMaybe<BoolFilter>;
  isEditableAfterCompetitionClosed?: InputMaybe<BoolFilter>;
  isFirstSelection?: InputMaybe<BoolFilter>;
  isReadonly?: InputMaybe<BoolFilter>;
  isSecondSelection?: InputMaybe<BoolFilter>;
  isSupervisor?: InputMaybe<BoolFilter>;
  lengthOfDjSet?: InputMaybe<StringNullableFilter>;
  lengthOfFilmSet?: InputMaybe<StringNullableFilter>;
  lengthOfSet?: InputMaybe<StringNullableFilter>;
  lightingAtEnd?: InputMaybe<StringNullableFilter>;
  lightingInstructions?: InputMaybe<StringNullableFilter>;
  lightingSettings?: InputMaybe<StringNullableFilter>;
  link?: InputMaybe<StringNullableFilter>;
  memberCount?: InputMaybe<IntFilter>;
  members?: InputMaybe<UserListRelationFilter>;
  microphoneCount?: InputMaybe<StringNullableFilter>;
  motivation?: InputMaybe<StringNullableFilter>;
  musicInstructions?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  numberOfArtworksPieces?: InputMaybe<StringNullableFilter>;
  originalAct?: InputMaybe<ActNullableRelationFilter>;
  originalActId?: InputMaybe<UuidNullableFilter>;
  ownDjEquipment?: InputMaybe<StringNullableFilter>;
  ownMusicInstruments?: InputMaybe<StringNullableFilter>;
  preliminaryPosition?: InputMaybe<IntNullableFilter>;
  presentationText?: InputMaybe<StringNullableFilter>;
  requiresDjLaptop?: InputMaybe<BoolFilter>;
  requiresMusic?: InputMaybe<BoolFilter>;
  requiresMusicNew?: InputMaybe<StringNullableFilter>;
  selfDescription?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumActStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visualsVideoFormat?: InputMaybe<StringNullableFilter>;
  workTitle?: InputMaybe<StringNullableFilter>;
};

export type ActWhereUniqueInput = {
  AND?: InputMaybe<Array<ActWhereInput>>;
  NOT?: InputMaybe<Array<ActWhereInput>>;
  OR?: InputMaybe<Array<ActWhereInput>>;
  areVisualsUsed?: InputMaybe<BoolFilter>;
  areVisualsUsedNew?: InputMaybe<StringNullableFilter>;
  artworkDimensions?: InputMaybe<StringNullableFilter>;
  artworkMaterial?: InputMaybe<StringNullableFilter>;
  artworkSize?: InputMaybe<StringNullableFilter>;
  artworkStand?: InputMaybe<StringNullableFilter>;
  attachments?: InputMaybe<ActAttachmentListRelationFilter>;
  category?: InputMaybe<StringFilter>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  contactStatus?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<StringNullableFilter>;
  copiedActs?: InputMaybe<ActListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserRelationFilter>;
  creatorId?: InputMaybe<UuidFilter>;
  decor?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  djEquipment?: InputMaybe<StringNullableFilter>;
  djSoftware?: InputMaybe<StringNullableFilter>;
  extraInformation?: InputMaybe<StringNullableFilter>;
  extraLightingInformation?: InputMaybe<StringNullableFilter>;
  extraMaterial?: InputMaybe<StringNullableFilter>;
  extraMusicInstruments?: InputMaybe<StringNullableListFilter>;
  extraVisualsInformation?: InputMaybe<StringNullableFilter>;
  feedbackNotes?: InputMaybe<StringNullableFilter>;
  feedbackSeen?: InputMaybe<BoolFilter>;
  feedbackUpload?: InputMaybe<StringNullableFilter>;
  filmVideoFormat?: InputMaybe<StringNullableFilter>;
  finalPosition?: InputMaybe<IntNullableFilter>;
  genre?: InputMaybe<StringNullableFilter>;
  hasGivenLivestreamConsent?: InputMaybe<BoolFilter>;
  hasIntroSong?: InputMaybe<BoolFilter>;
  hasSelfProducedTracks?: InputMaybe<BoolFilter>;
  hasSentFilm?: InputMaybe<BoolFilter>;
  hasSentMaterials?: InputMaybe<BoolFilter>;
  hasSentMusic?: InputMaybe<BoolFilter>;
  hasSentVisuals?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<ActInvitationListRelationFilter>;
  isComplete?: InputMaybe<BoolFilter>;
  isEditableAfterCompetitionClosed?: InputMaybe<BoolFilter>;
  isFirstSelection?: InputMaybe<BoolFilter>;
  isReadonly?: InputMaybe<BoolFilter>;
  isSecondSelection?: InputMaybe<BoolFilter>;
  isSupervisor?: InputMaybe<BoolFilter>;
  lengthOfDjSet?: InputMaybe<StringNullableFilter>;
  lengthOfFilmSet?: InputMaybe<StringNullableFilter>;
  lengthOfSet?: InputMaybe<StringNullableFilter>;
  lightingAtEnd?: InputMaybe<StringNullableFilter>;
  lightingInstructions?: InputMaybe<StringNullableFilter>;
  lightingSettings?: InputMaybe<StringNullableFilter>;
  link?: InputMaybe<StringNullableFilter>;
  memberCount?: InputMaybe<IntFilter>;
  members?: InputMaybe<UserListRelationFilter>;
  microphoneCount?: InputMaybe<StringNullableFilter>;
  motivation?: InputMaybe<StringNullableFilter>;
  musicInstructions?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  numberOfArtworksPieces?: InputMaybe<StringNullableFilter>;
  originalAct?: InputMaybe<ActNullableRelationFilter>;
  originalActId?: InputMaybe<UuidNullableFilter>;
  ownDjEquipment?: InputMaybe<StringNullableFilter>;
  ownMusicInstruments?: InputMaybe<StringNullableFilter>;
  preliminaryPosition?: InputMaybe<IntNullableFilter>;
  presentationText?: InputMaybe<StringNullableFilter>;
  requiresDjLaptop?: InputMaybe<BoolFilter>;
  requiresMusic?: InputMaybe<BoolFilter>;
  requiresMusicNew?: InputMaybe<StringNullableFilter>;
  selfDescription?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumActStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visualsVideoFormat?: InputMaybe<StringNullableFilter>;
  workTitle?: InputMaybe<StringNullableFilter>;
};

export type ActsByAge = {
  __typename?: 'ActsByAge';
  age: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
};

export type ActsByCategory = {
  __typename?: 'ActsByCategory';
  _count: Scalars['Float']['output'];
  category?: Maybe<Scalars['String']['output']>;
};

export type ActsByStatus = {
  __typename?: 'ActsByStatus';
  _count: Scalars['Float']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type ActsResponse = {
  __typename?: 'ActsResponse';
  count: Scalars['Int']['output'];
  items: Array<Act>;
};

export type AgendaItem = {
  __typename?: 'AgendaItem';
  date: Scalars['DateTime']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Applicant = {
  __typename?: 'Applicant';
  category: Scalars['String']['output'];
  id: Scalars['String']['output'];
  members: Array<User>;
};

export type ApplicantsResponse = {
  __typename?: 'ApplicantsResponse';
  count: Scalars['Int']['output'];
  items: Array<Applicant>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user: User;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type Comment = {
  __typename?: 'Comment';
  _count?: Maybe<CommentCount>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['String']['output']>;
  tutorialId?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

export type CommentCount = {
  __typename?: 'CommentCount';
  notification: Scalars['Int']['output'];
};


export type CommentCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};

export type CommentCreateManyPostInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CommentCreateManyPostInputEnvelope = {
  data: Array<CommentCreateManyPostInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommentCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  postId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CommentCreateManyProjectInputEnvelope = {
  data: Array<CommentCreateManyProjectInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommentCreateManyTutorialInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CommentCreateManyTutorialInputEnvelope = {
  data: Array<CommentCreateManyTutorialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommentCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentCreateManyUserInputEnvelope = {
  data: Array<CommentCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommentCreateNestedManyWithoutPostInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutPostInput>>;
  createMany?: InputMaybe<CommentCreateManyPostInputEnvelope>;
};

export type CommentCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutProjectInput>>;
  createMany?: InputMaybe<CommentCreateManyProjectInputEnvelope>;
};

export type CommentCreateNestedManyWithoutTutorialInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutTutorialInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutTutorialInput>>;
  createMany?: InputMaybe<CommentCreateManyTutorialInputEnvelope>;
};

export type CommentCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutUserInput>>;
  createMany?: InputMaybe<CommentCreateManyUserInputEnvelope>;
};

export type CommentCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<CommentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommentCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<CommentCreateWithoutNotificationInput>;
};

export type CommentCreateOrConnectWithoutNotificationInput = {
  create: CommentCreateWithoutNotificationInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateOrConnectWithoutPostInput = {
  create: CommentCreateWithoutPostInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateOrConnectWithoutProjectInput = {
  create: CommentCreateWithoutProjectInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateOrConnectWithoutTutorialInput = {
  create: CommentCreateWithoutTutorialInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateOrConnectWithoutUserInput = {
  create: CommentCreateWithoutUserInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateWithoutNotificationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  post?: InputMaybe<PostCreateNestedOneWithoutCommentsInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutCommentsInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutCommentsInput>;
  user: UserCreateNestedOneWithoutCommentsInput;
};

export type CommentCreateWithoutPostInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  notification?: InputMaybe<NotificationCreateNestedManyWithoutCommentInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutCommentsInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutCommentsInput>;
  user: UserCreateNestedOneWithoutCommentsInput;
};

export type CommentCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  notification?: InputMaybe<NotificationCreateNestedManyWithoutCommentInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutCommentsInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutCommentsInput>;
  user: UserCreateNestedOneWithoutCommentsInput;
};

export type CommentCreateWithoutTutorialInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  notification?: InputMaybe<NotificationCreateNestedManyWithoutCommentInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutCommentsInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutCommentsInput>;
  user: UserCreateNestedOneWithoutCommentsInput;
};

export type CommentCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  notification?: InputMaybe<NotificationCreateNestedManyWithoutCommentInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutCommentsInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutCommentsInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutCommentsInput>;
};

export type CommentListRelationFilter = {
  every?: InputMaybe<CommentWhereInput>;
  none?: InputMaybe<CommentWhereInput>;
  some?: InputMaybe<CommentWhereInput>;
};

export type CommentNullableRelationFilter = {
  is?: InputMaybe<CommentWhereInput>;
  isNot?: InputMaybe<CommentWhereInput>;
};

export type CommentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPrivate?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  post?: InputMaybe<PostOrderByWithRelationInput>;
  postId?: InputMaybe<SortOrderInput>;
  project?: InputMaybe<ProjectOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrderInput>;
  tutorial?: InputMaybe<TutorialOrderByWithRelationInput>;
  tutorialId?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum CommentScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsPrivate = 'isPrivate',
  Message = 'message',
  PostId = 'postId',
  ProjectId = 'projectId',
  TutorialId = 'tutorialId',
  UserId = 'userId'
}

export type CommentScalarWhereInput = {
  AND?: InputMaybe<Array<CommentScalarWhereInput>>;
  NOT?: InputMaybe<Array<CommentScalarWhereInput>>;
  OR?: InputMaybe<Array<CommentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isPrivate?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  projectId?: InputMaybe<UuidNullableFilter>;
  tutorialId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type CommentUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type CommentUpdateManyWithWhereWithoutPostInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithWhereWithoutProjectInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithWhereWithoutTutorialInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithWhereWithoutUserInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithoutPostNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutPostInput>>;
  createMany?: InputMaybe<CommentCreateManyPostInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutPostInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutPostInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutPostInput>>;
};

export type CommentUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutProjectInput>>;
  createMany?: InputMaybe<CommentCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type CommentUpdateManyWithoutTutorialNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutTutorialInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutTutorialInput>>;
  createMany?: InputMaybe<CommentCreateManyTutorialInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutTutorialInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutTutorialInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutTutorialInput>>;
};

export type CommentUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutUserInput>>;
  createMany?: InputMaybe<CommentCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CommentUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<CommentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommentCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<CommentCreateWithoutNotificationInput>;
  delete?: InputMaybe<CommentWhereInput>;
  disconnect?: InputMaybe<CommentWhereInput>;
  update?: InputMaybe<CommentUpdateToOneWithWhereWithoutNotificationInput>;
  upsert?: InputMaybe<CommentUpsertWithoutNotificationInput>;
};

export type CommentUpdateToOneWithWhereWithoutNotificationInput = {
  data: CommentUpdateWithoutNotificationInput;
  where?: InputMaybe<CommentWhereInput>;
};

export type CommentUpdateWithWhereUniqueWithoutPostInput = {
  data: CommentUpdateWithoutPostInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithWhereUniqueWithoutProjectInput = {
  data: CommentUpdateWithoutProjectInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithWhereUniqueWithoutTutorialInput = {
  data: CommentUpdateWithoutTutorialInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithWhereUniqueWithoutUserInput = {
  data: CommentUpdateWithoutUserInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithoutNotificationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneWithoutCommentsNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutCommentsNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutCommentsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCommentsNestedInput>;
};

export type CommentUpdateWithoutPostInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutCommentNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutCommentsNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutCommentsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCommentsNestedInput>;
};

export type CommentUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutCommentNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutCommentsNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutCommentsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCommentsNestedInput>;
};

export type CommentUpdateWithoutTutorialInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutCommentNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutCommentsNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutCommentsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCommentsNestedInput>;
};

export type CommentUpdateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutCommentNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutCommentsNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutCommentsNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutCommentsNestedInput>;
};

export type CommentUpsertWithWhereUniqueWithoutPostInput = {
  create: CommentCreateWithoutPostInput;
  update: CommentUpdateWithoutPostInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpsertWithWhereUniqueWithoutProjectInput = {
  create: CommentCreateWithoutProjectInput;
  update: CommentUpdateWithoutProjectInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpsertWithWhereUniqueWithoutTutorialInput = {
  create: CommentCreateWithoutTutorialInput;
  update: CommentUpdateWithoutTutorialInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpsertWithWhereUniqueWithoutUserInput = {
  create: CommentCreateWithoutUserInput;
  update: CommentUpdateWithoutUserInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpsertWithoutNotificationInput = {
  create: CommentCreateWithoutNotificationInput;
  update: CommentUpdateWithoutNotificationInput;
  where?: InputMaybe<CommentWhereInput>;
};

export type CommentWhereInput = {
  AND?: InputMaybe<Array<CommentWhereInput>>;
  NOT?: InputMaybe<Array<CommentWhereInput>>;
  OR?: InputMaybe<Array<CommentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isPrivate?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  post?: InputMaybe<PostNullableRelationFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  project?: InputMaybe<ProjectNullableRelationFilter>;
  projectId?: InputMaybe<UuidNullableFilter>;
  tutorial?: InputMaybe<TutorialNullableRelationFilter>;
  tutorialId?: InputMaybe<UuidNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type CommentWhereUniqueInput = {
  AND?: InputMaybe<Array<CommentWhereInput>>;
  NOT?: InputMaybe<Array<CommentWhereInput>>;
  OR?: InputMaybe<Array<CommentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  post?: InputMaybe<PostNullableRelationFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  project?: InputMaybe<ProjectNullableRelationFilter>;
  projectId?: InputMaybe<UuidNullableFilter>;
  tutorial?: InputMaybe<TutorialNullableRelationFilter>;
  tutorialId?: InputMaybe<UuidNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type CommentsResponse = {
  __typename?: 'CommentsResponse';
  count: Scalars['Int']['output'];
  items: Array<Comment>;
};

export type Competition = {
  __typename?: 'Competition';
  _count?: Maybe<CompetitionCount>;
  acts: ActsResponse;
  applicants: ApplicantsResponse;
  competitionPartners: Array<CompetitionPartner>;
  competitionPeople: Array<CompetitionPerson>;
  competitionPrizes: Array<CompetitionPrize>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  deadlineContentCreator?: Maybe<Scalars['DateTime']['output']>;
  deadlineDJ?: Maybe<Scalars['DateTime']['output']>;
  deadlineDans?: Maybe<Scalars['DateTime']['output']>;
  deadlineExpo?: Maybe<Scalars['DateTime']['output']>;
  deadlineFashion?: Maybe<Scalars['DateTime']['output']>;
  deadlineFilm?: Maybe<Scalars['DateTime']['output']>;
  deadlineMuziek?: Maybe<Scalars['DateTime']['output']>;
  deadlineTaal?: Maybe<Scalars['DateTime']['output']>;
  deadlineTheater?: Maybe<Scalars['DateTime']['output']>;
  disabilityProvisions: Array<Scalars['String']['output']>;
  firstRoundDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  isAttending: Scalars['Boolean']['output'];
  isFinal: Scalars['Boolean']['output'];
  isLive: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  program?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  shopLink?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  ticketLink?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};


export type CompetitionActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type CompetitionApplicantsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};

export type CompetitionCount = {
  __typename?: 'CompetitionCount';
  CompetitionPartner: Scalars['Int']['output'];
  CompetitionPerson: Scalars['Int']['output'];
  CompetitionPrize: Scalars['Int']['output'];
  acts: Scalars['Int']['output'];
};


export type CompetitionCountCompetitionPartnerArgs = {
  where?: InputMaybe<CompetitionPartnerWhereInput>;
};


export type CompetitionCountCompetitionPersonArgs = {
  where?: InputMaybe<CompetitionPersonWhereInput>;
};


export type CompetitionCountCompetitionPrizeArgs = {
  where?: InputMaybe<CompetitionPrizeWhereInput>;
};


export type CompetitionCountActsArgs = {
  where?: InputMaybe<ActWhereInput>;
};

export type CompetitionCreateInput = {
  CompetitionPartner?: InputMaybe<CompetitionPartnerCreateNestedManyWithoutCompetitionInput>;
  CompetitionPerson?: InputMaybe<CompetitionPersonCreateNestedManyWithoutCompetitionInput>;
  CompetitionPrize?: InputMaybe<CompetitionPrizeCreateNestedManyWithoutCompetitionInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutCompetitionInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineContentCreator?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDJ?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDans?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineExpo?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFashion?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFilm?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineMuziek?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTaal?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTheater?: InputMaybe<Scalars['DateTime']['input']>;
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  firstRoundDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  program?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  shopLink?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  year: Scalars['Int']['input'];
};

export type CompetitionCreateNestedOneWithoutActsInput = {
  connect?: InputMaybe<CompetitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CompetitionCreateOrConnectWithoutActsInput>;
  create?: InputMaybe<CompetitionCreateWithoutActsInput>;
};

export type CompetitionCreateOrConnectWithoutActsInput = {
  create: CompetitionCreateWithoutActsInput;
  where: CompetitionWhereUniqueInput;
};

export type CompetitionCreateWithoutActsInput = {
  CompetitionPartner?: InputMaybe<CompetitionPartnerCreateNestedManyWithoutCompetitionInput>;
  CompetitionPerson?: InputMaybe<CompetitionPersonCreateNestedManyWithoutCompetitionInput>;
  CompetitionPrize?: InputMaybe<CompetitionPrizeCreateNestedManyWithoutCompetitionInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineContentCreator?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDJ?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDans?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineExpo?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFashion?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFilm?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineMuziek?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTaal?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTheater?: InputMaybe<Scalars['DateTime']['input']>;
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  firstRoundDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  program?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  shopLink?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  year: Scalars['Int']['input'];
};

export type CompetitionOrderByWithRelationInput = {
  CompetitionPartner?: InputMaybe<CompetitionPartnerOrderByRelationAggregateInput>;
  CompetitionPerson?: InputMaybe<CompetitionPersonOrderByRelationAggregateInput>;
  CompetitionPrize?: InputMaybe<CompetitionPrizeOrderByRelationAggregateInput>;
  acts?: InputMaybe<ActOrderByRelationAggregateInput>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deadline?: InputMaybe<SortOrderInput>;
  deadlineContentCreator?: InputMaybe<SortOrderInput>;
  deadlineDJ?: InputMaybe<SortOrderInput>;
  deadlineDans?: InputMaybe<SortOrderInput>;
  deadlineExpo?: InputMaybe<SortOrderInput>;
  deadlineFashion?: InputMaybe<SortOrderInput>;
  deadlineFilm?: InputMaybe<SortOrderInput>;
  deadlineMuziek?: InputMaybe<SortOrderInput>;
  deadlineTaal?: InputMaybe<SortOrderInput>;
  deadlineTheater?: InputMaybe<SortOrderInput>;
  disabilityProvisions?: InputMaybe<SortOrder>;
  firstRoundDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  isFinal?: InputMaybe<SortOrder>;
  isLive?: InputMaybe<SortOrder>;
  location?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  program?: InputMaybe<SortOrderInput>;
  region?: InputMaybe<SortOrder>;
  shopLink?: InputMaybe<SortOrderInput>;
  slug?: InputMaybe<SortOrder>;
  thumbnail?: InputMaybe<SortOrderInput>;
  ticketLink?: InputMaybe<SortOrderInput>;
  time?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type CompetitionPartner = {
  __typename?: 'CompetitionPartner';
  competitionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  type: CompetitionPartnerType;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type CompetitionPartnerCreateManyCompetitionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  type?: InputMaybe<CompetitionPartnerType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionPartnerCreateManyCompetitionInputEnvelope = {
  data: Array<CompetitionPartnerCreateManyCompetitionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompetitionPartnerCreateNestedManyWithoutCompetitionInput = {
  connect?: InputMaybe<Array<CompetitionPartnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CompetitionPartnerCreateOrConnectWithoutCompetitionInput>>;
  create?: InputMaybe<Array<CompetitionPartnerCreateWithoutCompetitionInput>>;
  createMany?: InputMaybe<CompetitionPartnerCreateManyCompetitionInputEnvelope>;
};

export type CompetitionPartnerCreateOrConnectWithoutCompetitionInput = {
  create: CompetitionPartnerCreateWithoutCompetitionInput;
  where: CompetitionPartnerWhereUniqueInput;
};

export type CompetitionPartnerCreateWithoutCompetitionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  type?: InputMaybe<CompetitionPartnerType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionPartnerListRelationFilter = {
  every?: InputMaybe<CompetitionPartnerWhereInput>;
  none?: InputMaybe<CompetitionPartnerWhereInput>;
  some?: InputMaybe<CompetitionPartnerWhereInput>;
};

export type CompetitionPartnerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompetitionPartnerScalarWhereInput = {
  AND?: InputMaybe<Array<CompetitionPartnerScalarWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPartnerScalarWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPartnerScalarWhereInput>>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCompetitionPartnerTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export enum CompetitionPartnerType {
  Financier = 'FINANCIER',
  Partner = 'PARTNER'
}

export type CompetitionPartnerUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompetitionPartnerType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionPartnerUpdateManyWithWhereWithoutCompetitionInput = {
  data: CompetitionPartnerUpdateManyMutationInput;
  where: CompetitionPartnerScalarWhereInput;
};

export type CompetitionPartnerUpdateManyWithoutCompetitionNestedInput = {
  connect?: InputMaybe<Array<CompetitionPartnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CompetitionPartnerCreateOrConnectWithoutCompetitionInput>>;
  create?: InputMaybe<Array<CompetitionPartnerCreateWithoutCompetitionInput>>;
  createMany?: InputMaybe<CompetitionPartnerCreateManyCompetitionInputEnvelope>;
  delete?: InputMaybe<Array<CompetitionPartnerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CompetitionPartnerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CompetitionPartnerWhereUniqueInput>>;
  set?: InputMaybe<Array<CompetitionPartnerWhereUniqueInput>>;
  update?: InputMaybe<Array<CompetitionPartnerUpdateWithWhereUniqueWithoutCompetitionInput>>;
  updateMany?: InputMaybe<Array<CompetitionPartnerUpdateManyWithWhereWithoutCompetitionInput>>;
  upsert?: InputMaybe<Array<CompetitionPartnerUpsertWithWhereUniqueWithoutCompetitionInput>>;
};

export type CompetitionPartnerUpdateWithWhereUniqueWithoutCompetitionInput = {
  data: CompetitionPartnerUpdateWithoutCompetitionInput;
  where: CompetitionPartnerWhereUniqueInput;
};

export type CompetitionPartnerUpdateWithoutCompetitionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompetitionPartnerType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionPartnerUpsertWithWhereUniqueWithoutCompetitionInput = {
  create: CompetitionPartnerCreateWithoutCompetitionInput;
  update: CompetitionPartnerUpdateWithoutCompetitionInput;
  where: CompetitionPartnerWhereUniqueInput;
};

export type CompetitionPartnerWhereInput = {
  AND?: InputMaybe<Array<CompetitionPartnerWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPartnerWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPartnerWhereInput>>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCompetitionPartnerTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type CompetitionPartnerWhereUniqueInput = {
  AND?: InputMaybe<Array<CompetitionPartnerWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPartnerWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPartnerWhereInput>>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCompetitionPartnerTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type CompetitionPerson = {
  __typename?: 'CompetitionPerson';
  bio?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: CompetitionPersonType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompetitionPersonCreateManyCompetitionInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: CompetitionPersonType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPersonCreateManyCompetitionInputEnvelope = {
  data: Array<CompetitionPersonCreateManyCompetitionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompetitionPersonCreateNestedManyWithoutCompetitionInput = {
  connect?: InputMaybe<Array<CompetitionPersonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CompetitionPersonCreateOrConnectWithoutCompetitionInput>>;
  create?: InputMaybe<Array<CompetitionPersonCreateWithoutCompetitionInput>>;
  createMany?: InputMaybe<CompetitionPersonCreateManyCompetitionInputEnvelope>;
};

export type CompetitionPersonCreateOrConnectWithoutCompetitionInput = {
  create: CompetitionPersonCreateWithoutCompetitionInput;
  where: CompetitionPersonWhereUniqueInput;
};

export type CompetitionPersonCreateWithoutCompetitionInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: CompetitionPersonType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPersonListRelationFilter = {
  every?: InputMaybe<CompetitionPersonWhereInput>;
  none?: InputMaybe<CompetitionPersonWhereInput>;
  some?: InputMaybe<CompetitionPersonWhereInput>;
};

export type CompetitionPersonOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompetitionPersonScalarWhereInput = {
  AND?: InputMaybe<Array<CompetitionPersonScalarWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPersonScalarWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPersonScalarWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringNullableFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCompetitionPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum CompetitionPersonType {
  Host = 'HOST',
  Jury = 'JURY'
}

export type CompetitionPersonUpdateManyMutationInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompetitionPersonType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPersonUpdateManyWithWhereWithoutCompetitionInput = {
  data: CompetitionPersonUpdateManyMutationInput;
  where: CompetitionPersonScalarWhereInput;
};

export type CompetitionPersonUpdateManyWithoutCompetitionNestedInput = {
  connect?: InputMaybe<Array<CompetitionPersonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CompetitionPersonCreateOrConnectWithoutCompetitionInput>>;
  create?: InputMaybe<Array<CompetitionPersonCreateWithoutCompetitionInput>>;
  createMany?: InputMaybe<CompetitionPersonCreateManyCompetitionInputEnvelope>;
  delete?: InputMaybe<Array<CompetitionPersonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CompetitionPersonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CompetitionPersonWhereUniqueInput>>;
  set?: InputMaybe<Array<CompetitionPersonWhereUniqueInput>>;
  update?: InputMaybe<Array<CompetitionPersonUpdateWithWhereUniqueWithoutCompetitionInput>>;
  updateMany?: InputMaybe<Array<CompetitionPersonUpdateManyWithWhereWithoutCompetitionInput>>;
  upsert?: InputMaybe<Array<CompetitionPersonUpsertWithWhereUniqueWithoutCompetitionInput>>;
};

export type CompetitionPersonUpdateWithWhereUniqueWithoutCompetitionInput = {
  data: CompetitionPersonUpdateWithoutCompetitionInput;
  where: CompetitionPersonWhereUniqueInput;
};

export type CompetitionPersonUpdateWithoutCompetitionInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompetitionPersonType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPersonUpsertWithWhereUniqueWithoutCompetitionInput = {
  create: CompetitionPersonCreateWithoutCompetitionInput;
  update: CompetitionPersonUpdateWithoutCompetitionInput;
  where: CompetitionPersonWhereUniqueInput;
};

export type CompetitionPersonWhereInput = {
  AND?: InputMaybe<Array<CompetitionPersonWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPersonWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPersonWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringNullableFilter>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCompetitionPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CompetitionPersonWhereUniqueInput = {
  AND?: InputMaybe<Array<CompetitionPersonWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPersonWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPersonWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringNullableFilter>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCompetitionPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CompetitionPrize = {
  __typename?: 'CompetitionPrize';
  category: Scalars['String']['output'];
  competitionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompetitionPrizeCreateManyCompetitionInput = {
  category: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPrizeCreateManyCompetitionInputEnvelope = {
  data: Array<CompetitionPrizeCreateManyCompetitionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompetitionPrizeCreateNestedManyWithoutCompetitionInput = {
  connect?: InputMaybe<Array<CompetitionPrizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CompetitionPrizeCreateOrConnectWithoutCompetitionInput>>;
  create?: InputMaybe<Array<CompetitionPrizeCreateWithoutCompetitionInput>>;
  createMany?: InputMaybe<CompetitionPrizeCreateManyCompetitionInputEnvelope>;
};

export type CompetitionPrizeCreateOrConnectWithoutCompetitionInput = {
  create: CompetitionPrizeCreateWithoutCompetitionInput;
  where: CompetitionPrizeWhereUniqueInput;
};

export type CompetitionPrizeCreateWithoutCompetitionInput = {
  category: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPrizeListRelationFilter = {
  every?: InputMaybe<CompetitionPrizeWhereInput>;
  none?: InputMaybe<CompetitionPrizeWhereInput>;
  some?: InputMaybe<CompetitionPrizeWhereInput>;
};

export type CompetitionPrizeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompetitionPrizeScalarWhereInput = {
  AND?: InputMaybe<Array<CompetitionPrizeScalarWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPrizeScalarWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPrizeScalarWhereInput>>;
  category?: InputMaybe<StringFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  position?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CompetitionPrizeUpdateManyMutationInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPrizeUpdateManyWithWhereWithoutCompetitionInput = {
  data: CompetitionPrizeUpdateManyMutationInput;
  where: CompetitionPrizeScalarWhereInput;
};

export type CompetitionPrizeUpdateManyWithoutCompetitionNestedInput = {
  connect?: InputMaybe<Array<CompetitionPrizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CompetitionPrizeCreateOrConnectWithoutCompetitionInput>>;
  create?: InputMaybe<Array<CompetitionPrizeCreateWithoutCompetitionInput>>;
  createMany?: InputMaybe<CompetitionPrizeCreateManyCompetitionInputEnvelope>;
  delete?: InputMaybe<Array<CompetitionPrizeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CompetitionPrizeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CompetitionPrizeWhereUniqueInput>>;
  set?: InputMaybe<Array<CompetitionPrizeWhereUniqueInput>>;
  update?: InputMaybe<Array<CompetitionPrizeUpdateWithWhereUniqueWithoutCompetitionInput>>;
  updateMany?: InputMaybe<Array<CompetitionPrizeUpdateManyWithWhereWithoutCompetitionInput>>;
  upsert?: InputMaybe<Array<CompetitionPrizeUpsertWithWhereUniqueWithoutCompetitionInput>>;
};

export type CompetitionPrizeUpdateWithWhereUniqueWithoutCompetitionInput = {
  data: CompetitionPrizeUpdateWithoutCompetitionInput;
  where: CompetitionPrizeWhereUniqueInput;
};

export type CompetitionPrizeUpdateWithoutCompetitionInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompetitionPrizeUpsertWithWhereUniqueWithoutCompetitionInput = {
  create: CompetitionPrizeCreateWithoutCompetitionInput;
  update: CompetitionPrizeUpdateWithoutCompetitionInput;
  where: CompetitionPrizeWhereUniqueInput;
};

export type CompetitionPrizeWhereInput = {
  AND?: InputMaybe<Array<CompetitionPrizeWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPrizeWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPrizeWhereInput>>;
  category?: InputMaybe<StringFilter>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  position?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CompetitionPrizeWhereUniqueInput = {
  AND?: InputMaybe<Array<CompetitionPrizeWhereInput>>;
  NOT?: InputMaybe<Array<CompetitionPrizeWhereInput>>;
  OR?: InputMaybe<Array<CompetitionPrizeWhereInput>>;
  category?: InputMaybe<StringFilter>;
  competition?: InputMaybe<CompetitionRelationFilter>;
  competitionId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CompetitionRelationFilter = {
  is?: InputMaybe<CompetitionWhereInput>;
  isNot?: InputMaybe<CompetitionWhereInput>;
};

export enum CompetitionScalarFieldEnum {
  Content = 'content',
  CreatedAt = 'createdAt',
  Deadline = 'deadline',
  DeadlineContentCreator = 'deadlineContentCreator',
  DeadlineDj = 'deadlineDJ',
  DeadlineDans = 'deadlineDans',
  DeadlineExpo = 'deadlineExpo',
  DeadlineFashion = 'deadlineFashion',
  DeadlineFilm = 'deadlineFilm',
  DeadlineMuziek = 'deadlineMuziek',
  DeadlineTaal = 'deadlineTaal',
  DeadlineTheater = 'deadlineTheater',
  DisabilityProvisions = 'disabilityProvisions',
  FirstRoundDate = 'firstRoundDate',
  Id = 'id',
  IsArchived = 'isArchived',
  IsFinal = 'isFinal',
  IsLive = 'isLive',
  Location = 'location',
  Name = 'name',
  Program = 'program',
  Region = 'region',
  ShopLink = 'shopLink',
  Slug = 'slug',
  Thumbnail = 'thumbnail',
  TicketLink = 'ticketLink',
  Time = 'time',
  UpdatedAt = 'updatedAt',
  Year = 'year'
}

export type CompetitionUpdateOneRequiredWithoutActsNestedInput = {
  connect?: InputMaybe<CompetitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CompetitionCreateOrConnectWithoutActsInput>;
  create?: InputMaybe<CompetitionCreateWithoutActsInput>;
  update?: InputMaybe<CompetitionUpdateToOneWithWhereWithoutActsInput>;
  upsert?: InputMaybe<CompetitionUpsertWithoutActsInput>;
};

export type CompetitionUpdateToOneWithWhereWithoutActsInput = {
  data: CompetitionUpdateWithoutActsInput;
  where?: InputMaybe<CompetitionWhereInput>;
};

export type CompetitionUpdateWithoutActsInput = {
  CompetitionPartner?: InputMaybe<CompetitionPartnerUpdateManyWithoutCompetitionNestedInput>;
  CompetitionPerson?: InputMaybe<CompetitionPersonUpdateManyWithoutCompetitionNestedInput>;
  CompetitionPrize?: InputMaybe<CompetitionPrizeUpdateManyWithoutCompetitionNestedInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineContentCreator?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDJ?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDans?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineExpo?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFashion?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFilm?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineMuziek?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTaal?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTheater?: InputMaybe<Scalars['DateTime']['input']>;
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  firstRoundDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shopLink?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CompetitionUpsertWithoutActsInput = {
  create: CompetitionCreateWithoutActsInput;
  update: CompetitionUpdateWithoutActsInput;
  where?: InputMaybe<CompetitionWhereInput>;
};

export type CompetitionWhereInput = {
  AND?: InputMaybe<Array<CompetitionWhereInput>>;
  CompetitionPartner?: InputMaybe<CompetitionPartnerListRelationFilter>;
  CompetitionPerson?: InputMaybe<CompetitionPersonListRelationFilter>;
  CompetitionPrize?: InputMaybe<CompetitionPrizeListRelationFilter>;
  NOT?: InputMaybe<Array<CompetitionWhereInput>>;
  OR?: InputMaybe<Array<CompetitionWhereInput>>;
  acts?: InputMaybe<ActListRelationFilter>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadline?: InputMaybe<DateTimeNullableFilter>;
  deadlineContentCreator?: InputMaybe<DateTimeNullableFilter>;
  deadlineDJ?: InputMaybe<DateTimeNullableFilter>;
  deadlineDans?: InputMaybe<DateTimeNullableFilter>;
  deadlineExpo?: InputMaybe<DateTimeNullableFilter>;
  deadlineFashion?: InputMaybe<DateTimeNullableFilter>;
  deadlineFilm?: InputMaybe<DateTimeNullableFilter>;
  deadlineMuziek?: InputMaybe<DateTimeNullableFilter>;
  deadlineTaal?: InputMaybe<DateTimeNullableFilter>;
  deadlineTheater?: InputMaybe<DateTimeNullableFilter>;
  disabilityProvisions?: InputMaybe<StringNullableListFilter>;
  firstRoundDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  isFinal?: InputMaybe<BoolFilter>;
  isLive?: InputMaybe<BoolFilter>;
  location?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  program?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringFilter>;
  shopLink?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  thumbnail?: InputMaybe<StringNullableFilter>;
  ticketLink?: InputMaybe<StringNullableFilter>;
  time?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  year?: InputMaybe<IntFilter>;
};

export type CompetitionWhereUniqueInput = {
  AND?: InputMaybe<Array<CompetitionWhereInput>>;
  CompetitionPartner?: InputMaybe<CompetitionPartnerListRelationFilter>;
  CompetitionPerson?: InputMaybe<CompetitionPersonListRelationFilter>;
  CompetitionPrize?: InputMaybe<CompetitionPrizeListRelationFilter>;
  NOT?: InputMaybe<Array<CompetitionWhereInput>>;
  OR?: InputMaybe<Array<CompetitionWhereInput>>;
  acts?: InputMaybe<ActListRelationFilter>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadline?: InputMaybe<DateTimeNullableFilter>;
  deadlineContentCreator?: InputMaybe<DateTimeNullableFilter>;
  deadlineDJ?: InputMaybe<DateTimeNullableFilter>;
  deadlineDans?: InputMaybe<DateTimeNullableFilter>;
  deadlineExpo?: InputMaybe<DateTimeNullableFilter>;
  deadlineFashion?: InputMaybe<DateTimeNullableFilter>;
  deadlineFilm?: InputMaybe<DateTimeNullableFilter>;
  deadlineMuziek?: InputMaybe<DateTimeNullableFilter>;
  deadlineTaal?: InputMaybe<DateTimeNullableFilter>;
  deadlineTheater?: InputMaybe<DateTimeNullableFilter>;
  disabilityProvisions?: InputMaybe<StringNullableListFilter>;
  firstRoundDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<BoolFilter>;
  isFinal?: InputMaybe<BoolFilter>;
  isLive?: InputMaybe<BoolFilter>;
  location?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  program?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringFilter>;
  shopLink?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<StringNullableFilter>;
  ticketLink?: InputMaybe<StringNullableFilter>;
  time?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  year?: InputMaybe<IntFilter>;
};

export type CompetitionsResponse = {
  __typename?: 'CompetitionsResponse';
  count: Scalars['Int']['output'];
  items: Array<Competition>;
};

export type ConnectionCreateManyFollowerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type ConnectionCreateManyFollowerInputEnvelope = {
  data: Array<ConnectionCreateManyFollowerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectionCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  followerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConnectionCreateManyUserInputEnvelope = {
  data: Array<ConnectionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectionCreateNestedManyWithoutFollowerInput = {
  connect?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConnectionCreateOrConnectWithoutFollowerInput>>;
  create?: InputMaybe<Array<ConnectionCreateWithoutFollowerInput>>;
  createMany?: InputMaybe<ConnectionCreateManyFollowerInputEnvelope>;
};

export type ConnectionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConnectionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ConnectionCreateWithoutUserInput>>;
  createMany?: InputMaybe<ConnectionCreateManyUserInputEnvelope>;
};

export type ConnectionCreateOrConnectWithoutFollowerInput = {
  create: ConnectionCreateWithoutFollowerInput;
  where: ConnectionWhereUniqueInput;
};

export type ConnectionCreateOrConnectWithoutUserInput = {
  create: ConnectionCreateWithoutUserInput;
  where: ConnectionWhereUniqueInput;
};

export type ConnectionCreateWithoutFollowerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutFollowingInput;
};

export type ConnectionCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  follower: UserCreateNestedOneWithoutFollowersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConnectionListRelationFilter = {
  every?: InputMaybe<ConnectionWhereInput>;
  none?: InputMaybe<ConnectionWhereInput>;
  some?: InputMaybe<ConnectionWhereInput>;
};

export type ConnectionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ConnectionOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  follower?: InputMaybe<UserOrderByWithRelationInput>;
  followerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum ConnectionScalarFieldEnum {
  CreatedAt = 'createdAt',
  FollowerId = 'followerId',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ConnectionScalarWhereInput = {
  AND?: InputMaybe<Array<ConnectionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ConnectionScalarWhereInput>>;
  OR?: InputMaybe<Array<ConnectionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  followerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumConnectionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export enum ConnectionStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ConnectionUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConnectionUpdateManyWithWhereWithoutFollowerInput = {
  data: ConnectionUpdateManyMutationInput;
  where: ConnectionScalarWhereInput;
};

export type ConnectionUpdateManyWithWhereWithoutUserInput = {
  data: ConnectionUpdateManyMutationInput;
  where: ConnectionScalarWhereInput;
};

export type ConnectionUpdateManyWithoutFollowerNestedInput = {
  connect?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConnectionCreateOrConnectWithoutFollowerInput>>;
  create?: InputMaybe<Array<ConnectionCreateWithoutFollowerInput>>;
  createMany?: InputMaybe<ConnectionCreateManyFollowerInputEnvelope>;
  delete?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConnectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  set?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  update?: InputMaybe<Array<ConnectionUpdateWithWhereUniqueWithoutFollowerInput>>;
  updateMany?: InputMaybe<Array<ConnectionUpdateManyWithWhereWithoutFollowerInput>>;
  upsert?: InputMaybe<Array<ConnectionUpsertWithWhereUniqueWithoutFollowerInput>>;
};

export type ConnectionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConnectionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ConnectionCreateWithoutUserInput>>;
  createMany?: InputMaybe<ConnectionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConnectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  set?: InputMaybe<Array<ConnectionWhereUniqueInput>>;
  update?: InputMaybe<Array<ConnectionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ConnectionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ConnectionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ConnectionUpdateWithWhereUniqueWithoutFollowerInput = {
  data: ConnectionUpdateWithoutFollowerInput;
  where: ConnectionWhereUniqueInput;
};

export type ConnectionUpdateWithWhereUniqueWithoutUserInput = {
  data: ConnectionUpdateWithoutUserInput;
  where: ConnectionWhereUniqueInput;
};

export type ConnectionUpdateWithoutFollowerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutFollowingNestedInput>;
};

export type ConnectionUpdateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  follower?: InputMaybe<UserUpdateOneRequiredWithoutFollowersNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConnectionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConnectionUpsertWithWhereUniqueWithoutFollowerInput = {
  create: ConnectionCreateWithoutFollowerInput;
  update: ConnectionUpdateWithoutFollowerInput;
  where: ConnectionWhereUniqueInput;
};

export type ConnectionUpsertWithWhereUniqueWithoutUserInput = {
  create: ConnectionCreateWithoutUserInput;
  update: ConnectionUpdateWithoutUserInput;
  where: ConnectionWhereUniqueInput;
};

export type ConnectionUserIdFollowerIdCompoundUniqueInput = {
  followerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ConnectionWhereInput = {
  AND?: InputMaybe<Array<ConnectionWhereInput>>;
  NOT?: InputMaybe<Array<ConnectionWhereInput>>;
  OR?: InputMaybe<Array<ConnectionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  follower?: InputMaybe<UserRelationFilter>;
  followerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumConnectionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type ConnectionWhereUniqueInput = {
  AND?: InputMaybe<Array<ConnectionWhereInput>>;
  NOT?: InputMaybe<Array<ConnectionWhereInput>>;
  OR?: InputMaybe<Array<ConnectionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  follower?: InputMaybe<UserRelationFilter>;
  followerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumConnectionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userId_followerId?: InputMaybe<ConnectionUserIdFollowerIdCompoundUniqueInput>;
};

export type CreateCommentInput = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompetitionPartnerInput = {
  competitionId: Scalars['String']['input'];
  image: Scalars['String']['input'];
  type: CompetitionPartnerType;
  url: Scalars['String']['input'];
};

export type CreateCompetitionPersonInput = {
  bio: Scalars['String']['input'];
  category: Scalars['String']['input'];
  competitionId: Scalars['String']['input'];
  image: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: CompetitionPersonType;
};

export type CreateCompetitionPrizeInput = {
  category: Scalars['String']['input'];
  competitionId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  position: Scalars['Float']['input'];
};

export type CreateCustomNotificationsInput = {
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  filters: Filters;
  message: Scalars['String']['input'];
  search: Scalars['String']['input'];
};

export type CreateEventPersonInput = {
  bio: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  image: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: EventPersonType;
};

export type CreatePostInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  deadline: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  region: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: PostType;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRegionFinancerInput = {
  image: Scalars['String']['input'];
  regionPageId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateRegionPartnerInput = {
  image: Scalars['String']['input'];
  regionPageId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateRegionPersonInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  regionPageId: Scalars['String']['input'];
  type: RegionPersonType;
};

export type CreateTutorialInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  difficultyRating?: InputMaybe<Scalars['Float']['input']>;
  duration: Scalars['String']['input'];
  instructor: Scalars['String']['input'];
  title: Scalars['String']['input'];
  videoUrl: Scalars['String']['input'];
};

export type CustomFeed = {
  __typename?: 'CustomFeed';
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  heading: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  video?: Maybe<Scalars['String']['output']>;
};

export type CustomFeedCreateInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  heading: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  video?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type EnumActAttachmentTypeFilter = {
  equals?: InputMaybe<ActAttachmentType>;
  in?: InputMaybe<Array<ActAttachmentType>>;
  not?: InputMaybe<NestedEnumActAttachmentTypeFilter>;
  notIn?: InputMaybe<Array<ActAttachmentType>>;
};

export type EnumActStatusFilter = {
  equals?: InputMaybe<ActStatus>;
  in?: InputMaybe<Array<ActStatus>>;
  not?: InputMaybe<NestedEnumActStatusFilter>;
  notIn?: InputMaybe<Array<ActStatus>>;
};

export type EnumCompetitionPartnerTypeFilter = {
  equals?: InputMaybe<CompetitionPartnerType>;
  in?: InputMaybe<Array<CompetitionPartnerType>>;
  not?: InputMaybe<NestedEnumCompetitionPartnerTypeFilter>;
  notIn?: InputMaybe<Array<CompetitionPartnerType>>;
};

export type EnumCompetitionPersonTypeFilter = {
  equals?: InputMaybe<CompetitionPersonType>;
  in?: InputMaybe<Array<CompetitionPersonType>>;
  not?: InputMaybe<NestedEnumCompetitionPersonTypeFilter>;
  notIn?: InputMaybe<Array<CompetitionPersonType>>;
};

export type EnumConnectionStatusFilter = {
  equals?: InputMaybe<ConnectionStatus>;
  in?: InputMaybe<Array<ConnectionStatus>>;
  not?: InputMaybe<NestedEnumConnectionStatusFilter>;
  notIn?: InputMaybe<Array<ConnectionStatus>>;
};

export type EnumEventPersonTypeFilter = {
  equals?: InputMaybe<EventPersonType>;
  in?: InputMaybe<Array<EventPersonType>>;
  not?: InputMaybe<NestedEnumEventPersonTypeFilter>;
  notIn?: InputMaybe<Array<EventPersonType>>;
};

export type EnumNotificationTypeFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type EnumPostTypeFilter = {
  equals?: InputMaybe<PostType>;
  in?: InputMaybe<Array<PostType>>;
  not?: InputMaybe<NestedEnumPostTypeFilter>;
  notIn?: InputMaybe<Array<PostType>>;
};

export type EnumPrivacySettingFilter = {
  equals?: InputMaybe<PrivacySetting>;
  in?: InputMaybe<Array<PrivacySetting>>;
  not?: InputMaybe<NestedEnumPrivacySettingFilter>;
  notIn?: InputMaybe<Array<PrivacySetting>>;
};

export type EnumRegionPersonTypeFilter = {
  equals?: InputMaybe<RegionPersonType>;
  in?: InputMaybe<Array<RegionPersonType>>;
  not?: InputMaybe<NestedEnumRegionPersonTypeFilter>;
  notIn?: InputMaybe<Array<RegionPersonType>>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type Event = {
  __typename?: 'Event';
  _count?: Maybe<EventCount>;
  attendeeCount: Scalars['Float']['output'];
  attendees: EventAttendeesResponse;
  categories: Array<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  disabilityProvisions: Array<Scalars['String']['output']>;
  eventPeople: Array<EventPerson>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAttendable: Scalars['Boolean']['output'];
  isAttending: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isRestrictedToRegion: Scalars['Boolean']['output'];
  isReviewable: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  maxAttendees?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  reviews: EventReviewsResponse;
  slug: Scalars['String']['output'];
  ticketLink?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type EventAttendeesArgs = {
  cursor?: InputMaybe<UserEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserEventWhereInput>;
};


export type EventReviewsArgs = {
  cursor?: InputMaybe<UserEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserEventWhereInput>;
};

export type EventAttendee = {
  __typename?: 'EventAttendee';
  _count?: Maybe<UserCount>;
  acceptedInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  acts: ActsResponse;
  address?: Maybe<Scalars['String']['output']>;
  agenda: Array<AgendaItem>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  commentedOnPosts: Array<Post>;
  completedTutorialsCount: Scalars['Float']['output'];
  connectionProjects: ProjectsResponse;
  connectionStatus?: Maybe<Scalars['String']['output']>;
  connections: Array<UserConnection>;
  connectionsCount: Scalars['Float']['output'];
  contactPreference?: Maybe<Scalars['String']['output']>;
  createdActs: Array<Act>;
  createdActsCount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  customSlug?: Maybe<Scalars['String']['output']>;
  dateAttended: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  events: EventsResponse;
  eventsCount: Scalars['Float']['output'];
  eventsPendingReview: Array<Event>;
  firstName?: Maybe<Scalars['String']['output']>;
  foundVia?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasOrderedPromoPackage: Scalars['Boolean']['output'];
  hasPendingFeedback: Scalars['Boolean']['output'];
  howDidYouHear?: Maybe<Scalars['String']['output']>;
  howDidYouHearMulti: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  interests: Array<Scalars['String']['output']>;
  isConnected: Scalars['Boolean']['output'];
  isOver16: Scalars['Boolean']['output'];
  isParentNotified: Scalars['Boolean']['output'];
  isPrivacyCheckAccepted: Scalars['Boolean']['output'];
  isTooOld: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  matchedOnPosts: Array<Post>;
  notes?: Maybe<Scalars['String']['output']>;
  parentEmail?: Maybe<Scalars['String']['output']>;
  pendingConnections: Array<UserConnection>;
  pendingInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  postcode?: Maybe<Scalars['String']['output']>;
  posts: Array<Post>;
  postsCount: Scalars['Float']['output'];
  privacySetting: PrivacySetting;
  profileIncomplete: Scalars['Boolean']['output'];
  projects: ProjectsResponse;
  pronouns?: Maybe<Scalars['String']['output']>;
  pronounsMulti: Array<Scalars['String']['output']>;
  pronounsOther?: Maybe<Scalars['String']['output']>;
  reasonForSigningUp?: Maybe<Scalars['String']['output']>;
  recommendedConnections: Array<User>;
  recommendedEvents: Array<Event>;
  recommendedPosts: PostsResponse;
  recommendedTutorials: Array<Tutorial>;
  region?: Maybe<Scalars['String']['output']>;
  rejectedInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  residence?: Maybe<Scalars['String']['output']>;
  role: Role;
  school?: Maybe<Scalars['String']['output']>;
  schoolType?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  tutorials: TutorialsResponse;
  updatedAt: Scalars['DateTime']['output'];
};


export type EventAttendeeActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type EventAttendeeConnectionProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type EventAttendeeConnectionsArgs = {
  cursor?: InputMaybe<ConnectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConnectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConnectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConnectionWhereInput>;
};


export type EventAttendeeCreatedActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type EventAttendeeEventsArgs = {
  cursor?: InputMaybe<UserEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserEventWhereInput>;
};


export type EventAttendeePendingConnectionsArgs = {
  cursor?: InputMaybe<ConnectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConnectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConnectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConnectionWhereInput>;
};


export type EventAttendeePostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostWhereInput>;
};


export type EventAttendeeProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type EventAttendeeRecommendedPostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostWhereInput>;
};


export type EventAttendeeTutorialsArgs = {
  cursor?: InputMaybe<UserTutorialWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTutorialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTutorialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserTutorialWhereInput>;
};

export type EventAttendeesResponse = {
  __typename?: 'EventAttendeesResponse';
  count: Scalars['Int']['output'];
  items: Array<EventAttendee>;
};

export type EventCount = {
  __typename?: 'EventCount';
  EventPerson: Scalars['Int']['output'];
  notification: Scalars['Int']['output'];
  userEvents: Scalars['Int']['output'];
};


export type EventCountEventPersonArgs = {
  where?: InputMaybe<EventPersonWhereInput>;
};


export type EventCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type EventCountUserEventsArgs = {
  where?: InputMaybe<UserEventWhereInput>;
};

export type EventCreateInput = {
  EventPerson?: InputMaybe<EventPersonCreateNestedManyWithoutEventInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isAttendable?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRestrictedToRegion?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewable?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notification?: InputMaybe<NotificationCreateNestedManyWithoutEventInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutEventInput>;
};

export type EventCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<EventCreateWithoutNotificationInput>;
};

export type EventCreateNestedOneWithoutUserEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutUserEventsInput>;
  create?: InputMaybe<EventCreateWithoutUserEventsInput>;
};

export type EventCreateOrConnectWithoutNotificationInput = {
  create: EventCreateWithoutNotificationInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutUserEventsInput = {
  create: EventCreateWithoutUserEventsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateWithoutNotificationInput = {
  EventPerson?: InputMaybe<EventPersonCreateNestedManyWithoutEventInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isAttendable?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRestrictedToRegion?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewable?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutEventInput>;
};

export type EventCreateWithoutUserEventsInput = {
  EventPerson?: InputMaybe<EventPersonCreateNestedManyWithoutEventInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isAttendable?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRestrictedToRegion?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewable?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notification?: InputMaybe<NotificationCreateNestedManyWithoutEventInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventNullableRelationFilter = {
  is?: InputMaybe<EventWhereInput>;
  isNot?: InputMaybe<EventWhereInput>;
};

export type EventOrderByWithRelationInput = {
  EventPerson?: InputMaybe<EventPersonOrderByRelationAggregateInput>;
  categories?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  disabilityProvisions?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrderInput>;
  isAttendable?: InputMaybe<SortOrder>;
  isFeatured?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  isRestrictedToRegion?: InputMaybe<SortOrder>;
  isReviewable?: InputMaybe<SortOrder>;
  location?: InputMaybe<SortOrder>;
  maxAttendees?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  region?: InputMaybe<SortOrderInput>;
  slug?: InputMaybe<SortOrder>;
  ticketLink?: InputMaybe<SortOrderInput>;
  time?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userEvents?: InputMaybe<UserEventOrderByRelationAggregateInput>;
};

export type EventPerson = {
  __typename?: 'EventPerson';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: EventPersonType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventPersonCreateManyEventInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: EventPersonType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventPersonCreateManyEventInputEnvelope = {
  data: Array<EventPersonCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventPersonCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<EventPersonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventPersonCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventPersonCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventPersonCreateManyEventInputEnvelope>;
};

export type EventPersonCreateOrConnectWithoutEventInput = {
  create: EventPersonCreateWithoutEventInput;
  where: EventPersonWhereUniqueInput;
};

export type EventPersonCreateWithoutEventInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: EventPersonType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventPersonListRelationFilter = {
  every?: InputMaybe<EventPersonWhereInput>;
  none?: InputMaybe<EventPersonWhereInput>;
  some?: InputMaybe<EventPersonWhereInput>;
};

export type EventPersonOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventPersonScalarWhereInput = {
  AND?: InputMaybe<Array<EventPersonScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventPersonScalarWhereInput>>;
  OR?: InputMaybe<Array<EventPersonScalarWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumEventPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum EventPersonType {
  Host = 'HOST',
  Speaker = 'SPEAKER',
  Teacher = 'TEACHER'
}

export type EventPersonUpdateManyMutationInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventPersonType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventPersonUpdateManyWithWhereWithoutEventInput = {
  data: EventPersonUpdateManyMutationInput;
  where: EventPersonScalarWhereInput;
};

export type EventPersonUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<EventPersonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventPersonCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventPersonCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventPersonCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<EventPersonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventPersonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventPersonWhereUniqueInput>>;
  set?: InputMaybe<Array<EventPersonWhereUniqueInput>>;
  update?: InputMaybe<Array<EventPersonUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<EventPersonUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<EventPersonUpsertWithWhereUniqueWithoutEventInput>>;
};

export type EventPersonUpdateWithWhereUniqueWithoutEventInput = {
  data: EventPersonUpdateWithoutEventInput;
  where: EventPersonWhereUniqueInput;
};

export type EventPersonUpdateWithoutEventInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventPersonType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventPersonUpsertWithWhereUniqueWithoutEventInput = {
  create: EventPersonCreateWithoutEventInput;
  update: EventPersonUpdateWithoutEventInput;
  where: EventPersonWhereUniqueInput;
};

export type EventPersonWhereInput = {
  AND?: InputMaybe<Array<EventPersonWhereInput>>;
  NOT?: InputMaybe<Array<EventPersonWhereInput>>;
  OR?: InputMaybe<Array<EventPersonWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumEventPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EventPersonWhereUniqueInput = {
  AND?: InputMaybe<Array<EventPersonWhereInput>>;
  NOT?: InputMaybe<Array<EventPersonWhereInput>>;
  OR?: InputMaybe<Array<EventPersonWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumEventPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EventRelationFilter = {
  is?: InputMaybe<EventWhereInput>;
  isNot?: InputMaybe<EventWhereInput>;
};

export type EventReviewsResponse = {
  __typename?: 'EventReviewsResponse';
  count: Scalars['Int']['output'];
  items: Array<UserEvent>;
};

export enum EventScalarFieldEnum {
  Categories = 'categories',
  Content = 'content',
  CreatedAt = 'createdAt',
  Date = 'date',
  DisabilityProvisions = 'disabilityProvisions',
  Id = 'id',
  Image = 'image',
  IsAttendable = 'isAttendable',
  IsFeatured = 'isFeatured',
  IsPublished = 'isPublished',
  IsRestrictedToRegion = 'isRestrictedToRegion',
  IsReviewable = 'isReviewable',
  Location = 'location',
  MaxAttendees = 'maxAttendees',
  Name = 'name',
  Region = 'region',
  Slug = 'slug',
  TicketLink = 'ticketLink',
  Time = 'time',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type EventUpdateOneRequiredWithoutUserEventsNestedInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutUserEventsInput>;
  create?: InputMaybe<EventCreateWithoutUserEventsInput>;
  update?: InputMaybe<EventUpdateToOneWithWhereWithoutUserEventsInput>;
  upsert?: InputMaybe<EventUpsertWithoutUserEventsInput>;
};

export type EventUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<EventCreateWithoutNotificationInput>;
  delete?: InputMaybe<EventWhereInput>;
  disconnect?: InputMaybe<EventWhereInput>;
  update?: InputMaybe<EventUpdateToOneWithWhereWithoutNotificationInput>;
  upsert?: InputMaybe<EventUpsertWithoutNotificationInput>;
};

export type EventUpdateToOneWithWhereWithoutNotificationInput = {
  data: EventUpdateWithoutNotificationInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpdateToOneWithWhereWithoutUserEventsInput = {
  data: EventUpdateWithoutUserEventsInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpdateWithoutNotificationInput = {
  EventPerson?: InputMaybe<EventPersonUpdateManyWithoutEventNestedInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isAttendable?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRestrictedToRegion?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewable?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutEventNestedInput>;
};

export type EventUpdateWithoutUserEventsInput = {
  EventPerson?: InputMaybe<EventPersonUpdateManyWithoutEventNestedInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isAttendable?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRestrictedToRegion?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewable?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutEventNestedInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventUpsertWithoutNotificationInput = {
  create: EventCreateWithoutNotificationInput;
  update: EventUpdateWithoutNotificationInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpsertWithoutUserEventsInput = {
  create: EventCreateWithoutUserEventsInput;
  update: EventUpdateWithoutUserEventsInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventWhereInput = {
  AND?: InputMaybe<Array<EventWhereInput>>;
  EventPerson?: InputMaybe<EventPersonListRelationFilter>;
  NOT?: InputMaybe<Array<EventWhereInput>>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  categories?: InputMaybe<StringNullableListFilter>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  disabilityProvisions?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  isAttendable?: InputMaybe<BoolFilter>;
  isFeatured?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  isRestrictedToRegion?: InputMaybe<BoolFilter>;
  isReviewable?: InputMaybe<BoolFilter>;
  location?: InputMaybe<StringFilter>;
  maxAttendees?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  region?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  ticketLink?: InputMaybe<StringNullableFilter>;
  time?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEvents?: InputMaybe<UserEventListRelationFilter>;
};

export type EventWhereUniqueInput = {
  AND?: InputMaybe<Array<EventWhereInput>>;
  EventPerson?: InputMaybe<EventPersonListRelationFilter>;
  NOT?: InputMaybe<Array<EventWhereInput>>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  categories?: InputMaybe<StringNullableListFilter>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  disabilityProvisions?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  isAttendable?: InputMaybe<BoolFilter>;
  isFeatured?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  isRestrictedToRegion?: InputMaybe<BoolFilter>;
  isReviewable?: InputMaybe<BoolFilter>;
  location?: InputMaybe<StringFilter>;
  maxAttendees?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  region?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<StringNullableFilter>;
  time?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEvents?: InputMaybe<UserEventListRelationFilter>;
};

export type EventsResponse = {
  __typename?: 'EventsResponse';
  count: Scalars['Int']['output'];
  items: Array<Event>;
};

export type ExportActsInput = {
  category: Scalars['String']['input'];
  preliminaryPosition?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['String']['input'];
};

export type ExportUsersInput = {
  interests?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedProject = {
  __typename?: 'FeaturedProject';
  comments: CommentsResponse;
  creator: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type FeaturedProjectCommentsArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};

export type FeaturedProjectsResponse = {
  __typename?: 'FeaturedProjectsResponse';
  count: Scalars['Int']['output'];
  items: Array<FeaturedProject>;
};

export type Filters = {
  interests: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type GroupMember = {
  age: Scalars['Float']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvitationAct = {
  __typename?: 'InvitationAct';
  category?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  memberCount: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptActInvite: Scalars['Boolean']['output'];
  acceptConnection: Scalars['Boolean']['output'];
  adminUnAttendEvent: Scalars['Boolean']['output'];
  attendEvent: Scalars['Boolean']['output'];
  copyAct: Act;
  createAct: Act;
  createActAttachment: ActAttachment;
  createComment: Comment;
  createCompetition: Competition;
  createCompetitionPartner: CompetitionPartner;
  createCompetitionPerson: CompetitionPerson;
  createCompetitionPrize: CompetitionPrize;
  createCustomFeed: CustomFeed;
  createCustomNotifications: Scalars['Float']['output'];
  createEvent: Event;
  createEventPerson: EventPerson;
  createPage: Page;
  createPost: Post;
  createProject: Project;
  createProjectAdmin: Project;
  createRegionFinancer: RegionFinancer;
  createRegionPage: RegionPage;
  createRegionPartner: RegionPartner;
  createRegionPerson: RegionPerson;
  createTutorial: Tutorial;
  createUserPost: Scalars['Boolean']['output'];
  createUserTutorial: Scalars['Boolean']['output'];
  deleteActAttachment: Scalars['Boolean']['output'];
  destroyAct: Scalars['Boolean']['output'];
  destroyComment: Comment;
  destroyCompetition: Scalars['Boolean']['output'];
  destroyCompetitionPartner: Scalars['Boolean']['output'];
  destroyCompetitionPerson: Scalars['Boolean']['output'];
  destroyCompetitionPrize: Scalars['Boolean']['output'];
  destroyCustomFeed: Scalars['Boolean']['output'];
  destroyEvent: Scalars['Boolean']['output'];
  destroyEventPerson: Scalars['Boolean']['output'];
  destroyPage: Scalars['Boolean']['output'];
  destroyPost: Scalars['Boolean']['output'];
  destroyProject: Project;
  destroyRegionFinancer: Scalars['Boolean']['output'];
  destroyRegionPage: Scalars['Boolean']['output'];
  destroyRegionPartner: Scalars['Boolean']['output'];
  destroyRegionPerson: Scalars['Boolean']['output'];
  destroyTutorial: Scalars['Boolean']['output'];
  destroyUser: Scalars['Boolean']['output'];
  destroyUserTutorial: Scalars['Boolean']['output'];
  emailCompetitionApplicants: Scalars['Boolean']['output'];
  emailEventAttendees: Scalars['Boolean']['output'];
  exportActs: Scalars['Boolean']['output'];
  exportStats: Scalars['Boolean']['output'];
  exportUsers: Scalars['Boolean']['output'];
  finishActApplication: Act;
  forgotPassword: Scalars['Boolean']['output'];
  getBulkSignedS3UrlForPut?: Maybe<Array<SignedResponse>>;
  getSignedS3UrlForPut?: Maybe<SignedResponse>;
  inviteActMembers: Array<ActInvitation>;
  inviteActMembersAdmin: Array<ActInvitation>;
  login: AuthResponse;
  orderPromoPackage: Scalars['Boolean']['output'];
  register: AuthResponse;
  rejectActInvite: Scalars['Boolean']['output'];
  rejectConnection: Scalars['Boolean']['output'];
  removeActMember: Scalars['Boolean']['output'];
  removeConnection: Scalars['Boolean']['output'];
  requestConnection: Scalars['Boolean']['output'];
  resendActInvite: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  reviewEvent: Scalars['Boolean']['output'];
  shortRegister: AuthResponse;
  submitPinkPopForm: Scalars['Boolean']['output'];
  unAttendEvent: Scalars['Boolean']['output'];
  updateAct: Act;
  updateActAdmin: Act;
  updateActAttachment: ActAttachment;
  updateActFeedback: Act;
  updateComment: Comment;
  updateCompetition: Competition;
  updateCompetitionPartner: CompetitionPartner;
  updateCompetitionPerson: CompetitionPerson;
  updateCompetitionPrize: CompetitionPrize;
  updateCustomFeed: CustomFeed;
  updateEvent: Event;
  updateEventPerson: EventPerson;
  updateMe: User;
  updateNotification: Notification;
  updatePage: Page;
  updatePost: Post;
  updateProject: Project;
  updateRegionFinancer: RegionFinancer;
  updateRegionPage: RegionPage;
  updateRegionPartner: RegionPartner;
  updateRegionPerson: RegionPerson;
  updateTutorial: Tutorial;
  updateUser: User;
  updateUserAdmin: User;
  updateUserFromInvite: AuthResponse;
};


export type MutationAcceptActInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAcceptConnectionArgs = {
  followerId: Scalars['String']['input'];
};


export type MutationAdminUnAttendEventArgs = {
  eventId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAttendEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationCopyActArgs = {
  competitionId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationCreateActArgs = {
  data: ActCreateInput;
};


export type MutationCreateActAttachmentArgs = {
  data: ActAttachmentCreateInput;
};


export type MutationCreateCommentArgs = {
  data: CreateCommentInput;
};


export type MutationCreateCompetitionArgs = {
  data: CompetitionCreateInput;
};


export type MutationCreateCompetitionPartnerArgs = {
  data: CreateCompetitionPartnerInput;
};


export type MutationCreateCompetitionPersonArgs = {
  data: CreateCompetitionPersonInput;
};


export type MutationCreateCompetitionPrizeArgs = {
  data: CreateCompetitionPrizeInput;
};


export type MutationCreateCustomFeedArgs = {
  data: CustomFeedCreateInput;
};


export type MutationCreateCustomNotificationsArgs = {
  data: CreateCustomNotificationsInput;
};


export type MutationCreateEventArgs = {
  data: EventCreateInput;
};


export type MutationCreateEventPersonArgs = {
  data: CreateEventPersonInput;
};


export type MutationCreatePageArgs = {
  data: PageCreateInput;
};


export type MutationCreatePostArgs = {
  data: CreatePostInput;
};


export type MutationCreateProjectArgs = {
  data: ProjectCreateInput;
};


export type MutationCreateProjectAdminArgs = {
  creatorId: Scalars['String']['input'];
  data: ProjectCreateInput;
};


export type MutationCreateRegionFinancerArgs = {
  data: CreateRegionFinancerInput;
};


export type MutationCreateRegionPageArgs = {
  data: RegionPageCreateInput;
};


export type MutationCreateRegionPartnerArgs = {
  data: CreateRegionPartnerInput;
};


export type MutationCreateRegionPersonArgs = {
  data: CreateRegionPersonInput;
};


export type MutationCreateTutorialArgs = {
  data: CreateTutorialInput;
};


export type MutationCreateUserPostArgs = {
  postId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateUserTutorialArgs = {
  tutorialId: Scalars['String']['input'];
};


export type MutationDeleteActAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyActArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyCommentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyCompetitionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyCompetitionPartnerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyCompetitionPersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyCompetitionPrizeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyCustomFeedArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyEventArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyEventPersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyPageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyPostArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyProjectArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyRegionFinancerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyRegionPageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyRegionPartnerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyRegionPersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyTutorialArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyUserTutorialArgs = {
  tutorialId: Scalars['String']['input'];
};


export type MutationEmailCompetitionApplicantsArgs = {
  competitionId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationEmailEventAttendeesArgs = {
  eventId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationExportActsArgs = {
  filters: ExportActsInput;
  type: Scalars['String']['input'];
};


export type MutationExportStatsArgs = {
  filters: StatsInput;
};


export type MutationExportUsersArgs = {
  filters: ExportUsersInput;
  type: Scalars['String']['input'];
};


export type MutationFinishActApplicationArgs = {
  data: UpdateActInput;
  id: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGetBulkSignedS3UrlForPutArgs = {
  data: S3BulkSignedUrlInput;
};


export type MutationGetSignedS3UrlForPutArgs = {
  data: S3SignedUrlInput;
};


export type MutationInviteActMembersArgs = {
  actId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
};


export type MutationInviteActMembersAdminArgs = {
  actId: Scalars['String']['input'];
  data: Array<UpdateUserInput>;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationOrderPromoPackageArgs = {
  id: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  data: RegisterInput;
};


export type MutationRejectActInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRejectConnectionArgs = {
  followerId: Scalars['String']['input'];
};


export type MutationRemoveActMemberArgs = {
  id: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};


export type MutationRemoveConnectionArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRequestConnectionArgs = {
  userId: Scalars['String']['input'];
};


export type MutationResendActInviteArgs = {
  actId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  data: ResetPasswordInput;
};


export type MutationReviewEventArgs = {
  data: UpdateUserEventInput;
  eventId: Scalars['String']['input'];
};


export type MutationShortRegisterArgs = {
  data: ShortRegisterInput;
};


export type MutationSubmitPinkPopFormArgs = {
  data: PinkPopFormInput;
};


export type MutationUnAttendEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationUpdateActArgs = {
  data: UpdateActInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateActAdminArgs = {
  data: UpdateActAdminInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateActAttachmentArgs = {
  data: ActAttachmentUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateActFeedbackArgs = {
  data: UpdateActInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCommentArgs = {
  data: UpdateCommentInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCompetitionArgs = {
  data: UpdateCompetitionInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCompetitionPartnerArgs = {
  data: UpdateCompetitionPartnerInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCompetitionPersonArgs = {
  data: UpdateCompetitionPersonInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCompetitionPrizeArgs = {
  data: UpdateCompetitionPrizeInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCustomFeedArgs = {
  data: UpdateCustomFeedInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateEventArgs = {
  data: UpdateEventInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateEventPersonArgs = {
  data: UpdateEventPersonInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateMeArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateNotificationArgs = {
  data: UpdateNotificationInput;
  id: Scalars['String']['input'];
};


export type MutationUpdatePageArgs = {
  data: UpdatePageInput;
  id: Scalars['String']['input'];
};


export type MutationUpdatePostArgs = {
  data: UpdatePostInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateProjectArgs = {
  data: UpdateProjectInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateRegionFinancerArgs = {
  data: UpdateRegionFinancerInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateRegionPageArgs = {
  data: UpdateRegionPageInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateRegionPartnerArgs = {
  data: UpdateRegionPartnerInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateRegionPersonArgs = {
  data: UpdateRegionPersonInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTutorialArgs = {
  data: UpdateTutorialInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserAdminArgs = {
  data: UpdateUserAdminInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserFromInviteArgs = {
  data: RegisterFromInviteInput;
  id: Scalars['String']['input'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumActAttachmentTypeFilter = {
  equals?: InputMaybe<ActAttachmentType>;
  in?: InputMaybe<Array<ActAttachmentType>>;
  not?: InputMaybe<NestedEnumActAttachmentTypeFilter>;
  notIn?: InputMaybe<Array<ActAttachmentType>>;
};

export type NestedEnumActStatusFilter = {
  equals?: InputMaybe<ActStatus>;
  in?: InputMaybe<Array<ActStatus>>;
  not?: InputMaybe<NestedEnumActStatusFilter>;
  notIn?: InputMaybe<Array<ActStatus>>;
};

export type NestedEnumCompetitionPartnerTypeFilter = {
  equals?: InputMaybe<CompetitionPartnerType>;
  in?: InputMaybe<Array<CompetitionPartnerType>>;
  not?: InputMaybe<NestedEnumCompetitionPartnerTypeFilter>;
  notIn?: InputMaybe<Array<CompetitionPartnerType>>;
};

export type NestedEnumCompetitionPersonTypeFilter = {
  equals?: InputMaybe<CompetitionPersonType>;
  in?: InputMaybe<Array<CompetitionPersonType>>;
  not?: InputMaybe<NestedEnumCompetitionPersonTypeFilter>;
  notIn?: InputMaybe<Array<CompetitionPersonType>>;
};

export type NestedEnumConnectionStatusFilter = {
  equals?: InputMaybe<ConnectionStatus>;
  in?: InputMaybe<Array<ConnectionStatus>>;
  not?: InputMaybe<NestedEnumConnectionStatusFilter>;
  notIn?: InputMaybe<Array<ConnectionStatus>>;
};

export type NestedEnumEventPersonTypeFilter = {
  equals?: InputMaybe<EventPersonType>;
  in?: InputMaybe<Array<EventPersonType>>;
  not?: InputMaybe<NestedEnumEventPersonTypeFilter>;
  notIn?: InputMaybe<Array<EventPersonType>>;
};

export type NestedEnumNotificationTypeFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type NestedEnumPostTypeFilter = {
  equals?: InputMaybe<PostType>;
  in?: InputMaybe<Array<PostType>>;
  not?: InputMaybe<NestedEnumPostTypeFilter>;
  notIn?: InputMaybe<Array<PostType>>;
};

export type NestedEnumPrivacySettingFilter = {
  equals?: InputMaybe<PrivacySetting>;
  in?: InputMaybe<Array<PrivacySetting>>;
  not?: InputMaybe<NestedEnumPrivacySettingFilter>;
  notIn?: InputMaybe<Array<PrivacySetting>>;
};

export type NestedEnumRegionPersonTypeFilter = {
  equals?: InputMaybe<RegionPersonType>;
  in?: InputMaybe<Array<RegionPersonType>>;
  not?: InputMaybe<NestedEnumRegionPersonTypeFilter>;
  notIn?: InputMaybe<Array<RegionPersonType>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Notification = {
  __typename?: 'Notification';
  act?: Maybe<Act>;
  actId?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['String']['output']>;
  tutorial?: Maybe<Tutorial>;
  tutorialId?: Maybe<Scalars['String']['output']>;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type NotificationCreateManyActInput = {
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type NotificationCreateManyActInputEnvelope = {
  data: Array<NotificationCreateManyActInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyCommentInput = {
  actId?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type NotificationCreateManyCommentInputEnvelope = {
  data: Array<NotificationCreateManyCommentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyEventInput = {
  actId?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type NotificationCreateManyEventInputEnvelope = {
  data: Array<NotificationCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyPostInput = {
  actId?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type NotificationCreateManyPostInputEnvelope = {
  data: Array<NotificationCreateManyPostInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyProjectInput = {
  actId?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type NotificationCreateManyProjectInputEnvelope = {
  data: Array<NotificationCreateManyProjectInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyTutorialInput = {
  actId?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type NotificationCreateManyTutorialInputEnvelope = {
  data: Array<NotificationCreateManyTutorialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyUserInput = {
  actId?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tutorialId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyUserInputEnvelope = {
  data: Array<NotificationCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateNestedManyWithoutActInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutActInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutActInput>>;
  createMany?: InputMaybe<NotificationCreateManyActInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutCommentInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutCommentInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutCommentInput>>;
  createMany?: InputMaybe<NotificationCreateManyCommentInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutEventInput>>;
  createMany?: InputMaybe<NotificationCreateManyEventInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutPostInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutPostInput>>;
  createMany?: InputMaybe<NotificationCreateManyPostInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutProjectInput>>;
  createMany?: InputMaybe<NotificationCreateManyProjectInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutTutorialInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutTutorialInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutTutorialInput>>;
  createMany?: InputMaybe<NotificationCreateManyTutorialInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
};

export type NotificationCreateOrConnectWithoutActInput = {
  create: NotificationCreateWithoutActInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutCommentInput = {
  create: NotificationCreateWithoutCommentInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutEventInput = {
  create: NotificationCreateWithoutEventInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutPostInput = {
  create: NotificationCreateWithoutPostInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutProjectInput = {
  create: NotificationCreateWithoutProjectInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutTutorialInput = {
  create: NotificationCreateWithoutTutorialInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutUserInput = {
  create: NotificationCreateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateWithoutActInput = {
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventCreateNestedOneWithoutNotificationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostCreateNestedOneWithoutNotificationInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutNotificationInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutNotificationInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutNotificationInput;
};

export type NotificationCreateWithoutCommentInput = {
  act?: InputMaybe<ActCreateNestedOneWithoutNotificationInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventCreateNestedOneWithoutNotificationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostCreateNestedOneWithoutNotificationInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutNotificationInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutNotificationInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutNotificationInput;
};

export type NotificationCreateWithoutEventInput = {
  act?: InputMaybe<ActCreateNestedOneWithoutNotificationInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostCreateNestedOneWithoutNotificationInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutNotificationInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutNotificationInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutNotificationInput;
};

export type NotificationCreateWithoutPostInput = {
  act?: InputMaybe<ActCreateNestedOneWithoutNotificationInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventCreateNestedOneWithoutNotificationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutNotificationInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutNotificationInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutNotificationInput;
};

export type NotificationCreateWithoutProjectInput = {
  act?: InputMaybe<ActCreateNestedOneWithoutNotificationInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventCreateNestedOneWithoutNotificationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostCreateNestedOneWithoutNotificationInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutNotificationInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutNotificationInput;
};

export type NotificationCreateWithoutTutorialInput = {
  act?: InputMaybe<ActCreateNestedOneWithoutNotificationInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventCreateNestedOneWithoutNotificationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostCreateNestedOneWithoutNotificationInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutNotificationInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutNotificationInput;
};

export type NotificationCreateWithoutUserInput = {
  act?: InputMaybe<ActCreateNestedOneWithoutNotificationInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventCreateNestedOneWithoutNotificationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostCreateNestedOneWithoutNotificationInput>;
  project?: InputMaybe<ProjectCreateNestedOneWithoutNotificationInput>;
  tutorial?: InputMaybe<TutorialCreateNestedOneWithoutNotificationInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NotificationScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereInput>>;
  actId?: InputMaybe<UuidNullableFilter>;
  buttonUrl?: InputMaybe<StringNullableFilter>;
  commentId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isRead?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringNullableFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  projectId?: InputMaybe<UuidNullableFilter>;
  tutorialId?: InputMaybe<UuidNullableFilter>;
  type?: InputMaybe<EnumNotificationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export enum NotificationType {
  Comment = 'COMMENT',
  Custom = 'CUSTOM',
  EventAdded = 'EVENT_ADDED',
  Post = 'POST',
  ProjectAdded = 'PROJECT_ADDED',
  Tutorial = 'TUTORIAL',
  UpcomingCompetition = 'UPCOMING_COMPETITION',
  UpcomingEvent = 'UPCOMING_EVENT'
}

export type NotificationUpdateManyMutationInput = {
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUpdateManyWithWhereWithoutActInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutCommentInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutEventInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutPostInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutProjectInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutTutorialInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutUserInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithoutActNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutActInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutActInput>>;
  createMany?: InputMaybe<NotificationCreateManyActInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutActInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutActInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutActInput>>;
};

export type NotificationUpdateManyWithoutCommentNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutCommentInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutCommentInput>>;
  createMany?: InputMaybe<NotificationCreateManyCommentInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutCommentInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutCommentInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutCommentInput>>;
};

export type NotificationUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutEventInput>>;
  createMany?: InputMaybe<NotificationCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutEventInput>>;
};

export type NotificationUpdateManyWithoutPostNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutPostInput>>;
  createMany?: InputMaybe<NotificationCreateManyPostInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutPostInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutPostInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutPostInput>>;
};

export type NotificationUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutProjectInput>>;
  createMany?: InputMaybe<NotificationCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type NotificationUpdateManyWithoutTutorialNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutTutorialInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutTutorialInput>>;
  createMany?: InputMaybe<NotificationCreateManyTutorialInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutTutorialInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutTutorialInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutTutorialInput>>;
};

export type NotificationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type NotificationUpdateWithWhereUniqueWithoutActInput = {
  data: NotificationUpdateWithoutActInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutCommentInput = {
  data: NotificationUpdateWithoutCommentInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutEventInput = {
  data: NotificationUpdateWithoutEventInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutPostInput = {
  data: NotificationUpdateWithoutPostInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutProjectInput = {
  data: NotificationUpdateWithoutProjectInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutTutorialInput = {
  data: NotificationUpdateWithoutTutorialInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutUserInput = {
  data: NotificationUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithoutActInput = {
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneWithoutNotificationNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneWithoutNotificationNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutNotificationNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutNotificationNestedInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutCommentInput = {
  act?: InputMaybe<ActUpdateOneWithoutNotificationNestedInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneWithoutNotificationNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneWithoutNotificationNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutNotificationNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutNotificationNestedInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutEventInput = {
  act?: InputMaybe<ActUpdateOneWithoutNotificationNestedInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneWithoutNotificationNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutNotificationNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutNotificationNestedInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutPostInput = {
  act?: InputMaybe<ActUpdateOneWithoutNotificationNestedInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneWithoutNotificationNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<ProjectUpdateOneWithoutNotificationNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutNotificationNestedInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutProjectInput = {
  act?: InputMaybe<ActUpdateOneWithoutNotificationNestedInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneWithoutNotificationNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneWithoutNotificationNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutNotificationNestedInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutTutorialInput = {
  act?: InputMaybe<ActUpdateOneWithoutNotificationNestedInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneWithoutNotificationNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneWithoutNotificationNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutNotificationNestedInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutUserInput = {
  act?: InputMaybe<ActUpdateOneWithoutNotificationNestedInput>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<CommentUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneWithoutNotificationNestedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneWithoutNotificationNestedInput>;
  project?: InputMaybe<ProjectUpdateOneWithoutNotificationNestedInput>;
  tutorial?: InputMaybe<TutorialUpdateOneWithoutNotificationNestedInput>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUpsertWithWhereUniqueWithoutActInput = {
  create: NotificationCreateWithoutActInput;
  update: NotificationUpdateWithoutActInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutCommentInput = {
  create: NotificationCreateWithoutCommentInput;
  update: NotificationUpdateWithoutCommentInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutEventInput = {
  create: NotificationCreateWithoutEventInput;
  update: NotificationUpdateWithoutEventInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutPostInput = {
  create: NotificationCreateWithoutPostInput;
  update: NotificationUpdateWithoutPostInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutProjectInput = {
  create: NotificationCreateWithoutProjectInput;
  update: NotificationUpdateWithoutProjectInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutTutorialInput = {
  create: NotificationCreateWithoutTutorialInput;
  update: NotificationUpdateWithoutTutorialInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutUserInput = {
  create: NotificationCreateWithoutUserInput;
  update: NotificationUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  act?: InputMaybe<ActNullableRelationFilter>;
  actId?: InputMaybe<UuidNullableFilter>;
  buttonUrl?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<CommentNullableRelationFilter>;
  commentId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventNullableRelationFilter>;
  eventId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isRead?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostNullableRelationFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  project?: InputMaybe<ProjectNullableRelationFilter>;
  projectId?: InputMaybe<UuidNullableFilter>;
  tutorial?: InputMaybe<TutorialNullableRelationFilter>;
  tutorialId?: InputMaybe<UuidNullableFilter>;
  type?: InputMaybe<EnumNotificationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type NotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  act?: InputMaybe<ActNullableRelationFilter>;
  actId?: InputMaybe<UuidNullableFilter>;
  buttonUrl?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<CommentNullableRelationFilter>;
  commentId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventNullableRelationFilter>;
  eventId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostNullableRelationFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  project?: InputMaybe<ProjectNullableRelationFilter>;
  projectId?: InputMaybe<UuidNullableFilter>;
  tutorial?: InputMaybe<TutorialNullableRelationFilter>;
  tutorialId?: InputMaybe<UuidNullableFilter>;
  type?: InputMaybe<EnumNotificationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Page = {
  __typename?: 'Page';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PageCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageOrderByWithRelationInput = {
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PageScalarFieldEnum {
  Content = 'content',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  Slug = 'slug',
  UpdatedAt = 'updatedAt'
}

export type PageWhereInput = {
  AND?: InputMaybe<Array<PageWhereInput>>;
  NOT?: InputMaybe<Array<PageWhereInput>>;
  OR?: InputMaybe<Array<PageWhereInput>>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PageWhereUniqueInput = {
  AND?: InputMaybe<Array<PageWhereInput>>;
  NOT?: InputMaybe<Array<PageWhereInput>>;
  OR?: InputMaybe<Array<PageWhereInput>>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PagesResponse = {
  __typename?: 'PagesResponse';
  count: Scalars['Int']['output'];
  items: Array<Page>;
};

export type PinkPopFormInput = {
  age: Scalars['Float']['input'];
  coverBand: Scalars['String']['input'];
  coverSong: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groupMembers: Array<GroupMember>;
  lastName: Scalars['String']['input'];
  location: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  region: Scalars['String']['input'];
  video: Scalars['String']['input'];
};

export type Post = {
  __typename?: 'Post';
  _count?: Maybe<PostCount>;
  categories: Array<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  commenters: PostMatchedUsersResponse;
  comments: CommentsResponse;
  createdAt: Scalars['DateTime']['output'];
  deadline: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isClosed: Scalars['Boolean']['output'];
  matchedUsers: PostMatchedUsersResponse;
  region: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: PostType;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type PostCommentersArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type PostCommentsArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type PostMatchedUsersArgs = {
  cursor?: InputMaybe<UserPostWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPostWhereInput>;
};

export type PostCount = {
  __typename?: 'PostCount';
  comments: Scalars['Int']['output'];
  notification: Scalars['Int']['output'];
  userPosts: Scalars['Int']['output'];
};


export type PostCountCommentsArgs = {
  where?: InputMaybe<CommentWhereInput>;
};


export type PostCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type PostCountUserPostsArgs = {
  where?: InputMaybe<UserPostWhereInput>;
};

export type PostCreateManyUserInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  region: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostCreateManyUserInputEnvelope = {
  data: Array<PostCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PostCreateWithoutUserInput>>;
  createMany?: InputMaybe<PostCreateManyUserInputEnvelope>;
};

export type PostCreateNestedOneWithoutCommentsInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<PostCreateWithoutCommentsInput>;
};

export type PostCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<PostCreateWithoutNotificationInput>;
};

export type PostCreateNestedOneWithoutUserPostsInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutUserPostsInput>;
  create?: InputMaybe<PostCreateWithoutUserPostsInput>;
};

export type PostCreateOrConnectWithoutCommentsInput = {
  create: PostCreateWithoutCommentsInput;
  where: PostWhereUniqueInput;
};

export type PostCreateOrConnectWithoutNotificationInput = {
  create: PostCreateWithoutNotificationInput;
  where: PostWhereUniqueInput;
};

export type PostCreateOrConnectWithoutUserInput = {
  create: PostCreateWithoutUserInput;
  where: PostWhereUniqueInput;
};

export type PostCreateOrConnectWithoutUserPostsInput = {
  create: PostCreateWithoutUserPostsInput;
  where: PostWhereUniqueInput;
};

export type PostCreateWithoutCommentsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutPostInput>;
  region: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutPostsInput;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutPostInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostCreateWithoutNotificationInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutPostInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  region: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutPostsInput;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutPostInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostCreateWithoutUserInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutPostInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutPostInput>;
  region: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutPostInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostCreateWithoutUserPostsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutPostInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutPostInput>;
  region: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutPostsInput;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostListRelationFilter = {
  every?: InputMaybe<PostWhereInput>;
  none?: InputMaybe<PostWhereInput>;
  some?: InputMaybe<PostWhereInput>;
};

export type PostMatchedUsersResponse = {
  __typename?: 'PostMatchedUsersResponse';
  count: Scalars['Int']['output'];
  items: Array<User>;
};

export type PostNullableRelationFilter = {
  is?: InputMaybe<PostWhereInput>;
  isNot?: InputMaybe<PostWhereInput>;
};

export type PostOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PostOrderByWithRelationInput = {
  categories?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrderInput>;
  comments?: InputMaybe<CommentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deadline?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isClosed?: InputMaybe<SortOrder>;
  notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  region?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userPosts?: InputMaybe<UserPostOrderByRelationAggregateInput>;
  videoUrl?: InputMaybe<SortOrderInput>;
};

export type PostRelationFilter = {
  is?: InputMaybe<PostWhereInput>;
  isNot?: InputMaybe<PostWhereInput>;
};

export enum PostScalarFieldEnum {
  Categories = 'categories',
  Category = 'category',
  CreatedAt = 'createdAt',
  Deadline = 'deadline',
  Description = 'description',
  Id = 'id',
  IsClosed = 'isClosed',
  Region = 'region',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  VideoUrl = 'videoUrl'
}

export type PostScalarWhereInput = {
  AND?: InputMaybe<Array<PostScalarWhereInput>>;
  NOT?: InputMaybe<Array<PostScalarWhereInput>>;
  OR?: InputMaybe<Array<PostScalarWhereInput>>;
  categories?: InputMaybe<StringNullableListFilter>;
  category?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadline?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isClosed?: InputMaybe<BoolFilter>;
  region?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPostTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
};

export enum PostType {
  Looking = 'LOOKING',
  Offering = 'OFFERING'
}

export type PostUpdateManyMutationInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostUpdateManyWithWhereWithoutUserInput = {
  data: PostUpdateManyMutationInput;
  where: PostScalarWhereInput;
};

export type PostUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PostCreateWithoutUserInput>>;
  createMany?: InputMaybe<PostCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PostWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PostScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PostWhereUniqueInput>>;
  set?: InputMaybe<Array<PostWhereUniqueInput>>;
  update?: InputMaybe<Array<PostUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PostUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PostUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PostUpdateOneRequiredWithoutUserPostsNestedInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutUserPostsInput>;
  create?: InputMaybe<PostCreateWithoutUserPostsInput>;
  update?: InputMaybe<PostUpdateToOneWithWhereWithoutUserPostsInput>;
  upsert?: InputMaybe<PostUpsertWithoutUserPostsInput>;
};

export type PostUpdateOneWithoutCommentsNestedInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<PostCreateWithoutCommentsInput>;
  delete?: InputMaybe<PostWhereInput>;
  disconnect?: InputMaybe<PostWhereInput>;
  update?: InputMaybe<PostUpdateToOneWithWhereWithoutCommentsInput>;
  upsert?: InputMaybe<PostUpsertWithoutCommentsInput>;
};

export type PostUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<PostCreateWithoutNotificationInput>;
  delete?: InputMaybe<PostWhereInput>;
  disconnect?: InputMaybe<PostWhereInput>;
  update?: InputMaybe<PostUpdateToOneWithWhereWithoutNotificationInput>;
  upsert?: InputMaybe<PostUpsertWithoutNotificationInput>;
};

export type PostUpdateToOneWithWhereWithoutCommentsInput = {
  data: PostUpdateWithoutCommentsInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpdateToOneWithWhereWithoutNotificationInput = {
  data: PostUpdateWithoutNotificationInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpdateToOneWithWhereWithoutUserPostsInput = {
  data: PostUpdateWithoutUserPostsInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpdateWithWhereUniqueWithoutUserInput = {
  data: PostUpdateWithoutUserInput;
  where: PostWhereUniqueInput;
};

export type PostUpdateWithoutCommentsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutPostNestedInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPostsNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutPostNestedInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostUpdateWithoutNotificationInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutPostNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPostsNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutPostNestedInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostUpdateWithoutUserInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutPostNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutPostNestedInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutPostNestedInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostUpdateWithoutUserPostsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutPostNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutPostNestedInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPostsNestedInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PostUpsertWithWhereUniqueWithoutUserInput = {
  create: PostCreateWithoutUserInput;
  update: PostUpdateWithoutUserInput;
  where: PostWhereUniqueInput;
};

export type PostUpsertWithoutCommentsInput = {
  create: PostCreateWithoutCommentsInput;
  update: PostUpdateWithoutCommentsInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpsertWithoutNotificationInput = {
  create: PostCreateWithoutNotificationInput;
  update: PostUpdateWithoutNotificationInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpsertWithoutUserPostsInput = {
  create: PostCreateWithoutUserPostsInput;
  update: PostUpdateWithoutUserPostsInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostWhereInput = {
  AND?: InputMaybe<Array<PostWhereInput>>;
  NOT?: InputMaybe<Array<PostWhereInput>>;
  OR?: InputMaybe<Array<PostWhereInput>>;
  categories?: InputMaybe<StringNullableListFilter>;
  category?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadline?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isClosed?: InputMaybe<BoolFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  region?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPostTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
};

export type PostWhereUniqueInput = {
  AND?: InputMaybe<Array<PostWhereInput>>;
  NOT?: InputMaybe<Array<PostWhereInput>>;
  OR?: InputMaybe<Array<PostWhereInput>>;
  categories?: InputMaybe<StringNullableListFilter>;
  category?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadline?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<BoolFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  region?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPostTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
};

export type PostsResponse = {
  __typename?: 'PostsResponse';
  count: Scalars['Int']['output'];
  items: Array<Post>;
};

export enum PrivacySetting {
  Connections = 'CONNECTIONS',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Project = {
  __typename?: 'Project';
  _count?: Maybe<ProjectCount>;
  category?: Maybe<Scalars['String']['output']>;
  collaborators: UsersResponse;
  comments: CommentsResponse;
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isApproved: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  isSensitiveContent: Scalars['Boolean']['output'];
  pdf?: Maybe<Scalars['String']['output']>;
  privacySetting: PrivacySetting;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type ProjectCollaboratorsArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type ProjectCommentsArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};

export type ProjectCount = {
  __typename?: 'ProjectCount';
  collaborators: Scalars['Int']['output'];
  comments: Scalars['Int']['output'];
  notification: Scalars['Int']['output'];
};


export type ProjectCountCollaboratorsArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type ProjectCountCommentsArgs = {
  where?: InputMaybe<CommentWhereInput>;
};


export type ProjectCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};

export type ProjectCreateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<UserCreateNestedManyWithoutProjectCollaborationsInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutProjectsInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutProjectInput>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreateManyCreatorInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreateManyCreatorInputEnvelope = {
  data: Array<ProjectCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectCreateNestedManyWithoutCollaboratorsInput = {
  connect?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectCreateOrConnectWithoutCollaboratorsInput>>;
  create?: InputMaybe<Array<ProjectCreateWithoutCollaboratorsInput>>;
};

export type ProjectCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ProjectCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ProjectCreateManyCreatorInputEnvelope>;
};

export type ProjectCreateNestedOneWithoutCommentsInput = {
  connect?: InputMaybe<ProjectWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<ProjectCreateWithoutCommentsInput>;
};

export type ProjectCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<ProjectWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<ProjectCreateWithoutNotificationInput>;
};

export type ProjectCreateOrConnectWithoutCollaboratorsInput = {
  create: ProjectCreateWithoutCollaboratorsInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectCreateOrConnectWithoutCommentsInput = {
  create: ProjectCreateWithoutCommentsInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectCreateOrConnectWithoutCreatorInput = {
  create: ProjectCreateWithoutCreatorInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectCreateOrConnectWithoutNotificationInput = {
  create: ProjectCreateWithoutNotificationInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectCreateWithoutCollaboratorsInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutProjectsInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutProjectInput>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreateWithoutCommentsInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<UserCreateNestedManyWithoutProjectCollaborationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutProjectsInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutProjectInput>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreateWithoutCreatorInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<UserCreateNestedManyWithoutProjectCollaborationsInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutProjectInput>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreateWithoutNotificationInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<UserCreateNestedManyWithoutProjectCollaborationsInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator: UserCreateNestedOneWithoutProjectsInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectListRelationFilter = {
  every?: InputMaybe<ProjectWhereInput>;
  none?: InputMaybe<ProjectWhereInput>;
  some?: InputMaybe<ProjectWhereInput>;
};

export type ProjectNullableRelationFilter = {
  is?: InputMaybe<ProjectWhereInput>;
  isNot?: InputMaybe<ProjectWhereInput>;
};

export type ProjectOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectOrderByWithRelationInput = {
  category?: InputMaybe<SortOrderInput>;
  collaborators?: InputMaybe<UserOrderByRelationAggregateInput>;
  comments?: InputMaybe<CommentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  creator?: InputMaybe<UserOrderByWithRelationInput>;
  creatorId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrderInput>;
  isApproved?: InputMaybe<SortOrder>;
  isFeatured?: InputMaybe<SortOrder>;
  isSensitiveContent?: InputMaybe<SortOrder>;
  notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  pdf?: InputMaybe<SortOrderInput>;
  privacySetting?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export enum ProjectScalarFieldEnum {
  Category = 'category',
  CreatedAt = 'createdAt',
  CreatorId = 'creatorId',
  Description = 'description',
  Id = 'id',
  Image = 'image',
  IsApproved = 'isApproved',
  IsFeatured = 'isFeatured',
  IsSensitiveContent = 'isSensitiveContent',
  Pdf = 'pdf',
  PrivacySetting = 'privacySetting',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  Url = 'url'
}

export type ProjectScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectScalarWhereInput>>;
  category?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  isApproved?: InputMaybe<BoolFilter>;
  isFeatured?: InputMaybe<BoolFilter>;
  isSensitiveContent?: InputMaybe<BoolFilter>;
  pdf?: InputMaybe<StringNullableFilter>;
  privacySetting?: InputMaybe<EnumPrivacySettingFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ProjectUpdateManyMutationInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectUpdateManyWithWhereWithoutCollaboratorsInput = {
  data: ProjectUpdateManyMutationInput;
  where: ProjectScalarWhereInput;
};

export type ProjectUpdateManyWithWhereWithoutCreatorInput = {
  data: ProjectUpdateManyMutationInput;
  where: ProjectScalarWhereInput;
};

export type ProjectUpdateManyWithoutCollaboratorsNestedInput = {
  connect?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectCreateOrConnectWithoutCollaboratorsInput>>;
  create?: InputMaybe<Array<ProjectCreateWithoutCollaboratorsInput>>;
  delete?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectUpdateWithWhereUniqueWithoutCollaboratorsInput>>;
  updateMany?: InputMaybe<Array<ProjectUpdateManyWithWhereWithoutCollaboratorsInput>>;
  upsert?: InputMaybe<Array<ProjectUpsertWithWhereUniqueWithoutCollaboratorsInput>>;
};

export type ProjectUpdateManyWithoutCreatorNestedInput = {
  connect?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ProjectCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ProjectCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<ProjectUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<ProjectUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type ProjectUpdateOneWithoutCommentsNestedInput = {
  connect?: InputMaybe<ProjectWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<ProjectCreateWithoutCommentsInput>;
  delete?: InputMaybe<ProjectWhereInput>;
  disconnect?: InputMaybe<ProjectWhereInput>;
  update?: InputMaybe<ProjectUpdateToOneWithWhereWithoutCommentsInput>;
  upsert?: InputMaybe<ProjectUpsertWithoutCommentsInput>;
};

export type ProjectUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<ProjectWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<ProjectCreateWithoutNotificationInput>;
  delete?: InputMaybe<ProjectWhereInput>;
  disconnect?: InputMaybe<ProjectWhereInput>;
  update?: InputMaybe<ProjectUpdateToOneWithWhereWithoutNotificationInput>;
  upsert?: InputMaybe<ProjectUpsertWithoutNotificationInput>;
};

export type ProjectUpdateToOneWithWhereWithoutCommentsInput = {
  data: ProjectUpdateWithoutCommentsInput;
  where?: InputMaybe<ProjectWhereInput>;
};

export type ProjectUpdateToOneWithWhereWithoutNotificationInput = {
  data: ProjectUpdateWithoutNotificationInput;
  where?: InputMaybe<ProjectWhereInput>;
};

export type ProjectUpdateWithWhereUniqueWithoutCollaboratorsInput = {
  data: ProjectUpdateWithoutCollaboratorsInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectUpdateWithWhereUniqueWithoutCreatorInput = {
  data: ProjectUpdateWithoutCreatorInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectUpdateWithoutCollaboratorsInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutProjectsNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutProjectNestedInput>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectUpdateWithoutCommentsInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<UserUpdateManyWithoutProjectCollaborationsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutProjectsNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutProjectNestedInput>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectUpdateWithoutCreatorInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<UserUpdateManyWithoutProjectCollaborationsNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutProjectNestedInput>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectUpdateWithoutNotificationInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<UserUpdateManyWithoutProjectCollaborationsNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutProjectsNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectUpsertWithWhereUniqueWithoutCollaboratorsInput = {
  create: ProjectCreateWithoutCollaboratorsInput;
  update: ProjectUpdateWithoutCollaboratorsInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectUpsertWithWhereUniqueWithoutCreatorInput = {
  create: ProjectCreateWithoutCreatorInput;
  update: ProjectUpdateWithoutCreatorInput;
  where: ProjectWhereUniqueInput;
};

export type ProjectUpsertWithoutCommentsInput = {
  create: ProjectCreateWithoutCommentsInput;
  update: ProjectUpdateWithoutCommentsInput;
  where?: InputMaybe<ProjectWhereInput>;
};

export type ProjectUpsertWithoutNotificationInput = {
  create: ProjectCreateWithoutNotificationInput;
  update: ProjectUpdateWithoutNotificationInput;
  where?: InputMaybe<ProjectWhereInput>;
};

export type ProjectWhereInput = {
  AND?: InputMaybe<Array<ProjectWhereInput>>;
  NOT?: InputMaybe<Array<ProjectWhereInput>>;
  OR?: InputMaybe<Array<ProjectWhereInput>>;
  category?: InputMaybe<StringNullableFilter>;
  collaborators?: InputMaybe<UserListRelationFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserRelationFilter>;
  creatorId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  isApproved?: InputMaybe<BoolFilter>;
  isFeatured?: InputMaybe<BoolFilter>;
  isSensitiveContent?: InputMaybe<BoolFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  pdf?: InputMaybe<StringNullableFilter>;
  privacySetting?: InputMaybe<EnumPrivacySettingFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ProjectWhereUniqueInput = {
  AND?: InputMaybe<Array<ProjectWhereInput>>;
  NOT?: InputMaybe<Array<ProjectWhereInput>>;
  OR?: InputMaybe<Array<ProjectWhereInput>>;
  category?: InputMaybe<StringNullableFilter>;
  collaborators?: InputMaybe<UserListRelationFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserRelationFilter>;
  creatorId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  isApproved?: InputMaybe<BoolFilter>;
  isFeatured?: InputMaybe<BoolFilter>;
  isSensitiveContent?: InputMaybe<BoolFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  pdf?: InputMaybe<StringNullableFilter>;
  privacySetting?: InputMaybe<EnumPrivacySettingFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ProjectsResponse = {
  __typename?: 'ProjectsResponse';
  count: Scalars['Int']['output'];
  items: Array<Project>;
};

export type Query = {
  __typename?: 'Query';
  act?: Maybe<Act>;
  actAttachments: ActAttachmentsResponse;
  actCount?: Maybe<Scalars['Float']['output']>;
  actInvitation?: Maybe<ActInvitation>;
  actMembersCount?: Maybe<Scalars['Float']['output']>;
  actSignUpsByDay: Array<SignUpByWeek>;
  acts: ActsResponse;
  actsByAge: Array<ActsByAge>;
  actsByCategory: Array<ActsByCategory>;
  actsByStatus: Array<ActsByStatus>;
  competition?: Maybe<Competition>;
  competitions: CompetitionsResponse;
  customFeed?: Maybe<CustomFeed>;
  event?: Maybe<Event>;
  eventAttendeeCount?: Maybe<Scalars['Float']['output']>;
  eventCount?: Maybe<Scalars['Float']['output']>;
  eventForReview?: Maybe<Event>;
  events: EventsResponse;
  featuredProjects: FeaturedProjectsResponse;
  finalCompetition?: Maybe<Competition>;
  getSignedS3UrlForGet?: Maybe<Scalars['String']['output']>;
  me?: Maybe<User>;
  notifications: Array<Notification>;
  page?: Maybe<Page>;
  pages: PagesResponse;
  pendingActInvitations: Array<ActInvitation>;
  post?: Maybe<Post>;
  postCommentCount?: Maybe<Scalars['Float']['output']>;
  postCount?: Maybe<Scalars['Float']['output']>;
  postMatchCount?: Maybe<Scalars['Float']['output']>;
  posts: PostsResponse;
  profileStats: StatsResponse;
  project?: Maybe<Project>;
  projectCommentCount?: Maybe<Scalars['Float']['output']>;
  projectCount?: Maybe<Scalars['Float']['output']>;
  projects: ProjectsResponse;
  publicUsers: UsersResponse;
  refreshToken?: Maybe<RefreshTokenResponse>;
  regionPage?: Maybe<RegionPage>;
  regionPages: RegionPagesResponse;
  tutorial?: Maybe<Tutorial>;
  tutorialCommentCount?: Maybe<Scalars['Float']['output']>;
  tutorialCompletedCount?: Maybe<Scalars['Float']['output']>;
  tutorialCount?: Maybe<Scalars['Float']['output']>;
  tutorials: TutorialsResponse;
  upcomingFinalDate?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userCount: Scalars['Float']['output'];
  userSignUpsByDay: Array<SignUpByWeek>;
  users: UsersResponse;
  usersByAge: Array<UsersByAge>;
  usersBySchoolType: Array<UsersBySchoolType>;
};


export type QueryActArgs = {
  id: Scalars['String']['input'];
};


export type QueryActAttachmentsArgs = {
  cursor?: InputMaybe<ActAttachmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActAttachmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActAttachmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActAttachmentWhereInput>;
};


export type QueryActCountArgs = {
  data: StatsInput;
};


export type QueryActInvitationArgs = {
  id: Scalars['String']['input'];
};


export type QueryActMembersCountArgs = {
  data: StatsInput;
};


export type QueryActSignUpsByDayArgs = {
  data: StatsInput;
};


export type QueryActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type QueryActsByAgeArgs = {
  data: StatsInput;
};


export type QueryActsByCategoryArgs = {
  data: StatsInput;
};


export type QueryActsByStatusArgs = {
  data: StatsInput;
};


export type QueryCompetitionArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCompetitionsArgs = {
  cursor?: InputMaybe<CompetitionWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompetitionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompetitionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompetitionWhereInput>;
};


export type QueryEventArgs = {
  slug: Scalars['String']['input'];
};


export type QueryEventAttendeeCountArgs = {
  data: StatsInput;
};


export type QueryEventCountArgs = {
  data: StatsInput;
};


export type QueryEventForReviewArgs = {
  slug: Scalars['String']['input'];
};


export type QueryEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<Array<EventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryFeaturedProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type QueryFinalCompetitionArgs = {
  year: Scalars['Float']['input'];
};


export type QueryGetSignedS3UrlForGetArgs = {
  key: Scalars['String']['input'];
};


export type QueryPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPagesArgs = {
  cursor?: InputMaybe<PageWhereUniqueInput>;
  distinct?: InputMaybe<Array<PageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryPostArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostCommentCountArgs = {
  data: StatsInput;
};


export type QueryPostCountArgs = {
  data: StatsInput;
};


export type QueryPostMatchCountArgs = {
  data: StatsInput;
};


export type QueryPostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostWhereInput>;
};


export type QueryProfileStatsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryProjectCommentCountArgs = {
  data: StatsInput;
};


export type QueryProjectCountArgs = {
  data: StatsInput;
};


export type QueryProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type QueryPublicUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type QueryRegionPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRegionPagesArgs = {
  cursor?: InputMaybe<RegionPageWhereUniqueInput>;
  distinct?: InputMaybe<Array<RegionPageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RegionPageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionPageWhereInput>;
};


export type QueryTutorialArgs = {
  id: Scalars['String']['input'];
};


export type QueryTutorialCommentCountArgs = {
  data: StatsInput;
};


export type QueryTutorialCompletedCountArgs = {
  data: StatsInput;
};


export type QueryTutorialCountArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryTutorialsArgs = {
  cursor?: InputMaybe<TutorialWhereUniqueInput>;
  distinct?: InputMaybe<Array<TutorialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TutorialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TutorialWhereInput>;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserCountArgs = {
  data: StatsInput;
};


export type QueryUserSignUpsByDayArgs = {
  data: StatsInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersByAgeArgs = {
  data: StatsInput;
};


export type QueryUsersBySchoolTypeArgs = {
  data: StatsInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RefreshTokenResponse = {
  __typename?: 'RefreshTokenResponse';
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type RegionFinancer = {
  __typename?: 'RegionFinancer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  regionPageId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RegionFinancerCreateManyRegionPageInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type RegionFinancerCreateManyRegionPageInputEnvelope = {
  data: Array<RegionFinancerCreateManyRegionPageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegionFinancerCreateNestedManyWithoutRegionPageInput = {
  connect?: InputMaybe<Array<RegionFinancerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegionFinancerCreateOrConnectWithoutRegionPageInput>>;
  create?: InputMaybe<Array<RegionFinancerCreateWithoutRegionPageInput>>;
  createMany?: InputMaybe<RegionFinancerCreateManyRegionPageInputEnvelope>;
};

export type RegionFinancerCreateOrConnectWithoutRegionPageInput = {
  create: RegionFinancerCreateWithoutRegionPageInput;
  where: RegionFinancerWhereUniqueInput;
};

export type RegionFinancerCreateWithoutRegionPageInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type RegionFinancerListRelationFilter = {
  every?: InputMaybe<RegionFinancerWhereInput>;
  none?: InputMaybe<RegionFinancerWhereInput>;
  some?: InputMaybe<RegionFinancerWhereInput>;
};

export type RegionFinancerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RegionFinancerWhereInput = {
  AND?: InputMaybe<Array<RegionFinancerWhereInput>>;
  NOT?: InputMaybe<Array<RegionFinancerWhereInput>>;
  OR?: InputMaybe<Array<RegionFinancerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringFilter>;
  regionPage?: InputMaybe<RegionPageRelationFilter>;
  regionPageId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type RegionFinancerWhereUniqueInput = {
  AND?: InputMaybe<Array<RegionFinancerWhereInput>>;
  NOT?: InputMaybe<Array<RegionFinancerWhereInput>>;
  OR?: InputMaybe<Array<RegionFinancerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringFilter>;
  regionPage?: InputMaybe<RegionPageRelationFilter>;
  regionPageId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type RegionPage = {
  __typename?: 'RegionPage';
  _count?: Maybe<RegionPageCount>;
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  regionFinancers: Array<RegionFinancer>;
  regionPartners: Array<RegionPartner>;
  regionPeople: Array<RegionPerson>;
  slug: Scalars['String']['output'];
  tiktok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  whatsapp?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type RegionPageCount = {
  __typename?: 'RegionPageCount';
  regionFinancers: Scalars['Int']['output'];
  regionPartners: Scalars['Int']['output'];
  regionPeople: Scalars['Int']['output'];
};


export type RegionPageCountRegionFinancersArgs = {
  where?: InputMaybe<RegionFinancerWhereInput>;
};


export type RegionPageCountRegionPartnersArgs = {
  where?: InputMaybe<RegionPartnerWhereInput>;
};


export type RegionPageCountRegionPeopleArgs = {
  where?: InputMaybe<RegionPersonWhereInput>;
};

export type RegionPageCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  regionFinancers?: InputMaybe<RegionFinancerCreateNestedManyWithoutRegionPageInput>;
  regionPartners?: InputMaybe<RegionPartnerCreateNestedManyWithoutRegionPageInput>;
  regionPeople?: InputMaybe<RegionPersonCreateNestedManyWithoutRegionPageInput>;
  slug: Scalars['String']['input'];
  tiktok?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type RegionPageOrderByWithRelationInput = {
  address?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  facebook?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrderInput>;
  instagram?: InputMaybe<SortOrderInput>;
  linkedin?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  regionFinancers?: InputMaybe<RegionFinancerOrderByRelationAggregateInput>;
  regionPartners?: InputMaybe<RegionPartnerOrderByRelationAggregateInput>;
  regionPeople?: InputMaybe<RegionPersonOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  tiktok?: InputMaybe<SortOrderInput>;
  twitter?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  whatsapp?: InputMaybe<SortOrderInput>;
  youtube?: InputMaybe<SortOrderInput>;
};

export type RegionPageRelationFilter = {
  is?: InputMaybe<RegionPageWhereInput>;
  isNot?: InputMaybe<RegionPageWhereInput>;
};

export enum RegionPageScalarFieldEnum {
  Address = 'address',
  CreatedAt = 'createdAt',
  Description = 'description',
  Email = 'email',
  Facebook = 'facebook',
  Id = 'id',
  Image = 'image',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Name = 'name',
  Phone = 'phone',
  Slug = 'slug',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  UpdatedAt = 'updatedAt',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube'
}

export type RegionPageWhereInput = {
  AND?: InputMaybe<Array<RegionPageWhereInput>>;
  NOT?: InputMaybe<Array<RegionPageWhereInput>>;
  OR?: InputMaybe<Array<RegionPageWhereInput>>;
  address?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  facebook?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  instagram?: InputMaybe<StringNullableFilter>;
  linkedin?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  regionFinancers?: InputMaybe<RegionFinancerListRelationFilter>;
  regionPartners?: InputMaybe<RegionPartnerListRelationFilter>;
  regionPeople?: InputMaybe<RegionPersonListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  tiktok?: InputMaybe<StringNullableFilter>;
  twitter?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  whatsapp?: InputMaybe<StringNullableFilter>;
  youtube?: InputMaybe<StringNullableFilter>;
};

export type RegionPageWhereUniqueInput = {
  AND?: InputMaybe<Array<RegionPageWhereInput>>;
  NOT?: InputMaybe<Array<RegionPageWhereInput>>;
  OR?: InputMaybe<Array<RegionPageWhereInput>>;
  address?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  facebook?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  instagram?: InputMaybe<StringNullableFilter>;
  linkedin?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  regionFinancers?: InputMaybe<RegionFinancerListRelationFilter>;
  regionPartners?: InputMaybe<RegionPartnerListRelationFilter>;
  regionPeople?: InputMaybe<RegionPersonListRelationFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<StringNullableFilter>;
  twitter?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  whatsapp?: InputMaybe<StringNullableFilter>;
  youtube?: InputMaybe<StringNullableFilter>;
};

export type RegionPagesResponse = {
  __typename?: 'RegionPagesResponse';
  count: Scalars['Int']['output'];
  items: Array<RegionPage>;
};

export type RegionPartner = {
  __typename?: 'RegionPartner';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  regionPageId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RegionPartnerCreateManyRegionPageInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type RegionPartnerCreateManyRegionPageInputEnvelope = {
  data: Array<RegionPartnerCreateManyRegionPageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegionPartnerCreateNestedManyWithoutRegionPageInput = {
  connect?: InputMaybe<Array<RegionPartnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegionPartnerCreateOrConnectWithoutRegionPageInput>>;
  create?: InputMaybe<Array<RegionPartnerCreateWithoutRegionPageInput>>;
  createMany?: InputMaybe<RegionPartnerCreateManyRegionPageInputEnvelope>;
};

export type RegionPartnerCreateOrConnectWithoutRegionPageInput = {
  create: RegionPartnerCreateWithoutRegionPageInput;
  where: RegionPartnerWhereUniqueInput;
};

export type RegionPartnerCreateWithoutRegionPageInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type RegionPartnerListRelationFilter = {
  every?: InputMaybe<RegionPartnerWhereInput>;
  none?: InputMaybe<RegionPartnerWhereInput>;
  some?: InputMaybe<RegionPartnerWhereInput>;
};

export type RegionPartnerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RegionPartnerWhereInput = {
  AND?: InputMaybe<Array<RegionPartnerWhereInput>>;
  NOT?: InputMaybe<Array<RegionPartnerWhereInput>>;
  OR?: InputMaybe<Array<RegionPartnerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringFilter>;
  regionPage?: InputMaybe<RegionPageRelationFilter>;
  regionPageId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type RegionPartnerWhereUniqueInput = {
  AND?: InputMaybe<Array<RegionPartnerWhereInput>>;
  NOT?: InputMaybe<Array<RegionPartnerWhereInput>>;
  OR?: InputMaybe<Array<RegionPartnerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringFilter>;
  regionPage?: InputMaybe<RegionPageRelationFilter>;
  regionPageId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type RegionPerson = {
  __typename?: 'RegionPerson';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  regionPageId: Scalars['String']['output'];
  type: RegionPersonType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RegionPersonCreateManyRegionPageInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: RegionPersonType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegionPersonCreateManyRegionPageInputEnvelope = {
  data: Array<RegionPersonCreateManyRegionPageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegionPersonCreateNestedManyWithoutRegionPageInput = {
  connect?: InputMaybe<Array<RegionPersonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegionPersonCreateOrConnectWithoutRegionPageInput>>;
  create?: InputMaybe<Array<RegionPersonCreateWithoutRegionPageInput>>;
  createMany?: InputMaybe<RegionPersonCreateManyRegionPageInputEnvelope>;
};

export type RegionPersonCreateOrConnectWithoutRegionPageInput = {
  create: RegionPersonCreateWithoutRegionPageInput;
  where: RegionPersonWhereUniqueInput;
};

export type RegionPersonCreateWithoutRegionPageInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: RegionPersonType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegionPersonListRelationFilter = {
  every?: InputMaybe<RegionPersonWhereInput>;
  none?: InputMaybe<RegionPersonWhereInput>;
  some?: InputMaybe<RegionPersonWhereInput>;
};

export type RegionPersonOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum RegionPersonType {
  Ambassador = 'AMBASSADOR',
  Coach = 'COACH',
  Jongerenraad = 'JONGERENRAAD',
  RaadVanToezicht = 'RAAD_VAN_TOEZICHT',
  Team = 'TEAM'
}

export type RegionPersonWhereInput = {
  AND?: InputMaybe<Array<RegionPersonWhereInput>>;
  NOT?: InputMaybe<Array<RegionPersonWhereInput>>;
  OR?: InputMaybe<Array<RegionPersonWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  regionPage?: InputMaybe<RegionPageRelationFilter>;
  regionPageId?: InputMaybe<UuidFilter>;
  type?: InputMaybe<EnumRegionPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RegionPersonWhereUniqueInput = {
  AND?: InputMaybe<Array<RegionPersonWhereInput>>;
  NOT?: InputMaybe<Array<RegionPersonWhereInput>>;
  OR?: InputMaybe<Array<RegionPersonWhereInput>>;
  bio?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  regionPage?: InputMaybe<RegionPageRelationFilter>;
  regionPageId?: InputMaybe<UuidFilter>;
  type?: InputMaybe<EnumRegionPersonTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RegisterFromInviteInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16: Scalars['Boolean']['input'];
  isParentNotified: Scalars['Boolean']['input'];
  isPrivacyCheckAccepted: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  residence?: InputMaybe<Scalars['String']['input']>;
  school: Scalars['String']['input'];
  telephone: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export type S3BulkSignedUrlInput = {
  files: Array<S3SignedUrlInput>;
};

export type S3SignedUrlInput = {
  fileType: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ShortRegisterInput = {
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isOver16: Scalars['Boolean']['input'];
  isParentNotified: Scalars['Boolean']['input'];
  isPrivacyCheckAccepted: Scalars['Boolean']['input'];
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  region: Scalars['String']['input'];
  telephone: Scalars['String']['input'];
};

export type SignUpByWeek = {
  __typename?: 'SignUpByWeek';
  count?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['String']['output']>;
};

export type SignedResponse = {
  __typename?: 'SignedResponse';
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StatsInput = {
  endDate: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type StatsResponse = {
  __typename?: 'StatsResponse';
  competitions: Scalars['Float']['output'];
  events: Scalars['Float']['output'];
  posts: Scalars['Float']['output'];
  projects: Scalars['Float']['output'];
  tutorials: Scalars['Float']['output'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Tutorial = {
  __typename?: 'Tutorial';
  _count?: Maybe<TutorialCount>;
  categories: Array<Scalars['String']['output']>;
  comments: CommentsResponse;
  completedUsers: TutorialCompletedUsersResponse;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  difficultyRating?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['String']['output'];
  hasCompleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  instructor: Scalars['String']['output'];
  isLive: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoUrl: Scalars['String']['output'];
  viewCount?: Maybe<Scalars['String']['output']>;
};


export type TutorialCommentsArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type TutorialCompletedUsersArgs = {
  cursor?: InputMaybe<UserTutorialWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTutorialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTutorialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserTutorialWhereInput>;
};

export type TutorialCompletedUser = {
  __typename?: 'TutorialCompletedUser';
  _count?: Maybe<UserCount>;
  acceptedInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  acts: ActsResponse;
  address?: Maybe<Scalars['String']['output']>;
  agenda: Array<AgendaItem>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  commentedOnPosts: Array<Post>;
  completedTutorialsCount: Scalars['Float']['output'];
  connectionProjects: ProjectsResponse;
  connectionStatus?: Maybe<Scalars['String']['output']>;
  connections: Array<UserConnection>;
  connectionsCount: Scalars['Float']['output'];
  contactPreference?: Maybe<Scalars['String']['output']>;
  createdActs: Array<Act>;
  createdActsCount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  customSlug?: Maybe<Scalars['String']['output']>;
  dateCompleted: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  events: EventsResponse;
  eventsCount: Scalars['Float']['output'];
  eventsPendingReview: Array<Event>;
  firstName?: Maybe<Scalars['String']['output']>;
  foundVia?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasOrderedPromoPackage: Scalars['Boolean']['output'];
  hasPendingFeedback: Scalars['Boolean']['output'];
  howDidYouHear?: Maybe<Scalars['String']['output']>;
  howDidYouHearMulti: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  interests: Array<Scalars['String']['output']>;
  isConnected: Scalars['Boolean']['output'];
  isOver16: Scalars['Boolean']['output'];
  isParentNotified: Scalars['Boolean']['output'];
  isPrivacyCheckAccepted: Scalars['Boolean']['output'];
  isTooOld: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  matchedOnPosts: Array<Post>;
  notes?: Maybe<Scalars['String']['output']>;
  parentEmail?: Maybe<Scalars['String']['output']>;
  pendingConnections: Array<UserConnection>;
  pendingInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  postcode?: Maybe<Scalars['String']['output']>;
  posts: Array<Post>;
  postsCount: Scalars['Float']['output'];
  privacySetting: PrivacySetting;
  profileIncomplete: Scalars['Boolean']['output'];
  projects: ProjectsResponse;
  pronouns?: Maybe<Scalars['String']['output']>;
  pronounsMulti: Array<Scalars['String']['output']>;
  pronounsOther?: Maybe<Scalars['String']['output']>;
  reasonForSigningUp?: Maybe<Scalars['String']['output']>;
  recommendedConnections: Array<User>;
  recommendedEvents: Array<Event>;
  recommendedPosts: PostsResponse;
  recommendedTutorials: Array<Tutorial>;
  region?: Maybe<Scalars['String']['output']>;
  rejectedInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  residence?: Maybe<Scalars['String']['output']>;
  role: Role;
  school?: Maybe<Scalars['String']['output']>;
  schoolType?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  tutorials: TutorialsResponse;
  updatedAt: Scalars['DateTime']['output'];
};


export type TutorialCompletedUserActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type TutorialCompletedUserConnectionProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type TutorialCompletedUserConnectionsArgs = {
  cursor?: InputMaybe<ConnectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConnectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConnectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConnectionWhereInput>;
};


export type TutorialCompletedUserCreatedActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type TutorialCompletedUserEventsArgs = {
  cursor?: InputMaybe<UserEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserEventWhereInput>;
};


export type TutorialCompletedUserPendingConnectionsArgs = {
  cursor?: InputMaybe<ConnectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConnectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConnectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConnectionWhereInput>;
};


export type TutorialCompletedUserPostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostWhereInput>;
};


export type TutorialCompletedUserProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type TutorialCompletedUserRecommendedPostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostWhereInput>;
};


export type TutorialCompletedUserTutorialsArgs = {
  cursor?: InputMaybe<UserTutorialWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTutorialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTutorialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserTutorialWhereInput>;
};

export type TutorialCompletedUsersResponse = {
  __typename?: 'TutorialCompletedUsersResponse';
  count: Scalars['Int']['output'];
  items: Array<TutorialCompletedUser>;
};

export type TutorialCount = {
  __typename?: 'TutorialCount';
  comments: Scalars['Int']['output'];
  notification: Scalars['Int']['output'];
  userTutorials: Scalars['Int']['output'];
};


export type TutorialCountCommentsArgs = {
  where?: InputMaybe<CommentWhereInput>;
};


export type TutorialCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type TutorialCountUserTutorialsArgs = {
  where?: InputMaybe<UserTutorialWhereInput>;
};

export type TutorialCreateNestedOneWithoutCommentsInput = {
  connect?: InputMaybe<TutorialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TutorialCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<TutorialCreateWithoutCommentsInput>;
};

export type TutorialCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<TutorialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TutorialCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<TutorialCreateWithoutNotificationInput>;
};

export type TutorialCreateNestedOneWithoutUserTutorialsInput = {
  connect?: InputMaybe<TutorialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TutorialCreateOrConnectWithoutUserTutorialsInput>;
  create?: InputMaybe<TutorialCreateWithoutUserTutorialsInput>;
};

export type TutorialCreateOrConnectWithoutCommentsInput = {
  create: TutorialCreateWithoutCommentsInput;
  where: TutorialWhereUniqueInput;
};

export type TutorialCreateOrConnectWithoutNotificationInput = {
  create: TutorialCreateWithoutNotificationInput;
  where: TutorialWhereUniqueInput;
};

export type TutorialCreateOrConnectWithoutUserTutorialsInput = {
  create: TutorialCreateWithoutUserTutorialsInput;
  where: TutorialWhereUniqueInput;
};

export type TutorialCreateWithoutCommentsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  difficultyRating?: InputMaybe<Scalars['Int']['input']>;
  duration: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  instructor: Scalars['String']['input'];
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutTutorialInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutTutorialInput>;
  videoUrl: Scalars['String']['input'];
};

export type TutorialCreateWithoutNotificationInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutTutorialInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  difficultyRating?: InputMaybe<Scalars['Int']['input']>;
  duration: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  instructor: Scalars['String']['input'];
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutTutorialInput>;
  videoUrl: Scalars['String']['input'];
};

export type TutorialCreateWithoutUserTutorialsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutTutorialInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  difficultyRating?: InputMaybe<Scalars['Int']['input']>;
  duration: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  instructor: Scalars['String']['input'];
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutTutorialInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl: Scalars['String']['input'];
};

export type TutorialNullableRelationFilter = {
  is?: InputMaybe<TutorialWhereInput>;
  isNot?: InputMaybe<TutorialWhereInput>;
};

export type TutorialOrderByWithRelationInput = {
  categories?: InputMaybe<SortOrder>;
  comments?: InputMaybe<CommentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  difficultyRating?: InputMaybe<SortOrderInput>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instructor?: InputMaybe<SortOrder>;
  isLive?: InputMaybe<SortOrder>;
  notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userTutorials?: InputMaybe<UserTutorialOrderByRelationAggregateInput>;
  videoUrl?: InputMaybe<SortOrder>;
};

export type TutorialRelationFilter = {
  is?: InputMaybe<TutorialWhereInput>;
  isNot?: InputMaybe<TutorialWhereInput>;
};

export enum TutorialScalarFieldEnum {
  Categories = 'categories',
  CreatedAt = 'createdAt',
  Description = 'description',
  DifficultyRating = 'difficultyRating',
  Duration = 'duration',
  Id = 'id',
  Instructor = 'instructor',
  IsLive = 'isLive',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  VideoUrl = 'videoUrl'
}

export type TutorialUpdateOneRequiredWithoutUserTutorialsNestedInput = {
  connect?: InputMaybe<TutorialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TutorialCreateOrConnectWithoutUserTutorialsInput>;
  create?: InputMaybe<TutorialCreateWithoutUserTutorialsInput>;
  update?: InputMaybe<TutorialUpdateToOneWithWhereWithoutUserTutorialsInput>;
  upsert?: InputMaybe<TutorialUpsertWithoutUserTutorialsInput>;
};

export type TutorialUpdateOneWithoutCommentsNestedInput = {
  connect?: InputMaybe<TutorialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TutorialCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<TutorialCreateWithoutCommentsInput>;
  delete?: InputMaybe<TutorialWhereInput>;
  disconnect?: InputMaybe<TutorialWhereInput>;
  update?: InputMaybe<TutorialUpdateToOneWithWhereWithoutCommentsInput>;
  upsert?: InputMaybe<TutorialUpsertWithoutCommentsInput>;
};

export type TutorialUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<TutorialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TutorialCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<TutorialCreateWithoutNotificationInput>;
  delete?: InputMaybe<TutorialWhereInput>;
  disconnect?: InputMaybe<TutorialWhereInput>;
  update?: InputMaybe<TutorialUpdateToOneWithWhereWithoutNotificationInput>;
  upsert?: InputMaybe<TutorialUpsertWithoutNotificationInput>;
};

export type TutorialUpdateToOneWithWhereWithoutCommentsInput = {
  data: TutorialUpdateWithoutCommentsInput;
  where?: InputMaybe<TutorialWhereInput>;
};

export type TutorialUpdateToOneWithWhereWithoutNotificationInput = {
  data: TutorialUpdateWithoutNotificationInput;
  where?: InputMaybe<TutorialWhereInput>;
};

export type TutorialUpdateToOneWithWhereWithoutUserTutorialsInput = {
  data: TutorialUpdateWithoutUserTutorialsInput;
  where?: InputMaybe<TutorialWhereInput>;
};

export type TutorialUpdateWithoutCommentsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficultyRating?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructor?: InputMaybe<Scalars['String']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutTutorialNestedInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutTutorialNestedInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TutorialUpdateWithoutNotificationInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<CommentUpdateManyWithoutTutorialNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficultyRating?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructor?: InputMaybe<Scalars['String']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutTutorialNestedInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TutorialUpdateWithoutUserTutorialsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<CommentUpdateManyWithoutTutorialNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficultyRating?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructor?: InputMaybe<Scalars['String']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutTutorialNestedInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TutorialUpsertWithoutCommentsInput = {
  create: TutorialCreateWithoutCommentsInput;
  update: TutorialUpdateWithoutCommentsInput;
  where?: InputMaybe<TutorialWhereInput>;
};

export type TutorialUpsertWithoutNotificationInput = {
  create: TutorialCreateWithoutNotificationInput;
  update: TutorialUpdateWithoutNotificationInput;
  where?: InputMaybe<TutorialWhereInput>;
};

export type TutorialUpsertWithoutUserTutorialsInput = {
  create: TutorialCreateWithoutUserTutorialsInput;
  update: TutorialUpdateWithoutUserTutorialsInput;
  where?: InputMaybe<TutorialWhereInput>;
};

export type TutorialWhereInput = {
  AND?: InputMaybe<Array<TutorialWhereInput>>;
  NOT?: InputMaybe<Array<TutorialWhereInput>>;
  OR?: InputMaybe<Array<TutorialWhereInput>>;
  categories?: InputMaybe<StringNullableListFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  difficultyRating?: InputMaybe<IntNullableFilter>;
  duration?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  instructor?: InputMaybe<StringFilter>;
  isLive?: InputMaybe<BoolFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userTutorials?: InputMaybe<UserTutorialListRelationFilter>;
  videoUrl?: InputMaybe<StringFilter>;
};

export type TutorialWhereUniqueInput = {
  AND?: InputMaybe<Array<TutorialWhereInput>>;
  NOT?: InputMaybe<Array<TutorialWhereInput>>;
  OR?: InputMaybe<Array<TutorialWhereInput>>;
  categories?: InputMaybe<StringNullableListFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  difficultyRating?: InputMaybe<IntNullableFilter>;
  duration?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructor?: InputMaybe<StringFilter>;
  isLive?: InputMaybe<BoolFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userTutorials?: InputMaybe<UserTutorialListRelationFilter>;
  videoUrl?: InputMaybe<StringFilter>;
};

export type TutorialsResponse = {
  __typename?: 'TutorialsResponse';
  count: Scalars['Int']['output'];
  items: Array<Tutorial>;
};

export type UpdateActAdminInput = {
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['String']['input']>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackUpload?: InputMaybe<Scalars['String']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Float']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Float']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  musicStart?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Float']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateActInput = {
  areVisualsUsedNew?: InputMaybe<Scalars['String']['input']>;
  artworkDimensions?: InputMaybe<Scalars['String']['input']>;
  artworkMaterial?: InputMaybe<Scalars['String']['input']>;
  artworkSize?: InputMaybe<Scalars['String']['input']>;
  artworkStand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  contactStatus?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  decor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djEquipment?: InputMaybe<Scalars['String']['input']>;
  djSoftware?: InputMaybe<Scalars['String']['input']>;
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  extraLightingInformation?: InputMaybe<Scalars['String']['input']>;
  extraMaterial?: InputMaybe<Scalars['String']['input']>;
  extraMusicInstruments?: InputMaybe<Array<Scalars['String']['input']>>;
  extraVisualsInformation?: InputMaybe<Scalars['String']['input']>;
  feedbackSeen?: InputMaybe<Scalars['Boolean']['input']>;
  filmVideoFormat?: InputMaybe<Scalars['String']['input']>;
  finalPosition?: InputMaybe<Scalars['Float']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hasGivenLivestreamConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntroSong?: InputMaybe<Scalars['Boolean']['input']>;
  hasSelfProducedTracks?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentFilm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentMusic?: InputMaybe<Scalars['Boolean']['input']>;
  hasSentVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableAfterCompetitionClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfDjSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfFilmSet?: InputMaybe<Scalars['String']['input']>;
  lengthOfSet?: InputMaybe<Scalars['String']['input']>;
  lightingAtEnd?: InputMaybe<Scalars['String']['input']>;
  lightingInstructions?: InputMaybe<Scalars['String']['input']>;
  lightingSettings?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Float']['input']>;
  microphoneCount?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  musicInstructions?: InputMaybe<Scalars['String']['input']>;
  musicStart?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfArtworksPieces?: InputMaybe<Scalars['String']['input']>;
  ownDjEquipment?: InputMaybe<Scalars['String']['input']>;
  ownMusicInstruments?: InputMaybe<Scalars['String']['input']>;
  preliminaryPosition?: InputMaybe<Scalars['Float']['input']>;
  presentationText?: InputMaybe<Scalars['String']['input']>;
  requiresDjLaptop?: InputMaybe<Scalars['Boolean']['input']>;
  requiresMusicNew?: InputMaybe<Scalars['String']['input']>;
  selfDescription?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  visualsVideoFormat?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentInput = {
  isPrivate: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
};

export type UpdateCompetitionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineContentCreator?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDJ?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDans?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineExpo?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFashion?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineFilm?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineMuziek?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTaal?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTheater?: InputMaybe<Scalars['DateTime']['input']>;
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  firstRoundDate?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  shopLink?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCompetitionPartnerInput = {
  competitionId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompetitionPartnerType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompetitionPersonInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  competitionId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompetitionPersonType>;
};

export type UpdateCompetitionPrizeInput = {
  category: Scalars['String']['input'];
  competitionId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCustomFeedInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  disabilityProvisions?: InputMaybe<Array<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  isAttendable?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRestrictedToRegion?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewable?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maxAttendees?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  ticketLink?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventPersonInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventPersonType>;
};

export type UpdateNotificationInput = {
  isRead: Scalars['Boolean']['input'];
};

export type UpdatePageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePostInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collaboratorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent?: InputMaybe<Scalars['Boolean']['input']>;
  pdf?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRegionFinancerInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  regionPageId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRegionPageInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  regionPageId?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRegionPartnerInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  regionPageId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRegionPersonInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regionPageId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RegionPersonType>;
};

export type UpdateTutorialInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficultyRating?: InputMaybe<Scalars['Float']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  instructor?: InputMaybe<Scalars['String']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserAdminInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserEventInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  _count?: Maybe<UserCount>;
  acceptedInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  acts: ActsResponse;
  address?: Maybe<Scalars['String']['output']>;
  agenda: Array<AgendaItem>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  commentedOnPosts: Array<Post>;
  completedTutorialsCount: Scalars['Float']['output'];
  connectionProjects: ProjectsResponse;
  connectionStatus?: Maybe<Scalars['String']['output']>;
  connections: Array<UserConnection>;
  connectionsCount: Scalars['Float']['output'];
  contactPreference?: Maybe<Scalars['String']['output']>;
  createdActs: Array<Act>;
  createdActsCount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  customSlug?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  events: EventsResponse;
  eventsCount: Scalars['Float']['output'];
  eventsPendingReview: Array<Event>;
  firstName?: Maybe<Scalars['String']['output']>;
  foundVia?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasOrderedPromoPackage: Scalars['Boolean']['output'];
  hasPendingFeedback: Scalars['Boolean']['output'];
  howDidYouHear?: Maybe<Scalars['String']['output']>;
  howDidYouHearMulti: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  interests: Array<Scalars['String']['output']>;
  isConnected: Scalars['Boolean']['output'];
  isOver16: Scalars['Boolean']['output'];
  isParentNotified: Scalars['Boolean']['output'];
  isPrivacyCheckAccepted: Scalars['Boolean']['output'];
  isTooOld: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  matchedOnPosts: Array<Post>;
  notes?: Maybe<Scalars['String']['output']>;
  parentEmail?: Maybe<Scalars['String']['output']>;
  pendingConnections: Array<UserConnection>;
  pendingInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  postcode?: Maybe<Scalars['String']['output']>;
  posts: Array<Post>;
  postsCount: Scalars['Float']['output'];
  privacySetting: PrivacySetting;
  profileIncomplete: Scalars['Boolean']['output'];
  projects: ProjectsResponse;
  pronouns?: Maybe<Scalars['String']['output']>;
  pronounsMulti: Array<Scalars['String']['output']>;
  pronounsOther?: Maybe<Scalars['String']['output']>;
  reasonForSigningUp?: Maybe<Scalars['String']['output']>;
  recommendedConnections: Array<User>;
  recommendedEvents: Array<Event>;
  recommendedPosts: PostsResponse;
  recommendedTutorials: Array<Tutorial>;
  region?: Maybe<Scalars['String']['output']>;
  rejectedInvitationIds?: Maybe<Array<Scalars['String']['output']>>;
  residence?: Maybe<Scalars['String']['output']>;
  role: Role;
  school?: Maybe<Scalars['String']['output']>;
  schoolType?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  tutorials: TutorialsResponse;
  updatedAt: Scalars['DateTime']['output'];
};


export type UserActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type UserConnectionProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type UserConnectionsArgs = {
  cursor?: InputMaybe<ConnectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConnectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConnectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConnectionWhereInput>;
};


export type UserCreatedActsArgs = {
  cursor?: InputMaybe<ActWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActWhereInput>;
};


export type UserEventsArgs = {
  cursor?: InputMaybe<UserEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserEventWhereInput>;
};


export type UserPendingConnectionsArgs = {
  cursor?: InputMaybe<ConnectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConnectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConnectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConnectionWhereInput>;
};


export type UserPostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostWhereInput>;
};


export type UserProjectsArgs = {
  cursor?: InputMaybe<ProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
};


export type UserRecommendedPostsArgs = {
  cursor?: InputMaybe<PostWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostWhereInput>;
};


export type UserTutorialsArgs = {
  cursor?: InputMaybe<UserTutorialWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTutorialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTutorialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserTutorialWhereInput>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  createdAt: Scalars['DateTime']['output'];
  follower: User;
  id: Scalars['String']['output'];
  status: ConnectionStatus;
  user: User;
};

export type UserCount = {
  __typename?: 'UserCount';
  ActInvitation: Scalars['Int']['output'];
  acts: Scalars['Int']['output'];
  attachments: Scalars['Int']['output'];
  comments: Scalars['Int']['output'];
  createdActs: Scalars['Int']['output'];
  followers: Scalars['Int']['output'];
  following: Scalars['Int']['output'];
  notification: Scalars['Int']['output'];
  posts: Scalars['Int']['output'];
  projectCollaborations: Scalars['Int']['output'];
  projects: Scalars['Int']['output'];
  userEvents: Scalars['Int']['output'];
  userPosts: Scalars['Int']['output'];
  userTutorials: Scalars['Int']['output'];
};


export type UserCountActInvitationArgs = {
  where?: InputMaybe<ActInvitationWhereInput>;
};


export type UserCountActsArgs = {
  where?: InputMaybe<ActWhereInput>;
};


export type UserCountAttachmentsArgs = {
  where?: InputMaybe<ActAttachmentWhereInput>;
};


export type UserCountCommentsArgs = {
  where?: InputMaybe<CommentWhereInput>;
};


export type UserCountCreatedActsArgs = {
  where?: InputMaybe<ActWhereInput>;
};


export type UserCountFollowersArgs = {
  where?: InputMaybe<ConnectionWhereInput>;
};


export type UserCountFollowingArgs = {
  where?: InputMaybe<ConnectionWhereInput>;
};


export type UserCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type UserCountPostsArgs = {
  where?: InputMaybe<PostWhereInput>;
};


export type UserCountProjectCollaborationsArgs = {
  where?: InputMaybe<ProjectWhereInput>;
};


export type UserCountProjectsArgs = {
  where?: InputMaybe<ProjectWhereInput>;
};


export type UserCountUserEventsArgs = {
  where?: InputMaybe<UserEventWhereInput>;
};


export type UserCountUserPostsArgs = {
  where?: InputMaybe<UserPostWhereInput>;
};


export type UserCountUserTutorialsArgs = {
  where?: InputMaybe<UserTutorialWhereInput>;
};

export type UserCreateNestedManyWithoutActsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutActsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutActsInput>>;
};

export type UserCreateNestedManyWithoutProjectCollaborationsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutProjectCollaborationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutProjectCollaborationsInput>>;
};

export type UserCreateNestedOneWithoutActInvitationInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutActInvitationInput>;
  create?: InputMaybe<UserCreateWithoutActInvitationInput>;
};

export type UserCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<UserCreateWithoutAttachmentsInput>;
};

export type UserCreateNestedOneWithoutCommentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<UserCreateWithoutCommentsInput>;
};

export type UserCreateNestedOneWithoutCreatedActsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedActsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedActsInput>;
};

export type UserCreateNestedOneWithoutFollowersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFollowersInput>;
  create?: InputMaybe<UserCreateWithoutFollowersInput>;
};

export type UserCreateNestedOneWithoutFollowingInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFollowingInput>;
  create?: InputMaybe<UserCreateWithoutFollowingInput>;
};

export type UserCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<UserCreateWithoutNotificationInput>;
};

export type UserCreateNestedOneWithoutPostsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPostsInput>;
  create?: InputMaybe<UserCreateWithoutPostsInput>;
};

export type UserCreateNestedOneWithoutProjectsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProjectsInput>;
  create?: InputMaybe<UserCreateWithoutProjectsInput>;
};

export type UserCreateNestedOneWithoutUserEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserEventsInput>;
  create?: InputMaybe<UserCreateWithoutUserEventsInput>;
};

export type UserCreateNestedOneWithoutUserPostsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserPostsInput>;
  create?: InputMaybe<UserCreateWithoutUserPostsInput>;
};

export type UserCreateNestedOneWithoutUserTutorialsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserTutorialsInput>;
  create?: InputMaybe<UserCreateWithoutUserTutorialsInput>;
};

export type UserCreateOrConnectWithoutActInvitationInput = {
  create: UserCreateWithoutActInvitationInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutActsInput = {
  create: UserCreateWithoutActsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAttachmentsInput = {
  create: UserCreateWithoutAttachmentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCommentsInput = {
  create: UserCreateWithoutCommentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedActsInput = {
  create: UserCreateWithoutCreatedActsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFollowersInput = {
  create: UserCreateWithoutFollowersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFollowingInput = {
  create: UserCreateWithoutFollowingInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotificationInput = {
  create: UserCreateWithoutNotificationInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPostsInput = {
  create: UserCreateWithoutPostsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProjectCollaborationsInput = {
  create: UserCreateWithoutProjectCollaborationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProjectsInput = {
  create: UserCreateWithoutProjectsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserEventsInput = {
  create: UserCreateWithoutUserEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserPostsInput = {
  create: UserCreateWithoutUserPostsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserTutorialsInput = {
  create: UserCreateWithoutUserTutorialsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutActInvitationInput = {
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutActsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutAttachmentsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCommentsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCreatedActsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutFollowersInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutFollowingInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutNotificationInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutPostsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutProjectCollaborationsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutProjectsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserEventsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserPostsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userTutorials?: InputMaybe<UserTutorialCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserTutorialsInput = {
  ActInvitation?: InputMaybe<ActInvitationCreateNestedManyWithoutUserInput>;
  acts?: InputMaybe<ActCreateNestedManyWithoutMembersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentCreateNestedManyWithoutUploaderInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutUserInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActCreateNestedManyWithoutCreatorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionCreateNestedManyWithoutFollowerInput>;
  following?: InputMaybe<ConnectionCreateNestedManyWithoutUserInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostCreateNestedManyWithoutUserInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectCreateNestedManyWithoutCollaboratorsInput>;
  projects?: InputMaybe<ProjectCreateNestedManyWithoutCreatorInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventCreateNestedManyWithoutUserInput>;
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutUserInput>;
};

export type UserEvent = {
  __typename?: 'UserEvent';
  activityComments?: Maybe<Scalars['String']['output']>;
  activityRating?: Maybe<Scalars['String']['output']>;
  dateAttended: Scalars['DateTime']['output'];
  eventId: Scalars['String']['output'];
  generalFeedback?: Maybe<Scalars['String']['output']>;
  howDidYouHear?: Maybe<Scalars['String']['output']>;
  locationComments?: Maybe<Scalars['String']['output']>;
  tutorComments?: Maybe<Scalars['String']['output']>;
  tutorRating?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserEventCreateManyEventInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  dateAttended?: InputMaybe<Scalars['DateTime']['input']>;
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserEventCreateManyEventInputEnvelope = {
  data: Array<UserEventCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserEventCreateManyUserInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  dateAttended?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
};

export type UserEventCreateManyUserInputEnvelope = {
  data: Array<UserEventCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserEventCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserEventCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<UserEventCreateWithoutEventInput>>;
  createMany?: InputMaybe<UserEventCreateManyEventInputEnvelope>;
};

export type UserEventCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserEventCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserEventCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserEventCreateManyUserInputEnvelope>;
};

export type UserEventCreateOrConnectWithoutEventInput = {
  create: UserEventCreateWithoutEventInput;
  where: UserEventWhereUniqueInput;
};

export type UserEventCreateOrConnectWithoutUserInput = {
  create: UserEventCreateWithoutUserInput;
  where: UserEventWhereUniqueInput;
};

export type UserEventCreateWithoutEventInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  dateAttended?: InputMaybe<Scalars['DateTime']['input']>;
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutUserEventsInput;
};

export type UserEventCreateWithoutUserInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  dateAttended?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutUserEventsInput;
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
};

export type UserEventListRelationFilter = {
  every?: InputMaybe<UserEventWhereInput>;
  none?: InputMaybe<UserEventWhereInput>;
  some?: InputMaybe<UserEventWhereInput>;
};

export type UserEventOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserEventOrderByWithRelationInput = {
  activityComments?: InputMaybe<SortOrderInput>;
  activityRating?: InputMaybe<SortOrderInput>;
  dateAttended?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  generalFeedback?: InputMaybe<SortOrderInput>;
  howDidYouHear?: InputMaybe<SortOrderInput>;
  locationComments?: InputMaybe<SortOrderInput>;
  tutorComments?: InputMaybe<SortOrderInput>;
  tutorRating?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserEventScalarFieldEnum {
  ActivityComments = 'activityComments',
  ActivityRating = 'activityRating',
  DateAttended = 'dateAttended',
  EventId = 'eventId',
  GeneralFeedback = 'generalFeedback',
  HowDidYouHear = 'howDidYouHear',
  LocationComments = 'locationComments',
  TutorComments = 'tutorComments',
  TutorRating = 'tutorRating',
  UserId = 'userId'
}

export type UserEventScalarWhereInput = {
  AND?: InputMaybe<Array<UserEventScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserEventScalarWhereInput>>;
  OR?: InputMaybe<Array<UserEventScalarWhereInput>>;
  activityComments?: InputMaybe<StringNullableFilter>;
  activityRating?: InputMaybe<StringNullableFilter>;
  dateAttended?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<UuidFilter>;
  generalFeedback?: InputMaybe<StringNullableFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  locationComments?: InputMaybe<StringNullableFilter>;
  tutorComments?: InputMaybe<StringNullableFilter>;
  tutorRating?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserEventUpdateManyMutationInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  dateAttended?: InputMaybe<Scalars['DateTime']['input']>;
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
};

export type UserEventUpdateManyWithWhereWithoutEventInput = {
  data: UserEventUpdateManyMutationInput;
  where: UserEventScalarWhereInput;
};

export type UserEventUpdateManyWithWhereWithoutUserInput = {
  data: UserEventUpdateManyMutationInput;
  where: UserEventScalarWhereInput;
};

export type UserEventUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserEventCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<UserEventCreateWithoutEventInput>>;
  createMany?: InputMaybe<UserEventCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserEventScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  set?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  update?: InputMaybe<Array<UserEventUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<UserEventUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<UserEventUpsertWithWhereUniqueWithoutEventInput>>;
};

export type UserEventUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserEventCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserEventCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserEventCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserEventScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  set?: InputMaybe<Array<UserEventWhereUniqueInput>>;
  update?: InputMaybe<Array<UserEventUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserEventUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserEventUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserEventUpdateWithWhereUniqueWithoutEventInput = {
  data: UserEventUpdateWithoutEventInput;
  where: UserEventWhereUniqueInput;
};

export type UserEventUpdateWithWhereUniqueWithoutUserInput = {
  data: UserEventUpdateWithoutUserInput;
  where: UserEventWhereUniqueInput;
};

export type UserEventUpdateWithoutEventInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  dateAttended?: InputMaybe<Scalars['DateTime']['input']>;
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserEventsNestedInput>;
};

export type UserEventUpdateWithoutUserInput = {
  activityComments?: InputMaybe<Scalars['String']['input']>;
  activityRating?: InputMaybe<Scalars['String']['input']>;
  dateAttended?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutUserEventsNestedInput>;
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  locationComments?: InputMaybe<Scalars['String']['input']>;
  tutorComments?: InputMaybe<Scalars['String']['input']>;
  tutorRating?: InputMaybe<Scalars['String']['input']>;
};

export type UserEventUpsertWithWhereUniqueWithoutEventInput = {
  create: UserEventCreateWithoutEventInput;
  update: UserEventUpdateWithoutEventInput;
  where: UserEventWhereUniqueInput;
};

export type UserEventUpsertWithWhereUniqueWithoutUserInput = {
  create: UserEventCreateWithoutUserInput;
  update: UserEventUpdateWithoutUserInput;
  where: UserEventWhereUniqueInput;
};

export type UserEventUserIdEventIdCompoundUniqueInput = {
  eventId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserEventWhereInput = {
  AND?: InputMaybe<Array<UserEventWhereInput>>;
  NOT?: InputMaybe<Array<UserEventWhereInput>>;
  OR?: InputMaybe<Array<UserEventWhereInput>>;
  activityComments?: InputMaybe<StringNullableFilter>;
  activityRating?: InputMaybe<StringNullableFilter>;
  dateAttended?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  generalFeedback?: InputMaybe<StringNullableFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  locationComments?: InputMaybe<StringNullableFilter>;
  tutorComments?: InputMaybe<StringNullableFilter>;
  tutorRating?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserEventWhereUniqueInput = {
  AND?: InputMaybe<Array<UserEventWhereInput>>;
  NOT?: InputMaybe<Array<UserEventWhereInput>>;
  OR?: InputMaybe<Array<UserEventWhereInput>>;
  activityComments?: InputMaybe<StringNullableFilter>;
  activityRating?: InputMaybe<StringNullableFilter>;
  dateAttended?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  generalFeedback?: InputMaybe<StringNullableFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  locationComments?: InputMaybe<StringNullableFilter>;
  tutorComments?: InputMaybe<StringNullableFilter>;
  tutorRating?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userId_eventId?: InputMaybe<UserEventUserIdEventIdCompoundUniqueInput>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserNullableRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  ActInvitation?: InputMaybe<ActInvitationOrderByRelationAggregateInput>;
  acts?: InputMaybe<ActOrderByRelationAggregateInput>;
  address?: InputMaybe<SortOrderInput>;
  archivedAt?: InputMaybe<SortOrderInput>;
  attachments?: InputMaybe<ActAttachmentOrderByRelationAggregateInput>;
  avatar?: InputMaybe<SortOrderInput>;
  bio?: InputMaybe<SortOrderInput>;
  comments?: InputMaybe<CommentOrderByRelationAggregateInput>;
  contactPreference?: InputMaybe<SortOrderInput>;
  createdActs?: InputMaybe<ActOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customSlug?: InputMaybe<SortOrderInput>;
  dateOfBirth?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  followers?: InputMaybe<ConnectionOrderByRelationAggregateInput>;
  following?: InputMaybe<ConnectionOrderByRelationAggregateInput>;
  foundVia?: InputMaybe<SortOrderInput>;
  fullName?: InputMaybe<SortOrderInput>;
  gender?: InputMaybe<SortOrderInput>;
  hasOrderedPromoPackage?: InputMaybe<SortOrder>;
  howDidYouHear?: InputMaybe<SortOrderInput>;
  howDidYouHearMulti?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instagram?: InputMaybe<SortOrderInput>;
  interests?: InputMaybe<SortOrder>;
  isOver16?: InputMaybe<SortOrder>;
  isParentNotified?: InputMaybe<SortOrder>;
  isPrivacyCheckAccepted?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  notes?: InputMaybe<SortOrderInput>;
  notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  parentEmail?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrder>;
  postcode?: InputMaybe<SortOrderInput>;
  posts?: InputMaybe<PostOrderByRelationAggregateInput>;
  privacySetting?: InputMaybe<SortOrder>;
  projectCollaborations?: InputMaybe<ProjectOrderByRelationAggregateInput>;
  projects?: InputMaybe<ProjectOrderByRelationAggregateInput>;
  pronouns?: InputMaybe<SortOrderInput>;
  pronounsMulti?: InputMaybe<SortOrder>;
  pronounsOther?: InputMaybe<SortOrderInput>;
  reasonForSigningUp?: InputMaybe<SortOrderInput>;
  region?: InputMaybe<SortOrderInput>;
  residence?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  school?: InputMaybe<SortOrderInput>;
  schoolType?: InputMaybe<SortOrderInput>;
  telephone?: InputMaybe<SortOrderInput>;
  tiktok?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userEvents?: InputMaybe<UserEventOrderByRelationAggregateInput>;
  userPosts?: InputMaybe<UserPostOrderByRelationAggregateInput>;
  userTutorials?: InputMaybe<UserTutorialOrderByRelationAggregateInput>;
};

export type UserPostCreateManyPostInput = {
  dummy?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserPostCreateManyPostInputEnvelope = {
  data: Array<UserPostCreateManyPostInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPostCreateManyUserInput = {
  dummy?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};

export type UserPostCreateManyUserInputEnvelope = {
  data: Array<UserPostCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPostCreateNestedManyWithoutPostInput = {
  connect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPostCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<UserPostCreateWithoutPostInput>>;
  createMany?: InputMaybe<UserPostCreateManyPostInputEnvelope>;
};

export type UserPostCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPostCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserPostCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserPostCreateManyUserInputEnvelope>;
};

export type UserPostCreateOrConnectWithoutPostInput = {
  create: UserPostCreateWithoutPostInput;
  where: UserPostWhereUniqueInput;
};

export type UserPostCreateOrConnectWithoutUserInput = {
  create: UserPostCreateWithoutUserInput;
  where: UserPostWhereUniqueInput;
};

export type UserPostCreateWithoutPostInput = {
  dummy?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutUserPostsInput;
};

export type UserPostCreateWithoutUserInput = {
  dummy?: InputMaybe<Scalars['String']['input']>;
  post: PostCreateNestedOneWithoutUserPostsInput;
};

export type UserPostListRelationFilter = {
  every?: InputMaybe<UserPostWhereInput>;
  none?: InputMaybe<UserPostWhereInput>;
  some?: InputMaybe<UserPostWhereInput>;
};

export type UserPostOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserPostOrderByWithRelationInput = {
  dummy?: InputMaybe<SortOrderInput>;
  post?: InputMaybe<PostOrderByWithRelationInput>;
  postId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserPostScalarFieldEnum {
  Dummy = 'dummy',
  PostId = 'postId',
  UserId = 'userId'
}

export type UserPostScalarWhereInput = {
  AND?: InputMaybe<Array<UserPostScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserPostScalarWhereInput>>;
  OR?: InputMaybe<Array<UserPostScalarWhereInput>>;
  dummy?: InputMaybe<StringNullableFilter>;
  postId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserPostUpdateManyMutationInput = {
  dummy?: InputMaybe<Scalars['String']['input']>;
};

export type UserPostUpdateManyWithWhereWithoutPostInput = {
  data: UserPostUpdateManyMutationInput;
  where: UserPostScalarWhereInput;
};

export type UserPostUpdateManyWithWhereWithoutUserInput = {
  data: UserPostUpdateManyMutationInput;
  where: UserPostScalarWhereInput;
};

export type UserPostUpdateManyWithoutPostNestedInput = {
  connect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPostCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<UserPostCreateWithoutPostInput>>;
  createMany?: InputMaybe<UserPostCreateManyPostInputEnvelope>;
  delete?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserPostScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  set?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  update?: InputMaybe<Array<UserPostUpdateWithWhereUniqueWithoutPostInput>>;
  updateMany?: InputMaybe<Array<UserPostUpdateManyWithWhereWithoutPostInput>>;
  upsert?: InputMaybe<Array<UserPostUpsertWithWhereUniqueWithoutPostInput>>;
};

export type UserPostUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPostCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserPostCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserPostCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserPostScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  set?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  update?: InputMaybe<Array<UserPostUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserPostUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserPostUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserPostUpdateWithWhereUniqueWithoutPostInput = {
  data: UserPostUpdateWithoutPostInput;
  where: UserPostWhereUniqueInput;
};

export type UserPostUpdateWithWhereUniqueWithoutUserInput = {
  data: UserPostUpdateWithoutUserInput;
  where: UserPostWhereUniqueInput;
};

export type UserPostUpdateWithoutPostInput = {
  dummy?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserPostsNestedInput>;
};

export type UserPostUpdateWithoutUserInput = {
  dummy?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostUpdateOneRequiredWithoutUserPostsNestedInput>;
};

export type UserPostUpsertWithWhereUniqueWithoutPostInput = {
  create: UserPostCreateWithoutPostInput;
  update: UserPostUpdateWithoutPostInput;
  where: UserPostWhereUniqueInput;
};

export type UserPostUpsertWithWhereUniqueWithoutUserInput = {
  create: UserPostCreateWithoutUserInput;
  update: UserPostUpdateWithoutUserInput;
  where: UserPostWhereUniqueInput;
};

export type UserPostUserIdPostIdCompoundUniqueInput = {
  postId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserPostWhereInput = {
  AND?: InputMaybe<Array<UserPostWhereInput>>;
  NOT?: InputMaybe<Array<UserPostWhereInput>>;
  OR?: InputMaybe<Array<UserPostWhereInput>>;
  dummy?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostRelationFilter>;
  postId?: InputMaybe<UuidFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserPostWhereUniqueInput = {
  AND?: InputMaybe<Array<UserPostWhereInput>>;
  NOT?: InputMaybe<Array<UserPostWhereInput>>;
  OR?: InputMaybe<Array<UserPostWhereInput>>;
  dummy?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostRelationFilter>;
  postId?: InputMaybe<UuidFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userId_postId?: InputMaybe<UserPostUserIdPostIdCompoundUniqueInput>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
  Address = 'address',
  ArchivedAt = 'archivedAt',
  Avatar = 'avatar',
  Bio = 'bio',
  ContactPreference = 'contactPreference',
  CreatedAt = 'createdAt',
  CustomSlug = 'customSlug',
  DateOfBirth = 'dateOfBirth',
  Email = 'email',
  FirstName = 'firstName',
  FoundVia = 'foundVia',
  FullName = 'fullName',
  Gender = 'gender',
  HasOrderedPromoPackage = 'hasOrderedPromoPackage',
  HowDidYouHear = 'howDidYouHear',
  HowDidYouHearMulti = 'howDidYouHearMulti',
  Id = 'id',
  Instagram = 'instagram',
  Interests = 'interests',
  IsOver16 = 'isOver16',
  IsParentNotified = 'isParentNotified',
  IsPrivacyCheckAccepted = 'isPrivacyCheckAccepted',
  LastName = 'lastName',
  Notes = 'notes',
  ParentEmail = 'parentEmail',
  Password = 'password',
  Postcode = 'postcode',
  PrivacySetting = 'privacySetting',
  Pronouns = 'pronouns',
  PronounsMulti = 'pronounsMulti',
  PronounsOther = 'pronounsOther',
  ReasonForSigningUp = 'reasonForSigningUp',
  Region = 'region',
  Residence = 'residence',
  Role = 'role',
  School = 'school',
  SchoolType = 'schoolType',
  Telephone = 'telephone',
  Tiktok = 'tiktok',
  UpdatedAt = 'updatedAt'
}

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  address?: InputMaybe<StringNullableFilter>;
  archivedAt?: InputMaybe<DateTimeNullableFilter>;
  avatar?: InputMaybe<StringNullableFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  contactPreference?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customSlug?: InputMaybe<StringNullableFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  foundVia?: InputMaybe<StringNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  hasOrderedPromoPackage?: InputMaybe<BoolFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  howDidYouHearMulti?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<UuidFilter>;
  instagram?: InputMaybe<StringNullableFilter>;
  interests?: InputMaybe<StringNullableListFilter>;
  isOver16?: InputMaybe<BoolFilter>;
  isParentNotified?: InputMaybe<BoolFilter>;
  isPrivacyCheckAccepted?: InputMaybe<BoolFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  parentEmail?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringFilter>;
  postcode?: InputMaybe<StringNullableFilter>;
  privacySetting?: InputMaybe<EnumPrivacySettingFilter>;
  pronouns?: InputMaybe<StringNullableFilter>;
  pronounsMulti?: InputMaybe<StringNullableListFilter>;
  pronounsOther?: InputMaybe<StringNullableFilter>;
  reasonForSigningUp?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  residence?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  school?: InputMaybe<StringNullableFilter>;
  schoolType?: InputMaybe<StringNullableFilter>;
  telephone?: InputMaybe<StringNullableFilter>;
  tiktok?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UserTutorialCreateManyTutorialInput = {
  dateCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserTutorialCreateManyTutorialInputEnvelope = {
  data: Array<UserTutorialCreateManyTutorialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserTutorialCreateManyUserInput = {
  dateCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  tutorialId: Scalars['String']['input'];
};

export type UserTutorialCreateManyUserInputEnvelope = {
  data: Array<UserTutorialCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserTutorialCreateNestedManyWithoutTutorialInput = {
  connect?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTutorialCreateOrConnectWithoutTutorialInput>>;
  create?: InputMaybe<Array<UserTutorialCreateWithoutTutorialInput>>;
  createMany?: InputMaybe<UserTutorialCreateManyTutorialInputEnvelope>;
};

export type UserTutorialCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTutorialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserTutorialCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserTutorialCreateManyUserInputEnvelope>;
};

export type UserTutorialCreateOrConnectWithoutTutorialInput = {
  create: UserTutorialCreateWithoutTutorialInput;
  where: UserTutorialWhereUniqueInput;
};

export type UserTutorialCreateOrConnectWithoutUserInput = {
  create: UserTutorialCreateWithoutUserInput;
  where: UserTutorialWhereUniqueInput;
};

export type UserTutorialCreateWithoutTutorialInput = {
  dateCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutUserTutorialsInput;
};

export type UserTutorialCreateWithoutUserInput = {
  dateCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  tutorial: TutorialCreateNestedOneWithoutUserTutorialsInput;
};

export type UserTutorialListRelationFilter = {
  every?: InputMaybe<UserTutorialWhereInput>;
  none?: InputMaybe<UserTutorialWhereInput>;
  some?: InputMaybe<UserTutorialWhereInput>;
};

export type UserTutorialOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserTutorialOrderByWithRelationInput = {
  dateCompleted?: InputMaybe<SortOrder>;
  tutorial?: InputMaybe<TutorialOrderByWithRelationInput>;
  tutorialId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserTutorialScalarFieldEnum {
  DateCompleted = 'dateCompleted',
  TutorialId = 'tutorialId',
  UserId = 'userId'
}

export type UserTutorialScalarWhereInput = {
  AND?: InputMaybe<Array<UserTutorialScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserTutorialScalarWhereInput>>;
  OR?: InputMaybe<Array<UserTutorialScalarWhereInput>>;
  dateCompleted?: InputMaybe<DateTimeFilter>;
  tutorialId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserTutorialUpdateManyMutationInput = {
  dateCompleted?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserTutorialUpdateManyWithWhereWithoutTutorialInput = {
  data: UserTutorialUpdateManyMutationInput;
  where: UserTutorialScalarWhereInput;
};

export type UserTutorialUpdateManyWithWhereWithoutUserInput = {
  data: UserTutorialUpdateManyMutationInput;
  where: UserTutorialScalarWhereInput;
};

export type UserTutorialUpdateManyWithoutTutorialNestedInput = {
  connect?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTutorialCreateOrConnectWithoutTutorialInput>>;
  create?: InputMaybe<Array<UserTutorialCreateWithoutTutorialInput>>;
  createMany?: InputMaybe<UserTutorialCreateManyTutorialInputEnvelope>;
  delete?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserTutorialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  set?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  update?: InputMaybe<Array<UserTutorialUpdateWithWhereUniqueWithoutTutorialInput>>;
  updateMany?: InputMaybe<Array<UserTutorialUpdateManyWithWhereWithoutTutorialInput>>;
  upsert?: InputMaybe<Array<UserTutorialUpsertWithWhereUniqueWithoutTutorialInput>>;
};

export type UserTutorialUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTutorialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserTutorialCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserTutorialCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserTutorialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  set?: InputMaybe<Array<UserTutorialWhereUniqueInput>>;
  update?: InputMaybe<Array<UserTutorialUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserTutorialUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserTutorialUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserTutorialUpdateWithWhereUniqueWithoutTutorialInput = {
  data: UserTutorialUpdateWithoutTutorialInput;
  where: UserTutorialWhereUniqueInput;
};

export type UserTutorialUpdateWithWhereUniqueWithoutUserInput = {
  data: UserTutorialUpdateWithoutUserInput;
  where: UserTutorialWhereUniqueInput;
};

export type UserTutorialUpdateWithoutTutorialInput = {
  dateCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserTutorialsNestedInput>;
};

export type UserTutorialUpdateWithoutUserInput = {
  dateCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  tutorial?: InputMaybe<TutorialUpdateOneRequiredWithoutUserTutorialsNestedInput>;
};

export type UserTutorialUpsertWithWhereUniqueWithoutTutorialInput = {
  create: UserTutorialCreateWithoutTutorialInput;
  update: UserTutorialUpdateWithoutTutorialInput;
  where: UserTutorialWhereUniqueInput;
};

export type UserTutorialUpsertWithWhereUniqueWithoutUserInput = {
  create: UserTutorialCreateWithoutUserInput;
  update: UserTutorialUpdateWithoutUserInput;
  where: UserTutorialWhereUniqueInput;
};

export type UserTutorialUserIdTutorialIdCompoundUniqueInput = {
  tutorialId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserTutorialWhereInput = {
  AND?: InputMaybe<Array<UserTutorialWhereInput>>;
  NOT?: InputMaybe<Array<UserTutorialWhereInput>>;
  OR?: InputMaybe<Array<UserTutorialWhereInput>>;
  dateCompleted?: InputMaybe<DateTimeFilter>;
  tutorial?: InputMaybe<TutorialRelationFilter>;
  tutorialId?: InputMaybe<UuidFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserTutorialWhereUniqueInput = {
  AND?: InputMaybe<Array<UserTutorialWhereInput>>;
  NOT?: InputMaybe<Array<UserTutorialWhereInput>>;
  OR?: InputMaybe<Array<UserTutorialWhereInput>>;
  dateCompleted?: InputMaybe<DateTimeFilter>;
  tutorial?: InputMaybe<TutorialRelationFilter>;
  tutorialId?: InputMaybe<UuidFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userId_tutorialId?: InputMaybe<UserTutorialUserIdTutorialIdCompoundUniqueInput>;
};

export type UserUpdateManyMutationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserUpdateManyWithWhereWithoutActsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutProjectCollaborationsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutActsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutActsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutActsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutActsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutActsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutActsInput>>;
};

export type UserUpdateManyWithoutProjectCollaborationsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutProjectCollaborationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutProjectCollaborationsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutProjectCollaborationsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutProjectCollaborationsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutProjectCollaborationsInput>>;
};

export type UserUpdateOneRequiredWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<UserCreateWithoutAttachmentsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutAttachmentsInput>;
};

export type UserUpdateOneRequiredWithoutCommentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<UserCreateWithoutCommentsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCommentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCommentsInput>;
};

export type UserUpdateOneRequiredWithoutCreatedActsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedActsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedActsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedActsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedActsInput>;
};

export type UserUpdateOneRequiredWithoutFollowersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFollowersInput>;
  create?: InputMaybe<UserCreateWithoutFollowersInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutFollowersInput>;
  upsert?: InputMaybe<UserUpsertWithoutFollowersInput>;
};

export type UserUpdateOneRequiredWithoutFollowingNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFollowingInput>;
  create?: InputMaybe<UserCreateWithoutFollowingInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutFollowingInput>;
  upsert?: InputMaybe<UserUpsertWithoutFollowingInput>;
};

export type UserUpdateOneRequiredWithoutNotificationNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<UserCreateWithoutNotificationInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNotificationInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotificationInput>;
};

export type UserUpdateOneRequiredWithoutPostsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPostsInput>;
  create?: InputMaybe<UserCreateWithoutPostsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPostsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPostsInput>;
};

export type UserUpdateOneRequiredWithoutProjectsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProjectsInput>;
  create?: InputMaybe<UserCreateWithoutProjectsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutProjectsInput>;
  upsert?: InputMaybe<UserUpsertWithoutProjectsInput>;
};

export type UserUpdateOneRequiredWithoutUserEventsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserEventsInput>;
  create?: InputMaybe<UserCreateWithoutUserEventsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserEventsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserEventsInput>;
};

export type UserUpdateOneRequiredWithoutUserPostsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserPostsInput>;
  create?: InputMaybe<UserCreateWithoutUserPostsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserPostsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserPostsInput>;
};

export type UserUpdateOneRequiredWithoutUserTutorialsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserTutorialsInput>;
  create?: InputMaybe<UserCreateWithoutUserTutorialsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserTutorialsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserTutorialsInput>;
};

export type UserUpdateOneWithoutActInvitationNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutActInvitationInput>;
  create?: InputMaybe<UserCreateWithoutActInvitationInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutActInvitationInput>;
  upsert?: InputMaybe<UserUpsertWithoutActInvitationInput>;
};

export type UserUpdateToOneWithWhereWithoutActInvitationInput = {
  data: UserUpdateWithoutActInvitationInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: UserUpdateWithoutAttachmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCommentsInput = {
  data: UserUpdateWithoutCommentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedActsInput = {
  data: UserUpdateWithoutCreatedActsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutFollowersInput = {
  data: UserUpdateWithoutFollowersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutFollowingInput = {
  data: UserUpdateWithoutFollowingInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNotificationInput = {
  data: UserUpdateWithoutNotificationInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPostsInput = {
  data: UserUpdateWithoutPostsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutProjectsInput = {
  data: UserUpdateWithoutProjectsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserEventsInput = {
  data: UserUpdateWithoutUserEventsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserPostsInput = {
  data: UserUpdateWithoutUserPostsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserTutorialsInput = {
  data: UserUpdateWithoutUserTutorialsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutActsInput = {
  data: UserUpdateWithoutActsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutProjectCollaborationsInput = {
  data: UserUpdateWithoutProjectCollaborationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutActInvitationInput = {
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutActsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutAttachmentsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCommentsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedActsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutFollowersInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutFollowingInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutNotificationInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutPostsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutProjectCollaborationsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutProjectsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserEventsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserPostsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userTutorials?: InputMaybe<UserTutorialUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserTutorialsInput = {
  ActInvitation?: InputMaybe<ActInvitationUpdateManyWithoutUserNestedInput>;
  acts?: InputMaybe<ActUpdateManyWithoutMembersNestedInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  attachments?: InputMaybe<ActAttachmentUpdateManyWithoutUploaderNestedInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentUpdateManyWithoutUserNestedInput>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  createdActs?: InputMaybe<ActUpdateManyWithoutCreatorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<ConnectionUpdateManyWithoutFollowerNestedInput>;
  following?: InputMaybe<ConnectionUpdateManyWithoutUserNestedInput>;
  foundVia?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasOrderedPromoPackage?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isOver16?: InputMaybe<Scalars['Boolean']['input']>;
  isParentNotified?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivacyCheckAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<PostUpdateManyWithoutUserNestedInput>;
  privacySetting?: InputMaybe<PrivacySetting>;
  projectCollaborations?: InputMaybe<ProjectUpdateManyWithoutCollaboratorsNestedInput>;
  projects?: InputMaybe<ProjectUpdateManyWithoutCreatorNestedInput>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  pronounsMulti?: InputMaybe<Array<Scalars['String']['input']>>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  reasonForSigningUp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  residence?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userEvents?: InputMaybe<UserEventUpdateManyWithoutUserNestedInput>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutUserNestedInput>;
};

export type UserUpsertWithWhereUniqueWithoutActsInput = {
  create: UserCreateWithoutActsInput;
  update: UserUpdateWithoutActsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutProjectCollaborationsInput = {
  create: UserCreateWithoutProjectCollaborationsInput;
  update: UserUpdateWithoutProjectCollaborationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutActInvitationInput = {
  create: UserCreateWithoutActInvitationInput;
  update: UserUpdateWithoutActInvitationInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutAttachmentsInput = {
  create: UserCreateWithoutAttachmentsInput;
  update: UserUpdateWithoutAttachmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCommentsInput = {
  create: UserCreateWithoutCommentsInput;
  update: UserUpdateWithoutCommentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedActsInput = {
  create: UserCreateWithoutCreatedActsInput;
  update: UserUpdateWithoutCreatedActsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutFollowersInput = {
  create: UserCreateWithoutFollowersInput;
  update: UserUpdateWithoutFollowersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutFollowingInput = {
  create: UserCreateWithoutFollowingInput;
  update: UserUpdateWithoutFollowingInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNotificationInput = {
  create: UserCreateWithoutNotificationInput;
  update: UserUpdateWithoutNotificationInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPostsInput = {
  create: UserCreateWithoutPostsInput;
  update: UserUpdateWithoutPostsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutProjectsInput = {
  create: UserCreateWithoutProjectsInput;
  update: UserUpdateWithoutProjectsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserEventsInput = {
  create: UserCreateWithoutUserEventsInput;
  update: UserUpdateWithoutUserEventsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserPostsInput = {
  create: UserCreateWithoutUserPostsInput;
  update: UserUpdateWithoutUserPostsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserTutorialsInput = {
  create: UserCreateWithoutUserTutorialsInput;
  update: UserUpdateWithoutUserTutorialsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  ActInvitation?: InputMaybe<ActInvitationListRelationFilter>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  acts?: InputMaybe<ActListRelationFilter>;
  address?: InputMaybe<StringNullableFilter>;
  archivedAt?: InputMaybe<DateTimeNullableFilter>;
  attachments?: InputMaybe<ActAttachmentListRelationFilter>;
  avatar?: InputMaybe<StringNullableFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  contactPreference?: InputMaybe<StringNullableFilter>;
  createdActs?: InputMaybe<ActListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customSlug?: InputMaybe<StringNullableFilter>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  followers?: InputMaybe<ConnectionListRelationFilter>;
  following?: InputMaybe<ConnectionListRelationFilter>;
  foundVia?: InputMaybe<StringNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  hasOrderedPromoPackage?: InputMaybe<BoolFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  howDidYouHearMulti?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<UuidFilter>;
  instagram?: InputMaybe<StringNullableFilter>;
  interests?: InputMaybe<StringNullableListFilter>;
  isOver16?: InputMaybe<BoolFilter>;
  isParentNotified?: InputMaybe<BoolFilter>;
  isPrivacyCheckAccepted?: InputMaybe<BoolFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  parentEmail?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringFilter>;
  postcode?: InputMaybe<StringNullableFilter>;
  posts?: InputMaybe<PostListRelationFilter>;
  privacySetting?: InputMaybe<EnumPrivacySettingFilter>;
  projectCollaborations?: InputMaybe<ProjectListRelationFilter>;
  projects?: InputMaybe<ProjectListRelationFilter>;
  pronouns?: InputMaybe<StringNullableFilter>;
  pronounsMulti?: InputMaybe<StringNullableListFilter>;
  pronounsOther?: InputMaybe<StringNullableFilter>;
  reasonForSigningUp?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  residence?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  school?: InputMaybe<StringNullableFilter>;
  schoolType?: InputMaybe<StringNullableFilter>;
  telephone?: InputMaybe<StringNullableFilter>;
  tiktok?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEvents?: InputMaybe<UserEventListRelationFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  userTutorials?: InputMaybe<UserTutorialListRelationFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  ActInvitation?: InputMaybe<ActInvitationListRelationFilter>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  acts?: InputMaybe<ActListRelationFilter>;
  address?: InputMaybe<StringNullableFilter>;
  archivedAt?: InputMaybe<DateTimeNullableFilter>;
  attachments?: InputMaybe<ActAttachmentListRelationFilter>;
  avatar?: InputMaybe<StringNullableFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  contactPreference?: InputMaybe<StringNullableFilter>;
  createdActs?: InputMaybe<ActListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<StringNullableFilter>;
  followers?: InputMaybe<ConnectionListRelationFilter>;
  following?: InputMaybe<ConnectionListRelationFilter>;
  foundVia?: InputMaybe<StringNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  hasOrderedPromoPackage?: InputMaybe<BoolFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  howDidYouHearMulti?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<StringNullableFilter>;
  interests?: InputMaybe<StringNullableListFilter>;
  isOver16?: InputMaybe<BoolFilter>;
  isParentNotified?: InputMaybe<BoolFilter>;
  isPrivacyCheckAccepted?: InputMaybe<BoolFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  notification?: InputMaybe<NotificationListRelationFilter>;
  parentEmail?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringFilter>;
  postcode?: InputMaybe<StringNullableFilter>;
  posts?: InputMaybe<PostListRelationFilter>;
  privacySetting?: InputMaybe<EnumPrivacySettingFilter>;
  projectCollaborations?: InputMaybe<ProjectListRelationFilter>;
  projects?: InputMaybe<ProjectListRelationFilter>;
  pronouns?: InputMaybe<StringNullableFilter>;
  pronounsMulti?: InputMaybe<StringNullableListFilter>;
  pronounsOther?: InputMaybe<StringNullableFilter>;
  reasonForSigningUp?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  residence?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  school?: InputMaybe<StringNullableFilter>;
  schoolType?: InputMaybe<StringNullableFilter>;
  telephone?: InputMaybe<StringNullableFilter>;
  tiktok?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEvents?: InputMaybe<UserEventListRelationFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  userTutorials?: InputMaybe<UserTutorialListRelationFilter>;
};

export type UsersByAge = {
  __typename?: 'UsersByAge';
  age: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
};

export type UsersBySchoolType = {
  __typename?: 'UsersBySchoolType';
  _count: Scalars['Float']['output'];
  schoolType?: Maybe<Scalars['String']['output']>;
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  count: Scalars['Int']['output'];
  items: Array<User>;
};

export type UuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminActAttachmentFragment = { __typename?: 'ActAttachment', id: string, name: string, fileUrl: string, type: ActAttachmentType, createdAt: string, uploader: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type AdminGetActAttachmentsQueryVariables = Exact<{
  where?: InputMaybe<ActAttachmentWhereInput>;
  orderBy?: InputMaybe<Array<ActAttachmentOrderByWithRelationInput> | ActAttachmentOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminGetActAttachmentsQuery = { __typename?: 'Query', actAttachments: { __typename?: 'ActAttachmentsResponse', count: number, items: Array<{ __typename?: 'ActAttachment', id: string, name: string, fileUrl: string, type: ActAttachmentType, createdAt: string, uploader: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> } };

export type AdminDeleteActAttachmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteActAttachmentMutation = { __typename?: 'Mutation', deleteActAttachment: boolean };

export type UpdateActAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateActAdminInput;
}>;


export type UpdateActAdminMutation = { __typename?: 'Mutation', updateActAdmin: { __typename?: 'Act', id: string, name?: string | null, category: string, workTitle?: string | null, genre?: string | null, selfDescription?: string | null, description?: string | null, memberCount: number, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasIntroSong: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, contentType?: string | null, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, finalPosition?: number | null, notes?: string | null, preliminaryPosition?: number | null, status: ActStatus, hasSentMaterials: boolean, feedbackNotes?: string | null, feedbackUpload?: string | null, isEditableAfterCompetitionClosed: boolean, isReadonly: boolean, isSupervisor: boolean, completedPercent: number, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, competition: { __typename?: 'Competition', id: string, slug: string, name: string, year: number }, originalAct?: { __typename?: 'Act', id: string, name?: string | null, competition: { __typename?: 'Competition', id: string, name: string, year: number } } | null } };

export type DestroyAdminActMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminActMutation = { __typename?: 'Mutation', destroyAct: boolean };

export type ActGroupMemberFragment = { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, email: string, createdAt: string, pendingInvitationIds?: Array<string> | null, acceptedInvitationIds?: Array<string> | null, rejectedInvitationIds?: Array<string> | null };

export type GetAdminActGroupMembersQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput> | UserOrderByWithRelationInput>;
  where?: InputMaybe<UserWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminActGroupMembersQuery = { __typename?: 'Query', act?: { __typename?: 'Act', id: string, creatorId: string, members: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, email: string, createdAt: string, pendingInvitationIds?: Array<string> | null, acceptedInvitationIds?: Array<string> | null, rejectedInvitationIds?: Array<string> | null }> } } | null };

export type ResendActInviteMutationVariables = Exact<{
  actId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type ResendActInviteMutation = { __typename?: 'Mutation', resendActInvite: boolean };

export type AdminInviteActMembersMutationVariables = Exact<{
  actId: Scalars['String']['input'];
  data: Array<UpdateUserInput> | UpdateUserInput;
}>;


export type AdminInviteActMembersMutation = { __typename?: 'Mutation', inviteActMembersAdmin: Array<{ __typename?: 'ActInvitation', id: string }> };

export type GetAdminFinalCompetitionQueryVariables = Exact<{
  year: Scalars['Float']['input'];
}>;


export type GetAdminFinalCompetitionQuery = { __typename?: 'Query', finalCompetition?: { __typename?: 'Competition', id: string, name: string } | null };

export type GetActCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetActCountQuery = { __typename?: 'Query', actCount?: number | null };

export type GetActMemberCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetActMemberCountQuery = { __typename?: 'Query', actMembersCount?: number | null };

export type GetActsByCategoryQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetActsByCategoryQuery = { __typename?: 'Query', actsByCategory: Array<{ __typename?: 'ActsByCategory', category?: string | null, _count: number }> };

export type GetActsByStatusQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetActsByStatusQuery = { __typename?: 'Query', actsByStatus: Array<{ __typename?: 'ActsByStatus', status?: string | null, _count: number }> };

export type GetActsByAgeQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetActsByAgeQuery = { __typename?: 'Query', actsByAge: Array<{ __typename?: 'ActsByAge', age: number, count: number }> };

export type GetActSignUpsByDayQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetActSignUpsByDayQuery = { __typename?: 'Query', actSignUpsByDay: Array<{ __typename?: 'SignUpByWeek', week?: string | null, count?: number | null }> };

export type AdminCompetitionActFragment = { __typename?: 'Act', id: string, name?: string | null, category: string, createdAt: string, creator: { __typename?: 'User', id: string, fullName?: string | null } };

export type GetAdminCompetitionActsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput> | ActOrderByWithRelationInput>;
  where?: InputMaybe<ActWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminCompetitionActsQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, acts: { __typename?: 'ActsResponse', count: number, items: Array<{ __typename?: 'Act', id: string, name?: string | null, category: string, createdAt: string, creator: { __typename?: 'User', id: string, fullName?: string | null } }> }, applicants: { __typename?: 'ApplicantsResponse', count: number } } | null };

export type CompetitionDeadlinesFragment = { __typename?: 'Competition', deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null };

export type GetAdminCompetitionDeadlinesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminCompetitionDeadlinesQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null } | null };

export type UpdateCompetitionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateCompetitionInput;
}>;


export type UpdateCompetitionMutation = { __typename?: 'Mutation', updateCompetition: { __typename?: 'Competition', id: string, name: string, slug: string, firstRoundDate?: string | null, time?: string | null, isLive: boolean, region: string, location?: string | null, content?: string | null, thumbnail?: string | null, program?: string | null, ticketLink?: string | null, shopLink?: string | null, year: number, isArchived: boolean, isFinal: boolean, disabilityProvisions: Array<string>, acts: { __typename?: 'ActsResponse', count: number } } };

export type DestroyCompetitionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyCompetitionMutation = { __typename?: 'Mutation', destroyCompetition: boolean };

export type EmailApplicantsMutationVariables = Exact<{
  competitionId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type EmailApplicantsMutation = { __typename?: 'Mutation', emailCompetitionApplicants: boolean };

export type AdminCompetitionActForExportFragment = { __typename?: 'Act', id: string, isComplete: boolean, status: ActStatus, contactStatus?: string | null, notes?: string | null, preliminaryPosition?: number | null, finalPosition?: number | null, isFirstSelection: boolean, isSecondSelection: boolean, name?: string | null, category: string, workTitle?: string | null, selfDescription?: string | null, description?: string | null, genre?: string | null, memberCount: number, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasGivenLivestreamConsent: boolean, hasIntroSong: boolean, hasSentMaterials: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, createdAt: string, updatedAt: string, competition: { __typename?: 'Competition', id: string, name: string, region: string }, creator: { __typename?: 'User', fullName?: string | null, email: string, dateOfBirth?: string | null, telephone?: string | null, residence?: string | null }, members: { __typename?: 'UsersResponse', items: Array<{ __typename?: 'User', id: string, fullName?: string | null, email: string, dateOfBirth?: string | null, telephone?: string | null, residence?: string | null }> } };

export type GetAdminCompetitionActsForExportQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput> | ActOrderByWithRelationInput>;
  where?: InputMaybe<ActWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminCompetitionActsForExportQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, name: string, acts: { __typename?: 'ActsResponse', count: number, items: Array<{ __typename?: 'Act', id: string, isComplete: boolean, status: ActStatus, contactStatus?: string | null, notes?: string | null, preliminaryPosition?: number | null, finalPosition?: number | null, isFirstSelection: boolean, isSecondSelection: boolean, name?: string | null, category: string, workTitle?: string | null, selfDescription?: string | null, description?: string | null, genre?: string | null, memberCount: number, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasGivenLivestreamConsent: boolean, hasIntroSong: boolean, hasSentMaterials: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, createdAt: string, updatedAt: string, competition: { __typename?: 'Competition', id: string, name: string, region: string }, creator: { __typename?: 'User', fullName?: string | null, email: string, dateOfBirth?: string | null, telephone?: string | null, residence?: string | null }, members: { __typename?: 'UsersResponse', items: Array<{ __typename?: 'User', id: string, fullName?: string | null, email: string, dateOfBirth?: string | null, telephone?: string | null, residence?: string | null }> } }> } } | null };

export type CreateCompetitionPartnerMutationVariables = Exact<{
  data: CreateCompetitionPartnerInput;
}>;


export type CreateCompetitionPartnerMutation = { __typename?: 'Mutation', createCompetitionPartner: { __typename?: 'CompetitionPartner', id: string, url?: string | null, imageUrl?: string | null, type: CompetitionPartnerType } };

export type UpdateCompetitionPartnerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateCompetitionPartnerInput;
}>;


export type UpdateCompetitionPartnerMutation = { __typename?: 'Mutation', updateCompetitionPartner: { __typename?: 'CompetitionPartner', id: string, url?: string | null, imageUrl?: string | null, type: CompetitionPartnerType } };

export type AdminCompetitionPartnerFragment = { __typename?: 'CompetitionPartner', id: string, url?: string | null, imageUrl?: string | null, type: CompetitionPartnerType };

export type GetAdminCompetitionPartnersQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminCompetitionPartnersQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, competitionPartners: Array<{ __typename?: 'CompetitionPartner', id: string, url?: string | null, imageUrl?: string | null, type: CompetitionPartnerType }> } | null };

export type DestroyAdminCompetitionPartnerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminCompetitionPartnerMutation = { __typename?: 'Mutation', destroyCompetitionPartner: boolean };

export type AdminCompetitionPersonFragment = { __typename?: 'CompetitionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: CompetitionPersonType, category?: string | null };

export type GetAdminCompetitionPeopleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminCompetitionPeopleQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, competitionPeople: Array<{ __typename?: 'CompetitionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: CompetitionPersonType, category?: string | null }> } | null };

export type DestroyAdminCompetitionPersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminCompetitionPersonMutation = { __typename?: 'Mutation', destroyCompetitionPerson: boolean };

export type CreateCompetitionPersonMutationVariables = Exact<{
  data: CreateCompetitionPersonInput;
}>;


export type CreateCompetitionPersonMutation = { __typename?: 'Mutation', createCompetitionPerson: { __typename?: 'CompetitionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: CompetitionPersonType, category?: string | null } };

export type UpdateCompetitionPersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateCompetitionPersonInput;
}>;


export type UpdateCompetitionPersonMutation = { __typename?: 'Mutation', updateCompetitionPerson: { __typename?: 'CompetitionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: CompetitionPersonType, category?: string | null } };

export type CreateCompetitionPrizeMutationVariables = Exact<{
  data: CreateCompetitionPrizeInput;
}>;


export type CreateCompetitionPrizeMutation = { __typename?: 'Mutation', createCompetitionPrize: { __typename?: 'CompetitionPrize', id: string, description: string, position: number, category: string } };

export type UpdateCompetitionPrizeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateCompetitionPrizeInput;
}>;


export type UpdateCompetitionPrizeMutation = { __typename?: 'Mutation', updateCompetitionPrize: { __typename?: 'CompetitionPrize', id: string, description: string, position: number, category: string } };

export type AdminCompetitionPrizeFragment = { __typename?: 'CompetitionPrize', id: string, description: string, position: number, category: string };

export type GetAdminCompetitionPrizesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminCompetitionPrizesQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, competitionPrizes: Array<{ __typename?: 'CompetitionPrize', id: string, description: string, position: number, category: string }> } | null };

export type DestroyAdminCompetitionPrizeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminCompetitionPrizeMutation = { __typename?: 'Mutation', destroyCompetitionPrize: boolean };

export type AdminCreateActAttachmentMutationVariables = Exact<{
  data: ActAttachmentCreateInput;
}>;


export type AdminCreateActAttachmentMutation = { __typename?: 'Mutation', createActAttachment: { __typename?: 'ActAttachment', id: string, name: string, type: ActAttachmentType } };

export type AdminEventAttendeeFragment = { __typename?: 'EventAttendee', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting, email: string, dateAttended: string, telephone?: string | null, region?: string | null, isTooOld: boolean };

export type GetAdminEventAttendeesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput> | UserEventOrderByWithRelationInput>;
  where?: InputMaybe<UserEventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminEventAttendeesQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, attendees: { __typename?: 'EventAttendeesResponse', count: number, items: Array<{ __typename?: 'EventAttendee', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting, email: string, dateAttended: string, telephone?: string | null, region?: string | null, isTooOld: boolean }> } } | null };

export type AdminUnAttendEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
}>;


export type AdminUnAttendEventMutation = { __typename?: 'Mutation', adminUnAttendEvent: boolean };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'Event', id: string, name: string, slug: string, date: string, time?: string | null, location: string, content?: string | null, image?: string | null, type?: string | null, region?: string | null, categories: Array<string>, disabilityProvisions: Array<string>, ticketLink?: string | null, maxAttendees?: number | null, isRestrictedToRegion: boolean, isAttendable: boolean, isPublished: boolean, isReviewable: boolean, createdAt: string, updatedAt: string } };

export type DestroyEventMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyEventMutation = { __typename?: 'Mutation', destroyEvent: boolean };

export type EmailAttendeesMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type EmailAttendeesMutation = { __typename?: 'Mutation', emailEventAttendees: boolean };

export type AdminEventAttendeeForExportFragment = { __typename?: 'EventAttendee', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting, email: string, dateAttended: string };

export type GetAdminEventAttendeeForExportQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminEventAttendeeForExportQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, attendees: { __typename?: 'EventAttendeesResponse', count: number, items: Array<{ __typename?: 'EventAttendee', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting, email: string, dateAttended: string, telephone?: string | null, region?: string | null, isTooOld: boolean }> } } | null };

export type AdminEventPersonFragment = { __typename?: 'EventPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: EventPersonType };

export type GetAdminEventPeopleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminEventPeopleQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, eventPeople: Array<{ __typename?: 'EventPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: EventPersonType }> } | null };

export type DestroyAdminEventPersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminEventPersonMutation = { __typename?: 'Mutation', destroyEventPerson: boolean };

export type CreateEventPersonMutationVariables = Exact<{
  data: CreateEventPersonInput;
}>;


export type CreateEventPersonMutation = { __typename?: 'Mutation', createEventPerson: { __typename?: 'EventPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: EventPersonType } };

export type UpdateEventPersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateEventPersonInput;
}>;


export type UpdateEventPersonMutation = { __typename?: 'Mutation', updateEventPerson: { __typename?: 'EventPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: EventPersonType } };

export type AdminEventReviewFragment = { __typename?: 'UserEvent', userId: string, eventId: string, howDidYouHear?: string | null, activityRating?: string | null, activityComments?: string | null, tutorRating?: string | null, tutorComments?: string | null, locationComments?: string | null, generalFeedback?: string | null };

export type GetAdminEventReviewsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput> | UserEventOrderByWithRelationInput>;
  where?: InputMaybe<UserEventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminEventReviewsQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, reviews: { __typename?: 'EventReviewsResponse', count: number, items: Array<{ __typename?: 'UserEvent', userId: string, eventId: string, howDidYouHear?: string | null, activityRating?: string | null, activityComments?: string | null, tutorRating?: string | null, tutorComments?: string | null, locationComments?: string | null, generalFeedback?: string | null }> } } | null };

export type GetEventCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetEventCountQuery = { __typename?: 'Query', eventCount?: number | null };

export type GetEventAttendeeCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetEventAttendeeCountQuery = { __typename?: 'Query', eventAttendeeCount?: number | null };

export type AdminExportActsMutationVariables = Exact<{
  filters: ExportActsInput;
  type: Scalars['String']['input'];
}>;


export type AdminExportActsMutation = { __typename?: 'Mutation', exportActs: boolean };

export type AdminExportStatsMutationVariables = Exact<{
  filters: StatsInput;
}>;


export type AdminExportStatsMutation = { __typename?: 'Mutation', exportStats: boolean };

export type AdminExportUsersMutationVariables = Exact<{
  filters: ExportUsersInput;
  type: Scalars['String']['input'];
}>;


export type AdminExportUsersMutation = { __typename?: 'Mutation', exportUsers: boolean };

export type UpdatePageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdatePageInput;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', updatePage: { __typename?: 'Page', id: string, name: string, slug: string, content?: string | null } };

export type DestroyPageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyPageMutation = { __typename?: 'Mutation', destroyPage: boolean };

export type AdminPostCommentFragment = { __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, isPrivate: boolean, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type GetAdminPostCommentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminPostCommentsQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id: string, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, isPrivate: boolean, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> } } | null };

export type DestroyAdminPostCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminPostCommentMutation = { __typename?: 'Mutation', destroyComment: { __typename?: 'Comment', id: string } };

export type UpdateAdminPostMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdatePostInput;
}>;


export type UpdateAdminPostMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, type: PostType, isClosed: boolean, deadline: string, videoUrl?: string | null } };

export type DestroyAdminPostMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminPostMutation = { __typename?: 'Mutation', destroyPost: boolean };

export type AdminPostMatchFragment = { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null };

export type GetAdminPostMatchesQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminPostMatchesQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id: string, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null }> } } | null };

export type GetPostCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetPostCountQuery = { __typename?: 'Query', postCount?: number | null };

export type GetPostCommentCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetPostCommentCountQuery = { __typename?: 'Query', postCommentCount?: number | null };

export type GetPostMatchCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetPostMatchCountQuery = { __typename?: 'Query', postMatchCount?: number | null };

export type ProjectCollaboratorFragment = { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, email: string, createdAt: string };

export type GetAdminProjectCollaboratorsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminProjectCollaboratorsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, email: string, createdAt: string }> } } | null };

export type AdminProjectCommentFragment = { __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type GetAdminProjectCommentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminProjectCommentsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> } } | null };

export type DestroyAdminProjectCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminProjectCommentMutation = { __typename?: 'Mutation', destroyComment: { __typename?: 'Comment', id: string } };

export type AdminProjectOverviewFragment = { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, category?: string | null, isSensitiveContent: boolean, privacySetting: PrivacySetting, isFeatured: boolean, isApproved: boolean, createdAt: string, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string }> } };

export type AdminCreateProjectMutationVariables = Exact<{
  creatorId: Scalars['String']['input'];
  data: ProjectCreateInput;
}>;


export type AdminCreateProjectMutation = { __typename?: 'Mutation', createProjectAdmin: { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, category?: string | null, isSensitiveContent: boolean, privacySetting: PrivacySetting, isFeatured: boolean, isApproved: boolean, createdAt: string, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string }> } } };

export type GetAdminConnectionsForProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminConnectionsForProjectQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, connections: Array<{ __typename?: 'UserConnection', id: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, follower: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } | null };

export type GetProjectCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetProjectCountQuery = { __typename?: 'Query', projectCount?: number | null };

export type GetProjectCommentCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetProjectCommentCountQuery = { __typename?: 'Query', projectCommentCount?: number | null };

export type CreateRegionFinancerMutationVariables = Exact<{
  data: CreateRegionFinancerInput;
}>;


export type CreateRegionFinancerMutation = { __typename?: 'Mutation', createRegionFinancer: { __typename?: 'RegionFinancer', id: string, url?: string | null, imageUrl?: string | null } };

export type UpdateRegionFinancerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateRegionFinancerInput;
}>;


export type UpdateRegionFinancerMutation = { __typename?: 'Mutation', updateRegionFinancer: { __typename?: 'RegionFinancer', id: string, url?: string | null, imageUrl?: string | null } };

export type RegionFinancerFragment = { __typename?: 'RegionFinancer', id: string, url?: string | null, imageUrl?: string | null };

export type GetAdminRegionFinancersQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminRegionFinancersQuery = { __typename?: 'Query', regionPage?: { __typename?: 'RegionPage', id: string, regionFinancers: Array<{ __typename?: 'RegionFinancer', id: string, url?: string | null, imageUrl?: string | null }> } | null };

export type DestroyAdminRegionFinancerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminRegionFinancerMutation = { __typename?: 'Mutation', destroyRegionFinancer: boolean };

export type UpdateRegionPageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateRegionPageInput;
}>;


export type UpdateRegionPageMutation = { __typename?: 'Mutation', updateRegionPage: { __typename?: 'RegionPage', id: string, slug: string, name: string, description?: string | null, imageUrl?: string | null, address?: string | null, phone?: string | null, email?: string | null, instagram?: string | null, facebook?: string | null, tiktok?: string | null, whatsapp?: string | null, youtube?: string | null, twitter?: string | null, linkedin?: string | null } };

export type DestroyRegionPageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyRegionPageMutation = { __typename?: 'Mutation', destroyRegionPage: boolean };

export type CreateRegionPartnerMutationVariables = Exact<{
  data: CreateRegionPartnerInput;
}>;


export type CreateRegionPartnerMutation = { __typename?: 'Mutation', createRegionPartner: { __typename?: 'RegionPartner', id: string, url?: string | null, imageUrl?: string | null } };

export type UpdateRegionPartnerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateRegionPartnerInput;
}>;


export type UpdateRegionPartnerMutation = { __typename?: 'Mutation', updateRegionPartner: { __typename?: 'RegionPartner', id: string, url?: string | null, imageUrl?: string | null } };

export type RegionPartnerFragment = { __typename?: 'RegionPartner', id: string, url?: string | null, imageUrl?: string | null };

export type GetAdminRegionPartnersQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminRegionPartnersQuery = { __typename?: 'Query', regionPage?: { __typename?: 'RegionPage', id: string, regionPartners: Array<{ __typename?: 'RegionPartner', id: string, url?: string | null, imageUrl?: string | null }> } | null };

export type DestroyAdminRegionPartnerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminRegionPartnerMutation = { __typename?: 'Mutation', destroyRegionPartner: boolean };

export type RegionPersonFragment = { __typename?: 'RegionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: RegionPersonType, email?: string | null };

export type GetAdminRegionPeopleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminRegionPeopleQuery = { __typename?: 'Query', regionPage?: { __typename?: 'RegionPage', id: string, regionPeople: Array<{ __typename?: 'RegionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: RegionPersonType, email?: string | null }> } | null };

export type DestroyAdminRegionPersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminRegionPersonMutation = { __typename?: 'Mutation', destroyRegionPerson: boolean };

export type CreateRegionPersonMutationVariables = Exact<{
  data: CreateRegionPersonInput;
}>;


export type CreateRegionPersonMutation = { __typename?: 'Mutation', createRegionPerson: { __typename?: 'RegionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: RegionPersonType, email?: string | null } };

export type UpdateRegionPersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateRegionPersonInput;
}>;


export type UpdateRegionPersonMutation = { __typename?: 'Mutation', updateRegionPerson: { __typename?: 'RegionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: RegionPersonType, email?: string | null } };

export type AdminTutorialCommentFragment = { __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type GetAdminTutorialCommentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminTutorialCommentsQuery = { __typename?: 'Query', tutorial?: { __typename?: 'Tutorial', id: string, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> } } | null };

export type DestroyAdminTutorialCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminTutorialCommentMutation = { __typename?: 'Mutation', destroyComment: { __typename?: 'Comment', id: string } };

export type AdminTutorialCompletedUserFragment = { __typename?: 'TutorialCompletedUser', id: string, fullName?: string | null, avatarUrl?: string | null, email: string, dateCompleted: string };

export type GetAdminTutorialCompletedUsersQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTutorialOrderByWithRelationInput> | UserTutorialOrderByWithRelationInput>;
  where?: InputMaybe<UserTutorialWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminTutorialCompletedUsersQuery = { __typename?: 'Query', tutorial?: { __typename?: 'Tutorial', id: string, completedUsers: { __typename?: 'TutorialCompletedUsersResponse', count: number, items: Array<{ __typename?: 'TutorialCompletedUser', id: string, fullName?: string | null, avatarUrl?: string | null, email: string, dateCompleted: string }> } } | null };

export type UpdateAdminTutorialMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateTutorialInput;
}>;


export type UpdateAdminTutorialMutation = { __typename?: 'Mutation', updateTutorial: { __typename?: 'Tutorial', id: string, title: string, description: string, categories: Array<string>, duration: string, videoUrl: string, instructor: string, isLive: boolean, difficultyRating?: number | null, viewCount?: string | null } };

export type DestroyAdminTutorialMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminTutorialMutation = { __typename?: 'Mutation', destroyTutorial: boolean };

export type GetTutorialCountQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetTutorialCountQuery = { __typename?: 'Query', tutorialCount?: number | null };

export type GetTutorialCommentCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetTutorialCommentCountQuery = { __typename?: 'Query', tutorialCommentCount?: number | null };

export type GetTutorialCompletedCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetTutorialCompletedCountQuery = { __typename?: 'Query', tutorialCompletedCount?: number | null };

export type AdminUpdateActAttachmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: ActAttachmentUpdateInput;
}>;


export type AdminUpdateActAttachmentMutation = { __typename?: 'Mutation', updateActAttachment: { __typename?: 'ActAttachment', id: string, name: string, type: ActAttachmentType } };

export type AdminUserActFragment = { __typename?: 'Act', id: string, name?: string | null, category: string, creatorId: string, createdAt: string, competition: { __typename?: 'Competition', id: string, name: string, slug: string, year: number } };

export type GetUserActsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput> | ActOrderByWithRelationInput>;
  where?: InputMaybe<ActWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserActsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, acts: { __typename?: 'ActsResponse', count: number, items: Array<{ __typename?: 'Act', id: string, name?: string | null, category: string, creatorId: string, createdAt: string, competition: { __typename?: 'Competition', id: string, name: string, slug: string, year: number } }> } } | null };

export type UserConnectFragment = { __typename?: 'UserConnection', id: string, status: ConnectionStatus, createdAt: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, isTooOld: boolean }, follower: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } };

export type GetUserConnectionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConnectionOrderByWithRelationInput> | ConnectionOrderByWithRelationInput>;
}>;


export type GetUserConnectionsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, connections: Array<{ __typename?: 'UserConnection', id: string, status: ConnectionStatus, createdAt: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, isTooOld: boolean }, follower: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } | null };

export type UpdateUserAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateUserAdminInput;
}>;


export type UpdateUserAdminMutation = { __typename?: 'Mutation', updateUserAdmin: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, avatarUrl?: string | null, avatar?: string | null, region?: string | null, interests: Array<string>, bio?: string | null, tiktok?: string | null, notes?: string | null, instagram?: string | null, reasonForSigningUp?: string | null, howDidYouHearMulti: Array<string>, contactPreference?: string | null, telephone?: string | null, dateOfBirth?: string | null, gender?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, school?: string | null, schoolType?: string | null, foundVia?: string | null, parentEmail?: string | null, isPrivacyCheckAccepted: boolean, isParentNotified: boolean, isOver16: boolean, role: Role, privacySetting: PrivacySetting, createdAt: string, updatedAt: string, archivedAt?: string | null, acts: { __typename?: 'ActsResponse', count: number } } };

export type DestroyAdminUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyAdminUserMutation = { __typename?: 'Mutation', destroyUser: boolean };

export type UserEventFragment = { __typename?: 'Event', id: string, name: string, date: string, slug: string, type?: string | null, region?: string | null, categories: Array<string>, maxAttendees?: number | null, isPublished: boolean, createdAt: string, updatedAt: string, attendeeCount: number };

export type GetUserEventsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput> | UserEventOrderByWithRelationInput>;
  where?: InputMaybe<UserEventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserEventsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, events: { __typename?: 'EventsResponse', count: number, items: Array<{ __typename?: 'Event', id: string, name: string, date: string, slug: string, type?: string | null, region?: string | null, categories: Array<string>, maxAttendees?: number | null, isPublished: boolean, createdAt: string, updatedAt: string, attendeeCount: number }> } } | null };

export type GetAdminUserPostsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminUserPostsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, posts: Array<{ __typename?: 'Post', id: string, title: string, description: string, type: PostType, region: string, categories: Array<string>, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, fullName?: string | null, isTooOld: boolean }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } }>, commentedOnPosts: Array<{ __typename?: 'Post', id: string, title: string, description: string, type: PostType, region: string, categories: Array<string>, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, fullName?: string | null, isTooOld: boolean }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } }> } | null };

export type GetUserCountQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetUserCountQuery = { __typename?: 'Query', userCount: number };

export type GetUserSignUpsByDayQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetUserSignUpsByDayQuery = { __typename?: 'Query', userSignUpsByDay: Array<{ __typename?: 'SignUpByWeek', week?: string | null, count?: number | null }> };

export type GetUsersBySchoolTypeQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetUsersBySchoolTypeQuery = { __typename?: 'Query', usersBySchoolType: Array<{ __typename?: 'UsersBySchoolType', schoolType?: string | null, _count: number }> };

export type GetUsersByAgeQueryVariables = Exact<{
  data: StatsInput;
}>;


export type GetUsersByAgeQuery = { __typename?: 'Query', usersByAge: Array<{ __typename?: 'UsersByAge', age: number, count: number }> };

export type GetUserTutorialsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTutorialOrderByWithRelationInput> | UserTutorialOrderByWithRelationInput>;
  where?: InputMaybe<UserTutorialWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserTutorialsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, tutorials: { __typename?: 'TutorialsResponse', count: number, items: Array<{ __typename?: 'Tutorial', id: string, title: string, description: string, categories: Array<string>, isLive: boolean, viewCount?: string | null, createdAt: string, updatedAt: string }> } } | null };

export type AgendaItemFragment = { __typename?: 'AgendaItem', name: string, date: string, type: string, slug: string, image: string };

export type CreateActMutationVariables = Exact<{
  data: ActCreateInput;
}>;


export type CreateActMutation = { __typename?: 'Mutation', createAct: { __typename?: 'Act', id: string } };

export type Step1ActFragment = { __typename?: 'Act', id: string, category: string, completedPercent: number };

export type UpdateStep1ActMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateActInput;
}>;


export type UpdateStep1ActMutation = { __typename?: 'Mutation', updateAct: { __typename?: 'Act', id: string, category: string, completedPercent: number } };

export type Step2ActFragment = { __typename?: 'Act', id: string, name?: string | null, workTitle?: string | null, selfDescription?: string | null, description?: string | null, genre?: string | null, memberCount: number, category: string, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasIntroSong: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, contentType?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, completedPercent: number };

export type UpdateStep2ActMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateActInput;
}>;


export type UpdateStep2ActMutation = { __typename?: 'Mutation', updateAct: { __typename?: 'Act', id: string, name?: string | null, workTitle?: string | null, selfDescription?: string | null, description?: string | null, genre?: string | null, memberCount: number, category: string, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasIntroSong: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, contentType?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, completedPercent: number } };

export type Step3ActFragment = { __typename?: 'Act', id: string, category: string, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, completedPercent: number };

export type UpdateStep3ActMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateActInput;
}>;


export type UpdateStep3ActMutation = { __typename?: 'Mutation', finishActApplication: { __typename?: 'Act', id: string, category: string, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, completedPercent: number } };

export type ActAttachmentFragment = { __typename?: 'ActAttachment', id: string, name: string, type: ActAttachmentType, fileUrl: string };

export type ActAttachmentsFragment = { __typename?: 'Act', id: string, attachments: Array<{ __typename?: 'ActAttachment', id: string, name: string, type: ActAttachmentType, fileUrl: string }> };

export type CreateActAttachmentMutationVariables = Exact<{
  data: ActAttachmentCreateInput;
}>;


export type CreateActAttachmentMutation = { __typename?: 'Mutation', createActAttachment: { __typename?: 'ActAttachment', id: string, name: string, type: ActAttachmentType, fileUrl: string } };

export type DeleteActAttachmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteActAttachmentMutation = { __typename?: 'Mutation', deleteActAttachment: boolean };

export type ActConfirmationFragment = { __typename?: 'Act', id: string, name?: string | null, genre?: string | null, category: string, memberCount: number, completedPercent: number };

export type ActInvitationsFragment = { __typename?: 'Act', id: string, category: string, completedPercent: number, members: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, email: string, pendingInvitationIds?: Array<string> | null }> }, invitations: Array<{ __typename?: 'ActInvitation', id: string, email: string, actId: string }> };

export type InviteActMembersMutationVariables = Exact<{
  actId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InviteActMembersMutation = { __typename?: 'Mutation', inviteActMembers: Array<{ __typename?: 'ActInvitation', id: string }> };

export type ApplyActMemberFragment = { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, email: string, pendingInvitationIds?: Array<string> | null };

export type RemoveActMemberMutationVariables = Exact<{
  id: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;


export type RemoveActMemberMutation = { __typename?: 'Mutation', removeActMember: boolean };

export type ActMemberInviteFragment = { __typename?: 'ActInvitation', id: string, email: string, actId: string };

export type CompetitionApplicantFragment = { __typename?: 'Applicant', id: string, category: string, members: Array<{ __typename?: 'User', id: string, firstName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting }> };

export type CompetitionItemFragment = { __typename?: 'Competition', id: string, name: string, slug: string, region: string, deadline?: string | null, isLive: boolean, firstRoundDate?: string | null, year: number, isAttending: boolean, thumbnail?: string | null };

export type UserConnectionFragment = { __typename?: 'UserConnection', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> }, follower: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> } };

export type UpdateCustomFeedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateCustomFeedInput;
}>;


export type UpdateCustomFeedMutation = { __typename?: 'Mutation', updateCustomFeed: { __typename?: 'CustomFeed', id: string, heading: string, text: string, buttonText?: string | null, buttonUrl?: string | null, image?: string | null, video?: string | null } };

export type DestroyCustomFeedMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyCustomFeedMutation = { __typename?: 'Mutation', destroyCustomFeed: boolean };

export type CreateCustomNotificationsMutationVariables = Exact<{
  data: CreateCustomNotificationsInput;
}>;


export type CreateCustomNotificationsMutation = { __typename?: 'Mutation', createCustomNotifications: number };

export type AttendEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type AttendEventMutation = { __typename?: 'Mutation', attendEvent: boolean };

export type UnAttendEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type UnAttendEventMutation = { __typename?: 'Mutation', unAttendEvent: boolean };

export type EventAttendeeFragment = { __typename?: 'EventAttendee', id: string, firstName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting };

export type EventItemFragment = { __typename?: 'Event', id: string, name: string, type?: string | null, region?: string | null, categories: Array<string>, image?: string | null, date: string, slug: string, time?: string | null, location: string, maxAttendees?: number | null, attendeeCount: number };

export type LandingPageProjectItemFragment = { __typename?: 'FeaturedProject', id: string, title: string, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type GetLandingPageProjectsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput> | ProjectOrderByWithRelationInput>;
  where?: InputMaybe<ProjectWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLandingPageProjectsQuery = { __typename?: 'Query', featuredProjects: { __typename?: 'FeaturedProjectsResponse', count: number, items: Array<{ __typename?: 'FeaturedProject', id: string, title: string, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> } };

export type CustomFeedFragment = { __typename?: 'CustomFeed', id: string, heading: string, text: string, buttonUrl?: string | null, buttonText?: string | null, video?: string | null, image?: string | null };

export type FeedEventItemFragment = { __typename?: 'Event', id: string, name: string, type?: string | null, region?: string | null, categories: Array<string>, image?: string | null, date: string, slug: string, time?: string | null, location: string, maxAttendees?: number | null, attendeeCount: number };

export type FeaturedProjectItemFragment = { __typename?: 'FeaturedProject', id: string, title: string, image?: string | null, url?: string | null, description?: string | null, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, comments: { __typename?: 'CommentsResponse', count: number } };

export type LatestProjectItemFragment = { __typename?: 'Project', id: string, title: string, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string }, comments: { __typename?: 'CommentsResponse', count: number } };

export type GetUserFeedQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput> | ProjectOrderByWithRelationInput>;
  where?: InputMaybe<ProjectWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserFeedQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, bio?: string | null, avatarUrl?: string | null, interests: Array<string>, privacySetting: PrivacySetting, isConnected: boolean, connectionStatus?: string | null, tiktok?: string | null, instagram?: string | null, connectionsCount: number, connections: Array<{ __typename?: 'UserConnection', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> }, follower: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> } }>, connectionProjects: { __typename?: 'ProjectsResponse', items: Array<{ __typename?: 'Project', id: string, title: string, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string }, comments: { __typename?: 'CommentsResponse', count: number } }> }, recommendedPosts: { __typename?: 'PostsResponse', items: Array<{ __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, deadline: string, type: PostType, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', fullName?: string | null, avatarUrl?: string | null }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number }, comments: { __typename?: 'CommentsResponse', count: number } }> }, recommendedConnections: Array<{ __typename?: 'User', id: string, firstName?: string | null, interests: Array<string>, avatarUrl?: string | null, customSlug?: string | null }>, recommendedEvents: Array<{ __typename?: 'Event', id: string, name: string, type?: string | null, region?: string | null, categories: Array<string>, image?: string | null, date: string, slug: string, time?: string | null, location: string, maxAttendees?: number | null, attendeeCount: number }>, recommendedTutorials: Array<{ __typename?: 'Tutorial', id: string, videoUrl: string, title: string, duration: string, instructor: string, categories: Array<string>, isLive: boolean, createdAt: string, hasCompleted: boolean, difficultyRating?: number | null }>, agenda: Array<{ __typename?: 'AgendaItem', name: string, date: string, type: string, slug: string, image: string }> } | null, featuredProjects: { __typename?: 'FeaturedProjectsResponse', count: number, items: Array<{ __typename?: 'FeaturedProject', id: string, title: string, image?: string | null, url?: string | null, description?: string | null, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, comments: { __typename?: 'CommentsResponse', count: number } }> }, customFeed?: { __typename?: 'CustomFeed', id: string, heading: string, text: string, buttonUrl?: string | null, buttonText?: string | null, video?: string | null, image?: string | null } | null };

export type FeedPostItemFragment = { __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, deadline: string, type: PostType, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', fullName?: string | null, avatarUrl?: string | null }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number }, comments: { __typename?: 'CommentsResponse', count: number } };

export type RecommendedConnectionItemFragment = { __typename?: 'User', id: string, firstName?: string | null, interests: Array<string>, avatarUrl?: string | null, customSlug?: string | null };

export type FeedTutorialItemFragment = { __typename?: 'Tutorial', id: string, videoUrl: string, title: string, duration: string, instructor: string, categories: Array<string>, isLive: boolean, createdAt: string, difficultyRating?: number | null };

export type LandingPageEventItemFragment = { __typename?: 'Event', id: string, name: string, type?: string | null, image?: string | null, region?: string | null, categories: Array<string>, slug: string };

export type GetLandingPageEventsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput> | EventOrderByWithRelationInput>;
  where?: InputMaybe<EventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLandingPageEventsQuery = { __typename?: 'Query', events: { __typename?: 'EventsResponse', count: number, items: Array<{ __typename?: 'Event', id: string, name: string, type?: string | null, image?: string | null, region?: string | null, categories: Array<string>, slug: string }> } };

export type LoginMutationVariables = Exact<{
  data: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthResponse', token: string, refreshToken: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, region?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, avatar?: string | null, customSlug?: string | null, role: Role, email: string, profileIncomplete: boolean, hasPendingFeedback: boolean, hasOrderedPromoPackage: boolean, interests: Array<string>, createdAt: string, howDidYouHearMulti: Array<string> } } };

export type NotificationItemFragment = { __typename?: 'Notification', id: string, isRead: boolean, type: NotificationType, message?: string | null, buttonUrl?: string | null, userId: string, commentId?: string | null, postId?: string | null, eventId?: string | null, projectId?: string | null, tutorialId?: string | null, actId?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, email: string, fullName?: string | null }, comment?: { __typename?: 'Comment', id: string, message: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, post?: { __typename?: 'Post', id: string, title: string } | null, project?: { __typename?: 'Project', id: string, title: string, creatorId: string } | null } | null, post?: { __typename?: 'Post', id: string, title: string, category?: string | null, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } } | null, event?: { __typename?: 'Event', id: string, name: string, slug: string, location: string, date: string } | null, project?: { __typename?: 'Project', id: string, title: string, creator: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, tutorial?: { __typename?: 'Tutorial', id: string, title: string, instructor: string } | null, act?: { __typename?: 'Act', id: string, name?: string | null, competition: { __typename?: 'Competition', id: string, name: string, deadline?: string | null, firstRoundDate?: string | null, slug: string } } | null };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, isRead: boolean, type: NotificationType, message?: string | null, buttonUrl?: string | null, userId: string, commentId?: string | null, postId?: string | null, eventId?: string | null, projectId?: string | null, tutorialId?: string | null, actId?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, email: string, fullName?: string | null }, comment?: { __typename?: 'Comment', id: string, message: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, post?: { __typename?: 'Post', id: string, title: string } | null, project?: { __typename?: 'Project', id: string, title: string, creatorId: string } | null } | null, post?: { __typename?: 'Post', id: string, title: string, category?: string | null, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } } | null, event?: { __typename?: 'Event', id: string, name: string, slug: string, location: string, date: string } | null, project?: { __typename?: 'Project', id: string, title: string, creator: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, tutorial?: { __typename?: 'Tutorial', id: string, title: string, instructor: string } | null, act?: { __typename?: 'Act', id: string, name?: string | null, competition: { __typename?: 'Competition', id: string, name: string, deadline?: string | null, firstRoundDate?: string | null, slug: string } } | null }> };

export type PendingConnectionFragment = { __typename?: 'UserConnection', id: string, status: ConnectionStatus, createdAt: string, follower: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type GetPendingConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingConnectionsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, pendingConnections: Array<{ __typename?: 'UserConnection', id: string, status: ConnectionStatus, createdAt: string, follower: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> } | null };

export type AcceptConnectionMutationVariables = Exact<{
  followerId: Scalars['String']['input'];
}>;


export type AcceptConnectionMutation = { __typename?: 'Mutation', acceptConnection: boolean };

export type RejectConnectionMutationVariables = Exact<{
  followerId: Scalars['String']['input'];
}>;


export type RejectConnectionMutation = { __typename?: 'Mutation', rejectConnection: boolean };

export type PendingActFragment = { __typename?: 'ActInvitation', id: string, actId: string, email: string, createdAt: string };

export type GetPendingActInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingActInvitationsQuery = { __typename?: 'Query', pendingActInvitations: Array<{ __typename?: 'ActInvitation', id: string, actId: string, email: string, createdAt: string }> };

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateNotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename?: 'Notification', id: string, isRead: boolean, type: NotificationType, message?: string | null, buttonUrl?: string | null, userId: string, commentId?: string | null, postId?: string | null, eventId?: string | null, projectId?: string | null, tutorialId?: string | null, actId?: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, email: string, fullName?: string | null }, comment?: { __typename?: 'Comment', id: string, message: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, post?: { __typename?: 'Post', id: string, title: string } | null, project?: { __typename?: 'Project', id: string, title: string, creatorId: string } | null } | null, post?: { __typename?: 'Post', id: string, title: string, category?: string | null, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } } | null, event?: { __typename?: 'Event', id: string, name: string, slug: string, location: string, date: string } | null, project?: { __typename?: 'Project', id: string, title: string, creator: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, tutorial?: { __typename?: 'Tutorial', id: string, title: string, instructor: string } | null, act?: { __typename?: 'Act', id: string, name?: string | null, competition: { __typename?: 'Competition', id: string, name: string, deadline?: string | null, firstRoundDate?: string | null, slug: string } } | null } };

export type EventPendingReviewFragment = { __typename?: 'Event', id: string, name: string, slug: string, date: string };

export type GetEventsPendingReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventsPendingReviewQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, eventsPendingReview: Array<{ __typename?: 'Event', id: string, name: string, slug: string, date: string }> } | null };

export type SubmitPinkPopFormMutationVariables = Exact<{
  data: PinkPopFormInput;
}>;


export type SubmitPinkPopFormMutation = { __typename?: 'Mutation', submitPinkPopForm: boolean };

export type CreatePostMutationVariables = Exact<{
  data: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Post', id: string, title: string, description: string, type: PostType, region: string, categories: Array<string>, deadline: string, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, interests: Array<string> }, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, isPrivate: boolean, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, customSlug?: string | null }> }, commenters: { __typename?: 'PostMatchedUsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }> } } };

export type UpdatePostMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdatePostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, deadline: string, type: PostType, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', fullName?: string | null, avatarUrl?: string | null }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number }, comments: { __typename?: 'CommentsResponse', count: number } } };

export type PostItemFragment = { __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, deadline: string, type: PostType, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', fullName?: string | null, avatarUrl?: string | null }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number }, comments: { __typename?: 'CommentsResponse', count: number } };

export type ProfileActFragment = { __typename?: 'Act', id: string, name?: string | null, category: string, creatorId: string, isMissingInfo: boolean, isEditableAfterCompetitionClosed: boolean, hasFeedback: boolean, feedbackUpload?: string | null, preliminaryPosition?: number | null, finalPosition?: number | null, feedbackNotes?: string | null, status: ActStatus, competition: { __typename?: 'Competition', id: string, name: string, slug: string, year: number, thumbnail?: string | null, isFinal: boolean, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null } };

export type ProfileActCompetitionFragment = { __typename?: 'Competition', id: string, name: string, slug: string, year: number, thumbnail?: string | null, isFinal: boolean, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null };

export type GetProfileActsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput> | ActOrderByWithRelationInput>;
  where?: InputMaybe<ActWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProfileActsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, acts: { __typename?: 'ActsResponse', count: number, items: Array<{ __typename?: 'Act', id: string, name?: string | null, category: string, creatorId: string, isMissingInfo: boolean, isEditableAfterCompetitionClosed: boolean, hasFeedback: boolean, feedbackUpload?: string | null, preliminaryPosition?: number | null, finalPosition?: number | null, feedbackNotes?: string | null, status: ActStatus, competition: { __typename?: 'Competition', id: string, name: string, slug: string, year: number, thumbnail?: string | null, isFinal: boolean, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null } }> } } | null };

export type UpdateActFeedbackSeenMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateActInput;
}>;


export type UpdateActFeedbackSeenMutation = { __typename?: 'Mutation', updateActFeedback: { __typename?: 'Act', id: string, name?: string | null, category: string, creatorId: string, isMissingInfo: boolean, isEditableAfterCompetitionClosed: boolean, hasFeedback: boolean, feedbackUpload?: string | null, preliminaryPosition?: number | null, finalPosition?: number | null, feedbackNotes?: string | null, status: ActStatus, competition: { __typename?: 'Competition', id: string, name: string, slug: string, year: number, thumbnail?: string | null, isFinal: boolean, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null } } };

export type OrderPromoPackageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OrderPromoPackageMutation = { __typename?: 'Mutation', orderPromoPackage: boolean };

export type ProfileConnectionProjectFragment = { __typename?: 'Project', id: string, title: string, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, privacySetting: PrivacySetting, creatorId: string, createdAt: string, updatedAt: string, creator: { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null } };

export type GetProfileConnectionProjectsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput> | ProjectOrderByWithRelationInput>;
  where?: InputMaybe<ProjectWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProfileConnectionProjectsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, connectionProjects: { __typename?: 'ProjectsResponse', count: number, items: Array<{ __typename?: 'Project', id: string, title: string, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, privacySetting: PrivacySetting, creatorId: string, createdAt: string, updatedAt: string, creator: { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null } }> } } | null };

export type UpdateMeMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, email: string, bio?: string | null, avatar?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, region?: string | null, tiktok?: string | null, customSlug?: string | null, instagram?: string | null, interests: Array<string>, contactPreference?: string | null, privacySetting: PrivacySetting, telephone?: string | null, dateOfBirth?: string | null, gender?: string | null, residence?: string | null, schoolType?: string | null, school?: string | null, howDidYouHearMulti: Array<string> } };

export type ProfileEventFragment = { __typename?: 'Event', id: string, name: string, slug: string, date: string, time?: string | null, location: string, image?: string | null, type?: string | null, region?: string | null, categories: Array<string> };

export type GetProfileEventsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput> | UserEventOrderByWithRelationInput>;
  where?: InputMaybe<UserEventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProfileEventsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, events: { __typename?: 'EventsResponse', count: number, items: Array<{ __typename?: 'Event', id: string, name: string, slug: string, date: string, time?: string | null, location: string, image?: string | null, type?: string | null, region?: string | null, categories: Array<string> }> } } | null };

export type ProfilePostFragment = { __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, type: PostType, isClosed: boolean, deadline: string, userId: string, videoUrl?: string | null, createdAt: string, updatedAt: string, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } };

export type GetProfilePostsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  isNotCurrentUser: Scalars['Boolean']['input'];
}>;


export type GetProfilePostsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, posts: Array<{ __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, type: PostType, isClosed: boolean, deadline: string, userId: string, videoUrl?: string | null, createdAt: string, updatedAt: string, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } }>, commentedOnPosts?: Array<{ __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, type: PostType, isClosed: boolean, deadline: string, userId: string, videoUrl?: string | null, createdAt: string, updatedAt: string, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } }>, matchedOnPosts?: Array<{ __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, type: PostType, isClosed: boolean, deadline: string, userId: string, videoUrl?: string | null, createdAt: string, updatedAt: string, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } }> } | null };

export type ProfileProjectFragment = { __typename?: 'Project', id: string, title: string, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, createdAt: string, updatedAt: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } };

export type GetProfileProjectsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput> | ProjectOrderByWithRelationInput>;
  where?: InputMaybe<ProjectWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProfileProjectsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, projects: { __typename?: 'ProjectsResponse', count: number, items: Array<{ __typename?: 'Project', id: string, title: string, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, createdAt: string, updatedAt: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } }> } } | null };

export type DestroyProjectMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyProjectMutation = { __typename?: 'Mutation', destroyProject: { __typename?: 'Project', creatorId: string } };

export type GetProfileTutorialsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTutorialOrderByWithRelationInput> | UserTutorialOrderByWithRelationInput>;
  where?: InputMaybe<UserTutorialWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProfileTutorialsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, tutorials: { __typename?: 'TutorialsResponse', count: number, items: Array<{ __typename?: 'Tutorial', id: string, videoUrl: string, title: string, duration: string, instructor: string, categories: Array<string>, isLive: boolean, createdAt: string, hasCompleted: boolean, difficultyRating?: number | null }> } } | null };

export type CollaboratorItemFragment = { __typename?: 'User', id: string, firstName?: string | null, avatarUrl?: string | null };

export type CreateProjectMutationVariables = Exact<{
  data: ProjectCreateInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } } };

export type ProjectUserConnectionFragment = { __typename?: 'UserConnection', id: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, follower: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } };

export type GetConnectionsForProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectionsForProjectsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, connections: Array<{ __typename?: 'UserConnection', id: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, follower: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } | null };

export type UpdateProjectMutationVariables = Exact<{
  data: UpdateProjectInput;
  id: Scalars['String']['input'];
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } } };

export type Step2ProjectFragment = { __typename?: 'Project', id: string, pdf?: string | null, image?: string | null, url?: string | null, creatorId: string };

export type UpdateProjectStep2MutationVariables = Exact<{
  data: UpdateProjectInput;
  id: Scalars['String']['input'];
}>;


export type UpdateProjectStep2Mutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } } };

export type Step3ProjectFragment = { __typename?: 'Project', id: string, creatorId: string, privacySetting: PrivacySetting, isSensitiveContent: boolean };

export type UpdateProjectStep3MutationVariables = Exact<{
  data: UpdateProjectInput;
  id: Scalars['String']['input'];
}>;


export type UpdateProjectStep3Mutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } } };

export type ProjectItemFragment = { __typename?: 'Project', id: string, title: string, category?: string | null, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type RegisterMutationVariables = Exact<{
  data: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthResponse', token: string, refreshToken: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, region?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, avatar?: string | null, customSlug?: string | null, role: Role, email: string, profileIncomplete: boolean, hasPendingFeedback: boolean, hasOrderedPromoPackage: boolean, interests: Array<string>, createdAt: string, howDidYouHearMulti: Array<string> } } };

export type RegisterFromInviteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: RegisterFromInviteInput;
}>;


export type RegisterFromInviteMutation = { __typename?: 'Mutation', updateUserFromInvite: { __typename?: 'AuthResponse', token: string, refreshToken: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, region?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, avatar?: string | null, customSlug?: string | null, role: Role, email: string, profileIncomplete: boolean, hasPendingFeedback: boolean, hasOrderedPromoPackage: boolean, interests: Array<string>, createdAt: string, howDidYouHearMulti: Array<string> } } };

export type GetUpcomingFinalDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUpcomingFinalDateQuery = { __typename?: 'Query', upcomingFinalDate?: string | null };

export type ReviewEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  data: UpdateUserEventInput;
}>;


export type ReviewEventMutation = { __typename?: 'Mutation', reviewEvent: boolean };

export type ShortRegisterMutationVariables = Exact<{
  data: ShortRegisterInput;
}>;


export type ShortRegisterMutation = { __typename?: 'Mutation', shortRegister: { __typename?: 'AuthResponse', token: string, refreshToken: string, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, region?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, avatar?: string | null, customSlug?: string | null, role: Role, email: string, profileIncomplete: boolean, hasPendingFeedback: boolean, hasOrderedPromoPackage: boolean, interests: Array<string>, createdAt: string, howDidYouHearMulti: Array<string> } } };

export type CreateCommentMutationVariables = Exact<{
  data: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string } };

export type RequestConnectionMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RequestConnectionMutation = { __typename?: 'Mutation', requestConnection: boolean };

export type RemoveConnectionMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RemoveConnectionMutation = { __typename?: 'Mutation', removeConnection: boolean };

export type SearchUsersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput> | UserOrderByWithRelationInput>;
  where?: InputMaybe<UserWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', publicUsers: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, customSlug?: string | null, avatarUrl?: string | null, interests: Array<string> }> } };

export type EventAttendeeExportFragment = { __typename?: 'EventAttendee', id: string, email: string, firstName?: string | null, lastName?: string | null, dateAttended: string };

export type MeFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, region?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, avatar?: string | null, customSlug?: string | null, role: Role, email: string, profileIncomplete: boolean, hasPendingFeedback: boolean, hasOrderedPromoPackage: boolean, interests: Array<string>, createdAt: string, howDidYouHearMulti: Array<string> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, region?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, avatar?: string | null, customSlug?: string | null, role: Role, email: string, profileIncomplete: boolean, hasPendingFeedback: boolean, hasOrderedPromoPackage: boolean, interests: Array<string>, createdAt: string, howDidYouHearMulti: Array<string> } | null };

export type GetSignedUrlForPutMutationVariables = Exact<{
  data: S3SignedUrlInput;
}>;


export type GetSignedUrlForPutMutation = { __typename?: 'Mutation', getSignedS3UrlForPut?: { __typename?: 'SignedResponse', url: string, uploadUrl: string } | null };

export type GetBulkSignedUrlForPutMutationVariables = Exact<{
  data: S3BulkSignedUrlInput;
}>;


export type GetBulkSignedUrlForPutMutation = { __typename?: 'Mutation', getBulkSignedS3UrlForPut?: Array<{ __typename?: 'SignedResponse', url: string, uploadUrl: string, key: string }> | null };

export type PageDetailFragment = { __typename?: 'Page', id: string, name: string, content?: string | null };

export type GetPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id: string, name: string, content?: string | null } | null };

export type ActInvitationFragment = { __typename?: 'ActInvitation', id: string, email: string, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, region?: string | null, acceptedAt?: string | null, rejectedAt?: string | null, userId?: string | null, act: { __typename?: 'InvitationAct', id: string, name?: string | null, category?: string | null, genre?: string | null, memberCount: number } };

export type GetActInvitationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetActInvitationQuery = { __typename?: 'Query', actInvitation?: { __typename?: 'ActInvitation', id: string, email: string, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, region?: string | null, acceptedAt?: string | null, rejectedAt?: string | null, userId?: string | null, act: { __typename?: 'InvitationAct', id: string, name?: string | null, category?: string | null, genre?: string | null, memberCount: number } } | null };

export type AcceptActInviteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AcceptActInviteMutation = { __typename?: 'Mutation', acceptActInvite: boolean };

export type RejectActInviteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RejectActInviteMutation = { __typename?: 'Mutation', rejectActInvite: boolean };

export type AdminActDetailFragment = { __typename?: 'Act', id: string, name?: string | null, category: string, workTitle?: string | null, genre?: string | null, selfDescription?: string | null, description?: string | null, memberCount: number, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasIntroSong: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, contentType?: string | null, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, finalPosition?: number | null, notes?: string | null, preliminaryPosition?: number | null, status: ActStatus, hasSentMaterials: boolean, feedbackNotes?: string | null, feedbackUpload?: string | null, isEditableAfterCompetitionClosed: boolean, isReadonly: boolean, isSupervisor: boolean, completedPercent: number, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, competition: { __typename?: 'Competition', id: string, slug: string, name: string, year: number }, originalAct?: { __typename?: 'Act', id: string, name?: string | null, competition: { __typename?: 'Competition', id: string, name: string, year: number } } | null };

export type GetAdminActQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminActQuery = { __typename?: 'Query', act?: { __typename?: 'Act', id: string, name?: string | null, category: string, workTitle?: string | null, genre?: string | null, selfDescription?: string | null, description?: string | null, memberCount: number, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasIntroSong: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, contentType?: string | null, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, finalPosition?: number | null, notes?: string | null, preliminaryPosition?: number | null, status: ActStatus, hasSentMaterials: boolean, feedbackNotes?: string | null, feedbackUpload?: string | null, isEditableAfterCompetitionClosed: boolean, isReadonly: boolean, isSupervisor: boolean, completedPercent: number, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, competition: { __typename?: 'Competition', id: string, slug: string, name: string, year: number }, originalAct?: { __typename?: 'Act', id: string, name?: string | null, competition: { __typename?: 'Competition', id: string, name: string, year: number } } | null } | null };

export type AdminActItemFragment = { __typename?: 'Act', id: string, status: ActStatus, contactStatus?: string | null, name?: string | null, category: string, workTitle?: string | null, selfDescription?: string | null, description?: string | null, createdAt: string, creatorId: string, creator: { __typename?: 'User', id: string, fullName?: string | null }, competition: { __typename?: 'Competition', id: string, name: string, year: number }, attachments: Array<{ __typename?: 'ActAttachment', id: string, type: ActAttachmentType }> };

export type GetAdminActsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput> | ActOrderByWithRelationInput>;
  where?: InputMaybe<ActWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminActsQuery = { __typename?: 'Query', acts: { __typename?: 'ActsResponse', count: number, items: Array<{ __typename?: 'Act', id: string, status: ActStatus, contactStatus?: string | null, name?: string | null, category: string, workTitle?: string | null, selfDescription?: string | null, description?: string | null, createdAt: string, creatorId: string, creator: { __typename?: 'User', id: string, fullName?: string | null }, competition: { __typename?: 'Competition', id: string, name: string, year: number }, attachments: Array<{ __typename?: 'ActAttachment', id: string, type: ActAttachmentType }> }> } };

export type AdminCustomFeedItemFragment = { __typename?: 'CustomFeed', id: string, heading: string, text: string, buttonText?: string | null, buttonUrl?: string | null, image?: string | null, video?: string | null };

export type GetAdminCustomFeedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminCustomFeedQuery = { __typename?: 'Query', customFeed?: { __typename?: 'CustomFeed', id: string, heading: string, text: string, buttonText?: string | null, buttonUrl?: string | null, image?: string | null, video?: string | null } | null };

export type CreateCustomFeedMutationVariables = Exact<{
  data: CustomFeedCreateInput;
}>;


export type CreateCustomFeedMutation = { __typename?: 'Mutation', createCustomFeed: { __typename?: 'CustomFeed', id: string, heading: string, text: string, buttonText?: string | null, buttonUrl?: string | null, image?: string | null, video?: string | null } };

export type AdminUserDetailFragment = { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, avatarUrl?: string | null, avatar?: string | null, region?: string | null, interests: Array<string>, bio?: string | null, tiktok?: string | null, notes?: string | null, instagram?: string | null, reasonForSigningUp?: string | null, howDidYouHearMulti: Array<string>, contactPreference?: string | null, telephone?: string | null, dateOfBirth?: string | null, gender?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, school?: string | null, schoolType?: string | null, foundVia?: string | null, parentEmail?: string | null, isPrivacyCheckAccepted: boolean, isParentNotified: boolean, isOver16: boolean, role: Role, privacySetting: PrivacySetting, createdAt: string, updatedAt: string, archivedAt?: string | null, acts: { __typename?: 'ActsResponse', count: number } };

export type GetAdminUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, avatarUrl?: string | null, avatar?: string | null, region?: string | null, interests: Array<string>, bio?: string | null, tiktok?: string | null, notes?: string | null, instagram?: string | null, reasonForSigningUp?: string | null, howDidYouHearMulti: Array<string>, contactPreference?: string | null, telephone?: string | null, dateOfBirth?: string | null, gender?: string | null, residence?: string | null, address?: string | null, postcode?: string | null, school?: string | null, schoolType?: string | null, foundVia?: string | null, parentEmail?: string | null, isPrivacyCheckAccepted: boolean, isParentNotified: boolean, isOver16: boolean, role: Role, privacySetting: PrivacySetting, createdAt: string, updatedAt: string, archivedAt?: string | null, acts: { __typename?: 'ActsResponse', count: number } } | null };

export type AdminProjectDetailFragment = { __typename?: 'Project', id: string, title: string, category?: string | null, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, createdAt: string, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } };

export type GetAdminProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, category?: string | null, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, createdAt: string, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } } | null };

export type AdminUserItemFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, region?: string | null, email: string, completedTutorialsCount: number, eventsCount: number, createdActsCount: number, isTooOld: boolean, updatedAt: string, createdAt: string, archivedAt?: string | null, dateOfBirth?: string | null };

export type GetAdminUsersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput> | UserOrderByWithRelationInput>;
  where?: InputMaybe<UserWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, region?: string | null, email: string, completedTutorialsCount: number, eventsCount: number, createdActsCount: number, isTooOld: boolean, updatedAt: string, createdAt: string, archivedAt?: string | null, dateOfBirth?: string | null }> } };

export type AdminPageDetailFragment = { __typename?: 'Page', id: string, name: string, slug: string, content?: string | null };

export type GetAdminPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminPageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id: string, name: string, slug: string, content?: string | null } | null };

export type CreatePageMutationVariables = Exact<{
  data: PageCreateInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'Page', id: string, slug: string } };

export type AdminPageItemFragment = { __typename?: 'Page', id: string, name: string, slug: string, content?: string | null, createdAt: string, updatedAt: string };

export type GetAdminPagesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PageOrderByWithRelationInput> | PageOrderByWithRelationInput>;
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminPagesQuery = { __typename?: 'Query', pages: { __typename?: 'PagesResponse', count: number, items: Array<{ __typename?: 'Page', id: string, name: string, slug: string, content?: string | null, createdAt: string, updatedAt: string }> } };

export type AdminPostDetailFragment = { __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, type: PostType, isClosed: boolean, deadline: string, videoUrl?: string | null };

export type GetAdminPostQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminPostQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, type: PostType, isClosed: boolean, deadline: string, videoUrl?: string | null } | null };

export type CreatePostAdminMutationVariables = Exact<{
  data: CreatePostInput;
}>;


export type CreatePostAdminMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Post', id: string, title: string } };

export type AdminPostItemFragment = { __typename?: 'Post', id: string, title: string, description: string, type: PostType, region: string, categories: Array<string>, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, fullName?: string | null, isTooOld: boolean }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } };

export type GetAdminPostsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput> | PostOrderByWithRelationInput>;
  where?: InputMaybe<PostWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResponse', count: number, items: Array<{ __typename?: 'Post', id: string, title: string, description: string, type: PostType, region: string, categories: Array<string>, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, fullName?: string | null, isTooOld: boolean }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number } }> } };

export type AdminProjectItemFragment = { __typename?: 'Project', id: string, title: string, category?: string | null, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, createdAt: string, creator: { __typename?: 'User', id: string, fullName?: string | null } };

export type GetAdminProjectsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderByWithRelationInput> | ProjectOrderByWithRelationInput>;
  where?: InputMaybe<ProjectWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectsResponse', count: number, items: Array<{ __typename?: 'Project', id: string, title: string, category?: string | null, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, createdAt: string, creator: { __typename?: 'User', id: string, fullName?: string | null } }> } };

export type AdminRegionPageDetailFragment = { __typename?: 'RegionPage', id: string, slug: string, name: string, description?: string | null, imageUrl?: string | null, address?: string | null, phone?: string | null, email?: string | null, instagram?: string | null, facebook?: string | null, tiktok?: string | null, whatsapp?: string | null, youtube?: string | null, twitter?: string | null, linkedin?: string | null };

export type GetAdminRegionPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminRegionPageQuery = { __typename?: 'Query', regionPage?: { __typename?: 'RegionPage', id: string, slug: string, name: string, description?: string | null, imageUrl?: string | null, address?: string | null, phone?: string | null, email?: string | null, instagram?: string | null, facebook?: string | null, tiktok?: string | null, whatsapp?: string | null, youtube?: string | null, twitter?: string | null, linkedin?: string | null } | null };

export type CreateRegionPageMutationVariables = Exact<{
  data: RegionPageCreateInput;
}>;


export type CreateRegionPageMutation = { __typename?: 'Mutation', createRegionPage: { __typename?: 'RegionPage', id: string, slug: string, name: string, description?: string | null, image?: string | null, address?: string | null, phone?: string | null, email?: string | null, instagram?: string | null, facebook?: string | null, tiktok?: string | null, whatsapp?: string | null, youtube?: string | null, twitter?: string | null, linkedin?: string | null } };

export type AdminRegionPageItemFragment = { __typename?: 'RegionPage', id: string, name: string, slug: string, createdAt: string, updatedAt: string };

export type GetAdminRegionPagesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionPageOrderByWithRelationInput> | RegionPageOrderByWithRelationInput>;
  where?: InputMaybe<RegionPageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminRegionPagesQuery = { __typename?: 'Query', regionPages: { __typename?: 'RegionPagesResponse', count: number, items: Array<{ __typename?: 'RegionPage', id: string, name: string, slug: string, createdAt: string, updatedAt: string }> } };

export type AdminEventInfoFragment = { __typename?: 'Event', id: string, name: string, slug: string, date: string, time?: string | null, location: string, content?: string | null, image?: string | null, type?: string | null, region?: string | null, categories: Array<string>, disabilityProvisions: Array<string>, ticketLink?: string | null, maxAttendees?: number | null, isRestrictedToRegion: boolean, isAttendable: boolean, isPublished: boolean, isReviewable: boolean, createdAt: string, updatedAt: string };

export type GetAdminEventQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminEventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, name: string, slug: string, date: string, time?: string | null, location: string, content?: string | null, image?: string | null, type?: string | null, region?: string | null, categories: Array<string>, disabilityProvisions: Array<string>, ticketLink?: string | null, maxAttendees?: number | null, isRestrictedToRegion: boolean, isAttendable: boolean, isPublished: boolean, isReviewable: boolean, createdAt: string, updatedAt: string } | null };

export type CreateEventMutationVariables = Exact<{
  data: EventCreateInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', id: string, slug: string } };

export type AdminEventItemFragment = { __typename?: 'Event', id: string, name: string, date: string, slug: string, type?: string | null, region?: string | null, categories: Array<string>, maxAttendees?: number | null, isPublished: boolean, createdAt: string, updatedAt: string, attendeeCount: number };

export type GetAdminEventsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput> | EventOrderByWithRelationInput>;
  where?: InputMaybe<EventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminEventsQuery = { __typename?: 'Query', events: { __typename?: 'EventsResponse', count: number, items: Array<{ __typename?: 'Event', id: string, name: string, date: string, slug: string, type?: string | null, region?: string | null, categories: Array<string>, maxAttendees?: number | null, isPublished: boolean, createdAt: string, updatedAt: string, attendeeCount: number }> } };

export type AdminTutorialDetailFragment = { __typename?: 'Tutorial', id: string, title: string, description: string, categories: Array<string>, duration: string, videoUrl: string, instructor: string, isLive: boolean, difficultyRating?: number | null, viewCount?: string | null };

export type GetAdminTutorialQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdminTutorialQuery = { __typename?: 'Query', tutorial?: { __typename?: 'Tutorial', id: string, title: string, description: string, categories: Array<string>, duration: string, videoUrl: string, instructor: string, isLive: boolean, difficultyRating?: number | null, viewCount?: string | null } | null };

export type CreateTutorialAdminMutationVariables = Exact<{
  data: CreateTutorialInput;
}>;


export type CreateTutorialAdminMutation = { __typename?: 'Mutation', createTutorial: { __typename?: 'Tutorial', id: string, title: string } };

export type AdminTutorialItemFragment = { __typename?: 'Tutorial', id: string, title: string, description: string, categories: Array<string>, isLive: boolean, viewCount?: string | null, createdAt: string, updatedAt: string };

export type GetAdminTutorialsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TutorialOrderByWithRelationInput> | TutorialOrderByWithRelationInput>;
  where?: InputMaybe<TutorialWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminTutorialsQuery = { __typename?: 'Query', tutorials: { __typename?: 'TutorialsResponse', count: number, items: Array<{ __typename?: 'Tutorial', id: string, title: string, description: string, categories: Array<string>, isLive: boolean, viewCount?: string | null, createdAt: string, updatedAt: string }> } };

export type AdminCompetitionInfoFragment = { __typename?: 'Competition', id: string, name: string, slug: string, firstRoundDate?: string | null, time?: string | null, isLive: boolean, region: string, location?: string | null, content?: string | null, thumbnail?: string | null, program?: string | null, ticketLink?: string | null, shopLink?: string | null, year: number, isArchived: boolean, isFinal: boolean, disabilityProvisions: Array<string>, acts: { __typename?: 'ActsResponse', count: number } };

export type GetAdminCompetitionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminCompetitionQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, name: string, slug: string, firstRoundDate?: string | null, time?: string | null, isLive: boolean, region: string, location?: string | null, content?: string | null, thumbnail?: string | null, program?: string | null, ticketLink?: string | null, shopLink?: string | null, year: number, isArchived: boolean, isFinal: boolean, disabilityProvisions: Array<string>, acts: { __typename?: 'ActsResponse', count: number } } | null };

export type CreateCompetitionMutationVariables = Exact<{
  data: CompetitionCreateInput;
}>;


export type CreateCompetitionMutation = { __typename?: 'Mutation', createCompetition: { __typename?: 'Competition', id: string, slug: string } };

export type AdminCompetitionItemFragment = { __typename?: 'Competition', id: string, name: string, slug: string, content?: string | null, createdAt: string, updatedAt: string };

export type GetAdminCompetitionsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompetitionOrderByWithRelationInput> | CompetitionOrderByWithRelationInput>;
  where?: InputMaybe<CompetitionWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminCompetitionsQuery = { __typename?: 'Query', competitions: { __typename?: 'CompetitionsResponse', count: number, items: Array<{ __typename?: 'Competition', id: string, name: string, slug: string, content?: string | null, createdAt: string, updatedAt: string }> } };

export type RefreshTokenQueryVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenQuery = { __typename?: 'Query', refreshToken?: { __typename?: 'RefreshTokenResponse', token: string, refreshToken: string } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type CommentItemDetailFragment = { __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, isPrivate: boolean, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } };

export type PostDetailFragment = { __typename?: 'Post', id: string, title: string, description: string, type: PostType, region: string, categories: Array<string>, deadline: string, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, interests: Array<string> }, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, isPrivate: boolean, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, customSlug?: string | null }> }, commenters: { __typename?: 'PostMatchedUsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }> } };

export type GetPostQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPostQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id: string, title: string, description: string, type: PostType, region: string, categories: Array<string>, deadline: string, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, interests: Array<string> }, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, deletedAt?: string | null, isPrivate: boolean, userId: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, customSlug?: string | null }> }, commenters: { __typename?: 'PostMatchedUsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null }> } } | null };

export type CreateUserPostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type CreateUserPostMutation = { __typename?: 'Mutation', createUserPost: boolean };

export type DestroyCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DestroyCommentMutation = { __typename?: 'Mutation', destroyComment: { __typename?: 'Comment', id: string } };

export type GetPostsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PostOrderByWithRelationInput> | PostOrderByWithRelationInput>;
  where?: InputMaybe<PostWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResponse', count: number, items: Array<{ __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, deadline: string, type: PostType, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', fullName?: string | null, avatarUrl?: string | null }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number }, comments: { __typename?: 'CommentsResponse', count: number } }> } };

export type GetProjectsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectsResponse', count: number, items: Array<{ __typename?: 'Project', id: string, title: string, category?: string | null, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null } }> } };

export type RegionPageDetailFragment = { __typename?: 'RegionPage', id: string, name: string, description?: string | null, imageUrl?: string | null, address?: string | null, phone?: string | null, email?: string | null, instagram?: string | null, facebook?: string | null, tiktok?: string | null, whatsapp?: string | null, youtube?: string | null, twitter?: string | null, linkedin?: string | null, regionPeople: Array<{ __typename?: 'RegionPerson', id: string, name: string, type: RegionPersonType, imageUrl?: string | null, email?: string | null, bio?: string | null }>, regionPartners: Array<{ __typename?: 'RegionPartner', id: string, imageUrl?: string | null, url?: string | null }>, regionFinancers: Array<{ __typename?: 'RegionFinancer', id: string, imageUrl?: string | null, url?: string | null }> };

export type GetRegionPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetRegionPageQuery = { __typename?: 'Query', regionPage?: { __typename?: 'RegionPage', id: string, name: string, description?: string | null, imageUrl?: string | null, address?: string | null, phone?: string | null, email?: string | null, instagram?: string | null, facebook?: string | null, tiktok?: string | null, whatsapp?: string | null, youtube?: string | null, twitter?: string | null, linkedin?: string | null, regionPeople: Array<{ __typename?: 'RegionPerson', id: string, name: string, type: RegionPersonType, imageUrl?: string | null, email?: string | null, bio?: string | null }>, regionPartners: Array<{ __typename?: 'RegionPartner', id: string, imageUrl?: string | null, url?: string | null }>, regionFinancers: Array<{ __typename?: 'RegionFinancer', id: string, imageUrl?: string | null, url?: string | null }> } | null };

export type ResetPasswordMutationVariables = Exact<{
  data: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type EventPersonFragment = { __typename?: 'EventPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: EventPersonType };

export type EventDetailFragment = { __typename?: 'Event', id: string, name: string, slug: string, date: string, time?: string | null, location: string, content?: string | null, image?: string | null, type?: string | null, region?: string | null, categories: Array<string>, disabilityProvisions: Array<string>, ticketLink?: string | null, maxAttendees?: number | null, isRestrictedToRegion: boolean, isAttendable: boolean, isPublished: boolean, createdAt: string, updatedAt: string, isAttending: boolean, attendeeCount: number, attendees: { __typename?: 'EventAttendeesResponse', count: number, items: Array<{ __typename?: 'EventAttendee', id: string, firstName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting }> }, eventPeople: Array<{ __typename?: 'EventPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: EventPersonType }> };

export type GetEventQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserEventOrderByWithRelationInput> | UserEventOrderByWithRelationInput>;
  where?: InputMaybe<UserEventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, name: string, slug: string, date: string, time?: string | null, location: string, content?: string | null, image?: string | null, type?: string | null, region?: string | null, categories: Array<string>, disabilityProvisions: Array<string>, ticketLink?: string | null, maxAttendees?: number | null, isRestrictedToRegion: boolean, isAttendable: boolean, isPublished: boolean, createdAt: string, updatedAt: string, isAttending: boolean, attendeeCount: number, attendees: { __typename?: 'EventAttendeesResponse', count: number, items: Array<{ __typename?: 'EventAttendee', id: string, firstName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting }> }, eventPeople: Array<{ __typename?: 'EventPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: EventPersonType }> } | null };

export type GetEventForReviewQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetEventForReviewQuery = { __typename?: 'Query', eventForReview?: { __typename?: 'Event', id: string, name: string } | null };

export type GetEventsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput> | EventOrderByWithRelationInput>;
  where?: InputMaybe<EventWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEventsQuery = { __typename?: 'Query', events: { __typename?: 'EventsResponse', count: number, items: Array<{ __typename?: 'Event', id: string, name: string, type?: string | null, region?: string | null, categories: Array<string>, image?: string | null, date: string, slug: string, time?: string | null, location: string, maxAttendees?: number | null, attendeeCount: number }> } };

export type TutorialDetailFragment = { __typename?: 'Tutorial', id: string, videoUrl: string, title: string, instructor: string, categories: Array<string>, isLive: boolean, viewCount?: string | null, hasCompleted: boolean, difficultyRating?: number | null, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, isPrivate: boolean, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null } }> } };

export type CommentItemFragment = { __typename?: 'Comment', id: string, message: string, createdAt: string, isPrivate: boolean, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null } };

export type GetTutorialQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  where?: InputMaybe<CommentWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTutorialQuery = { __typename?: 'Query', tutorial?: { __typename?: 'Tutorial', id: string, videoUrl: string, title: string, instructor: string, categories: Array<string>, isLive: boolean, viewCount?: string | null, hasCompleted: boolean, difficultyRating?: number | null, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, isPrivate: boolean, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null } }> } } | null };

export type DestroyUserTutorialMutationVariables = Exact<{
  tutorialId: Scalars['String']['input'];
}>;


export type DestroyUserTutorialMutation = { __typename?: 'Mutation', destroyUserTutorial: boolean };

export type CreateUserTutorialMutationVariables = Exact<{
  tutorialId: Scalars['String']['input'];
}>;


export type CreateUserTutorialMutation = { __typename?: 'Mutation', createUserTutorial: boolean };

export type TutorialItemFragment = { __typename?: 'Tutorial', id: string, videoUrl: string, title: string, duration: string, instructor: string, categories: Array<string>, isLive: boolean, createdAt: string, hasCompleted: boolean, difficultyRating?: number | null };

export type GetTutorialsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TutorialOrderByWithRelationInput> | TutorialOrderByWithRelationInput>;
  where?: InputMaybe<TutorialWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTutorialsQuery = { __typename?: 'Query', tutorials: { __typename?: 'TutorialsResponse', count: number, items: Array<{ __typename?: 'Tutorial', id: string, videoUrl: string, title: string, duration: string, instructor: string, categories: Array<string>, isLive: boolean, createdAt: string, hasCompleted: boolean, difficultyRating?: number | null }> } };

export type ProfileEditDetailsFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, email: string, bio?: string | null, avatar?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, region?: string | null, tiktok?: string | null, customSlug?: string | null, instagram?: string | null, interests: Array<string>, contactPreference?: string | null, privacySetting: PrivacySetting, telephone?: string | null, dateOfBirth?: string | null, gender?: string | null, residence?: string | null, schoolType?: string | null, school?: string | null, howDidYouHearMulti: Array<string> };

export type GetProfileEditDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileEditDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, email: string, bio?: string | null, avatar?: string | null, address?: string | null, postcode?: string | null, avatarUrl?: string | null, region?: string | null, tiktok?: string | null, customSlug?: string | null, instagram?: string | null, interests: Array<string>, contactPreference?: string | null, privacySetting: PrivacySetting, telephone?: string | null, dateOfBirth?: string | null, gender?: string | null, residence?: string | null, schoolType?: string | null, school?: string | null, howDidYouHearMulti: Array<string> } | null };

export type UserProfileFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, bio?: string | null, avatarUrl?: string | null, interests: Array<string>, privacySetting: PrivacySetting, isConnected: boolean, connectionStatus?: string | null, tiktok?: string | null, instagram?: string | null, connectionsCount: number, connections: Array<{ __typename?: 'UserConnection', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> }, follower: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> } }>, connectionProjects: { __typename?: 'ProjectsResponse', items: Array<{ __typename?: 'Project', id: string, title: string, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string }, comments: { __typename?: 'CommentsResponse', count: number } }> }, recommendedPosts: { __typename?: 'PostsResponse', items: Array<{ __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, deadline: string, type: PostType, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', fullName?: string | null, avatarUrl?: string | null }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number }, comments: { __typename?: 'CommentsResponse', count: number } }> }, recommendedConnections: Array<{ __typename?: 'User', id: string, firstName?: string | null, interests: Array<string>, avatarUrl?: string | null, customSlug?: string | null }>, recommendedEvents: Array<{ __typename?: 'Event', id: string, name: string, type?: string | null, region?: string | null, categories: Array<string>, image?: string | null, date: string, slug: string, time?: string | null, location: string, maxAttendees?: number | null, attendeeCount: number }>, recommendedTutorials: Array<{ __typename?: 'Tutorial', id: string, videoUrl: string, title: string, duration: string, instructor: string, categories: Array<string>, isLive: boolean, createdAt: string, hasCompleted: boolean, difficultyRating?: number | null }>, agenda: Array<{ __typename?: 'AgendaItem', name: string, date: string, type: string, slug: string, image: string }> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, pronounsMulti: Array<string>, pronounsOther?: string | null, bio?: string | null, avatarUrl?: string | null, interests: Array<string>, privacySetting: PrivacySetting, isConnected: boolean, connectionStatus?: string | null, tiktok?: string | null, instagram?: string | null, connectionsCount: number, connections: Array<{ __typename?: 'UserConnection', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> }, follower: { __typename?: 'User', id: string, fullName?: string | null, avatarUrl?: string | null, interests: Array<string> } }>, connectionProjects: { __typename?: 'ProjectsResponse', items: Array<{ __typename?: 'Project', id: string, title: string, image?: string | null, url?: string | null, creator: { __typename?: 'User', id: string }, comments: { __typename?: 'CommentsResponse', count: number } }> }, recommendedPosts: { __typename?: 'PostsResponse', items: Array<{ __typename?: 'Post', id: string, title: string, description: string, categories: Array<string>, region: string, deadline: string, type: PostType, videoUrl?: string | null, createdAt: string, user: { __typename?: 'User', fullName?: string | null, avatarUrl?: string | null }, matchedUsers: { __typename?: 'PostMatchedUsersResponse', count: number }, comments: { __typename?: 'CommentsResponse', count: number } }> }, recommendedConnections: Array<{ __typename?: 'User', id: string, firstName?: string | null, interests: Array<string>, avatarUrl?: string | null, customSlug?: string | null }>, recommendedEvents: Array<{ __typename?: 'Event', id: string, name: string, type?: string | null, region?: string | null, categories: Array<string>, image?: string | null, date: string, slug: string, time?: string | null, location: string, maxAttendees?: number | null, attendeeCount: number }>, recommendedTutorials: Array<{ __typename?: 'Tutorial', id: string, videoUrl: string, title: string, duration: string, instructor: string, categories: Array<string>, isLive: boolean, createdAt: string, hasCompleted: boolean, difficultyRating?: number | null }>, agenda: Array<{ __typename?: 'AgendaItem', name: string, date: string, type: string, slug: string, image: string }> } | null };

export type GetProfileStatsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetProfileStatsQuery = { __typename?: 'Query', profileStats: { __typename?: 'StatsResponse', events: number, competitions: number, tutorials: number, posts: number, projects: number } };

export type ProjectDetailFragment = { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, privacySetting: PrivacySetting, creatorId: string, createdAt: string, creator: { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, interests: Array<string> }, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, isPrivate: boolean, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null } }> }, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, firstName?: string | null, avatarUrl?: string | null }> } };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  where?: InputMaybe<CommentWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, privacySetting: PrivacySetting, creatorId: string, createdAt: string, creator: { __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, interests: Array<string> }, comments: { __typename?: 'CommentsResponse', count: number, items: Array<{ __typename?: 'Comment', id: string, message: string, createdAt: string, isPrivate: boolean, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, avatarUrl?: string | null } }> }, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, firstName?: string | null, avatarUrl?: string | null }> } } | null };

export type EditProjectFragment = { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } };

export type GetEditProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEditProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, description?: string | null, pdf?: string | null, image?: string | null, url?: string | null, isSensitiveContent: boolean, isFeatured: boolean, isApproved: boolean, privacySetting: PrivacySetting, creatorId: string, collaborators: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, fullName?: string | null }> } } | null };

export type UserItemFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, customSlug?: string | null, avatarUrl?: string | null, interests: Array<string> };

export type GetPublicUsersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput> | UserOrderByWithRelationInput>;
  where?: InputMaybe<UserWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPublicUsersQuery = { __typename?: 'Query', publicUsers: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, customSlug?: string | null, avatarUrl?: string | null, interests: Array<string> }> } };

export type ApplyCompetitionFragment = { __typename?: 'Competition', id: string, name: string, deadline?: string | null, region: string, year: number, slug: string, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null };

export type GetApplyCompetitionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetApplyCompetitionQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, name: string, deadline?: string | null, region: string, year: number, slug: string, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null } | null };

export type GetApplyMyActsQueryVariables = Exact<{
  where?: InputMaybe<ActWhereInput>;
}>;


export type GetApplyMyActsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, createdActs: Array<{ __typename?: 'Act', id: string, name?: string | null, category: string, competition: { __typename?: 'Competition', id: string, year: number } }> } | null };

export type ApplyActFragment = { __typename?: 'Act', id: string, status: ActStatus, isReadonly: boolean, isEditableAfterCompetitionClosed: boolean, category: string, completedPercent: number, name?: string | null, workTitle?: string | null, selfDescription?: string | null, description?: string | null, genre?: string | null, memberCount: number, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasIntroSong: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, contentType?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, competition: { __typename?: 'Competition', id: string, year: number, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null }, attachments: Array<{ __typename?: 'ActAttachment', id: string, name: string, type: ActAttachmentType, fileUrl: string }>, members: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, email: string, pendingInvitationIds?: Array<string> | null }> }, invitations: Array<{ __typename?: 'ActInvitation', id: string, email: string, actId: string }> };

export type GetActQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetActQuery = { __typename?: 'Query', act?: { __typename?: 'Act', id: string, status: ActStatus, isReadonly: boolean, isEditableAfterCompetitionClosed: boolean, category: string, completedPercent: number, name?: string | null, workTitle?: string | null, selfDescription?: string | null, description?: string | null, genre?: string | null, memberCount: number, link?: string | null, motivation?: string | null, hasSelfProducedTracks: boolean, hasIntroSong: boolean, lengthOfSet?: string | null, lengthOfDjSet?: string | null, lengthOfFilmSet?: string | null, presentationText?: string | null, djEquipment?: string | null, requiresDjLaptop: boolean, djSoftware?: string | null, ownDjEquipment?: string | null, contentType?: string | null, numberOfArtworksPieces?: string | null, artworkDimensions?: string | null, artworkSize?: string | null, artworkStand?: string | null, artworkMaterial?: string | null, filmVideoFormat?: string | null, lightingSettings?: string | null, lightingAtEnd?: string | null, lightingInstructions?: string | null, extraLightingInformation?: string | null, microphoneCount?: string | null, requiresMusicNew?: string | null, musicInstructions?: string | null, areVisualsUsedNew?: string | null, hasSentVisuals: boolean, visualsVideoFormat?: string | null, extraVisualsInformation?: string | null, extraMusicInstruments: Array<string>, ownMusicInstruments?: string | null, decor?: string | null, extraMaterial?: string | null, extraInformation?: string | null, competition: { __typename?: 'Competition', id: string, year: number, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null }, attachments: Array<{ __typename?: 'ActAttachment', id: string, name: string, type: ActAttachmentType, fileUrl: string }>, members: { __typename?: 'UsersResponse', count: number, items: Array<{ __typename?: 'User', id: string, avatarUrl?: string | null, fullName?: string | null, email: string, pendingInvitationIds?: Array<string> | null }> }, invitations: Array<{ __typename?: 'ActInvitation', id: string, email: string, actId: string }> } | null };

export type CopyActMutationVariables = Exact<{
  id: Scalars['String']['input'];
  competitionId: Scalars['String']['input'];
}>;


export type CopyActMutation = { __typename?: 'Mutation', copyAct: { __typename?: 'Act', id: string } };

export type CompetitionPersonFragment = { __typename?: 'CompetitionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: CompetitionPersonType, category?: string | null };

export type CompetitionPartnerFragment = { __typename?: 'CompetitionPartner', id: string, imageUrl?: string | null, url?: string | null, type: CompetitionPartnerType };

export type CompetitionPrizeFragment = { __typename?: 'CompetitionPrize', id: string, description: string, position: number, category: string };

export type CompetitionDetailFragment = { __typename?: 'Competition', id: string, name: string, time?: string | null, content?: string | null, slug: string, ticketLink?: string | null, shopLink?: string | null, program?: string | null, isFinal: boolean, location?: string | null, disabilityProvisions: Array<string>, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null, competitionPeople: Array<{ __typename?: 'CompetitionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: CompetitionPersonType, category?: string | null }>, competitionPrizes: Array<{ __typename?: 'CompetitionPrize', id: string, description: string, position: number, category: string }>, competitionPartners: Array<{ __typename?: 'CompetitionPartner', id: string, imageUrl?: string | null, url?: string | null, type: CompetitionPartnerType }>, applicants: { __typename?: 'ApplicantsResponse', count: number, items: Array<{ __typename?: 'Applicant', id: string, category: string, members: Array<{ __typename?: 'User', id: string, firstName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting }> }> } };

export type GetCompetitionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActOrderByWithRelationInput> | ActOrderByWithRelationInput>;
  where?: InputMaybe<ActWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCompetitionQuery = { __typename?: 'Query', competition?: { __typename?: 'Competition', id: string, name: string, time?: string | null, content?: string | null, slug: string, ticketLink?: string | null, shopLink?: string | null, program?: string | null, isFinal: boolean, location?: string | null, disabilityProvisions: Array<string>, deadline?: string | null, deadlineDans?: string | null, deadlineDJ?: string | null, deadlineExpo?: string | null, deadlineFashion?: string | null, deadlineFilm?: string | null, deadlineMuziek?: string | null, deadlineTaal?: string | null, deadlineTheater?: string | null, firstRoundDate?: string | null, competitionPeople: Array<{ __typename?: 'CompetitionPerson', id: string, name: string, bio?: string | null, imageUrl?: string | null, type: CompetitionPersonType, category?: string | null }>, competitionPrizes: Array<{ __typename?: 'CompetitionPrize', id: string, description: string, position: number, category: string }>, competitionPartners: Array<{ __typename?: 'CompetitionPartner', id: string, imageUrl?: string | null, url?: string | null, type: CompetitionPartnerType }>, applicants: { __typename?: 'ApplicantsResponse', count: number, items: Array<{ __typename?: 'Applicant', id: string, category: string, members: Array<{ __typename?: 'User', id: string, firstName?: string | null, avatarUrl?: string | null, privacySetting: PrivacySetting }> }> } } | null };

export type GetCompetitionsQueryVariables = Exact<{
  where?: InputMaybe<CompetitionWhereInput>;
}>;


export type GetCompetitionsQuery = { __typename?: 'Query', competitions: { __typename?: 'CompetitionsResponse', count: number, items: Array<{ __typename?: 'Competition', id: string, name: string, slug: string, region: string, deadline?: string | null, isLive: boolean, firstRoundDate?: string | null, year: number, isAttending: boolean, thumbnail?: string | null }> } };

export const AdminActAttachmentFragmentDoc = gql`
    fragment AdminActAttachment on ActAttachment {
  id
  name
  fileUrl
  type
  createdAt
  uploader {
    id
    fullName
    avatarUrl
  }
}
    `;
export const ActGroupMemberFragmentDoc = gql`
    fragment ActGroupMember on User {
  id
  fullName
  avatarUrl
  email
  createdAt
  pendingInvitationIds
  acceptedInvitationIds
  rejectedInvitationIds
}
    `;
export const AdminCompetitionActFragmentDoc = gql`
    fragment AdminCompetitionAct on Act {
  id
  name
  category
  createdAt
  creator {
    id
    fullName
  }
}
    `;
export const AdminCompetitionActForExportFragmentDoc = gql`
    fragment AdminCompetitionActForExport on Act {
  id
  isComplete
  status
  contactStatus
  notes
  preliminaryPosition
  finalPosition
  isFirstSelection
  isSecondSelection
  name
  category
  workTitle
  selfDescription
  description
  genre
  memberCount
  link
  motivation
  hasSelfProducedTracks
  hasGivenLivestreamConsent
  hasIntroSong
  hasSentMaterials
  lengthOfSet
  lengthOfDjSet
  lengthOfFilmSet
  presentationText
  djEquipment
  requiresDjLaptop
  djSoftware
  ownDjEquipment
  numberOfArtworksPieces
  artworkDimensions
  artworkSize
  artworkStand
  artworkMaterial
  filmVideoFormat
  lightingSettings
  lightingAtEnd
  lightingInstructions
  extraLightingInformation
  microphoneCount
  requiresMusicNew
  musicInstructions
  areVisualsUsedNew
  hasSentVisuals
  visualsVideoFormat
  extraVisualsInformation
  extraMusicInstruments
  ownMusicInstruments
  decor
  extraMaterial
  extraInformation
  createdAt
  updatedAt
  competition {
    id
    name
    region
  }
  creator {
    fullName
    email
    dateOfBirth
    telephone
    residence
  }
  members {
    items {
      id
      fullName
      email
      dateOfBirth
      telephone
      residence
    }
  }
}
    `;
export const AdminCompetitionPartnerFragmentDoc = gql`
    fragment AdminCompetitionPartner on CompetitionPartner {
  id
  url
  imageUrl
  type
}
    `;
export const AdminCompetitionPersonFragmentDoc = gql`
    fragment AdminCompetitionPerson on CompetitionPerson {
  id
  name
  bio
  imageUrl
  type
  category
}
    `;
export const AdminCompetitionPrizeFragmentDoc = gql`
    fragment AdminCompetitionPrize on CompetitionPrize {
  id
  description
  position
  category
}
    `;
export const AdminEventAttendeeFragmentDoc = gql`
    fragment AdminEventAttendee on EventAttendee {
  id
  firstName
  lastName
  fullName
  avatarUrl
  privacySetting
  email
  dateAttended
  telephone
  region
  isTooOld
}
    `;
export const AdminEventAttendeeForExportFragmentDoc = gql`
    fragment AdminEventAttendeeForExport on EventAttendee {
  id
  firstName
  lastName
  fullName
  avatarUrl
  privacySetting
  email
  dateAttended
}
    `;
export const AdminEventPersonFragmentDoc = gql`
    fragment AdminEventPerson on EventPerson {
  id
  name
  bio
  imageUrl
  type
}
    `;
export const AdminEventReviewFragmentDoc = gql`
    fragment AdminEventReview on UserEvent {
  userId
  eventId
  howDidYouHear
  activityRating
  activityComments
  tutorRating
  tutorComments
  locationComments
  generalFeedback
}
    `;
export const AdminPostCommentFragmentDoc = gql`
    fragment AdminPostComment on Comment {
  id
  message
  createdAt
  deletedAt
  isPrivate
  userId
  user {
    id
    fullName
    avatarUrl
  }
}
    `;
export const AdminPostMatchFragmentDoc = gql`
    fragment AdminPostMatch on User {
  id
  avatarUrl
  fullName
}
    `;
export const ProjectCollaboratorFragmentDoc = gql`
    fragment ProjectCollaborator on User {
  id
  fullName
  avatarUrl
  email
  createdAt
}
    `;
export const AdminProjectCommentFragmentDoc = gql`
    fragment AdminProjectComment on Comment {
  id
  message
  createdAt
  deletedAt
  userId
  user {
    id
    fullName
    avatarUrl
  }
}
    `;
export const AdminProjectOverviewFragmentDoc = gql`
    fragment AdminProjectOverview on Project {
  id
  title
  description
  pdf
  image
  url
  category
  isSensitiveContent
  privacySetting
  isFeatured
  isApproved
  createdAt
  creatorId
  collaborators {
    items {
      id
    }
    count
  }
}
    `;
export const RegionFinancerFragmentDoc = gql`
    fragment RegionFinancer on RegionFinancer {
  id
  url
  imageUrl
}
    `;
export const RegionPartnerFragmentDoc = gql`
    fragment RegionPartner on RegionPartner {
  id
  url
  imageUrl
}
    `;
export const RegionPersonFragmentDoc = gql`
    fragment RegionPerson on RegionPerson {
  id
  name
  bio
  imageUrl
  type
  email
}
    `;
export const AdminTutorialCommentFragmentDoc = gql`
    fragment AdminTutorialComment on Comment {
  id
  message
  createdAt
  deletedAt
  userId
  user {
    id
    fullName
    avatarUrl
  }
}
    `;
export const AdminTutorialCompletedUserFragmentDoc = gql`
    fragment AdminTutorialCompletedUser on TutorialCompletedUser {
  id
  fullName
  avatarUrl
  email
  dateCompleted
}
    `;
export const AdminUserActFragmentDoc = gql`
    fragment AdminUserAct on Act {
  id
  name
  category
  creatorId
  createdAt
  competition {
    id
    name
    slug
    year
  }
}
    `;
export const UserConnectFragmentDoc = gql`
    fragment UserConnect on UserConnection {
  id
  status
  createdAt
  user {
    id
    firstName
    lastName
    isTooOld
  }
  follower {
    id
    firstName
    lastName
  }
}
    `;
export const UserEventFragmentDoc = gql`
    fragment UserEvent on Event {
  id
  name
  date
  slug
  type
  region
  categories
  maxAttendees
  isPublished
  createdAt
  updatedAt
  attendeeCount
}
    `;
export const CompetitionItemFragmentDoc = gql`
    fragment CompetitionItem on Competition {
  id
  name
  slug
  region
  deadline
  isLive
  firstRoundDate
  year
  isAttending
  thumbnail
}
    `;
export const LandingPageProjectItemFragmentDoc = gql`
    fragment LandingPageProjectItem on FeaturedProject {
  id
  title
  image
  url
  creator {
    id
    fullName
    avatarUrl
  }
}
    `;
export const CustomFeedFragmentDoc = gql`
    fragment CustomFeed on CustomFeed {
  id
  heading
  text
  buttonUrl
  buttonText
  video
  image
}
    `;
export const FeedEventItemFragmentDoc = gql`
    fragment FeedEventItem on Event {
  id
  name
  type
  region
  categories
  image
  date
  slug
  time
  location
  time
  maxAttendees
  attendeeCount
}
    `;
export const FeaturedProjectItemFragmentDoc = gql`
    fragment FeaturedProjectItem on FeaturedProject {
  id
  title
  image
  url
  description
  creator {
    id
    fullName
    avatarUrl
  }
  comments {
    count
  }
}
    `;
export const FeedPostItemFragmentDoc = gql`
    fragment FeedPostItem on Post {
  id
  title
  description
  categories
  region
  deadline
  type
  videoUrl
  user {
    fullName
    avatarUrl
  }
  matchedUsers {
    count
  }
  createdAt
  comments {
    count
  }
}
    `;
export const FeedTutorialItemFragmentDoc = gql`
    fragment FeedTutorialItem on Tutorial {
  id
  videoUrl
  title
  duration
  instructor
  categories
  isLive
  createdAt
  difficultyRating
}
    `;
export const LandingPageEventItemFragmentDoc = gql`
    fragment LandingPageEventItem on Event {
  id
  name
  type
  image
  region
  categories
  slug
}
    `;
export const NotificationItemFragmentDoc = gql`
    fragment NotificationItem on Notification {
  id
  isRead
  type
  message
  buttonUrl
  userId
  user {
    id
    email
    fullName
  }
  commentId
  comment {
    id
    message
    user {
      id
      fullName
      avatarUrl
    }
    post {
      id
      title
    }
    project {
      id
      title
      creatorId
    }
  }
  postId
  post {
    id
    title
    category
    user {
      id
      fullName
      avatarUrl
    }
  }
  eventId
  event {
    id
    name
    slug
    location
    date
  }
  projectId
  project {
    id
    title
    creator {
      id
      firstName
      lastName
    }
  }
  tutorialId
  tutorial {
    id
    title
    instructor
  }
  actId
  act {
    id
    name
    competition {
      id
      name
      deadline
      firstRoundDate
      slug
    }
  }
  createdAt
  updatedAt
}
    `;
export const PendingConnectionFragmentDoc = gql`
    fragment PendingConnection on UserConnection {
  id
  status
  createdAt
  follower {
    id
    fullName
    avatarUrl
  }
}
    `;
export const PendingActFragmentDoc = gql`
    fragment PendingAct on ActInvitation {
  id
  actId
  email
  createdAt
}
    `;
export const EventPendingReviewFragmentDoc = gql`
    fragment EventPendingReview on Event {
  id
  name
  slug
  date
}
    `;
export const CompetitionDeadlinesFragmentDoc = gql`
    fragment CompetitionDeadlines on Competition {
  deadline
  deadlineDans
  deadlineDJ
  deadlineExpo
  deadlineFashion
  deadlineFilm
  deadlineMuziek
  deadlineTaal
  deadlineTheater
  firstRoundDate
}
    `;
export const ProfileActCompetitionFragmentDoc = gql`
    fragment ProfileActCompetition on Competition {
  id
  name
  slug
  year
  thumbnail
  isFinal
  ...CompetitionDeadlines
}
    ${CompetitionDeadlinesFragmentDoc}`;
export const ProfileActFragmentDoc = gql`
    fragment ProfileAct on Act {
  id
  name
  category
  creatorId
  isMissingInfo
  isEditableAfterCompetitionClosed
  hasFeedback
  feedbackUpload
  preliminaryPosition
  finalPosition
  feedbackNotes
  status
  competition {
    ...ProfileActCompetition
  }
}
    ${ProfileActCompetitionFragmentDoc}`;
export const ProfileConnectionProjectFragmentDoc = gql`
    fragment ProfileConnectionProject on Project {
  id
  title
  pdf
  image
  url
  isSensitiveContent
  privacySetting
  creatorId
  creator {
    id
    avatarUrl
    fullName
  }
  createdAt
  updatedAt
}
    `;
export const ProfileEventFragmentDoc = gql`
    fragment ProfileEvent on Event {
  id
  name
  slug
  date
  time
  location
  image
  type
  region
  categories
}
    `;
export const ProfilePostFragmentDoc = gql`
    fragment ProfilePost on Post {
  id
  title
  description
  categories
  region
  type
  isClosed
  deadline
  userId
  videoUrl
  matchedUsers {
    count
  }
  createdAt
  updatedAt
}
    `;
export const ProfileProjectFragmentDoc = gql`
    fragment ProfileProject on Project {
  id
  title
  pdf
  image
  url
  isSensitiveContent
  isFeatured
  isApproved
  privacySetting
  creatorId
  createdAt
  updatedAt
  collaborators {
    items {
      id
      fullName
    }
    count
  }
}
    `;
export const ProjectUserConnectionFragmentDoc = gql`
    fragment ProjectUserConnection on UserConnection {
  id
  user {
    id
    firstName
    lastName
  }
  follower {
    id
    firstName
    lastName
  }
}
    `;
export const Step2ProjectFragmentDoc = gql`
    fragment Step2Project on Project {
  id
  pdf
  image
  url
  creatorId
}
    `;
export const Step3ProjectFragmentDoc = gql`
    fragment Step3Project on Project {
  id
  creatorId
  privacySetting
  isSensitiveContent
}
    `;
export const ProjectItemFragmentDoc = gql`
    fragment ProjectItem on Project {
  id
  title
  category
  image
  url
  creator {
    id
    fullName
    avatarUrl
  }
}
    `;
export const EventAttendeeExportFragmentDoc = gql`
    fragment EventAttendeeExport on EventAttendee {
  id
  email
  firstName
  lastName
  dateAttended
}
    `;
export const MeFragmentDoc = gql`
    fragment Me on User {
  id
  firstName
  lastName
  fullName
  pronounsMulti
  pronounsOther
  region
  residence
  address
  postcode
  avatarUrl
  avatar
  customSlug
  role
  email
  profileIncomplete
  hasPendingFeedback
  hasOrderedPromoPackage
  interests
  createdAt
  howDidYouHearMulti
}
    `;
export const PageDetailFragmentDoc = gql`
    fragment PageDetail on Page {
  id
  name
  content
}
    `;
export const ActInvitationFragmentDoc = gql`
    fragment ActInvitation on ActInvitation {
  id
  email
  firstName
  lastName
  dateOfBirth
  region
  acceptedAt
  rejectedAt
  userId
  act {
    id
    name
    category
    genre
    memberCount
  }
}
    `;
export const AdminActDetailFragmentDoc = gql`
    fragment AdminActDetail on Act {
  id
  name
  category
  workTitle
  genre
  selfDescription
  description
  memberCount
  link
  motivation
  hasSelfProducedTracks
  hasIntroSong
  lengthOfSet
  lengthOfDjSet
  lengthOfFilmSet
  presentationText
  djEquipment
  requiresDjLaptop
  djSoftware
  ownDjEquipment
  numberOfArtworksPieces
  artworkDimensions
  artworkSize
  artworkStand
  artworkMaterial
  filmVideoFormat
  lightingSettings
  lightingAtEnd
  lightingInstructions
  extraLightingInformation
  microphoneCount
  contentType
  requiresMusicNew
  musicInstructions
  areVisualsUsedNew
  hasSentVisuals
  visualsVideoFormat
  extraVisualsInformation
  extraMusicInstruments
  ownMusicInstruments
  decor
  extraMaterial
  extraInformation
  finalPosition
  notes
  preliminaryPosition
  status
  hasSentMaterials
  feedbackNotes
  feedbackUpload
  isEditableAfterCompetitionClosed
  isReadonly
  isSupervisor
  completedPercent
  creator {
    id
    fullName
    avatarUrl
  }
  competition {
    id
    slug
    name
    year
  }
  originalAct {
    id
    name
    competition {
      id
      name
      year
    }
  }
}
    `;
export const AdminActItemFragmentDoc = gql`
    fragment AdminActItem on Act {
  id
  status
  contactStatus
  name
  category
  workTitle
  selfDescription
  description
  createdAt
  creatorId
  creator {
    id
    fullName
  }
  competition {
    id
    name
    year
  }
  attachments {
    id
    type
  }
}
    `;
export const AdminCustomFeedItemFragmentDoc = gql`
    fragment AdminCustomFeedItem on CustomFeed {
  id
  heading
  text
  buttonText
  buttonUrl
  image
  video
}
    `;
export const AdminUserDetailFragmentDoc = gql`
    fragment AdminUserDetail on User {
  id
  email
  firstName
  lastName
  fullName
  pronounsMulti
  pronounsOther
  avatarUrl
  avatar
  region
  interests
  bio
  tiktok
  notes
  instagram
  reasonForSigningUp
  howDidYouHearMulti
  contactPreference
  telephone
  dateOfBirth
  gender
  residence
  address
  postcode
  school
  schoolType
  foundVia
  parentEmail
  isPrivacyCheckAccepted
  isParentNotified
  isOver16
  role
  privacySetting
  createdAt
  updatedAt
  archivedAt
  acts {
    count
  }
}
    `;
export const AdminProjectDetailFragmentDoc = gql`
    fragment AdminProjectDetail on Project {
  id
  title
  category
  description
  pdf
  image
  url
  isSensitiveContent
  isFeatured
  isApproved
  privacySetting
  creator {
    id
    fullName
    avatarUrl
  }
  createdAt
  collaborators {
    items {
      id
      fullName
    }
    count
  }
}
    `;
export const AdminUserItemFragmentDoc = gql`
    fragment AdminUserItem on User {
  id
  firstName
  lastName
  fullName
  region
  email
  completedTutorialsCount
  eventsCount
  createdActsCount
  isTooOld
  updatedAt
  createdAt
  archivedAt
  dateOfBirth
}
    `;
export const AdminPageDetailFragmentDoc = gql`
    fragment AdminPageDetail on Page {
  id
  name
  slug
  content
}
    `;
export const AdminPageItemFragmentDoc = gql`
    fragment AdminPageItem on Page {
  id
  name
  slug
  content
  createdAt
  updatedAt
}
    `;
export const AdminPostDetailFragmentDoc = gql`
    fragment AdminPostDetail on Post {
  id
  title
  description
  categories
  region
  type
  isClosed
  deadline
  videoUrl
}
    `;
export const AdminPostItemFragmentDoc = gql`
    fragment AdminPostItem on Post {
  id
  title
  description
  type
  region
  categories
  user {
    id
    fullName
    isTooOld
  }
  matchedUsers {
    count
  }
  createdAt
  updatedAt
}
    `;
export const AdminProjectItemFragmentDoc = gql`
    fragment AdminProjectItem on Project {
  id
  title
  category
  isFeatured
  isApproved
  privacySetting
  creator {
    id
    fullName
  }
  createdAt
}
    `;
export const AdminRegionPageDetailFragmentDoc = gql`
    fragment AdminRegionPageDetail on RegionPage {
  id
  slug
  name
  description
  imageUrl
  address
  phone
  email
  instagram
  facebook
  tiktok
  whatsapp
  youtube
  twitter
  linkedin
}
    `;
export const AdminRegionPageItemFragmentDoc = gql`
    fragment AdminRegionPageItem on RegionPage {
  id
  name
  slug
  createdAt
  updatedAt
}
    `;
export const AdminEventInfoFragmentDoc = gql`
    fragment AdminEventInfo on Event {
  id
  name
  slug
  date
  time
  location
  content
  image
  type
  region
  categories
  disabilityProvisions
  ticketLink
  maxAttendees
  isRestrictedToRegion
  isAttendable
  isPublished
  isReviewable
  createdAt
  updatedAt
  ticketLink
}
    `;
export const AdminEventItemFragmentDoc = gql`
    fragment AdminEventItem on Event {
  id
  name
  date
  slug
  type
  region
  categories
  maxAttendees
  isPublished
  createdAt
  updatedAt
  attendeeCount
}
    `;
export const AdminTutorialDetailFragmentDoc = gql`
    fragment AdminTutorialDetail on Tutorial {
  id
  title
  description
  categories
  duration
  videoUrl
  instructor
  isLive
  difficultyRating
  viewCount
}
    `;
export const AdminTutorialItemFragmentDoc = gql`
    fragment AdminTutorialItem on Tutorial {
  id
  title
  description
  categories
  isLive
  viewCount
  createdAt
  updatedAt
}
    `;
export const AdminCompetitionInfoFragmentDoc = gql`
    fragment AdminCompetitionInfo on Competition {
  id
  name
  slug
  firstRoundDate
  time
  isLive
  region
  location
  content
  thumbnail
  program
  ticketLink
  shopLink
  year
  isArchived
  isFinal
  disabilityProvisions
  acts {
    count
  }
}
    `;
export const AdminCompetitionItemFragmentDoc = gql`
    fragment AdminCompetitionItem on Competition {
  id
  name
  slug
  content
  createdAt
  updatedAt
}
    `;
export const CommentItemDetailFragmentDoc = gql`
    fragment CommentItemDetail on Comment {
  id
  message
  createdAt
  deletedAt
  isPrivate
  userId
  user {
    id
    fullName
    avatarUrl
  }
}
    `;
export const PostDetailFragmentDoc = gql`
    fragment PostDetail on Post {
  id
  title
  description
  type
  region
  categories
  deadline
  videoUrl
  createdAt
  user {
    id
    avatarUrl
    fullName
    interests
  }
  comments {
    items {
      ...CommentItemDetail
    }
    count
  }
  matchedUsers {
    items {
      id
      fullName
      avatarUrl
      customSlug
    }
    count
  }
  commenters {
    items {
      id
      fullName
      avatarUrl
    }
    count
  }
}
    ${CommentItemDetailFragmentDoc}`;
export const RegionPageDetailFragmentDoc = gql`
    fragment RegionPageDetail on RegionPage {
  id
  name
  description
  imageUrl
  address
  phone
  email
  instagram
  facebook
  tiktok
  whatsapp
  youtube
  twitter
  linkedin
  regionPeople {
    id
    name
    type
    imageUrl
    email
    bio
  }
  regionPartners {
    id
    imageUrl
    url
  }
  regionFinancers {
    id
    imageUrl
    url
  }
}
    `;
export const EventAttendeeFragmentDoc = gql`
    fragment EventAttendee on EventAttendee {
  id
  firstName
  avatarUrl
  privacySetting
}
    `;
export const EventPersonFragmentDoc = gql`
    fragment EventPerson on EventPerson {
  id
  name
  bio
  imageUrl
  type
}
    `;
export const EventDetailFragmentDoc = gql`
    fragment EventDetail on Event {
  id
  name
  slug
  date
  time
  location
  content
  image
  type
  region
  categories
  disabilityProvisions
  ticketLink
  maxAttendees
  isRestrictedToRegion
  isAttendable
  isPublished
  createdAt
  updatedAt
  ticketLink
  isAttending
  attendeeCount
  attendees(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...EventAttendee
    }
    count
  }
  eventPeople {
    ...EventPerson
  }
}
    ${EventAttendeeFragmentDoc}
${EventPersonFragmentDoc}`;
export const CommentItemFragmentDoc = gql`
    fragment CommentItem on Comment {
  id
  message
  createdAt
  isPrivate
  user {
    id
    firstName
    lastName
    fullName
    avatarUrl
  }
}
    `;
export const TutorialDetailFragmentDoc = gql`
    fragment TutorialDetail on Tutorial {
  id
  videoUrl
  title
  instructor
  categories
  isLive
  viewCount
  hasCompleted
  difficultyRating
  comments(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...CommentItem
    }
    count
  }
}
    ${CommentItemFragmentDoc}`;
export const ProfileEditDetailsFragmentDoc = gql`
    fragment ProfileEditDetails on User {
  id
  firstName
  lastName
  fullName
  pronounsMulti
  pronounsOther
  email
  bio
  avatar
  address
  postcode
  avatarUrl
  region
  tiktok
  customSlug
  instagram
  interests
  contactPreference
  privacySetting
  telephone
  dateOfBirth
  gender
  residence
  schoolType
  school
  howDidYouHearMulti
}
    `;
export const UserConnectionFragmentDoc = gql`
    fragment UserConnection on UserConnection {
  id
  user {
    id
    fullName
    avatarUrl
    interests
  }
  follower {
    id
    fullName
    avatarUrl
    interests
  }
}
    `;
export const PostItemFragmentDoc = gql`
    fragment PostItem on Post {
  id
  title
  description
  categories
  region
  deadline
  type
  videoUrl
  user {
    fullName
    avatarUrl
  }
  matchedUsers {
    count
  }
  createdAt
  comments {
    count
  }
}
    `;
export const LatestProjectItemFragmentDoc = gql`
    fragment LatestProjectItem on Project {
  id
  title
  image
  url
  creator {
    id
  }
  comments {
    count
  }
}
    `;
export const RecommendedConnectionItemFragmentDoc = gql`
    fragment RecommendedConnectionItem on User {
  id
  firstName
  interests
  avatarUrl
  customSlug
}
    `;
export const EventItemFragmentDoc = gql`
    fragment EventItem on Event {
  id
  name
  type
  region
  categories
  image
  date
  slug
  time
  location
  time
  maxAttendees
  attendeeCount
}
    `;
export const TutorialItemFragmentDoc = gql`
    fragment TutorialItem on Tutorial {
  id
  videoUrl
  title
  duration
  instructor
  categories
  isLive
  createdAt
  hasCompleted
  difficultyRating
}
    `;
export const AgendaItemFragmentDoc = gql`
    fragment AgendaItem on AgendaItem {
  name
  date
  type
  slug
  image
}
    `;
export const UserProfileFragmentDoc = gql`
    fragment UserProfile on User {
  id
  firstName
  lastName
  fullName
  pronounsMulti
  pronounsOther
  bio
  avatarUrl
  interests
  privacySetting
  isConnected
  connectionStatus
  connections {
    ...UserConnection
  }
  connectionProjects {
    items {
      id
    }
  }
  tiktok
  instagram
  connectionsCount
  recommendedPosts {
    items {
      ...PostItem
    }
  }
  connectionProjects {
    items {
      ...LatestProjectItem
    }
  }
  recommendedConnections {
    ...RecommendedConnectionItem
  }
  recommendedEvents {
    ...EventItem
  }
  recommendedTutorials {
    ...TutorialItem
  }
  agenda {
    ...AgendaItem
  }
}
    ${UserConnectionFragmentDoc}
${PostItemFragmentDoc}
${LatestProjectItemFragmentDoc}
${RecommendedConnectionItemFragmentDoc}
${EventItemFragmentDoc}
${TutorialItemFragmentDoc}
${AgendaItemFragmentDoc}`;
export const CollaboratorItemFragmentDoc = gql`
    fragment CollaboratorItem on User {
  id
  firstName
  avatarUrl
}
    `;
export const ProjectDetailFragmentDoc = gql`
    fragment ProjectDetail on Project {
  id
  title
  description
  pdf
  image
  url
  isSensitiveContent
  privacySetting
  creatorId
  creator {
    id
    avatarUrl
    fullName
    interests
  }
  createdAt
  comments(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...CommentItem
    }
    count
  }
  collaborators {
    items {
      ...CollaboratorItem
    }
    count
  }
}
    ${CommentItemFragmentDoc}
${CollaboratorItemFragmentDoc}`;
export const EditProjectFragmentDoc = gql`
    fragment EditProject on Project {
  id
  title
  description
  pdf
  image
  url
  isSensitiveContent
  isFeatured
  isApproved
  privacySetting
  creatorId
  collaborators {
    items {
      id
      fullName
    }
    count
  }
}
    `;
export const UserItemFragmentDoc = gql`
    fragment UserItem on User {
  id
  firstName
  lastName
  fullName
  customSlug
  avatarUrl
  interests
}
    `;
export const ApplyCompetitionFragmentDoc = gql`
    fragment ApplyCompetition on Competition {
  id
  name
  deadline
  region
  year
  slug
  ...CompetitionDeadlines
}
    ${CompetitionDeadlinesFragmentDoc}`;
export const Step1ActFragmentDoc = gql`
    fragment Step1Act on Act {
  id
  category
  completedPercent
}
    `;
export const Step2ActFragmentDoc = gql`
    fragment Step2Act on Act {
  id
  name
  workTitle
  selfDescription
  description
  genre
  memberCount
  category
  link
  motivation
  hasSelfProducedTracks
  hasIntroSong
  lengthOfSet
  lengthOfDjSet
  lengthOfFilmSet
  presentationText
  djEquipment
  requiresDjLaptop
  djSoftware
  ownDjEquipment
  contentType
  numberOfArtworksPieces
  artworkDimensions
  artworkSize
  artworkStand
  artworkMaterial
  filmVideoFormat
  lightingSettings
  lightingAtEnd
  lightingInstructions
  extraLightingInformation
  microphoneCount
  completedPercent
}
    `;
export const Step3ActFragmentDoc = gql`
    fragment Step3Act on Act {
  id
  category
  requiresMusicNew
  musicInstructions
  areVisualsUsedNew
  hasSentVisuals
  visualsVideoFormat
  extraVisualsInformation
  extraMusicInstruments
  ownMusicInstruments
  decor
  extraMaterial
  extraInformation
  completedPercent
}
    `;
export const ActAttachmentFragmentDoc = gql`
    fragment ActAttachment on ActAttachment {
  id
  name
  type
  fileUrl
}
    `;
export const ActAttachmentsFragmentDoc = gql`
    fragment ActAttachments on Act {
  id
  attachments {
    ...ActAttachment
  }
}
    ${ActAttachmentFragmentDoc}`;
export const ApplyActMemberFragmentDoc = gql`
    fragment ApplyActMember on User {
  id
  avatarUrl
  fullName
  email
  pendingInvitationIds
}
    `;
export const ActMemberInviteFragmentDoc = gql`
    fragment ActMemberInvite on ActInvitation {
  id
  email
  actId
}
    `;
export const ActInvitationsFragmentDoc = gql`
    fragment ActInvitations on Act {
  id
  category
  completedPercent
  members {
    count
    items {
      ...ApplyActMember
    }
  }
  invitations {
    ...ActMemberInvite
  }
}
    ${ApplyActMemberFragmentDoc}
${ActMemberInviteFragmentDoc}`;
export const ActConfirmationFragmentDoc = gql`
    fragment ActConfirmation on Act {
  id
  name
  genre
  category
  memberCount
  completedPercent
}
    `;
export const ApplyActFragmentDoc = gql`
    fragment ApplyAct on Act {
  id
  status
  isReadonly
  isEditableAfterCompetitionClosed
  ...Step1Act
  ...Step2Act
  ...Step3Act
  ...ActAttachments
  ...ActInvitations
  ...ActConfirmation
  competition {
    id
    year
    ...CompetitionDeadlines
  }
}
    ${Step1ActFragmentDoc}
${Step2ActFragmentDoc}
${Step3ActFragmentDoc}
${ActAttachmentsFragmentDoc}
${ActInvitationsFragmentDoc}
${ActConfirmationFragmentDoc}
${CompetitionDeadlinesFragmentDoc}`;
export const CompetitionPersonFragmentDoc = gql`
    fragment CompetitionPerson on CompetitionPerson {
  id
  name
  bio
  imageUrl
  type
  category
}
    `;
export const CompetitionPrizeFragmentDoc = gql`
    fragment CompetitionPrize on CompetitionPrize {
  id
  description
  position
  category
}
    `;
export const CompetitionPartnerFragmentDoc = gql`
    fragment CompetitionPartner on CompetitionPartner {
  id
  imageUrl
  url
  type
}
    `;
export const CompetitionApplicantFragmentDoc = gql`
    fragment CompetitionApplicant on Applicant {
  id
  category
  members {
    id
    firstName
    avatarUrl
    privacySetting
  }
}
    `;
export const CompetitionDetailFragmentDoc = gql`
    fragment CompetitionDetail on Competition {
  id
  name
  time
  content
  slug
  ticketLink
  shopLink
  program
  isFinal
  location
  disabilityProvisions
  deadline
  ...CompetitionDeadlines
  competitionPeople {
    ...CompetitionPerson
  }
  competitionPrizes {
    ...CompetitionPrize
  }
  competitionPartners {
    ...CompetitionPartner
  }
  applicants(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...CompetitionApplicant
    }
    count
  }
}
    ${CompetitionDeadlinesFragmentDoc}
${CompetitionPersonFragmentDoc}
${CompetitionPrizeFragmentDoc}
${CompetitionPartnerFragmentDoc}
${CompetitionApplicantFragmentDoc}`;
export const AdminGetActAttachmentsDocument = gql`
    query AdminGetActAttachments($where: ActAttachmentWhereInput, $orderBy: [ActAttachmentOrderByWithRelationInput!], $take: Int, $skip: Int) {
  actAttachments(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    items {
      ...AdminActAttachment
    }
    count
  }
}
    ${AdminActAttachmentFragmentDoc}`;
export function useAdminGetActAttachmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminGetActAttachmentsQuery, AdminGetActAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminGetActAttachmentsQuery, AdminGetActAttachmentsQueryVariables>(AdminGetActAttachmentsDocument, options);
      }
export function useAdminGetActAttachmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminGetActAttachmentsQuery, AdminGetActAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminGetActAttachmentsQuery, AdminGetActAttachmentsQueryVariables>(AdminGetActAttachmentsDocument, options);
        }
export function useAdminGetActAttachmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminGetActAttachmentsQuery, AdminGetActAttachmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminGetActAttachmentsQuery, AdminGetActAttachmentsQueryVariables>(AdminGetActAttachmentsDocument, options);
        }
export type AdminGetActAttachmentsQueryHookResult = ReturnType<typeof useAdminGetActAttachmentsQuery>;
export type AdminGetActAttachmentsLazyQueryHookResult = ReturnType<typeof useAdminGetActAttachmentsLazyQuery>;
export type AdminGetActAttachmentsSuspenseQueryHookResult = ReturnType<typeof useAdminGetActAttachmentsSuspenseQuery>;
export type AdminGetActAttachmentsQueryResult = Apollo.QueryResult<AdminGetActAttachmentsQuery, AdminGetActAttachmentsQueryVariables>;
export const AdminDeleteActAttachmentDocument = gql`
    mutation AdminDeleteActAttachment($id: String!) {
  deleteActAttachment(id: $id)
}
    `;
export function useAdminDeleteActAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteActAttachmentMutation, AdminDeleteActAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteActAttachmentMutation, AdminDeleteActAttachmentMutationVariables>(AdminDeleteActAttachmentDocument, options);
      }
export type AdminDeleteActAttachmentMutationHookResult = ReturnType<typeof useAdminDeleteActAttachmentMutation>;
export type AdminDeleteActAttachmentMutationResult = Apollo.MutationResult<AdminDeleteActAttachmentMutation>;
export type AdminDeleteActAttachmentMutationOptions = Apollo.BaseMutationOptions<AdminDeleteActAttachmentMutation, AdminDeleteActAttachmentMutationVariables>;
export const UpdateActAdminDocument = gql`
    mutation UpdateActAdmin($id: String!, $data: UpdateActAdminInput!) {
  updateActAdmin(id: $id, data: $data) {
    ...AdminActDetail
  }
}
    ${AdminActDetailFragmentDoc}`;
export function useUpdateActAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateActAdminMutation, UpdateActAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateActAdminMutation, UpdateActAdminMutationVariables>(UpdateActAdminDocument, options);
      }
export type UpdateActAdminMutationHookResult = ReturnType<typeof useUpdateActAdminMutation>;
export type UpdateActAdminMutationResult = Apollo.MutationResult<UpdateActAdminMutation>;
export type UpdateActAdminMutationOptions = Apollo.BaseMutationOptions<UpdateActAdminMutation, UpdateActAdminMutationVariables>;
export const DestroyAdminActDocument = gql`
    mutation DestroyAdminAct($id: String!) {
  destroyAct(id: $id)
}
    `;
export function useDestroyAdminActMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminActMutation, DestroyAdminActMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminActMutation, DestroyAdminActMutationVariables>(DestroyAdminActDocument, options);
      }
export type DestroyAdminActMutationHookResult = ReturnType<typeof useDestroyAdminActMutation>;
export type DestroyAdminActMutationResult = Apollo.MutationResult<DestroyAdminActMutation>;
export type DestroyAdminActMutationOptions = Apollo.BaseMutationOptions<DestroyAdminActMutation, DestroyAdminActMutationVariables>;
export const GetAdminActGroupMembersDocument = gql`
    query GetAdminActGroupMembers($id: String!, $take: Int, $orderBy: [UserOrderByWithRelationInput!], $where: UserWhereInput, $skip: Int) {
  act(id: $id) {
    id
    creatorId
    members(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...ActGroupMember
      }
      count
    }
  }
}
    ${ActGroupMemberFragmentDoc}`;
export function useGetAdminActGroupMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminActGroupMembersQuery, GetAdminActGroupMembersQueryVariables> & ({ variables: GetAdminActGroupMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminActGroupMembersQuery, GetAdminActGroupMembersQueryVariables>(GetAdminActGroupMembersDocument, options);
      }
export function useGetAdminActGroupMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminActGroupMembersQuery, GetAdminActGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminActGroupMembersQuery, GetAdminActGroupMembersQueryVariables>(GetAdminActGroupMembersDocument, options);
        }
export function useGetAdminActGroupMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminActGroupMembersQuery, GetAdminActGroupMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminActGroupMembersQuery, GetAdminActGroupMembersQueryVariables>(GetAdminActGroupMembersDocument, options);
        }
export type GetAdminActGroupMembersQueryHookResult = ReturnType<typeof useGetAdminActGroupMembersQuery>;
export type GetAdminActGroupMembersLazyQueryHookResult = ReturnType<typeof useGetAdminActGroupMembersLazyQuery>;
export type GetAdminActGroupMembersSuspenseQueryHookResult = ReturnType<typeof useGetAdminActGroupMembersSuspenseQuery>;
export type GetAdminActGroupMembersQueryResult = Apollo.QueryResult<GetAdminActGroupMembersQuery, GetAdminActGroupMembersQueryVariables>;
export const ResendActInviteDocument = gql`
    mutation ResendActInvite($actId: String!, $userId: String!) {
  resendActInvite(actId: $actId, userId: $userId)
}
    `;
export function useResendActInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendActInviteMutation, ResendActInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendActInviteMutation, ResendActInviteMutationVariables>(ResendActInviteDocument, options);
      }
export type ResendActInviteMutationHookResult = ReturnType<typeof useResendActInviteMutation>;
export type ResendActInviteMutationResult = Apollo.MutationResult<ResendActInviteMutation>;
export type ResendActInviteMutationOptions = Apollo.BaseMutationOptions<ResendActInviteMutation, ResendActInviteMutationVariables>;
export const AdminInviteActMembersDocument = gql`
    mutation AdminInviteActMembers($actId: String!, $data: [UpdateUserInput!]!) {
  inviteActMembersAdmin(actId: $actId, data: $data) {
    id
  }
}
    `;
export function useAdminInviteActMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminInviteActMembersMutation, AdminInviteActMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminInviteActMembersMutation, AdminInviteActMembersMutationVariables>(AdminInviteActMembersDocument, options);
      }
export type AdminInviteActMembersMutationHookResult = ReturnType<typeof useAdminInviteActMembersMutation>;
export type AdminInviteActMembersMutationResult = Apollo.MutationResult<AdminInviteActMembersMutation>;
export type AdminInviteActMembersMutationOptions = Apollo.BaseMutationOptions<AdminInviteActMembersMutation, AdminInviteActMembersMutationVariables>;
export const GetAdminFinalCompetitionDocument = gql`
    query GetAdminFinalCompetition($year: Float!) {
  finalCompetition(year: $year) {
    id
    name
  }
}
    `;
export function useGetAdminFinalCompetitionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminFinalCompetitionQuery, GetAdminFinalCompetitionQueryVariables> & ({ variables: GetAdminFinalCompetitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminFinalCompetitionQuery, GetAdminFinalCompetitionQueryVariables>(GetAdminFinalCompetitionDocument, options);
      }
export function useGetAdminFinalCompetitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminFinalCompetitionQuery, GetAdminFinalCompetitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminFinalCompetitionQuery, GetAdminFinalCompetitionQueryVariables>(GetAdminFinalCompetitionDocument, options);
        }
export function useGetAdminFinalCompetitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminFinalCompetitionQuery, GetAdminFinalCompetitionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminFinalCompetitionQuery, GetAdminFinalCompetitionQueryVariables>(GetAdminFinalCompetitionDocument, options);
        }
export type GetAdminFinalCompetitionQueryHookResult = ReturnType<typeof useGetAdminFinalCompetitionQuery>;
export type GetAdminFinalCompetitionLazyQueryHookResult = ReturnType<typeof useGetAdminFinalCompetitionLazyQuery>;
export type GetAdminFinalCompetitionSuspenseQueryHookResult = ReturnType<typeof useGetAdminFinalCompetitionSuspenseQuery>;
export type GetAdminFinalCompetitionQueryResult = Apollo.QueryResult<GetAdminFinalCompetitionQuery, GetAdminFinalCompetitionQueryVariables>;
export const GetActCountDocument = gql`
    query GetActCount($data: StatsInput!) {
  actCount(data: $data)
}
    `;
export function useGetActCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActCountQuery, GetActCountQueryVariables> & ({ variables: GetActCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActCountQuery, GetActCountQueryVariables>(GetActCountDocument, options);
      }
export function useGetActCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActCountQuery, GetActCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActCountQuery, GetActCountQueryVariables>(GetActCountDocument, options);
        }
export function useGetActCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActCountQuery, GetActCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActCountQuery, GetActCountQueryVariables>(GetActCountDocument, options);
        }
export type GetActCountQueryHookResult = ReturnType<typeof useGetActCountQuery>;
export type GetActCountLazyQueryHookResult = ReturnType<typeof useGetActCountLazyQuery>;
export type GetActCountSuspenseQueryHookResult = ReturnType<typeof useGetActCountSuspenseQuery>;
export type GetActCountQueryResult = Apollo.QueryResult<GetActCountQuery, GetActCountQueryVariables>;
export const GetActMemberCountDocument = gql`
    query GetActMemberCount($data: StatsInput!) {
  actMembersCount(data: $data)
}
    `;
export function useGetActMemberCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActMemberCountQuery, GetActMemberCountQueryVariables> & ({ variables: GetActMemberCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActMemberCountQuery, GetActMemberCountQueryVariables>(GetActMemberCountDocument, options);
      }
export function useGetActMemberCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActMemberCountQuery, GetActMemberCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActMemberCountQuery, GetActMemberCountQueryVariables>(GetActMemberCountDocument, options);
        }
export function useGetActMemberCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActMemberCountQuery, GetActMemberCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActMemberCountQuery, GetActMemberCountQueryVariables>(GetActMemberCountDocument, options);
        }
export type GetActMemberCountQueryHookResult = ReturnType<typeof useGetActMemberCountQuery>;
export type GetActMemberCountLazyQueryHookResult = ReturnType<typeof useGetActMemberCountLazyQuery>;
export type GetActMemberCountSuspenseQueryHookResult = ReturnType<typeof useGetActMemberCountSuspenseQuery>;
export type GetActMemberCountQueryResult = Apollo.QueryResult<GetActMemberCountQuery, GetActMemberCountQueryVariables>;
export const GetActsByCategoryDocument = gql`
    query GetActsByCategory($data: StatsInput!) {
  actsByCategory(data: $data) {
    category
    _count
  }
}
    `;
export function useGetActsByCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActsByCategoryQuery, GetActsByCategoryQueryVariables> & ({ variables: GetActsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActsByCategoryQuery, GetActsByCategoryQueryVariables>(GetActsByCategoryDocument, options);
      }
export function useGetActsByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActsByCategoryQuery, GetActsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActsByCategoryQuery, GetActsByCategoryQueryVariables>(GetActsByCategoryDocument, options);
        }
export function useGetActsByCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActsByCategoryQuery, GetActsByCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActsByCategoryQuery, GetActsByCategoryQueryVariables>(GetActsByCategoryDocument, options);
        }
export type GetActsByCategoryQueryHookResult = ReturnType<typeof useGetActsByCategoryQuery>;
export type GetActsByCategoryLazyQueryHookResult = ReturnType<typeof useGetActsByCategoryLazyQuery>;
export type GetActsByCategorySuspenseQueryHookResult = ReturnType<typeof useGetActsByCategorySuspenseQuery>;
export type GetActsByCategoryQueryResult = Apollo.QueryResult<GetActsByCategoryQuery, GetActsByCategoryQueryVariables>;
export const GetActsByStatusDocument = gql`
    query GetActsByStatus($data: StatsInput!) {
  actsByStatus(data: $data) {
    status
    _count
  }
}
    `;
export function useGetActsByStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActsByStatusQuery, GetActsByStatusQueryVariables> & ({ variables: GetActsByStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActsByStatusQuery, GetActsByStatusQueryVariables>(GetActsByStatusDocument, options);
      }
export function useGetActsByStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActsByStatusQuery, GetActsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActsByStatusQuery, GetActsByStatusQueryVariables>(GetActsByStatusDocument, options);
        }
export function useGetActsByStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActsByStatusQuery, GetActsByStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActsByStatusQuery, GetActsByStatusQueryVariables>(GetActsByStatusDocument, options);
        }
export type GetActsByStatusQueryHookResult = ReturnType<typeof useGetActsByStatusQuery>;
export type GetActsByStatusLazyQueryHookResult = ReturnType<typeof useGetActsByStatusLazyQuery>;
export type GetActsByStatusSuspenseQueryHookResult = ReturnType<typeof useGetActsByStatusSuspenseQuery>;
export type GetActsByStatusQueryResult = Apollo.QueryResult<GetActsByStatusQuery, GetActsByStatusQueryVariables>;
export const GetActsByAgeDocument = gql`
    query GetActsByAge($data: StatsInput!) {
  actsByAge(data: $data) {
    age
    count
  }
}
    `;
export function useGetActsByAgeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActsByAgeQuery, GetActsByAgeQueryVariables> & ({ variables: GetActsByAgeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActsByAgeQuery, GetActsByAgeQueryVariables>(GetActsByAgeDocument, options);
      }
export function useGetActsByAgeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActsByAgeQuery, GetActsByAgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActsByAgeQuery, GetActsByAgeQueryVariables>(GetActsByAgeDocument, options);
        }
export function useGetActsByAgeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActsByAgeQuery, GetActsByAgeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActsByAgeQuery, GetActsByAgeQueryVariables>(GetActsByAgeDocument, options);
        }
export type GetActsByAgeQueryHookResult = ReturnType<typeof useGetActsByAgeQuery>;
export type GetActsByAgeLazyQueryHookResult = ReturnType<typeof useGetActsByAgeLazyQuery>;
export type GetActsByAgeSuspenseQueryHookResult = ReturnType<typeof useGetActsByAgeSuspenseQuery>;
export type GetActsByAgeQueryResult = Apollo.QueryResult<GetActsByAgeQuery, GetActsByAgeQueryVariables>;
export const GetActSignUpsByDayDocument = gql`
    query GetActSignUpsByDay($data: StatsInput!) {
  actSignUpsByDay(data: $data) {
    week
    count
  }
}
    `;
export function useGetActSignUpsByDayQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActSignUpsByDayQuery, GetActSignUpsByDayQueryVariables> & ({ variables: GetActSignUpsByDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActSignUpsByDayQuery, GetActSignUpsByDayQueryVariables>(GetActSignUpsByDayDocument, options);
      }
export function useGetActSignUpsByDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActSignUpsByDayQuery, GetActSignUpsByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActSignUpsByDayQuery, GetActSignUpsByDayQueryVariables>(GetActSignUpsByDayDocument, options);
        }
export function useGetActSignUpsByDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActSignUpsByDayQuery, GetActSignUpsByDayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActSignUpsByDayQuery, GetActSignUpsByDayQueryVariables>(GetActSignUpsByDayDocument, options);
        }
export type GetActSignUpsByDayQueryHookResult = ReturnType<typeof useGetActSignUpsByDayQuery>;
export type GetActSignUpsByDayLazyQueryHookResult = ReturnType<typeof useGetActSignUpsByDayLazyQuery>;
export type GetActSignUpsByDaySuspenseQueryHookResult = ReturnType<typeof useGetActSignUpsByDaySuspenseQuery>;
export type GetActSignUpsByDayQueryResult = Apollo.QueryResult<GetActSignUpsByDayQuery, GetActSignUpsByDayQueryVariables>;
export const GetAdminCompetitionActsDocument = gql`
    query GetAdminCompetitionActs($slug: String!, $take: Int, $orderBy: [ActOrderByWithRelationInput!], $where: ActWhereInput, $skip: Int) {
  competition(slug: $slug) {
    id
    acts(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...AdminCompetitionAct
      }
      count
    }
    applicants {
      count
    }
  }
}
    ${AdminCompetitionActFragmentDoc}`;
export function useGetAdminCompetitionActsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionActsQuery, GetAdminCompetitionActsQueryVariables> & ({ variables: GetAdminCompetitionActsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionActsQuery, GetAdminCompetitionActsQueryVariables>(GetAdminCompetitionActsDocument, options);
      }
export function useGetAdminCompetitionActsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionActsQuery, GetAdminCompetitionActsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionActsQuery, GetAdminCompetitionActsQueryVariables>(GetAdminCompetitionActsDocument, options);
        }
export function useGetAdminCompetitionActsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionActsQuery, GetAdminCompetitionActsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionActsQuery, GetAdminCompetitionActsQueryVariables>(GetAdminCompetitionActsDocument, options);
        }
export type GetAdminCompetitionActsQueryHookResult = ReturnType<typeof useGetAdminCompetitionActsQuery>;
export type GetAdminCompetitionActsLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionActsLazyQuery>;
export type GetAdminCompetitionActsSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionActsSuspenseQuery>;
export type GetAdminCompetitionActsQueryResult = Apollo.QueryResult<GetAdminCompetitionActsQuery, GetAdminCompetitionActsQueryVariables>;
export const GetAdminCompetitionDeadlinesDocument = gql`
    query GetAdminCompetitionDeadlines($slug: String!) {
  competition(slug: $slug) {
    id
    ...CompetitionDeadlines
  }
}
    ${CompetitionDeadlinesFragmentDoc}`;
export function useGetAdminCompetitionDeadlinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionDeadlinesQuery, GetAdminCompetitionDeadlinesQueryVariables> & ({ variables: GetAdminCompetitionDeadlinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionDeadlinesQuery, GetAdminCompetitionDeadlinesQueryVariables>(GetAdminCompetitionDeadlinesDocument, options);
      }
export function useGetAdminCompetitionDeadlinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionDeadlinesQuery, GetAdminCompetitionDeadlinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionDeadlinesQuery, GetAdminCompetitionDeadlinesQueryVariables>(GetAdminCompetitionDeadlinesDocument, options);
        }
export function useGetAdminCompetitionDeadlinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionDeadlinesQuery, GetAdminCompetitionDeadlinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionDeadlinesQuery, GetAdminCompetitionDeadlinesQueryVariables>(GetAdminCompetitionDeadlinesDocument, options);
        }
export type GetAdminCompetitionDeadlinesQueryHookResult = ReturnType<typeof useGetAdminCompetitionDeadlinesQuery>;
export type GetAdminCompetitionDeadlinesLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionDeadlinesLazyQuery>;
export type GetAdminCompetitionDeadlinesSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionDeadlinesSuspenseQuery>;
export type GetAdminCompetitionDeadlinesQueryResult = Apollo.QueryResult<GetAdminCompetitionDeadlinesQuery, GetAdminCompetitionDeadlinesQueryVariables>;
export const UpdateCompetitionDocument = gql`
    mutation UpdateCompetition($id: String!, $data: UpdateCompetitionInput!) {
  updateCompetition(id: $id, data: $data) {
    ...AdminCompetitionInfo
  }
}
    ${AdminCompetitionInfoFragmentDoc}`;
export function useUpdateCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompetitionMutation, UpdateCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompetitionMutation, UpdateCompetitionMutationVariables>(UpdateCompetitionDocument, options);
      }
export type UpdateCompetitionMutationHookResult = ReturnType<typeof useUpdateCompetitionMutation>;
export type UpdateCompetitionMutationResult = Apollo.MutationResult<UpdateCompetitionMutation>;
export type UpdateCompetitionMutationOptions = Apollo.BaseMutationOptions<UpdateCompetitionMutation, UpdateCompetitionMutationVariables>;
export const DestroyCompetitionDocument = gql`
    mutation DestroyCompetition($id: String!) {
  destroyCompetition(id: $id)
}
    `;
export function useDestroyCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyCompetitionMutation, DestroyCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyCompetitionMutation, DestroyCompetitionMutationVariables>(DestroyCompetitionDocument, options);
      }
export type DestroyCompetitionMutationHookResult = ReturnType<typeof useDestroyCompetitionMutation>;
export type DestroyCompetitionMutationResult = Apollo.MutationResult<DestroyCompetitionMutation>;
export type DestroyCompetitionMutationOptions = Apollo.BaseMutationOptions<DestroyCompetitionMutation, DestroyCompetitionMutationVariables>;
export const EmailApplicantsDocument = gql`
    mutation EmailApplicants($competitionId: String!, $message: String!) {
  emailCompetitionApplicants(competitionId: $competitionId, message: $message)
}
    `;
export function useEmailApplicantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailApplicantsMutation, EmailApplicantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailApplicantsMutation, EmailApplicantsMutationVariables>(EmailApplicantsDocument, options);
      }
export type EmailApplicantsMutationHookResult = ReturnType<typeof useEmailApplicantsMutation>;
export type EmailApplicantsMutationResult = Apollo.MutationResult<EmailApplicantsMutation>;
export type EmailApplicantsMutationOptions = Apollo.BaseMutationOptions<EmailApplicantsMutation, EmailApplicantsMutationVariables>;
export const GetAdminCompetitionActsForExportDocument = gql`
    query GetAdminCompetitionActsForExport($slug: String!, $take: Int, $orderBy: [ActOrderByWithRelationInput!], $where: ActWhereInput, $skip: Int) {
  competition(slug: $slug) {
    id
    name
    acts(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...AdminCompetitionActForExport
      }
      count
    }
  }
}
    ${AdminCompetitionActForExportFragmentDoc}`;
export function useGetAdminCompetitionActsForExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionActsForExportQuery, GetAdminCompetitionActsForExportQueryVariables> & ({ variables: GetAdminCompetitionActsForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionActsForExportQuery, GetAdminCompetitionActsForExportQueryVariables>(GetAdminCompetitionActsForExportDocument, options);
      }
export function useGetAdminCompetitionActsForExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionActsForExportQuery, GetAdminCompetitionActsForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionActsForExportQuery, GetAdminCompetitionActsForExportQueryVariables>(GetAdminCompetitionActsForExportDocument, options);
        }
export function useGetAdminCompetitionActsForExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionActsForExportQuery, GetAdminCompetitionActsForExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionActsForExportQuery, GetAdminCompetitionActsForExportQueryVariables>(GetAdminCompetitionActsForExportDocument, options);
        }
export type GetAdminCompetitionActsForExportQueryHookResult = ReturnType<typeof useGetAdminCompetitionActsForExportQuery>;
export type GetAdminCompetitionActsForExportLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionActsForExportLazyQuery>;
export type GetAdminCompetitionActsForExportSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionActsForExportSuspenseQuery>;
export type GetAdminCompetitionActsForExportQueryResult = Apollo.QueryResult<GetAdminCompetitionActsForExportQuery, GetAdminCompetitionActsForExportQueryVariables>;
export const CreateCompetitionPartnerDocument = gql`
    mutation CreateCompetitionPartner($data: CreateCompetitionPartnerInput!) {
  createCompetitionPartner(data: $data) {
    ...AdminCompetitionPartner
  }
}
    ${AdminCompetitionPartnerFragmentDoc}`;
export function useCreateCompetitionPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCompetitionPartnerMutation, CreateCompetitionPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCompetitionPartnerMutation, CreateCompetitionPartnerMutationVariables>(CreateCompetitionPartnerDocument, options);
      }
export type CreateCompetitionPartnerMutationHookResult = ReturnType<typeof useCreateCompetitionPartnerMutation>;
export type CreateCompetitionPartnerMutationResult = Apollo.MutationResult<CreateCompetitionPartnerMutation>;
export type CreateCompetitionPartnerMutationOptions = Apollo.BaseMutationOptions<CreateCompetitionPartnerMutation, CreateCompetitionPartnerMutationVariables>;
export const UpdateCompetitionPartnerDocument = gql`
    mutation UpdateCompetitionPartner($id: String!, $data: UpdateCompetitionPartnerInput!) {
  updateCompetitionPartner(id: $id, data: $data) {
    ...AdminCompetitionPartner
  }
}
    ${AdminCompetitionPartnerFragmentDoc}`;
export function useUpdateCompetitionPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompetitionPartnerMutation, UpdateCompetitionPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompetitionPartnerMutation, UpdateCompetitionPartnerMutationVariables>(UpdateCompetitionPartnerDocument, options);
      }
export type UpdateCompetitionPartnerMutationHookResult = ReturnType<typeof useUpdateCompetitionPartnerMutation>;
export type UpdateCompetitionPartnerMutationResult = Apollo.MutationResult<UpdateCompetitionPartnerMutation>;
export type UpdateCompetitionPartnerMutationOptions = Apollo.BaseMutationOptions<UpdateCompetitionPartnerMutation, UpdateCompetitionPartnerMutationVariables>;
export const GetAdminCompetitionPartnersDocument = gql`
    query GetAdminCompetitionPartners($slug: String!) {
  competition(slug: $slug) {
    id
    competitionPartners {
      ...AdminCompetitionPartner
    }
  }
}
    ${AdminCompetitionPartnerFragmentDoc}`;
export function useGetAdminCompetitionPartnersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionPartnersQuery, GetAdminCompetitionPartnersQueryVariables> & ({ variables: GetAdminCompetitionPartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionPartnersQuery, GetAdminCompetitionPartnersQueryVariables>(GetAdminCompetitionPartnersDocument, options);
      }
export function useGetAdminCompetitionPartnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionPartnersQuery, GetAdminCompetitionPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionPartnersQuery, GetAdminCompetitionPartnersQueryVariables>(GetAdminCompetitionPartnersDocument, options);
        }
export function useGetAdminCompetitionPartnersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionPartnersQuery, GetAdminCompetitionPartnersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionPartnersQuery, GetAdminCompetitionPartnersQueryVariables>(GetAdminCompetitionPartnersDocument, options);
        }
export type GetAdminCompetitionPartnersQueryHookResult = ReturnType<typeof useGetAdminCompetitionPartnersQuery>;
export type GetAdminCompetitionPartnersLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionPartnersLazyQuery>;
export type GetAdminCompetitionPartnersSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionPartnersSuspenseQuery>;
export type GetAdminCompetitionPartnersQueryResult = Apollo.QueryResult<GetAdminCompetitionPartnersQuery, GetAdminCompetitionPartnersQueryVariables>;
export const DestroyAdminCompetitionPartnerDocument = gql`
    mutation DestroyAdminCompetitionPartner($id: String!) {
  destroyCompetitionPartner(id: $id)
}
    `;
export function useDestroyAdminCompetitionPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminCompetitionPartnerMutation, DestroyAdminCompetitionPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminCompetitionPartnerMutation, DestroyAdminCompetitionPartnerMutationVariables>(DestroyAdminCompetitionPartnerDocument, options);
      }
export type DestroyAdminCompetitionPartnerMutationHookResult = ReturnType<typeof useDestroyAdminCompetitionPartnerMutation>;
export type DestroyAdminCompetitionPartnerMutationResult = Apollo.MutationResult<DestroyAdminCompetitionPartnerMutation>;
export type DestroyAdminCompetitionPartnerMutationOptions = Apollo.BaseMutationOptions<DestroyAdminCompetitionPartnerMutation, DestroyAdminCompetitionPartnerMutationVariables>;
export const GetAdminCompetitionPeopleDocument = gql`
    query GetAdminCompetitionPeople($slug: String!) {
  competition(slug: $slug) {
    id
    competitionPeople {
      ...CompetitionPerson
    }
  }
}
    ${CompetitionPersonFragmentDoc}`;
export function useGetAdminCompetitionPeopleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionPeopleQuery, GetAdminCompetitionPeopleQueryVariables> & ({ variables: GetAdminCompetitionPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionPeopleQuery, GetAdminCompetitionPeopleQueryVariables>(GetAdminCompetitionPeopleDocument, options);
      }
export function useGetAdminCompetitionPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionPeopleQuery, GetAdminCompetitionPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionPeopleQuery, GetAdminCompetitionPeopleQueryVariables>(GetAdminCompetitionPeopleDocument, options);
        }
export function useGetAdminCompetitionPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionPeopleQuery, GetAdminCompetitionPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionPeopleQuery, GetAdminCompetitionPeopleQueryVariables>(GetAdminCompetitionPeopleDocument, options);
        }
export type GetAdminCompetitionPeopleQueryHookResult = ReturnType<typeof useGetAdminCompetitionPeopleQuery>;
export type GetAdminCompetitionPeopleLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionPeopleLazyQuery>;
export type GetAdminCompetitionPeopleSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionPeopleSuspenseQuery>;
export type GetAdminCompetitionPeopleQueryResult = Apollo.QueryResult<GetAdminCompetitionPeopleQuery, GetAdminCompetitionPeopleQueryVariables>;
export const DestroyAdminCompetitionPersonDocument = gql`
    mutation DestroyAdminCompetitionPerson($id: String!) {
  destroyCompetitionPerson(id: $id)
}
    `;
export function useDestroyAdminCompetitionPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminCompetitionPersonMutation, DestroyAdminCompetitionPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminCompetitionPersonMutation, DestroyAdminCompetitionPersonMutationVariables>(DestroyAdminCompetitionPersonDocument, options);
      }
export type DestroyAdminCompetitionPersonMutationHookResult = ReturnType<typeof useDestroyAdminCompetitionPersonMutation>;
export type DestroyAdminCompetitionPersonMutationResult = Apollo.MutationResult<DestroyAdminCompetitionPersonMutation>;
export type DestroyAdminCompetitionPersonMutationOptions = Apollo.BaseMutationOptions<DestroyAdminCompetitionPersonMutation, DestroyAdminCompetitionPersonMutationVariables>;
export const CreateCompetitionPersonDocument = gql`
    mutation CreateCompetitionPerson($data: CreateCompetitionPersonInput!) {
  createCompetitionPerson(data: $data) {
    ...CompetitionPerson
  }
}
    ${CompetitionPersonFragmentDoc}`;
export function useCreateCompetitionPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCompetitionPersonMutation, CreateCompetitionPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCompetitionPersonMutation, CreateCompetitionPersonMutationVariables>(CreateCompetitionPersonDocument, options);
      }
export type CreateCompetitionPersonMutationHookResult = ReturnType<typeof useCreateCompetitionPersonMutation>;
export type CreateCompetitionPersonMutationResult = Apollo.MutationResult<CreateCompetitionPersonMutation>;
export type CreateCompetitionPersonMutationOptions = Apollo.BaseMutationOptions<CreateCompetitionPersonMutation, CreateCompetitionPersonMutationVariables>;
export const UpdateCompetitionPersonDocument = gql`
    mutation UpdateCompetitionPerson($id: String!, $data: UpdateCompetitionPersonInput!) {
  updateCompetitionPerson(id: $id, data: $data) {
    ...CompetitionPerson
  }
}
    ${CompetitionPersonFragmentDoc}`;
export function useUpdateCompetitionPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompetitionPersonMutation, UpdateCompetitionPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompetitionPersonMutation, UpdateCompetitionPersonMutationVariables>(UpdateCompetitionPersonDocument, options);
      }
export type UpdateCompetitionPersonMutationHookResult = ReturnType<typeof useUpdateCompetitionPersonMutation>;
export type UpdateCompetitionPersonMutationResult = Apollo.MutationResult<UpdateCompetitionPersonMutation>;
export type UpdateCompetitionPersonMutationOptions = Apollo.BaseMutationOptions<UpdateCompetitionPersonMutation, UpdateCompetitionPersonMutationVariables>;
export const CreateCompetitionPrizeDocument = gql`
    mutation CreateCompetitionPrize($data: CreateCompetitionPrizeInput!) {
  createCompetitionPrize(data: $data) {
    ...CompetitionPrize
  }
}
    ${CompetitionPrizeFragmentDoc}`;
export function useCreateCompetitionPrizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCompetitionPrizeMutation, CreateCompetitionPrizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCompetitionPrizeMutation, CreateCompetitionPrizeMutationVariables>(CreateCompetitionPrizeDocument, options);
      }
export type CreateCompetitionPrizeMutationHookResult = ReturnType<typeof useCreateCompetitionPrizeMutation>;
export type CreateCompetitionPrizeMutationResult = Apollo.MutationResult<CreateCompetitionPrizeMutation>;
export type CreateCompetitionPrizeMutationOptions = Apollo.BaseMutationOptions<CreateCompetitionPrizeMutation, CreateCompetitionPrizeMutationVariables>;
export const UpdateCompetitionPrizeDocument = gql`
    mutation UpdateCompetitionPrize($id: String!, $data: UpdateCompetitionPrizeInput!) {
  updateCompetitionPrize(id: $id, data: $data) {
    ...CompetitionPrize
  }
}
    ${CompetitionPrizeFragmentDoc}`;
export function useUpdateCompetitionPrizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompetitionPrizeMutation, UpdateCompetitionPrizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompetitionPrizeMutation, UpdateCompetitionPrizeMutationVariables>(UpdateCompetitionPrizeDocument, options);
      }
export type UpdateCompetitionPrizeMutationHookResult = ReturnType<typeof useUpdateCompetitionPrizeMutation>;
export type UpdateCompetitionPrizeMutationResult = Apollo.MutationResult<UpdateCompetitionPrizeMutation>;
export type UpdateCompetitionPrizeMutationOptions = Apollo.BaseMutationOptions<UpdateCompetitionPrizeMutation, UpdateCompetitionPrizeMutationVariables>;
export const GetAdminCompetitionPrizesDocument = gql`
    query GetAdminCompetitionPrizes($slug: String!) {
  competition(slug: $slug) {
    id
    competitionPrizes {
      ...CompetitionPrize
    }
  }
}
    ${CompetitionPrizeFragmentDoc}`;
export function useGetAdminCompetitionPrizesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionPrizesQuery, GetAdminCompetitionPrizesQueryVariables> & ({ variables: GetAdminCompetitionPrizesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionPrizesQuery, GetAdminCompetitionPrizesQueryVariables>(GetAdminCompetitionPrizesDocument, options);
      }
export function useGetAdminCompetitionPrizesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionPrizesQuery, GetAdminCompetitionPrizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionPrizesQuery, GetAdminCompetitionPrizesQueryVariables>(GetAdminCompetitionPrizesDocument, options);
        }
export function useGetAdminCompetitionPrizesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionPrizesQuery, GetAdminCompetitionPrizesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionPrizesQuery, GetAdminCompetitionPrizesQueryVariables>(GetAdminCompetitionPrizesDocument, options);
        }
export type GetAdminCompetitionPrizesQueryHookResult = ReturnType<typeof useGetAdminCompetitionPrizesQuery>;
export type GetAdminCompetitionPrizesLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionPrizesLazyQuery>;
export type GetAdminCompetitionPrizesSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionPrizesSuspenseQuery>;
export type GetAdminCompetitionPrizesQueryResult = Apollo.QueryResult<GetAdminCompetitionPrizesQuery, GetAdminCompetitionPrizesQueryVariables>;
export const DestroyAdminCompetitionPrizeDocument = gql`
    mutation DestroyAdminCompetitionPrize($id: String!) {
  destroyCompetitionPrize(id: $id)
}
    `;
export function useDestroyAdminCompetitionPrizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminCompetitionPrizeMutation, DestroyAdminCompetitionPrizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminCompetitionPrizeMutation, DestroyAdminCompetitionPrizeMutationVariables>(DestroyAdminCompetitionPrizeDocument, options);
      }
export type DestroyAdminCompetitionPrizeMutationHookResult = ReturnType<typeof useDestroyAdminCompetitionPrizeMutation>;
export type DestroyAdminCompetitionPrizeMutationResult = Apollo.MutationResult<DestroyAdminCompetitionPrizeMutation>;
export type DestroyAdminCompetitionPrizeMutationOptions = Apollo.BaseMutationOptions<DestroyAdminCompetitionPrizeMutation, DestroyAdminCompetitionPrizeMutationVariables>;
export const AdminCreateActAttachmentDocument = gql`
    mutation AdminCreateActAttachment($data: ActAttachmentCreateInput!) {
  createActAttachment(data: $data) {
    id
    name
    type
  }
}
    `;
export function useAdminCreateActAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateActAttachmentMutation, AdminCreateActAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateActAttachmentMutation, AdminCreateActAttachmentMutationVariables>(AdminCreateActAttachmentDocument, options);
      }
export type AdminCreateActAttachmentMutationHookResult = ReturnType<typeof useAdminCreateActAttachmentMutation>;
export type AdminCreateActAttachmentMutationResult = Apollo.MutationResult<AdminCreateActAttachmentMutation>;
export type AdminCreateActAttachmentMutationOptions = Apollo.BaseMutationOptions<AdminCreateActAttachmentMutation, AdminCreateActAttachmentMutationVariables>;
export const GetAdminEventAttendeesDocument = gql`
    query GetAdminEventAttendees($slug: String!, $take: Int, $orderBy: [UserEventOrderByWithRelationInput!], $where: UserEventWhereInput, $skip: Int) {
  event(slug: $slug) {
    id
    attendees(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...AdminEventAttendee
      }
      count
    }
  }
}
    ${AdminEventAttendeeFragmentDoc}`;
export function useGetAdminEventAttendeesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminEventAttendeesQuery, GetAdminEventAttendeesQueryVariables> & ({ variables: GetAdminEventAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminEventAttendeesQuery, GetAdminEventAttendeesQueryVariables>(GetAdminEventAttendeesDocument, options);
      }
export function useGetAdminEventAttendeesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminEventAttendeesQuery, GetAdminEventAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminEventAttendeesQuery, GetAdminEventAttendeesQueryVariables>(GetAdminEventAttendeesDocument, options);
        }
export function useGetAdminEventAttendeesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminEventAttendeesQuery, GetAdminEventAttendeesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminEventAttendeesQuery, GetAdminEventAttendeesQueryVariables>(GetAdminEventAttendeesDocument, options);
        }
export type GetAdminEventAttendeesQueryHookResult = ReturnType<typeof useGetAdminEventAttendeesQuery>;
export type GetAdminEventAttendeesLazyQueryHookResult = ReturnType<typeof useGetAdminEventAttendeesLazyQuery>;
export type GetAdminEventAttendeesSuspenseQueryHookResult = ReturnType<typeof useGetAdminEventAttendeesSuspenseQuery>;
export type GetAdminEventAttendeesQueryResult = Apollo.QueryResult<GetAdminEventAttendeesQuery, GetAdminEventAttendeesQueryVariables>;
export const AdminUnAttendEventDocument = gql`
    mutation AdminUnAttendEvent($userId: String!, $eventId: String!) {
  adminUnAttendEvent(eventId: $eventId, userId: $userId)
}
    `;
export function useAdminUnAttendEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUnAttendEventMutation, AdminUnAttendEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUnAttendEventMutation, AdminUnAttendEventMutationVariables>(AdminUnAttendEventDocument, options);
      }
export type AdminUnAttendEventMutationHookResult = ReturnType<typeof useAdminUnAttendEventMutation>;
export type AdminUnAttendEventMutationResult = Apollo.MutationResult<AdminUnAttendEventMutation>;
export type AdminUnAttendEventMutationOptions = Apollo.BaseMutationOptions<AdminUnAttendEventMutation, AdminUnAttendEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($id: String!, $data: UpdateEventInput!) {
  updateEvent(id: $id, data: $data) {
    ...AdminEventInfo
  }
}
    ${AdminEventInfoFragmentDoc}`;
export function useUpdateEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const DestroyEventDocument = gql`
    mutation DestroyEvent($id: String!) {
  destroyEvent(id: $id)
}
    `;
export function useDestroyEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyEventMutation, DestroyEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyEventMutation, DestroyEventMutationVariables>(DestroyEventDocument, options);
      }
export type DestroyEventMutationHookResult = ReturnType<typeof useDestroyEventMutation>;
export type DestroyEventMutationResult = Apollo.MutationResult<DestroyEventMutation>;
export type DestroyEventMutationOptions = Apollo.BaseMutationOptions<DestroyEventMutation, DestroyEventMutationVariables>;
export const EmailAttendeesDocument = gql`
    mutation EmailAttendees($eventId: String!, $message: String!) {
  emailEventAttendees(eventId: $eventId, message: $message)
}
    `;
export function useEmailAttendeesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailAttendeesMutation, EmailAttendeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailAttendeesMutation, EmailAttendeesMutationVariables>(EmailAttendeesDocument, options);
      }
export type EmailAttendeesMutationHookResult = ReturnType<typeof useEmailAttendeesMutation>;
export type EmailAttendeesMutationResult = Apollo.MutationResult<EmailAttendeesMutation>;
export type EmailAttendeesMutationOptions = Apollo.BaseMutationOptions<EmailAttendeesMutation, EmailAttendeesMutationVariables>;
export const GetAdminEventAttendeeForExportDocument = gql`
    query GetAdminEventAttendeeForExport($slug: String!) {
  event(slug: $slug) {
    id
    attendees {
      items {
        ...AdminEventAttendee
      }
      count
    }
  }
}
    ${AdminEventAttendeeFragmentDoc}`;
export function useGetAdminEventAttendeeForExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminEventAttendeeForExportQuery, GetAdminEventAttendeeForExportQueryVariables> & ({ variables: GetAdminEventAttendeeForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminEventAttendeeForExportQuery, GetAdminEventAttendeeForExportQueryVariables>(GetAdminEventAttendeeForExportDocument, options);
      }
export function useGetAdminEventAttendeeForExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminEventAttendeeForExportQuery, GetAdminEventAttendeeForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminEventAttendeeForExportQuery, GetAdminEventAttendeeForExportQueryVariables>(GetAdminEventAttendeeForExportDocument, options);
        }
export function useGetAdminEventAttendeeForExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminEventAttendeeForExportQuery, GetAdminEventAttendeeForExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminEventAttendeeForExportQuery, GetAdminEventAttendeeForExportQueryVariables>(GetAdminEventAttendeeForExportDocument, options);
        }
export type GetAdminEventAttendeeForExportQueryHookResult = ReturnType<typeof useGetAdminEventAttendeeForExportQuery>;
export type GetAdminEventAttendeeForExportLazyQueryHookResult = ReturnType<typeof useGetAdminEventAttendeeForExportLazyQuery>;
export type GetAdminEventAttendeeForExportSuspenseQueryHookResult = ReturnType<typeof useGetAdminEventAttendeeForExportSuspenseQuery>;
export type GetAdminEventAttendeeForExportQueryResult = Apollo.QueryResult<GetAdminEventAttendeeForExportQuery, GetAdminEventAttendeeForExportQueryVariables>;
export const GetAdminEventPeopleDocument = gql`
    query GetAdminEventPeople($slug: String!) {
  event(slug: $slug) {
    id
    eventPeople {
      ...EventPerson
    }
  }
}
    ${EventPersonFragmentDoc}`;
export function useGetAdminEventPeopleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminEventPeopleQuery, GetAdminEventPeopleQueryVariables> & ({ variables: GetAdminEventPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminEventPeopleQuery, GetAdminEventPeopleQueryVariables>(GetAdminEventPeopleDocument, options);
      }
export function useGetAdminEventPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminEventPeopleQuery, GetAdminEventPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminEventPeopleQuery, GetAdminEventPeopleQueryVariables>(GetAdminEventPeopleDocument, options);
        }
export function useGetAdminEventPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminEventPeopleQuery, GetAdminEventPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminEventPeopleQuery, GetAdminEventPeopleQueryVariables>(GetAdminEventPeopleDocument, options);
        }
export type GetAdminEventPeopleQueryHookResult = ReturnType<typeof useGetAdminEventPeopleQuery>;
export type GetAdminEventPeopleLazyQueryHookResult = ReturnType<typeof useGetAdminEventPeopleLazyQuery>;
export type GetAdminEventPeopleSuspenseQueryHookResult = ReturnType<typeof useGetAdminEventPeopleSuspenseQuery>;
export type GetAdminEventPeopleQueryResult = Apollo.QueryResult<GetAdminEventPeopleQuery, GetAdminEventPeopleQueryVariables>;
export const DestroyAdminEventPersonDocument = gql`
    mutation DestroyAdminEventPerson($id: String!) {
  destroyEventPerson(id: $id)
}
    `;
export function useDestroyAdminEventPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminEventPersonMutation, DestroyAdminEventPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminEventPersonMutation, DestroyAdminEventPersonMutationVariables>(DestroyAdminEventPersonDocument, options);
      }
export type DestroyAdminEventPersonMutationHookResult = ReturnType<typeof useDestroyAdminEventPersonMutation>;
export type DestroyAdminEventPersonMutationResult = Apollo.MutationResult<DestroyAdminEventPersonMutation>;
export type DestroyAdminEventPersonMutationOptions = Apollo.BaseMutationOptions<DestroyAdminEventPersonMutation, DestroyAdminEventPersonMutationVariables>;
export const CreateEventPersonDocument = gql`
    mutation CreateEventPerson($data: CreateEventPersonInput!) {
  createEventPerson(data: $data) {
    ...EventPerson
  }
}
    ${EventPersonFragmentDoc}`;
export function useCreateEventPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventPersonMutation, CreateEventPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEventPersonMutation, CreateEventPersonMutationVariables>(CreateEventPersonDocument, options);
      }
export type CreateEventPersonMutationHookResult = ReturnType<typeof useCreateEventPersonMutation>;
export type CreateEventPersonMutationResult = Apollo.MutationResult<CreateEventPersonMutation>;
export type CreateEventPersonMutationOptions = Apollo.BaseMutationOptions<CreateEventPersonMutation, CreateEventPersonMutationVariables>;
export const UpdateEventPersonDocument = gql`
    mutation UpdateEventPerson($id: String!, $data: UpdateEventPersonInput!) {
  updateEventPerson(id: $id, data: $data) {
    ...EventPerson
  }
}
    ${EventPersonFragmentDoc}`;
export function useUpdateEventPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventPersonMutation, UpdateEventPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEventPersonMutation, UpdateEventPersonMutationVariables>(UpdateEventPersonDocument, options);
      }
export type UpdateEventPersonMutationHookResult = ReturnType<typeof useUpdateEventPersonMutation>;
export type UpdateEventPersonMutationResult = Apollo.MutationResult<UpdateEventPersonMutation>;
export type UpdateEventPersonMutationOptions = Apollo.BaseMutationOptions<UpdateEventPersonMutation, UpdateEventPersonMutationVariables>;
export const GetAdminEventReviewsDocument = gql`
    query GetAdminEventReviews($slug: String!, $take: Int, $orderBy: [UserEventOrderByWithRelationInput!], $where: UserEventWhereInput, $skip: Int) {
  event(slug: $slug) {
    id
    reviews(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...AdminEventReview
      }
      count
    }
  }
}
    ${AdminEventReviewFragmentDoc}`;
export function useGetAdminEventReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminEventReviewsQuery, GetAdminEventReviewsQueryVariables> & ({ variables: GetAdminEventReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminEventReviewsQuery, GetAdminEventReviewsQueryVariables>(GetAdminEventReviewsDocument, options);
      }
export function useGetAdminEventReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminEventReviewsQuery, GetAdminEventReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminEventReviewsQuery, GetAdminEventReviewsQueryVariables>(GetAdminEventReviewsDocument, options);
        }
export function useGetAdminEventReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminEventReviewsQuery, GetAdminEventReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminEventReviewsQuery, GetAdminEventReviewsQueryVariables>(GetAdminEventReviewsDocument, options);
        }
export type GetAdminEventReviewsQueryHookResult = ReturnType<typeof useGetAdminEventReviewsQuery>;
export type GetAdminEventReviewsLazyQueryHookResult = ReturnType<typeof useGetAdminEventReviewsLazyQuery>;
export type GetAdminEventReviewsSuspenseQueryHookResult = ReturnType<typeof useGetAdminEventReviewsSuspenseQuery>;
export type GetAdminEventReviewsQueryResult = Apollo.QueryResult<GetAdminEventReviewsQuery, GetAdminEventReviewsQueryVariables>;
export const GetEventCountDocument = gql`
    query GetEventCount($data: StatsInput!) {
  eventCount(data: $data)
}
    `;
export function useGetEventCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEventCountQuery, GetEventCountQueryVariables> & ({ variables: GetEventCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEventCountQuery, GetEventCountQueryVariables>(GetEventCountDocument, options);
      }
export function useGetEventCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventCountQuery, GetEventCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEventCountQuery, GetEventCountQueryVariables>(GetEventCountDocument, options);
        }
export function useGetEventCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEventCountQuery, GetEventCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEventCountQuery, GetEventCountQueryVariables>(GetEventCountDocument, options);
        }
export type GetEventCountQueryHookResult = ReturnType<typeof useGetEventCountQuery>;
export type GetEventCountLazyQueryHookResult = ReturnType<typeof useGetEventCountLazyQuery>;
export type GetEventCountSuspenseQueryHookResult = ReturnType<typeof useGetEventCountSuspenseQuery>;
export type GetEventCountQueryResult = Apollo.QueryResult<GetEventCountQuery, GetEventCountQueryVariables>;
export const GetEventAttendeeCountDocument = gql`
    query GetEventAttendeeCount($data: StatsInput!) {
  eventAttendeeCount(data: $data)
}
    `;
export function useGetEventAttendeeCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEventAttendeeCountQuery, GetEventAttendeeCountQueryVariables> & ({ variables: GetEventAttendeeCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEventAttendeeCountQuery, GetEventAttendeeCountQueryVariables>(GetEventAttendeeCountDocument, options);
      }
export function useGetEventAttendeeCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventAttendeeCountQuery, GetEventAttendeeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEventAttendeeCountQuery, GetEventAttendeeCountQueryVariables>(GetEventAttendeeCountDocument, options);
        }
export function useGetEventAttendeeCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEventAttendeeCountQuery, GetEventAttendeeCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEventAttendeeCountQuery, GetEventAttendeeCountQueryVariables>(GetEventAttendeeCountDocument, options);
        }
export type GetEventAttendeeCountQueryHookResult = ReturnType<typeof useGetEventAttendeeCountQuery>;
export type GetEventAttendeeCountLazyQueryHookResult = ReturnType<typeof useGetEventAttendeeCountLazyQuery>;
export type GetEventAttendeeCountSuspenseQueryHookResult = ReturnType<typeof useGetEventAttendeeCountSuspenseQuery>;
export type GetEventAttendeeCountQueryResult = Apollo.QueryResult<GetEventAttendeeCountQuery, GetEventAttendeeCountQueryVariables>;
export const AdminExportActsDocument = gql`
    mutation AdminExportActs($filters: ExportActsInput!, $type: String!) {
  exportActs(filters: $filters, type: $type)
}
    `;
export function useAdminExportActsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminExportActsMutation, AdminExportActsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminExportActsMutation, AdminExportActsMutationVariables>(AdminExportActsDocument, options);
      }
export type AdminExportActsMutationHookResult = ReturnType<typeof useAdminExportActsMutation>;
export type AdminExportActsMutationResult = Apollo.MutationResult<AdminExportActsMutation>;
export type AdminExportActsMutationOptions = Apollo.BaseMutationOptions<AdminExportActsMutation, AdminExportActsMutationVariables>;
export const AdminExportStatsDocument = gql`
    mutation AdminExportStats($filters: StatsInput!) {
  exportStats(filters: $filters)
}
    `;
export function useAdminExportStatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminExportStatsMutation, AdminExportStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminExportStatsMutation, AdminExportStatsMutationVariables>(AdminExportStatsDocument, options);
      }
export type AdminExportStatsMutationHookResult = ReturnType<typeof useAdminExportStatsMutation>;
export type AdminExportStatsMutationResult = Apollo.MutationResult<AdminExportStatsMutation>;
export type AdminExportStatsMutationOptions = Apollo.BaseMutationOptions<AdminExportStatsMutation, AdminExportStatsMutationVariables>;
export const AdminExportUsersDocument = gql`
    mutation AdminExportUsers($filters: ExportUsersInput!, $type: String!) {
  exportUsers(filters: $filters, type: $type)
}
    `;
export function useAdminExportUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminExportUsersMutation, AdminExportUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminExportUsersMutation, AdminExportUsersMutationVariables>(AdminExportUsersDocument, options);
      }
export type AdminExportUsersMutationHookResult = ReturnType<typeof useAdminExportUsersMutation>;
export type AdminExportUsersMutationResult = Apollo.MutationResult<AdminExportUsersMutation>;
export type AdminExportUsersMutationOptions = Apollo.BaseMutationOptions<AdminExportUsersMutation, AdminExportUsersMutationVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($id: String!, $data: UpdatePageInput!) {
  updatePage(id: $id, data: $data) {
    ...AdminPageDetail
  }
}
    ${AdminPageDetailFragmentDoc}`;
export function useUpdatePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const DestroyPageDocument = gql`
    mutation DestroyPage($id: String!) {
  destroyPage(id: $id)
}
    `;
export function useDestroyPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyPageMutation, DestroyPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyPageMutation, DestroyPageMutationVariables>(DestroyPageDocument, options);
      }
export type DestroyPageMutationHookResult = ReturnType<typeof useDestroyPageMutation>;
export type DestroyPageMutationResult = Apollo.MutationResult<DestroyPageMutation>;
export type DestroyPageMutationOptions = Apollo.BaseMutationOptions<DestroyPageMutation, DestroyPageMutationVariables>;
export const GetAdminPostCommentsDocument = gql`
    query GetAdminPostComments($id: String!, $take: Int, $orderBy: [CommentOrderByWithRelationInput!], $skip: Int) {
  post(id: $id) {
    id
    comments(take: $take, orderBy: $orderBy, skip: $skip) {
      items {
        ...AdminPostComment
      }
      count
    }
  }
}
    ${AdminPostCommentFragmentDoc}`;
export function useGetAdminPostCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminPostCommentsQuery, GetAdminPostCommentsQueryVariables> & ({ variables: GetAdminPostCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminPostCommentsQuery, GetAdminPostCommentsQueryVariables>(GetAdminPostCommentsDocument, options);
      }
export function useGetAdminPostCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminPostCommentsQuery, GetAdminPostCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminPostCommentsQuery, GetAdminPostCommentsQueryVariables>(GetAdminPostCommentsDocument, options);
        }
export function useGetAdminPostCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminPostCommentsQuery, GetAdminPostCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminPostCommentsQuery, GetAdminPostCommentsQueryVariables>(GetAdminPostCommentsDocument, options);
        }
export type GetAdminPostCommentsQueryHookResult = ReturnType<typeof useGetAdminPostCommentsQuery>;
export type GetAdminPostCommentsLazyQueryHookResult = ReturnType<typeof useGetAdminPostCommentsLazyQuery>;
export type GetAdminPostCommentsSuspenseQueryHookResult = ReturnType<typeof useGetAdminPostCommentsSuspenseQuery>;
export type GetAdminPostCommentsQueryResult = Apollo.QueryResult<GetAdminPostCommentsQuery, GetAdminPostCommentsQueryVariables>;
export const DestroyAdminPostCommentDocument = gql`
    mutation DestroyAdminPostComment($id: String!) {
  destroyComment(id: $id) {
    id
  }
}
    `;
export function useDestroyAdminPostCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminPostCommentMutation, DestroyAdminPostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminPostCommentMutation, DestroyAdminPostCommentMutationVariables>(DestroyAdminPostCommentDocument, options);
      }
export type DestroyAdminPostCommentMutationHookResult = ReturnType<typeof useDestroyAdminPostCommentMutation>;
export type DestroyAdminPostCommentMutationResult = Apollo.MutationResult<DestroyAdminPostCommentMutation>;
export type DestroyAdminPostCommentMutationOptions = Apollo.BaseMutationOptions<DestroyAdminPostCommentMutation, DestroyAdminPostCommentMutationVariables>;
export const UpdateAdminPostDocument = gql`
    mutation UpdateAdminPost($id: String!, $data: UpdatePostInput!) {
  updatePost(id: $id, data: $data) {
    ...AdminPostDetail
  }
}
    ${AdminPostDetailFragmentDoc}`;
export function useUpdateAdminPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdminPostMutation, UpdateAdminPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdminPostMutation, UpdateAdminPostMutationVariables>(UpdateAdminPostDocument, options);
      }
export type UpdateAdminPostMutationHookResult = ReturnType<typeof useUpdateAdminPostMutation>;
export type UpdateAdminPostMutationResult = Apollo.MutationResult<UpdateAdminPostMutation>;
export type UpdateAdminPostMutationOptions = Apollo.BaseMutationOptions<UpdateAdminPostMutation, UpdateAdminPostMutationVariables>;
export const DestroyAdminPostDocument = gql`
    mutation DestroyAdminPost($id: String!) {
  destroyPost(id: $id)
}
    `;
export function useDestroyAdminPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminPostMutation, DestroyAdminPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminPostMutation, DestroyAdminPostMutationVariables>(DestroyAdminPostDocument, options);
      }
export type DestroyAdminPostMutationHookResult = ReturnType<typeof useDestroyAdminPostMutation>;
export type DestroyAdminPostMutationResult = Apollo.MutationResult<DestroyAdminPostMutation>;
export type DestroyAdminPostMutationOptions = Apollo.BaseMutationOptions<DestroyAdminPostMutation, DestroyAdminPostMutationVariables>;
export const GetAdminPostMatchesDocument = gql`
    query GetAdminPostMatches($id: String!, $take: Int, $skip: Int) {
  post(id: $id) {
    id
    matchedUsers(take: $take, skip: $skip) {
      items {
        ...AdminPostMatch
      }
      count
    }
  }
}
    ${AdminPostMatchFragmentDoc}`;
export function useGetAdminPostMatchesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminPostMatchesQuery, GetAdminPostMatchesQueryVariables> & ({ variables: GetAdminPostMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminPostMatchesQuery, GetAdminPostMatchesQueryVariables>(GetAdminPostMatchesDocument, options);
      }
export function useGetAdminPostMatchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminPostMatchesQuery, GetAdminPostMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminPostMatchesQuery, GetAdminPostMatchesQueryVariables>(GetAdminPostMatchesDocument, options);
        }
export function useGetAdminPostMatchesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminPostMatchesQuery, GetAdminPostMatchesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminPostMatchesQuery, GetAdminPostMatchesQueryVariables>(GetAdminPostMatchesDocument, options);
        }
export type GetAdminPostMatchesQueryHookResult = ReturnType<typeof useGetAdminPostMatchesQuery>;
export type GetAdminPostMatchesLazyQueryHookResult = ReturnType<typeof useGetAdminPostMatchesLazyQuery>;
export type GetAdminPostMatchesSuspenseQueryHookResult = ReturnType<typeof useGetAdminPostMatchesSuspenseQuery>;
export type GetAdminPostMatchesQueryResult = Apollo.QueryResult<GetAdminPostMatchesQuery, GetAdminPostMatchesQueryVariables>;
export const GetPostCountDocument = gql`
    query GetPostCount($data: StatsInput!) {
  postCount(data: $data)
}
    `;
export function useGetPostCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostCountQuery, GetPostCountQueryVariables> & ({ variables: GetPostCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostCountQuery, GetPostCountQueryVariables>(GetPostCountDocument, options);
      }
export function useGetPostCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostCountQuery, GetPostCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostCountQuery, GetPostCountQueryVariables>(GetPostCountDocument, options);
        }
export function useGetPostCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostCountQuery, GetPostCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostCountQuery, GetPostCountQueryVariables>(GetPostCountDocument, options);
        }
export type GetPostCountQueryHookResult = ReturnType<typeof useGetPostCountQuery>;
export type GetPostCountLazyQueryHookResult = ReturnType<typeof useGetPostCountLazyQuery>;
export type GetPostCountSuspenseQueryHookResult = ReturnType<typeof useGetPostCountSuspenseQuery>;
export type GetPostCountQueryResult = Apollo.QueryResult<GetPostCountQuery, GetPostCountQueryVariables>;
export const GetPostCommentCountDocument = gql`
    query GetPostCommentCount($data: StatsInput!) {
  postCommentCount(data: $data)
}
    `;
export function useGetPostCommentCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostCommentCountQuery, GetPostCommentCountQueryVariables> & ({ variables: GetPostCommentCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostCommentCountQuery, GetPostCommentCountQueryVariables>(GetPostCommentCountDocument, options);
      }
export function useGetPostCommentCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostCommentCountQuery, GetPostCommentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostCommentCountQuery, GetPostCommentCountQueryVariables>(GetPostCommentCountDocument, options);
        }
export function useGetPostCommentCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostCommentCountQuery, GetPostCommentCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostCommentCountQuery, GetPostCommentCountQueryVariables>(GetPostCommentCountDocument, options);
        }
export type GetPostCommentCountQueryHookResult = ReturnType<typeof useGetPostCommentCountQuery>;
export type GetPostCommentCountLazyQueryHookResult = ReturnType<typeof useGetPostCommentCountLazyQuery>;
export type GetPostCommentCountSuspenseQueryHookResult = ReturnType<typeof useGetPostCommentCountSuspenseQuery>;
export type GetPostCommentCountQueryResult = Apollo.QueryResult<GetPostCommentCountQuery, GetPostCommentCountQueryVariables>;
export const GetPostMatchCountDocument = gql`
    query GetPostMatchCount($data: StatsInput!) {
  postMatchCount(data: $data)
}
    `;
export function useGetPostMatchCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostMatchCountQuery, GetPostMatchCountQueryVariables> & ({ variables: GetPostMatchCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostMatchCountQuery, GetPostMatchCountQueryVariables>(GetPostMatchCountDocument, options);
      }
export function useGetPostMatchCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostMatchCountQuery, GetPostMatchCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostMatchCountQuery, GetPostMatchCountQueryVariables>(GetPostMatchCountDocument, options);
        }
export function useGetPostMatchCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostMatchCountQuery, GetPostMatchCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostMatchCountQuery, GetPostMatchCountQueryVariables>(GetPostMatchCountDocument, options);
        }
export type GetPostMatchCountQueryHookResult = ReturnType<typeof useGetPostMatchCountQuery>;
export type GetPostMatchCountLazyQueryHookResult = ReturnType<typeof useGetPostMatchCountLazyQuery>;
export type GetPostMatchCountSuspenseQueryHookResult = ReturnType<typeof useGetPostMatchCountSuspenseQuery>;
export type GetPostMatchCountQueryResult = Apollo.QueryResult<GetPostMatchCountQuery, GetPostMatchCountQueryVariables>;
export const GetAdminProjectCollaboratorsDocument = gql`
    query GetAdminProjectCollaborators($id: String!) {
  project(id: $id) {
    id
    creatorId
    collaborators {
      items {
        ...ProjectCollaborator
      }
      count
    }
  }
}
    ${ProjectCollaboratorFragmentDoc}`;
export function useGetAdminProjectCollaboratorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminProjectCollaboratorsQuery, GetAdminProjectCollaboratorsQueryVariables> & ({ variables: GetAdminProjectCollaboratorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminProjectCollaboratorsQuery, GetAdminProjectCollaboratorsQueryVariables>(GetAdminProjectCollaboratorsDocument, options);
      }
export function useGetAdminProjectCollaboratorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminProjectCollaboratorsQuery, GetAdminProjectCollaboratorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminProjectCollaboratorsQuery, GetAdminProjectCollaboratorsQueryVariables>(GetAdminProjectCollaboratorsDocument, options);
        }
export function useGetAdminProjectCollaboratorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminProjectCollaboratorsQuery, GetAdminProjectCollaboratorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminProjectCollaboratorsQuery, GetAdminProjectCollaboratorsQueryVariables>(GetAdminProjectCollaboratorsDocument, options);
        }
export type GetAdminProjectCollaboratorsQueryHookResult = ReturnType<typeof useGetAdminProjectCollaboratorsQuery>;
export type GetAdminProjectCollaboratorsLazyQueryHookResult = ReturnType<typeof useGetAdminProjectCollaboratorsLazyQuery>;
export type GetAdminProjectCollaboratorsSuspenseQueryHookResult = ReturnType<typeof useGetAdminProjectCollaboratorsSuspenseQuery>;
export type GetAdminProjectCollaboratorsQueryResult = Apollo.QueryResult<GetAdminProjectCollaboratorsQuery, GetAdminProjectCollaboratorsQueryVariables>;
export const GetAdminProjectCommentsDocument = gql`
    query GetAdminProjectComments($id: String!, $take: Int, $orderBy: [CommentOrderByWithRelationInput!], $skip: Int) {
  project(id: $id) {
    id
    comments(take: $take, orderBy: $orderBy, skip: $skip) {
      items {
        ...AdminProjectComment
      }
      count
    }
  }
}
    ${AdminProjectCommentFragmentDoc}`;
export function useGetAdminProjectCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminProjectCommentsQuery, GetAdminProjectCommentsQueryVariables> & ({ variables: GetAdminProjectCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminProjectCommentsQuery, GetAdminProjectCommentsQueryVariables>(GetAdminProjectCommentsDocument, options);
      }
export function useGetAdminProjectCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminProjectCommentsQuery, GetAdminProjectCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminProjectCommentsQuery, GetAdminProjectCommentsQueryVariables>(GetAdminProjectCommentsDocument, options);
        }
export function useGetAdminProjectCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminProjectCommentsQuery, GetAdminProjectCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminProjectCommentsQuery, GetAdminProjectCommentsQueryVariables>(GetAdminProjectCommentsDocument, options);
        }
export type GetAdminProjectCommentsQueryHookResult = ReturnType<typeof useGetAdminProjectCommentsQuery>;
export type GetAdminProjectCommentsLazyQueryHookResult = ReturnType<typeof useGetAdminProjectCommentsLazyQuery>;
export type GetAdminProjectCommentsSuspenseQueryHookResult = ReturnType<typeof useGetAdminProjectCommentsSuspenseQuery>;
export type GetAdminProjectCommentsQueryResult = Apollo.QueryResult<GetAdminProjectCommentsQuery, GetAdminProjectCommentsQueryVariables>;
export const DestroyAdminProjectCommentDocument = gql`
    mutation DestroyAdminProjectComment($id: String!) {
  destroyComment(id: $id) {
    id
  }
}
    `;
export function useDestroyAdminProjectCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminProjectCommentMutation, DestroyAdminProjectCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminProjectCommentMutation, DestroyAdminProjectCommentMutationVariables>(DestroyAdminProjectCommentDocument, options);
      }
export type DestroyAdminProjectCommentMutationHookResult = ReturnType<typeof useDestroyAdminProjectCommentMutation>;
export type DestroyAdminProjectCommentMutationResult = Apollo.MutationResult<DestroyAdminProjectCommentMutation>;
export type DestroyAdminProjectCommentMutationOptions = Apollo.BaseMutationOptions<DestroyAdminProjectCommentMutation, DestroyAdminProjectCommentMutationVariables>;
export const AdminCreateProjectDocument = gql`
    mutation AdminCreateProject($creatorId: String!, $data: ProjectCreateInput!) {
  createProjectAdmin(creatorId: $creatorId, data: $data) {
    ...AdminProjectOverview
  }
}
    ${AdminProjectOverviewFragmentDoc}`;
export function useAdminCreateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateProjectMutation, AdminCreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateProjectMutation, AdminCreateProjectMutationVariables>(AdminCreateProjectDocument, options);
      }
export type AdminCreateProjectMutationHookResult = ReturnType<typeof useAdminCreateProjectMutation>;
export type AdminCreateProjectMutationResult = Apollo.MutationResult<AdminCreateProjectMutation>;
export type AdminCreateProjectMutationOptions = Apollo.BaseMutationOptions<AdminCreateProjectMutation, AdminCreateProjectMutationVariables>;
export const GetAdminConnectionsForProjectDocument = gql`
    query GetAdminConnectionsForProject($id: String!) {
  user(id: $id) {
    id
    connections {
      ...ProjectUserConnection
    }
  }
}
    ${ProjectUserConnectionFragmentDoc}`;
export function useGetAdminConnectionsForProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminConnectionsForProjectQuery, GetAdminConnectionsForProjectQueryVariables> & ({ variables: GetAdminConnectionsForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminConnectionsForProjectQuery, GetAdminConnectionsForProjectQueryVariables>(GetAdminConnectionsForProjectDocument, options);
      }
export function useGetAdminConnectionsForProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminConnectionsForProjectQuery, GetAdminConnectionsForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminConnectionsForProjectQuery, GetAdminConnectionsForProjectQueryVariables>(GetAdminConnectionsForProjectDocument, options);
        }
export function useGetAdminConnectionsForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminConnectionsForProjectQuery, GetAdminConnectionsForProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminConnectionsForProjectQuery, GetAdminConnectionsForProjectQueryVariables>(GetAdminConnectionsForProjectDocument, options);
        }
export type GetAdminConnectionsForProjectQueryHookResult = ReturnType<typeof useGetAdminConnectionsForProjectQuery>;
export type GetAdminConnectionsForProjectLazyQueryHookResult = ReturnType<typeof useGetAdminConnectionsForProjectLazyQuery>;
export type GetAdminConnectionsForProjectSuspenseQueryHookResult = ReturnType<typeof useGetAdminConnectionsForProjectSuspenseQuery>;
export type GetAdminConnectionsForProjectQueryResult = Apollo.QueryResult<GetAdminConnectionsForProjectQuery, GetAdminConnectionsForProjectQueryVariables>;
export const GetProjectCountDocument = gql`
    query GetProjectCount($data: StatsInput!) {
  projectCount(data: $data)
}
    `;
export function useGetProjectCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectCountQuery, GetProjectCountQueryVariables> & ({ variables: GetProjectCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectCountQuery, GetProjectCountQueryVariables>(GetProjectCountDocument, options);
      }
export function useGetProjectCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectCountQuery, GetProjectCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectCountQuery, GetProjectCountQueryVariables>(GetProjectCountDocument, options);
        }
export function useGetProjectCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectCountQuery, GetProjectCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectCountQuery, GetProjectCountQueryVariables>(GetProjectCountDocument, options);
        }
export type GetProjectCountQueryHookResult = ReturnType<typeof useGetProjectCountQuery>;
export type GetProjectCountLazyQueryHookResult = ReturnType<typeof useGetProjectCountLazyQuery>;
export type GetProjectCountSuspenseQueryHookResult = ReturnType<typeof useGetProjectCountSuspenseQuery>;
export type GetProjectCountQueryResult = Apollo.QueryResult<GetProjectCountQuery, GetProjectCountQueryVariables>;
export const GetProjectCommentCountDocument = gql`
    query GetProjectCommentCount($data: StatsInput!) {
  projectCommentCount(data: $data)
}
    `;
export function useGetProjectCommentCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectCommentCountQuery, GetProjectCommentCountQueryVariables> & ({ variables: GetProjectCommentCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectCommentCountQuery, GetProjectCommentCountQueryVariables>(GetProjectCommentCountDocument, options);
      }
export function useGetProjectCommentCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectCommentCountQuery, GetProjectCommentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectCommentCountQuery, GetProjectCommentCountQueryVariables>(GetProjectCommentCountDocument, options);
        }
export function useGetProjectCommentCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectCommentCountQuery, GetProjectCommentCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectCommentCountQuery, GetProjectCommentCountQueryVariables>(GetProjectCommentCountDocument, options);
        }
export type GetProjectCommentCountQueryHookResult = ReturnType<typeof useGetProjectCommentCountQuery>;
export type GetProjectCommentCountLazyQueryHookResult = ReturnType<typeof useGetProjectCommentCountLazyQuery>;
export type GetProjectCommentCountSuspenseQueryHookResult = ReturnType<typeof useGetProjectCommentCountSuspenseQuery>;
export type GetProjectCommentCountQueryResult = Apollo.QueryResult<GetProjectCommentCountQuery, GetProjectCommentCountQueryVariables>;
export const CreateRegionFinancerDocument = gql`
    mutation CreateRegionFinancer($data: CreateRegionFinancerInput!) {
  createRegionFinancer(data: $data) {
    ...RegionFinancer
  }
}
    ${RegionFinancerFragmentDoc}`;
export function useCreateRegionFinancerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegionFinancerMutation, CreateRegionFinancerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegionFinancerMutation, CreateRegionFinancerMutationVariables>(CreateRegionFinancerDocument, options);
      }
export type CreateRegionFinancerMutationHookResult = ReturnType<typeof useCreateRegionFinancerMutation>;
export type CreateRegionFinancerMutationResult = Apollo.MutationResult<CreateRegionFinancerMutation>;
export type CreateRegionFinancerMutationOptions = Apollo.BaseMutationOptions<CreateRegionFinancerMutation, CreateRegionFinancerMutationVariables>;
export const UpdateRegionFinancerDocument = gql`
    mutation UpdateRegionFinancer($id: String!, $data: UpdateRegionFinancerInput!) {
  updateRegionFinancer(id: $id, data: $data) {
    ...RegionFinancer
  }
}
    ${RegionFinancerFragmentDoc}`;
export function useUpdateRegionFinancerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegionFinancerMutation, UpdateRegionFinancerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRegionFinancerMutation, UpdateRegionFinancerMutationVariables>(UpdateRegionFinancerDocument, options);
      }
export type UpdateRegionFinancerMutationHookResult = ReturnType<typeof useUpdateRegionFinancerMutation>;
export type UpdateRegionFinancerMutationResult = Apollo.MutationResult<UpdateRegionFinancerMutation>;
export type UpdateRegionFinancerMutationOptions = Apollo.BaseMutationOptions<UpdateRegionFinancerMutation, UpdateRegionFinancerMutationVariables>;
export const GetAdminRegionFinancersDocument = gql`
    query GetAdminRegionFinancers($slug: String!) {
  regionPage(slug: $slug) {
    id
    regionFinancers {
      ...RegionFinancer
    }
  }
}
    ${RegionFinancerFragmentDoc}`;
export function useGetAdminRegionFinancersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminRegionFinancersQuery, GetAdminRegionFinancersQueryVariables> & ({ variables: GetAdminRegionFinancersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminRegionFinancersQuery, GetAdminRegionFinancersQueryVariables>(GetAdminRegionFinancersDocument, options);
      }
export function useGetAdminRegionFinancersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegionFinancersQuery, GetAdminRegionFinancersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminRegionFinancersQuery, GetAdminRegionFinancersQueryVariables>(GetAdminRegionFinancersDocument, options);
        }
export function useGetAdminRegionFinancersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminRegionFinancersQuery, GetAdminRegionFinancersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminRegionFinancersQuery, GetAdminRegionFinancersQueryVariables>(GetAdminRegionFinancersDocument, options);
        }
export type GetAdminRegionFinancersQueryHookResult = ReturnType<typeof useGetAdminRegionFinancersQuery>;
export type GetAdminRegionFinancersLazyQueryHookResult = ReturnType<typeof useGetAdminRegionFinancersLazyQuery>;
export type GetAdminRegionFinancersSuspenseQueryHookResult = ReturnType<typeof useGetAdminRegionFinancersSuspenseQuery>;
export type GetAdminRegionFinancersQueryResult = Apollo.QueryResult<GetAdminRegionFinancersQuery, GetAdminRegionFinancersQueryVariables>;
export const DestroyAdminRegionFinancerDocument = gql`
    mutation DestroyAdminRegionFinancer($id: String!) {
  destroyRegionFinancer(id: $id)
}
    `;
export function useDestroyAdminRegionFinancerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminRegionFinancerMutation, DestroyAdminRegionFinancerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminRegionFinancerMutation, DestroyAdminRegionFinancerMutationVariables>(DestroyAdminRegionFinancerDocument, options);
      }
export type DestroyAdminRegionFinancerMutationHookResult = ReturnType<typeof useDestroyAdminRegionFinancerMutation>;
export type DestroyAdminRegionFinancerMutationResult = Apollo.MutationResult<DestroyAdminRegionFinancerMutation>;
export type DestroyAdminRegionFinancerMutationOptions = Apollo.BaseMutationOptions<DestroyAdminRegionFinancerMutation, DestroyAdminRegionFinancerMutationVariables>;
export const UpdateRegionPageDocument = gql`
    mutation UpdateRegionPage($id: String!, $data: UpdateRegionPageInput!) {
  updateRegionPage(id: $id, data: $data) {
    ...AdminRegionPageDetail
  }
}
    ${AdminRegionPageDetailFragmentDoc}`;
export function useUpdateRegionPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegionPageMutation, UpdateRegionPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRegionPageMutation, UpdateRegionPageMutationVariables>(UpdateRegionPageDocument, options);
      }
export type UpdateRegionPageMutationHookResult = ReturnType<typeof useUpdateRegionPageMutation>;
export type UpdateRegionPageMutationResult = Apollo.MutationResult<UpdateRegionPageMutation>;
export type UpdateRegionPageMutationOptions = Apollo.BaseMutationOptions<UpdateRegionPageMutation, UpdateRegionPageMutationVariables>;
export const DestroyRegionPageDocument = gql`
    mutation DestroyRegionPage($id: String!) {
  destroyRegionPage(id: $id)
}
    `;
export function useDestroyRegionPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyRegionPageMutation, DestroyRegionPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyRegionPageMutation, DestroyRegionPageMutationVariables>(DestroyRegionPageDocument, options);
      }
export type DestroyRegionPageMutationHookResult = ReturnType<typeof useDestroyRegionPageMutation>;
export type DestroyRegionPageMutationResult = Apollo.MutationResult<DestroyRegionPageMutation>;
export type DestroyRegionPageMutationOptions = Apollo.BaseMutationOptions<DestroyRegionPageMutation, DestroyRegionPageMutationVariables>;
export const CreateRegionPartnerDocument = gql`
    mutation CreateRegionPartner($data: CreateRegionPartnerInput!) {
  createRegionPartner(data: $data) {
    ...RegionPartner
  }
}
    ${RegionPartnerFragmentDoc}`;
export function useCreateRegionPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegionPartnerMutation, CreateRegionPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegionPartnerMutation, CreateRegionPartnerMutationVariables>(CreateRegionPartnerDocument, options);
      }
export type CreateRegionPartnerMutationHookResult = ReturnType<typeof useCreateRegionPartnerMutation>;
export type CreateRegionPartnerMutationResult = Apollo.MutationResult<CreateRegionPartnerMutation>;
export type CreateRegionPartnerMutationOptions = Apollo.BaseMutationOptions<CreateRegionPartnerMutation, CreateRegionPartnerMutationVariables>;
export const UpdateRegionPartnerDocument = gql`
    mutation UpdateRegionPartner($id: String!, $data: UpdateRegionPartnerInput!) {
  updateRegionPartner(id: $id, data: $data) {
    ...RegionPartner
  }
}
    ${RegionPartnerFragmentDoc}`;
export function useUpdateRegionPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegionPartnerMutation, UpdateRegionPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRegionPartnerMutation, UpdateRegionPartnerMutationVariables>(UpdateRegionPartnerDocument, options);
      }
export type UpdateRegionPartnerMutationHookResult = ReturnType<typeof useUpdateRegionPartnerMutation>;
export type UpdateRegionPartnerMutationResult = Apollo.MutationResult<UpdateRegionPartnerMutation>;
export type UpdateRegionPartnerMutationOptions = Apollo.BaseMutationOptions<UpdateRegionPartnerMutation, UpdateRegionPartnerMutationVariables>;
export const GetAdminRegionPartnersDocument = gql`
    query GetAdminRegionPartners($slug: String!) {
  regionPage(slug: $slug) {
    id
    regionPartners {
      ...RegionPartner
    }
  }
}
    ${RegionPartnerFragmentDoc}`;
export function useGetAdminRegionPartnersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminRegionPartnersQuery, GetAdminRegionPartnersQueryVariables> & ({ variables: GetAdminRegionPartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminRegionPartnersQuery, GetAdminRegionPartnersQueryVariables>(GetAdminRegionPartnersDocument, options);
      }
export function useGetAdminRegionPartnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegionPartnersQuery, GetAdminRegionPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminRegionPartnersQuery, GetAdminRegionPartnersQueryVariables>(GetAdminRegionPartnersDocument, options);
        }
export function useGetAdminRegionPartnersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminRegionPartnersQuery, GetAdminRegionPartnersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminRegionPartnersQuery, GetAdminRegionPartnersQueryVariables>(GetAdminRegionPartnersDocument, options);
        }
export type GetAdminRegionPartnersQueryHookResult = ReturnType<typeof useGetAdminRegionPartnersQuery>;
export type GetAdminRegionPartnersLazyQueryHookResult = ReturnType<typeof useGetAdminRegionPartnersLazyQuery>;
export type GetAdminRegionPartnersSuspenseQueryHookResult = ReturnType<typeof useGetAdminRegionPartnersSuspenseQuery>;
export type GetAdminRegionPartnersQueryResult = Apollo.QueryResult<GetAdminRegionPartnersQuery, GetAdminRegionPartnersQueryVariables>;
export const DestroyAdminRegionPartnerDocument = gql`
    mutation DestroyAdminRegionPartner($id: String!) {
  destroyRegionPartner(id: $id)
}
    `;
export function useDestroyAdminRegionPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminRegionPartnerMutation, DestroyAdminRegionPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminRegionPartnerMutation, DestroyAdminRegionPartnerMutationVariables>(DestroyAdminRegionPartnerDocument, options);
      }
export type DestroyAdminRegionPartnerMutationHookResult = ReturnType<typeof useDestroyAdminRegionPartnerMutation>;
export type DestroyAdminRegionPartnerMutationResult = Apollo.MutationResult<DestroyAdminRegionPartnerMutation>;
export type DestroyAdminRegionPartnerMutationOptions = Apollo.BaseMutationOptions<DestroyAdminRegionPartnerMutation, DestroyAdminRegionPartnerMutationVariables>;
export const GetAdminRegionPeopleDocument = gql`
    query GetAdminRegionPeople($slug: String!) {
  regionPage(slug: $slug) {
    id
    regionPeople {
      ...RegionPerson
    }
  }
}
    ${RegionPersonFragmentDoc}`;
export function useGetAdminRegionPeopleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminRegionPeopleQuery, GetAdminRegionPeopleQueryVariables> & ({ variables: GetAdminRegionPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminRegionPeopleQuery, GetAdminRegionPeopleQueryVariables>(GetAdminRegionPeopleDocument, options);
      }
export function useGetAdminRegionPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegionPeopleQuery, GetAdminRegionPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminRegionPeopleQuery, GetAdminRegionPeopleQueryVariables>(GetAdminRegionPeopleDocument, options);
        }
export function useGetAdminRegionPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminRegionPeopleQuery, GetAdminRegionPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminRegionPeopleQuery, GetAdminRegionPeopleQueryVariables>(GetAdminRegionPeopleDocument, options);
        }
export type GetAdminRegionPeopleQueryHookResult = ReturnType<typeof useGetAdminRegionPeopleQuery>;
export type GetAdminRegionPeopleLazyQueryHookResult = ReturnType<typeof useGetAdminRegionPeopleLazyQuery>;
export type GetAdminRegionPeopleSuspenseQueryHookResult = ReturnType<typeof useGetAdminRegionPeopleSuspenseQuery>;
export type GetAdminRegionPeopleQueryResult = Apollo.QueryResult<GetAdminRegionPeopleQuery, GetAdminRegionPeopleQueryVariables>;
export const DestroyAdminRegionPersonDocument = gql`
    mutation DestroyAdminRegionPerson($id: String!) {
  destroyRegionPerson(id: $id)
}
    `;
export function useDestroyAdminRegionPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminRegionPersonMutation, DestroyAdminRegionPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminRegionPersonMutation, DestroyAdminRegionPersonMutationVariables>(DestroyAdminRegionPersonDocument, options);
      }
export type DestroyAdminRegionPersonMutationHookResult = ReturnType<typeof useDestroyAdminRegionPersonMutation>;
export type DestroyAdminRegionPersonMutationResult = Apollo.MutationResult<DestroyAdminRegionPersonMutation>;
export type DestroyAdminRegionPersonMutationOptions = Apollo.BaseMutationOptions<DestroyAdminRegionPersonMutation, DestroyAdminRegionPersonMutationVariables>;
export const CreateRegionPersonDocument = gql`
    mutation CreateRegionPerson($data: CreateRegionPersonInput!) {
  createRegionPerson(data: $data) {
    ...RegionPerson
  }
}
    ${RegionPersonFragmentDoc}`;
export function useCreateRegionPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegionPersonMutation, CreateRegionPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegionPersonMutation, CreateRegionPersonMutationVariables>(CreateRegionPersonDocument, options);
      }
export type CreateRegionPersonMutationHookResult = ReturnType<typeof useCreateRegionPersonMutation>;
export type CreateRegionPersonMutationResult = Apollo.MutationResult<CreateRegionPersonMutation>;
export type CreateRegionPersonMutationOptions = Apollo.BaseMutationOptions<CreateRegionPersonMutation, CreateRegionPersonMutationVariables>;
export const UpdateRegionPersonDocument = gql`
    mutation UpdateRegionPerson($id: String!, $data: UpdateRegionPersonInput!) {
  updateRegionPerson(id: $id, data: $data) {
    ...RegionPerson
  }
}
    ${RegionPersonFragmentDoc}`;
export function useUpdateRegionPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegionPersonMutation, UpdateRegionPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRegionPersonMutation, UpdateRegionPersonMutationVariables>(UpdateRegionPersonDocument, options);
      }
export type UpdateRegionPersonMutationHookResult = ReturnType<typeof useUpdateRegionPersonMutation>;
export type UpdateRegionPersonMutationResult = Apollo.MutationResult<UpdateRegionPersonMutation>;
export type UpdateRegionPersonMutationOptions = Apollo.BaseMutationOptions<UpdateRegionPersonMutation, UpdateRegionPersonMutationVariables>;
export const GetAdminTutorialCommentsDocument = gql`
    query GetAdminTutorialComments($id: String!, $take: Int, $orderBy: [CommentOrderByWithRelationInput!], $skip: Int) {
  tutorial(id: $id) {
    id
    comments(take: $take, orderBy: $orderBy, skip: $skip) {
      items {
        ...AdminTutorialComment
      }
      count
    }
  }
}
    ${AdminTutorialCommentFragmentDoc}`;
export function useGetAdminTutorialCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminTutorialCommentsQuery, GetAdminTutorialCommentsQueryVariables> & ({ variables: GetAdminTutorialCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminTutorialCommentsQuery, GetAdminTutorialCommentsQueryVariables>(GetAdminTutorialCommentsDocument, options);
      }
export function useGetAdminTutorialCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminTutorialCommentsQuery, GetAdminTutorialCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminTutorialCommentsQuery, GetAdminTutorialCommentsQueryVariables>(GetAdminTutorialCommentsDocument, options);
        }
export function useGetAdminTutorialCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminTutorialCommentsQuery, GetAdminTutorialCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminTutorialCommentsQuery, GetAdminTutorialCommentsQueryVariables>(GetAdminTutorialCommentsDocument, options);
        }
export type GetAdminTutorialCommentsQueryHookResult = ReturnType<typeof useGetAdminTutorialCommentsQuery>;
export type GetAdminTutorialCommentsLazyQueryHookResult = ReturnType<typeof useGetAdminTutorialCommentsLazyQuery>;
export type GetAdminTutorialCommentsSuspenseQueryHookResult = ReturnType<typeof useGetAdminTutorialCommentsSuspenseQuery>;
export type GetAdminTutorialCommentsQueryResult = Apollo.QueryResult<GetAdminTutorialCommentsQuery, GetAdminTutorialCommentsQueryVariables>;
export const DestroyAdminTutorialCommentDocument = gql`
    mutation DestroyAdminTutorialComment($id: String!) {
  destroyComment(id: $id) {
    id
  }
}
    `;
export function useDestroyAdminTutorialCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminTutorialCommentMutation, DestroyAdminTutorialCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminTutorialCommentMutation, DestroyAdminTutorialCommentMutationVariables>(DestroyAdminTutorialCommentDocument, options);
      }
export type DestroyAdminTutorialCommentMutationHookResult = ReturnType<typeof useDestroyAdminTutorialCommentMutation>;
export type DestroyAdminTutorialCommentMutationResult = Apollo.MutationResult<DestroyAdminTutorialCommentMutation>;
export type DestroyAdminTutorialCommentMutationOptions = Apollo.BaseMutationOptions<DestroyAdminTutorialCommentMutation, DestroyAdminTutorialCommentMutationVariables>;
export const GetAdminTutorialCompletedUsersDocument = gql`
    query GetAdminTutorialCompletedUsers($id: String!, $take: Int, $orderBy: [UserTutorialOrderByWithRelationInput!], $where: UserTutorialWhereInput, $skip: Int) {
  tutorial(id: $id) {
    id
    completedUsers(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...AdminTutorialCompletedUser
      }
      count
    }
  }
}
    ${AdminTutorialCompletedUserFragmentDoc}`;
export function useGetAdminTutorialCompletedUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminTutorialCompletedUsersQuery, GetAdminTutorialCompletedUsersQueryVariables> & ({ variables: GetAdminTutorialCompletedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminTutorialCompletedUsersQuery, GetAdminTutorialCompletedUsersQueryVariables>(GetAdminTutorialCompletedUsersDocument, options);
      }
export function useGetAdminTutorialCompletedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminTutorialCompletedUsersQuery, GetAdminTutorialCompletedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminTutorialCompletedUsersQuery, GetAdminTutorialCompletedUsersQueryVariables>(GetAdminTutorialCompletedUsersDocument, options);
        }
export function useGetAdminTutorialCompletedUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminTutorialCompletedUsersQuery, GetAdminTutorialCompletedUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminTutorialCompletedUsersQuery, GetAdminTutorialCompletedUsersQueryVariables>(GetAdminTutorialCompletedUsersDocument, options);
        }
export type GetAdminTutorialCompletedUsersQueryHookResult = ReturnType<typeof useGetAdminTutorialCompletedUsersQuery>;
export type GetAdminTutorialCompletedUsersLazyQueryHookResult = ReturnType<typeof useGetAdminTutorialCompletedUsersLazyQuery>;
export type GetAdminTutorialCompletedUsersSuspenseQueryHookResult = ReturnType<typeof useGetAdminTutorialCompletedUsersSuspenseQuery>;
export type GetAdminTutorialCompletedUsersQueryResult = Apollo.QueryResult<GetAdminTutorialCompletedUsersQuery, GetAdminTutorialCompletedUsersQueryVariables>;
export const UpdateAdminTutorialDocument = gql`
    mutation UpdateAdminTutorial($id: String!, $data: UpdateTutorialInput!) {
  updateTutorial(id: $id, data: $data) {
    ...AdminTutorialDetail
  }
}
    ${AdminTutorialDetailFragmentDoc}`;
export function useUpdateAdminTutorialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdminTutorialMutation, UpdateAdminTutorialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdminTutorialMutation, UpdateAdminTutorialMutationVariables>(UpdateAdminTutorialDocument, options);
      }
export type UpdateAdminTutorialMutationHookResult = ReturnType<typeof useUpdateAdminTutorialMutation>;
export type UpdateAdminTutorialMutationResult = Apollo.MutationResult<UpdateAdminTutorialMutation>;
export type UpdateAdminTutorialMutationOptions = Apollo.BaseMutationOptions<UpdateAdminTutorialMutation, UpdateAdminTutorialMutationVariables>;
export const DestroyAdminTutorialDocument = gql`
    mutation DestroyAdminTutorial($id: String!) {
  destroyTutorial(id: $id)
}
    `;
export function useDestroyAdminTutorialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminTutorialMutation, DestroyAdminTutorialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminTutorialMutation, DestroyAdminTutorialMutationVariables>(DestroyAdminTutorialDocument, options);
      }
export type DestroyAdminTutorialMutationHookResult = ReturnType<typeof useDestroyAdminTutorialMutation>;
export type DestroyAdminTutorialMutationResult = Apollo.MutationResult<DestroyAdminTutorialMutation>;
export type DestroyAdminTutorialMutationOptions = Apollo.BaseMutationOptions<DestroyAdminTutorialMutation, DestroyAdminTutorialMutationVariables>;
export const GetTutorialCountDocument = gql`
    query GetTutorialCount($startDate: String!, $endDate: String!) {
  tutorialCount(startDate: $startDate, endDate: $endDate)
}
    `;
export function useGetTutorialCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTutorialCountQuery, GetTutorialCountQueryVariables> & ({ variables: GetTutorialCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTutorialCountQuery, GetTutorialCountQueryVariables>(GetTutorialCountDocument, options);
      }
export function useGetTutorialCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTutorialCountQuery, GetTutorialCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTutorialCountQuery, GetTutorialCountQueryVariables>(GetTutorialCountDocument, options);
        }
export function useGetTutorialCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTutorialCountQuery, GetTutorialCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTutorialCountQuery, GetTutorialCountQueryVariables>(GetTutorialCountDocument, options);
        }
export type GetTutorialCountQueryHookResult = ReturnType<typeof useGetTutorialCountQuery>;
export type GetTutorialCountLazyQueryHookResult = ReturnType<typeof useGetTutorialCountLazyQuery>;
export type GetTutorialCountSuspenseQueryHookResult = ReturnType<typeof useGetTutorialCountSuspenseQuery>;
export type GetTutorialCountQueryResult = Apollo.QueryResult<GetTutorialCountQuery, GetTutorialCountQueryVariables>;
export const GetTutorialCommentCountDocument = gql`
    query GetTutorialCommentCount($data: StatsInput!) {
  tutorialCommentCount(data: $data)
}
    `;
export function useGetTutorialCommentCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTutorialCommentCountQuery, GetTutorialCommentCountQueryVariables> & ({ variables: GetTutorialCommentCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTutorialCommentCountQuery, GetTutorialCommentCountQueryVariables>(GetTutorialCommentCountDocument, options);
      }
export function useGetTutorialCommentCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTutorialCommentCountQuery, GetTutorialCommentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTutorialCommentCountQuery, GetTutorialCommentCountQueryVariables>(GetTutorialCommentCountDocument, options);
        }
export function useGetTutorialCommentCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTutorialCommentCountQuery, GetTutorialCommentCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTutorialCommentCountQuery, GetTutorialCommentCountQueryVariables>(GetTutorialCommentCountDocument, options);
        }
export type GetTutorialCommentCountQueryHookResult = ReturnType<typeof useGetTutorialCommentCountQuery>;
export type GetTutorialCommentCountLazyQueryHookResult = ReturnType<typeof useGetTutorialCommentCountLazyQuery>;
export type GetTutorialCommentCountSuspenseQueryHookResult = ReturnType<typeof useGetTutorialCommentCountSuspenseQuery>;
export type GetTutorialCommentCountQueryResult = Apollo.QueryResult<GetTutorialCommentCountQuery, GetTutorialCommentCountQueryVariables>;
export const GetTutorialCompletedCountDocument = gql`
    query GetTutorialCompletedCount($data: StatsInput!) {
  tutorialCompletedCount(data: $data)
}
    `;
export function useGetTutorialCompletedCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTutorialCompletedCountQuery, GetTutorialCompletedCountQueryVariables> & ({ variables: GetTutorialCompletedCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTutorialCompletedCountQuery, GetTutorialCompletedCountQueryVariables>(GetTutorialCompletedCountDocument, options);
      }
export function useGetTutorialCompletedCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTutorialCompletedCountQuery, GetTutorialCompletedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTutorialCompletedCountQuery, GetTutorialCompletedCountQueryVariables>(GetTutorialCompletedCountDocument, options);
        }
export function useGetTutorialCompletedCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTutorialCompletedCountQuery, GetTutorialCompletedCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTutorialCompletedCountQuery, GetTutorialCompletedCountQueryVariables>(GetTutorialCompletedCountDocument, options);
        }
export type GetTutorialCompletedCountQueryHookResult = ReturnType<typeof useGetTutorialCompletedCountQuery>;
export type GetTutorialCompletedCountLazyQueryHookResult = ReturnType<typeof useGetTutorialCompletedCountLazyQuery>;
export type GetTutorialCompletedCountSuspenseQueryHookResult = ReturnType<typeof useGetTutorialCompletedCountSuspenseQuery>;
export type GetTutorialCompletedCountQueryResult = Apollo.QueryResult<GetTutorialCompletedCountQuery, GetTutorialCompletedCountQueryVariables>;
export const AdminUpdateActAttachmentDocument = gql`
    mutation AdminUpdateActAttachment($id: String!, $data: ActAttachmentUpdateInput!) {
  updateActAttachment(id: $id, data: $data) {
    id
    name
    type
  }
}
    `;
export function useAdminUpdateActAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateActAttachmentMutation, AdminUpdateActAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateActAttachmentMutation, AdminUpdateActAttachmentMutationVariables>(AdminUpdateActAttachmentDocument, options);
      }
export type AdminUpdateActAttachmentMutationHookResult = ReturnType<typeof useAdminUpdateActAttachmentMutation>;
export type AdminUpdateActAttachmentMutationResult = Apollo.MutationResult<AdminUpdateActAttachmentMutation>;
export type AdminUpdateActAttachmentMutationOptions = Apollo.BaseMutationOptions<AdminUpdateActAttachmentMutation, AdminUpdateActAttachmentMutationVariables>;
export const GetUserActsDocument = gql`
    query GetUserActs($id: String!, $take: Int, $orderBy: [ActOrderByWithRelationInput!], $where: ActWhereInput, $skip: Int) {
  user(id: $id) {
    id
    acts(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...AdminUserAct
      }
      count
    }
  }
}
    ${AdminUserActFragmentDoc}`;
export function useGetUserActsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserActsQuery, GetUserActsQueryVariables> & ({ variables: GetUserActsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserActsQuery, GetUserActsQueryVariables>(GetUserActsDocument, options);
      }
export function useGetUserActsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserActsQuery, GetUserActsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserActsQuery, GetUserActsQueryVariables>(GetUserActsDocument, options);
        }
export function useGetUserActsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserActsQuery, GetUserActsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserActsQuery, GetUserActsQueryVariables>(GetUserActsDocument, options);
        }
export type GetUserActsQueryHookResult = ReturnType<typeof useGetUserActsQuery>;
export type GetUserActsLazyQueryHookResult = ReturnType<typeof useGetUserActsLazyQuery>;
export type GetUserActsSuspenseQueryHookResult = ReturnType<typeof useGetUserActsSuspenseQuery>;
export type GetUserActsQueryResult = Apollo.QueryResult<GetUserActsQuery, GetUserActsQueryVariables>;
export const GetUserConnectionsDocument = gql`
    query GetUserConnections($id: String!, $take: Int, $orderBy: [ConnectionOrderByWithRelationInput!]) {
  user(id: $id) {
    id
    connections(take: $take, orderBy: $orderBy) {
      ...UserConnect
    }
  }
}
    ${UserConnectFragmentDoc}`;
export function useGetUserConnectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserConnectionsQuery, GetUserConnectionsQueryVariables> & ({ variables: GetUserConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>(GetUserConnectionsDocument, options);
      }
export function useGetUserConnectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>(GetUserConnectionsDocument, options);
        }
export function useGetUserConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>(GetUserConnectionsDocument, options);
        }
export type GetUserConnectionsQueryHookResult = ReturnType<typeof useGetUserConnectionsQuery>;
export type GetUserConnectionsLazyQueryHookResult = ReturnType<typeof useGetUserConnectionsLazyQuery>;
export type GetUserConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetUserConnectionsSuspenseQuery>;
export type GetUserConnectionsQueryResult = Apollo.QueryResult<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>;
export const UpdateUserAdminDocument = gql`
    mutation UpdateUserAdmin($id: String!, $data: UpdateUserAdminInput!) {
  updateUserAdmin(id: $id, data: $data) {
    ...AdminUserDetail
  }
}
    ${AdminUserDetailFragmentDoc}`;
export function useUpdateUserAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAdminMutation, UpdateUserAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserAdminMutation, UpdateUserAdminMutationVariables>(UpdateUserAdminDocument, options);
      }
export type UpdateUserAdminMutationHookResult = ReturnType<typeof useUpdateUserAdminMutation>;
export type UpdateUserAdminMutationResult = Apollo.MutationResult<UpdateUserAdminMutation>;
export type UpdateUserAdminMutationOptions = Apollo.BaseMutationOptions<UpdateUserAdminMutation, UpdateUserAdminMutationVariables>;
export const DestroyAdminUserDocument = gql`
    mutation DestroyAdminUser($id: String!) {
  destroyUser(id: $id)
}
    `;
export function useDestroyAdminUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyAdminUserMutation, DestroyAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyAdminUserMutation, DestroyAdminUserMutationVariables>(DestroyAdminUserDocument, options);
      }
export type DestroyAdminUserMutationHookResult = ReturnType<typeof useDestroyAdminUserMutation>;
export type DestroyAdminUserMutationResult = Apollo.MutationResult<DestroyAdminUserMutation>;
export type DestroyAdminUserMutationOptions = Apollo.BaseMutationOptions<DestroyAdminUserMutation, DestroyAdminUserMutationVariables>;
export const GetUserEventsDocument = gql`
    query GetUserEvents($id: String!, $take: Int, $orderBy: [UserEventOrderByWithRelationInput!], $where: UserEventWhereInput, $skip: Int) {
  user(id: $id) {
    id
    events(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...UserEvent
      }
      count
    }
  }
}
    ${UserEventFragmentDoc}`;
export function useGetUserEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables> & ({ variables: GetUserEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
      }
export function useGetUserEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
        }
export function useGetUserEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
        }
export type GetUserEventsQueryHookResult = ReturnType<typeof useGetUserEventsQuery>;
export type GetUserEventsLazyQueryHookResult = ReturnType<typeof useGetUserEventsLazyQuery>;
export type GetUserEventsSuspenseQueryHookResult = ReturnType<typeof useGetUserEventsSuspenseQuery>;
export type GetUserEventsQueryResult = Apollo.QueryResult<GetUserEventsQuery, GetUserEventsQueryVariables>;
export const GetAdminUserPostsDocument = gql`
    query GetAdminUserPosts($id: String!) {
  user(id: $id) {
    id
    posts {
      ...AdminPostItem
    }
    commentedOnPosts {
      ...AdminPostItem
    }
  }
}
    ${AdminPostItemFragmentDoc}`;
export function useGetAdminUserPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminUserPostsQuery, GetAdminUserPostsQueryVariables> & ({ variables: GetAdminUserPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminUserPostsQuery, GetAdminUserPostsQueryVariables>(GetAdminUserPostsDocument, options);
      }
export function useGetAdminUserPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminUserPostsQuery, GetAdminUserPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminUserPostsQuery, GetAdminUserPostsQueryVariables>(GetAdminUserPostsDocument, options);
        }
export function useGetAdminUserPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminUserPostsQuery, GetAdminUserPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminUserPostsQuery, GetAdminUserPostsQueryVariables>(GetAdminUserPostsDocument, options);
        }
export type GetAdminUserPostsQueryHookResult = ReturnType<typeof useGetAdminUserPostsQuery>;
export type GetAdminUserPostsLazyQueryHookResult = ReturnType<typeof useGetAdminUserPostsLazyQuery>;
export type GetAdminUserPostsSuspenseQueryHookResult = ReturnType<typeof useGetAdminUserPostsSuspenseQuery>;
export type GetAdminUserPostsQueryResult = Apollo.QueryResult<GetAdminUserPostsQuery, GetAdminUserPostsQueryVariables>;
export const GetUserCountDocument = gql`
    query GetUserCount($data: StatsInput!) {
  userCount(data: $data)
}
    `;
export function useGetUserCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserCountQuery, GetUserCountQueryVariables> & ({ variables: GetUserCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserCountQuery, GetUserCountQueryVariables>(GetUserCountDocument, options);
      }
export function useGetUserCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserCountQuery, GetUserCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserCountQuery, GetUserCountQueryVariables>(GetUserCountDocument, options);
        }
export function useGetUserCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserCountQuery, GetUserCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserCountQuery, GetUserCountQueryVariables>(GetUserCountDocument, options);
        }
export type GetUserCountQueryHookResult = ReturnType<typeof useGetUserCountQuery>;
export type GetUserCountLazyQueryHookResult = ReturnType<typeof useGetUserCountLazyQuery>;
export type GetUserCountSuspenseQueryHookResult = ReturnType<typeof useGetUserCountSuspenseQuery>;
export type GetUserCountQueryResult = Apollo.QueryResult<GetUserCountQuery, GetUserCountQueryVariables>;
export const GetUserSignUpsByDayDocument = gql`
    query GetUserSignUpsByDay($data: StatsInput!) {
  userSignUpsByDay(data: $data) {
    week
    count
  }
}
    `;
export function useGetUserSignUpsByDayQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserSignUpsByDayQuery, GetUserSignUpsByDayQueryVariables> & ({ variables: GetUserSignUpsByDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSignUpsByDayQuery, GetUserSignUpsByDayQueryVariables>(GetUserSignUpsByDayDocument, options);
      }
export function useGetUserSignUpsByDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSignUpsByDayQuery, GetUserSignUpsByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSignUpsByDayQuery, GetUserSignUpsByDayQueryVariables>(GetUserSignUpsByDayDocument, options);
        }
export function useGetUserSignUpsByDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserSignUpsByDayQuery, GetUserSignUpsByDayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserSignUpsByDayQuery, GetUserSignUpsByDayQueryVariables>(GetUserSignUpsByDayDocument, options);
        }
export type GetUserSignUpsByDayQueryHookResult = ReturnType<typeof useGetUserSignUpsByDayQuery>;
export type GetUserSignUpsByDayLazyQueryHookResult = ReturnType<typeof useGetUserSignUpsByDayLazyQuery>;
export type GetUserSignUpsByDaySuspenseQueryHookResult = ReturnType<typeof useGetUserSignUpsByDaySuspenseQuery>;
export type GetUserSignUpsByDayQueryResult = Apollo.QueryResult<GetUserSignUpsByDayQuery, GetUserSignUpsByDayQueryVariables>;
export const GetUsersBySchoolTypeDocument = gql`
    query GetUsersBySchoolType($data: StatsInput!) {
  usersBySchoolType(data: $data) {
    schoolType
    _count
  }
}
    `;
export function useGetUsersBySchoolTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUsersBySchoolTypeQuery, GetUsersBySchoolTypeQueryVariables> & ({ variables: GetUsersBySchoolTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersBySchoolTypeQuery, GetUsersBySchoolTypeQueryVariables>(GetUsersBySchoolTypeDocument, options);
      }
export function useGetUsersBySchoolTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersBySchoolTypeQuery, GetUsersBySchoolTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersBySchoolTypeQuery, GetUsersBySchoolTypeQueryVariables>(GetUsersBySchoolTypeDocument, options);
        }
export function useGetUsersBySchoolTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersBySchoolTypeQuery, GetUsersBySchoolTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersBySchoolTypeQuery, GetUsersBySchoolTypeQueryVariables>(GetUsersBySchoolTypeDocument, options);
        }
export type GetUsersBySchoolTypeQueryHookResult = ReturnType<typeof useGetUsersBySchoolTypeQuery>;
export type GetUsersBySchoolTypeLazyQueryHookResult = ReturnType<typeof useGetUsersBySchoolTypeLazyQuery>;
export type GetUsersBySchoolTypeSuspenseQueryHookResult = ReturnType<typeof useGetUsersBySchoolTypeSuspenseQuery>;
export type GetUsersBySchoolTypeQueryResult = Apollo.QueryResult<GetUsersBySchoolTypeQuery, GetUsersBySchoolTypeQueryVariables>;
export const GetUsersByAgeDocument = gql`
    query GetUsersByAge($data: StatsInput!) {
  usersByAge(data: $data) {
    age
    count
  }
}
    `;
export function useGetUsersByAgeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUsersByAgeQuery, GetUsersByAgeQueryVariables> & ({ variables: GetUsersByAgeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersByAgeQuery, GetUsersByAgeQueryVariables>(GetUsersByAgeDocument, options);
      }
export function useGetUsersByAgeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersByAgeQuery, GetUsersByAgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersByAgeQuery, GetUsersByAgeQueryVariables>(GetUsersByAgeDocument, options);
        }
export function useGetUsersByAgeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersByAgeQuery, GetUsersByAgeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersByAgeQuery, GetUsersByAgeQueryVariables>(GetUsersByAgeDocument, options);
        }
export type GetUsersByAgeQueryHookResult = ReturnType<typeof useGetUsersByAgeQuery>;
export type GetUsersByAgeLazyQueryHookResult = ReturnType<typeof useGetUsersByAgeLazyQuery>;
export type GetUsersByAgeSuspenseQueryHookResult = ReturnType<typeof useGetUsersByAgeSuspenseQuery>;
export type GetUsersByAgeQueryResult = Apollo.QueryResult<GetUsersByAgeQuery, GetUsersByAgeQueryVariables>;
export const GetUserTutorialsDocument = gql`
    query GetUserTutorials($id: String!, $take: Int, $orderBy: [UserTutorialOrderByWithRelationInput!], $where: UserTutorialWhereInput, $skip: Int) {
  user(id: $id) {
    id
    tutorials(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...AdminTutorialItem
      }
      count
    }
  }
}
    ${AdminTutorialItemFragmentDoc}`;
export function useGetUserTutorialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserTutorialsQuery, GetUserTutorialsQueryVariables> & ({ variables: GetUserTutorialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserTutorialsQuery, GetUserTutorialsQueryVariables>(GetUserTutorialsDocument, options);
      }
export function useGetUserTutorialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserTutorialsQuery, GetUserTutorialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserTutorialsQuery, GetUserTutorialsQueryVariables>(GetUserTutorialsDocument, options);
        }
export function useGetUserTutorialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserTutorialsQuery, GetUserTutorialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserTutorialsQuery, GetUserTutorialsQueryVariables>(GetUserTutorialsDocument, options);
        }
export type GetUserTutorialsQueryHookResult = ReturnType<typeof useGetUserTutorialsQuery>;
export type GetUserTutorialsLazyQueryHookResult = ReturnType<typeof useGetUserTutorialsLazyQuery>;
export type GetUserTutorialsSuspenseQueryHookResult = ReturnType<typeof useGetUserTutorialsSuspenseQuery>;
export type GetUserTutorialsQueryResult = Apollo.QueryResult<GetUserTutorialsQuery, GetUserTutorialsQueryVariables>;
export const CreateActDocument = gql`
    mutation CreateAct($data: ActCreateInput!) {
  createAct(data: $data) {
    id
  }
}
    `;
export function useCreateActMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateActMutation, CreateActMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateActMutation, CreateActMutationVariables>(CreateActDocument, options);
      }
export type CreateActMutationHookResult = ReturnType<typeof useCreateActMutation>;
export type CreateActMutationResult = Apollo.MutationResult<CreateActMutation>;
export type CreateActMutationOptions = Apollo.BaseMutationOptions<CreateActMutation, CreateActMutationVariables>;
export const UpdateStep1ActDocument = gql`
    mutation UpdateStep1Act($id: String!, $data: UpdateActInput!) {
  updateAct(id: $id, data: $data) {
    ...Step1Act
  }
}
    ${Step1ActFragmentDoc}`;
export function useUpdateStep1ActMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStep1ActMutation, UpdateStep1ActMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStep1ActMutation, UpdateStep1ActMutationVariables>(UpdateStep1ActDocument, options);
      }
export type UpdateStep1ActMutationHookResult = ReturnType<typeof useUpdateStep1ActMutation>;
export type UpdateStep1ActMutationResult = Apollo.MutationResult<UpdateStep1ActMutation>;
export type UpdateStep1ActMutationOptions = Apollo.BaseMutationOptions<UpdateStep1ActMutation, UpdateStep1ActMutationVariables>;
export const UpdateStep2ActDocument = gql`
    mutation UpdateStep2Act($id: String!, $data: UpdateActInput!) {
  updateAct(id: $id, data: $data) {
    ...Step2Act
  }
}
    ${Step2ActFragmentDoc}`;
export function useUpdateStep2ActMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStep2ActMutation, UpdateStep2ActMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStep2ActMutation, UpdateStep2ActMutationVariables>(UpdateStep2ActDocument, options);
      }
export type UpdateStep2ActMutationHookResult = ReturnType<typeof useUpdateStep2ActMutation>;
export type UpdateStep2ActMutationResult = Apollo.MutationResult<UpdateStep2ActMutation>;
export type UpdateStep2ActMutationOptions = Apollo.BaseMutationOptions<UpdateStep2ActMutation, UpdateStep2ActMutationVariables>;
export const UpdateStep3ActDocument = gql`
    mutation UpdateStep3Act($id: String!, $data: UpdateActInput!) {
  finishActApplication(id: $id, data: $data) {
    ...Step3Act
  }
}
    ${Step3ActFragmentDoc}`;
export function useUpdateStep3ActMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStep3ActMutation, UpdateStep3ActMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStep3ActMutation, UpdateStep3ActMutationVariables>(UpdateStep3ActDocument, options);
      }
export type UpdateStep3ActMutationHookResult = ReturnType<typeof useUpdateStep3ActMutation>;
export type UpdateStep3ActMutationResult = Apollo.MutationResult<UpdateStep3ActMutation>;
export type UpdateStep3ActMutationOptions = Apollo.BaseMutationOptions<UpdateStep3ActMutation, UpdateStep3ActMutationVariables>;
export const CreateActAttachmentDocument = gql`
    mutation CreateActAttachment($data: ActAttachmentCreateInput!) {
  createActAttachment(data: $data) {
    ...ActAttachment
  }
}
    ${ActAttachmentFragmentDoc}`;
export function useCreateActAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateActAttachmentMutation, CreateActAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateActAttachmentMutation, CreateActAttachmentMutationVariables>(CreateActAttachmentDocument, options);
      }
export type CreateActAttachmentMutationHookResult = ReturnType<typeof useCreateActAttachmentMutation>;
export type CreateActAttachmentMutationResult = Apollo.MutationResult<CreateActAttachmentMutation>;
export type CreateActAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateActAttachmentMutation, CreateActAttachmentMutationVariables>;
export const DeleteActAttachmentDocument = gql`
    mutation DeleteActAttachment($id: String!) {
  deleteActAttachment(id: $id)
}
    `;
export function useDeleteActAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteActAttachmentMutation, DeleteActAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteActAttachmentMutation, DeleteActAttachmentMutationVariables>(DeleteActAttachmentDocument, options);
      }
export type DeleteActAttachmentMutationHookResult = ReturnType<typeof useDeleteActAttachmentMutation>;
export type DeleteActAttachmentMutationResult = Apollo.MutationResult<DeleteActAttachmentMutation>;
export type DeleteActAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteActAttachmentMutation, DeleteActAttachmentMutationVariables>;
export const InviteActMembersDocument = gql`
    mutation InviteActMembers($actId: String!, $emails: [String!]!) {
  inviteActMembers(actId: $actId, emails: $emails) {
    id
  }
}
    `;
export function useInviteActMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteActMembersMutation, InviteActMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InviteActMembersMutation, InviteActMembersMutationVariables>(InviteActMembersDocument, options);
      }
export type InviteActMembersMutationHookResult = ReturnType<typeof useInviteActMembersMutation>;
export type InviteActMembersMutationResult = Apollo.MutationResult<InviteActMembersMutation>;
export type InviteActMembersMutationOptions = Apollo.BaseMutationOptions<InviteActMembersMutation, InviteActMembersMutationVariables>;
export const RemoveActMemberDocument = gql`
    mutation RemoveActMember($id: String!, $memberId: String!) {
  removeActMember(id: $id, memberId: $memberId)
}
    `;
export function useRemoveActMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveActMemberMutation, RemoveActMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveActMemberMutation, RemoveActMemberMutationVariables>(RemoveActMemberDocument, options);
      }
export type RemoveActMemberMutationHookResult = ReturnType<typeof useRemoveActMemberMutation>;
export type RemoveActMemberMutationResult = Apollo.MutationResult<RemoveActMemberMutation>;
export type RemoveActMemberMutationOptions = Apollo.BaseMutationOptions<RemoveActMemberMutation, RemoveActMemberMutationVariables>;
export const UpdateCustomFeedDocument = gql`
    mutation UpdateCustomFeed($id: String!, $data: UpdateCustomFeedInput!) {
  updateCustomFeed(id: $id, data: $data) {
    ...AdminCustomFeedItem
  }
}
    ${AdminCustomFeedItemFragmentDoc}`;
export function useUpdateCustomFeedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomFeedMutation, UpdateCustomFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCustomFeedMutation, UpdateCustomFeedMutationVariables>(UpdateCustomFeedDocument, options);
      }
export type UpdateCustomFeedMutationHookResult = ReturnType<typeof useUpdateCustomFeedMutation>;
export type UpdateCustomFeedMutationResult = Apollo.MutationResult<UpdateCustomFeedMutation>;
export type UpdateCustomFeedMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFeedMutation, UpdateCustomFeedMutationVariables>;
export const DestroyCustomFeedDocument = gql`
    mutation DestroyCustomFeed($id: String!) {
  destroyCustomFeed(id: $id)
}
    `;
export function useDestroyCustomFeedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyCustomFeedMutation, DestroyCustomFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyCustomFeedMutation, DestroyCustomFeedMutationVariables>(DestroyCustomFeedDocument, options);
      }
export type DestroyCustomFeedMutationHookResult = ReturnType<typeof useDestroyCustomFeedMutation>;
export type DestroyCustomFeedMutationResult = Apollo.MutationResult<DestroyCustomFeedMutation>;
export type DestroyCustomFeedMutationOptions = Apollo.BaseMutationOptions<DestroyCustomFeedMutation, DestroyCustomFeedMutationVariables>;
export const CreateCustomNotificationsDocument = gql`
    mutation CreateCustomNotifications($data: CreateCustomNotificationsInput!) {
  createCustomNotifications(data: $data)
}
    `;
export function useCreateCustomNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomNotificationsMutation, CreateCustomNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomNotificationsMutation, CreateCustomNotificationsMutationVariables>(CreateCustomNotificationsDocument, options);
      }
export type CreateCustomNotificationsMutationHookResult = ReturnType<typeof useCreateCustomNotificationsMutation>;
export type CreateCustomNotificationsMutationResult = Apollo.MutationResult<CreateCustomNotificationsMutation>;
export type CreateCustomNotificationsMutationOptions = Apollo.BaseMutationOptions<CreateCustomNotificationsMutation, CreateCustomNotificationsMutationVariables>;
export const AttendEventDocument = gql`
    mutation AttendEvent($eventId: String!) {
  attendEvent(eventId: $eventId)
}
    `;
export function useAttendEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AttendEventMutation, AttendEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttendEventMutation, AttendEventMutationVariables>(AttendEventDocument, options);
      }
export type AttendEventMutationHookResult = ReturnType<typeof useAttendEventMutation>;
export type AttendEventMutationResult = Apollo.MutationResult<AttendEventMutation>;
export type AttendEventMutationOptions = Apollo.BaseMutationOptions<AttendEventMutation, AttendEventMutationVariables>;
export const UnAttendEventDocument = gql`
    mutation UnAttendEvent($eventId: String!) {
  unAttendEvent(eventId: $eventId)
}
    `;
export function useUnAttendEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnAttendEventMutation, UnAttendEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnAttendEventMutation, UnAttendEventMutationVariables>(UnAttendEventDocument, options);
      }
export type UnAttendEventMutationHookResult = ReturnType<typeof useUnAttendEventMutation>;
export type UnAttendEventMutationResult = Apollo.MutationResult<UnAttendEventMutation>;
export type UnAttendEventMutationOptions = Apollo.BaseMutationOptions<UnAttendEventMutation, UnAttendEventMutationVariables>;
export const GetLandingPageProjectsDocument = gql`
    query GetLandingPageProjects($take: Int, $orderBy: [ProjectOrderByWithRelationInput!], $where: ProjectWhereInput, $skip: Int) {
  featuredProjects(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...LandingPageProjectItem
    }
    count
  }
}
    ${LandingPageProjectItemFragmentDoc}`;
export function useGetLandingPageProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLandingPageProjectsQuery, GetLandingPageProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLandingPageProjectsQuery, GetLandingPageProjectsQueryVariables>(GetLandingPageProjectsDocument, options);
      }
export function useGetLandingPageProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLandingPageProjectsQuery, GetLandingPageProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLandingPageProjectsQuery, GetLandingPageProjectsQueryVariables>(GetLandingPageProjectsDocument, options);
        }
export function useGetLandingPageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLandingPageProjectsQuery, GetLandingPageProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLandingPageProjectsQuery, GetLandingPageProjectsQueryVariables>(GetLandingPageProjectsDocument, options);
        }
export type GetLandingPageProjectsQueryHookResult = ReturnType<typeof useGetLandingPageProjectsQuery>;
export type GetLandingPageProjectsLazyQueryHookResult = ReturnType<typeof useGetLandingPageProjectsLazyQuery>;
export type GetLandingPageProjectsSuspenseQueryHookResult = ReturnType<typeof useGetLandingPageProjectsSuspenseQuery>;
export type GetLandingPageProjectsQueryResult = Apollo.QueryResult<GetLandingPageProjectsQuery, GetLandingPageProjectsQueryVariables>;
export const GetUserFeedDocument = gql`
    query GetUserFeed($id: String!, $take: Int, $orderBy: [ProjectOrderByWithRelationInput!], $where: ProjectWhereInput, $skip: Int) {
  user(id: $id) {
    ...UserProfile
  }
  featuredProjects(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...FeaturedProjectItem
    }
    count
  }
  customFeed {
    ...CustomFeed
  }
}
    ${UserProfileFragmentDoc}
${FeaturedProjectItemFragmentDoc}
${CustomFeedFragmentDoc}`;
export function useGetUserFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserFeedQuery, GetUserFeedQueryVariables> & ({ variables: GetUserFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFeedQuery, GetUserFeedQueryVariables>(GetUserFeedDocument, options);
      }
export function useGetUserFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFeedQuery, GetUserFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFeedQuery, GetUserFeedQueryVariables>(GetUserFeedDocument, options);
        }
export function useGetUserFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFeedQuery, GetUserFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserFeedQuery, GetUserFeedQueryVariables>(GetUserFeedDocument, options);
        }
export type GetUserFeedQueryHookResult = ReturnType<typeof useGetUserFeedQuery>;
export type GetUserFeedLazyQueryHookResult = ReturnType<typeof useGetUserFeedLazyQuery>;
export type GetUserFeedSuspenseQueryHookResult = ReturnType<typeof useGetUserFeedSuspenseQuery>;
export type GetUserFeedQueryResult = Apollo.QueryResult<GetUserFeedQuery, GetUserFeedQueryVariables>;
export const GetLandingPageEventsDocument = gql`
    query GetLandingPageEvents($take: Int, $orderBy: [EventOrderByWithRelationInput!], $where: EventWhereInput, $skip: Int) {
  events(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...LandingPageEventItem
    }
    count
  }
}
    ${LandingPageEventItemFragmentDoc}`;
export function useGetLandingPageEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLandingPageEventsQuery, GetLandingPageEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLandingPageEventsQuery, GetLandingPageEventsQueryVariables>(GetLandingPageEventsDocument, options);
      }
export function useGetLandingPageEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLandingPageEventsQuery, GetLandingPageEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLandingPageEventsQuery, GetLandingPageEventsQueryVariables>(GetLandingPageEventsDocument, options);
        }
export function useGetLandingPageEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLandingPageEventsQuery, GetLandingPageEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLandingPageEventsQuery, GetLandingPageEventsQueryVariables>(GetLandingPageEventsDocument, options);
        }
export type GetLandingPageEventsQueryHookResult = ReturnType<typeof useGetLandingPageEventsQuery>;
export type GetLandingPageEventsLazyQueryHookResult = ReturnType<typeof useGetLandingPageEventsLazyQuery>;
export type GetLandingPageEventsSuspenseQueryHookResult = ReturnType<typeof useGetLandingPageEventsSuspenseQuery>;
export type GetLandingPageEventsQueryResult = Apollo.QueryResult<GetLandingPageEventsQuery, GetLandingPageEventsQueryVariables>;
export const LoginDocument = gql`
    mutation Login($data: LoginInput!) {
  login(data: $data) {
    user {
      ...Me
    }
    token
    refreshToken
  }
}
    ${MeFragmentDoc}`;
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications {
  notifications {
    ...NotificationItem
  }
}
    ${NotificationItemFragmentDoc}`;
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetPendingConnectionsDocument = gql`
    query GetPendingConnections {
  me {
    id
    pendingConnections {
      ...PendingConnection
    }
  }
}
    ${PendingConnectionFragmentDoc}`;
export function useGetPendingConnectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPendingConnectionsQuery, GetPendingConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPendingConnectionsQuery, GetPendingConnectionsQueryVariables>(GetPendingConnectionsDocument, options);
      }
export function useGetPendingConnectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPendingConnectionsQuery, GetPendingConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPendingConnectionsQuery, GetPendingConnectionsQueryVariables>(GetPendingConnectionsDocument, options);
        }
export function useGetPendingConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPendingConnectionsQuery, GetPendingConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPendingConnectionsQuery, GetPendingConnectionsQueryVariables>(GetPendingConnectionsDocument, options);
        }
export type GetPendingConnectionsQueryHookResult = ReturnType<typeof useGetPendingConnectionsQuery>;
export type GetPendingConnectionsLazyQueryHookResult = ReturnType<typeof useGetPendingConnectionsLazyQuery>;
export type GetPendingConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetPendingConnectionsSuspenseQuery>;
export type GetPendingConnectionsQueryResult = Apollo.QueryResult<GetPendingConnectionsQuery, GetPendingConnectionsQueryVariables>;
export const AcceptConnectionDocument = gql`
    mutation AcceptConnection($followerId: String!) {
  acceptConnection(followerId: $followerId)
}
    `;
export function useAcceptConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptConnectionMutation, AcceptConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptConnectionMutation, AcceptConnectionMutationVariables>(AcceptConnectionDocument, options);
      }
export type AcceptConnectionMutationHookResult = ReturnType<typeof useAcceptConnectionMutation>;
export type AcceptConnectionMutationResult = Apollo.MutationResult<AcceptConnectionMutation>;
export type AcceptConnectionMutationOptions = Apollo.BaseMutationOptions<AcceptConnectionMutation, AcceptConnectionMutationVariables>;
export const RejectConnectionDocument = gql`
    mutation RejectConnection($followerId: String!) {
  rejectConnection(followerId: $followerId)
}
    `;
export function useRejectConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectConnectionMutation, RejectConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectConnectionMutation, RejectConnectionMutationVariables>(RejectConnectionDocument, options);
      }
export type RejectConnectionMutationHookResult = ReturnType<typeof useRejectConnectionMutation>;
export type RejectConnectionMutationResult = Apollo.MutationResult<RejectConnectionMutation>;
export type RejectConnectionMutationOptions = Apollo.BaseMutationOptions<RejectConnectionMutation, RejectConnectionMutationVariables>;
export const GetPendingActInvitationsDocument = gql`
    query GetPendingActInvitations {
  pendingActInvitations {
    ...PendingAct
  }
}
    ${PendingActFragmentDoc}`;
export function useGetPendingActInvitationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPendingActInvitationsQuery, GetPendingActInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPendingActInvitationsQuery, GetPendingActInvitationsQueryVariables>(GetPendingActInvitationsDocument, options);
      }
export function useGetPendingActInvitationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPendingActInvitationsQuery, GetPendingActInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPendingActInvitationsQuery, GetPendingActInvitationsQueryVariables>(GetPendingActInvitationsDocument, options);
        }
export function useGetPendingActInvitationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPendingActInvitationsQuery, GetPendingActInvitationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPendingActInvitationsQuery, GetPendingActInvitationsQueryVariables>(GetPendingActInvitationsDocument, options);
        }
export type GetPendingActInvitationsQueryHookResult = ReturnType<typeof useGetPendingActInvitationsQuery>;
export type GetPendingActInvitationsLazyQueryHookResult = ReturnType<typeof useGetPendingActInvitationsLazyQuery>;
export type GetPendingActInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetPendingActInvitationsSuspenseQuery>;
export type GetPendingActInvitationsQueryResult = Apollo.QueryResult<GetPendingActInvitationsQuery, GetPendingActInvitationsQueryVariables>;
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($id: String!, $data: UpdateNotificationInput!) {
  updateNotification(id: $id, data: $data) {
    ...NotificationItem
  }
}
    ${NotificationItemFragmentDoc}`;
export function useUpdateNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const GetEventsPendingReviewDocument = gql`
    query GetEventsPendingReview {
  me {
    id
    eventsPendingReview {
      ...EventPendingReview
    }
  }
}
    ${EventPendingReviewFragmentDoc}`;
export function useGetEventsPendingReviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventsPendingReviewQuery, GetEventsPendingReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEventsPendingReviewQuery, GetEventsPendingReviewQueryVariables>(GetEventsPendingReviewDocument, options);
      }
export function useGetEventsPendingReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventsPendingReviewQuery, GetEventsPendingReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEventsPendingReviewQuery, GetEventsPendingReviewQueryVariables>(GetEventsPendingReviewDocument, options);
        }
export function useGetEventsPendingReviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEventsPendingReviewQuery, GetEventsPendingReviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEventsPendingReviewQuery, GetEventsPendingReviewQueryVariables>(GetEventsPendingReviewDocument, options);
        }
export type GetEventsPendingReviewQueryHookResult = ReturnType<typeof useGetEventsPendingReviewQuery>;
export type GetEventsPendingReviewLazyQueryHookResult = ReturnType<typeof useGetEventsPendingReviewLazyQuery>;
export type GetEventsPendingReviewSuspenseQueryHookResult = ReturnType<typeof useGetEventsPendingReviewSuspenseQuery>;
export type GetEventsPendingReviewQueryResult = Apollo.QueryResult<GetEventsPendingReviewQuery, GetEventsPendingReviewQueryVariables>;
export const SubmitPinkPopFormDocument = gql`
    mutation SubmitPinkPopForm($data: PinkPopFormInput!) {
  submitPinkPopForm(data: $data)
}
    `;
export function useSubmitPinkPopFormMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitPinkPopFormMutation, SubmitPinkPopFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitPinkPopFormMutation, SubmitPinkPopFormMutationVariables>(SubmitPinkPopFormDocument, options);
      }
export type SubmitPinkPopFormMutationHookResult = ReturnType<typeof useSubmitPinkPopFormMutation>;
export type SubmitPinkPopFormMutationResult = Apollo.MutationResult<SubmitPinkPopFormMutation>;
export type SubmitPinkPopFormMutationOptions = Apollo.BaseMutationOptions<SubmitPinkPopFormMutation, SubmitPinkPopFormMutationVariables>;
export const CreatePostDocument = gql`
    mutation CreatePost($data: CreatePostInput!) {
  createPost(data: $data) {
    ...PostDetail
  }
}
    ${PostDetailFragmentDoc}`;
export function useCreatePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const UpdatePostDocument = gql`
    mutation UpdatePost($id: String!, $data: UpdatePostInput!) {
  updatePost(id: $id, data: $data) {
    ...PostItem
  }
}
    ${PostItemFragmentDoc}`;
export function useUpdatePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const GetProfileActsDocument = gql`
    query GetProfileActs($id: String!, $take: Int, $orderBy: [ActOrderByWithRelationInput!], $where: ActWhereInput, $skip: Int) {
  user(id: $id) {
    id
    acts(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...ProfileAct
      }
      count
    }
  }
}
    ${ProfileActFragmentDoc}`;
export function useGetProfileActsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfileActsQuery, GetProfileActsQueryVariables> & ({ variables: GetProfileActsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileActsQuery, GetProfileActsQueryVariables>(GetProfileActsDocument, options);
      }
export function useGetProfileActsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileActsQuery, GetProfileActsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileActsQuery, GetProfileActsQueryVariables>(GetProfileActsDocument, options);
        }
export function useGetProfileActsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileActsQuery, GetProfileActsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileActsQuery, GetProfileActsQueryVariables>(GetProfileActsDocument, options);
        }
export type GetProfileActsQueryHookResult = ReturnType<typeof useGetProfileActsQuery>;
export type GetProfileActsLazyQueryHookResult = ReturnType<typeof useGetProfileActsLazyQuery>;
export type GetProfileActsSuspenseQueryHookResult = ReturnType<typeof useGetProfileActsSuspenseQuery>;
export type GetProfileActsQueryResult = Apollo.QueryResult<GetProfileActsQuery, GetProfileActsQueryVariables>;
export const UpdateActFeedbackSeenDocument = gql`
    mutation UpdateActFeedbackSeen($id: String!, $data: UpdateActInput!) {
  updateActFeedback(id: $id, data: $data) {
    ...ProfileAct
  }
}
    ${ProfileActFragmentDoc}`;
export function useUpdateActFeedbackSeenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateActFeedbackSeenMutation, UpdateActFeedbackSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateActFeedbackSeenMutation, UpdateActFeedbackSeenMutationVariables>(UpdateActFeedbackSeenDocument, options);
      }
export type UpdateActFeedbackSeenMutationHookResult = ReturnType<typeof useUpdateActFeedbackSeenMutation>;
export type UpdateActFeedbackSeenMutationResult = Apollo.MutationResult<UpdateActFeedbackSeenMutation>;
export type UpdateActFeedbackSeenMutationOptions = Apollo.BaseMutationOptions<UpdateActFeedbackSeenMutation, UpdateActFeedbackSeenMutationVariables>;
export const OrderPromoPackageDocument = gql`
    mutation OrderPromoPackage($id: String!) {
  orderPromoPackage(id: $id)
}
    `;
export function useOrderPromoPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrderPromoPackageMutation, OrderPromoPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrderPromoPackageMutation, OrderPromoPackageMutationVariables>(OrderPromoPackageDocument, options);
      }
export type OrderPromoPackageMutationHookResult = ReturnType<typeof useOrderPromoPackageMutation>;
export type OrderPromoPackageMutationResult = Apollo.MutationResult<OrderPromoPackageMutation>;
export type OrderPromoPackageMutationOptions = Apollo.BaseMutationOptions<OrderPromoPackageMutation, OrderPromoPackageMutationVariables>;
export const GetProfileConnectionProjectsDocument = gql`
    query GetProfileConnectionProjects($id: String!, $take: Int, $orderBy: [ProjectOrderByWithRelationInput!], $where: ProjectWhereInput, $skip: Int) {
  user(id: $id) {
    id
    connectionProjects(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...ProfileConnectionProject
      }
      count
    }
  }
}
    ${ProfileConnectionProjectFragmentDoc}`;
export function useGetProfileConnectionProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfileConnectionProjectsQuery, GetProfileConnectionProjectsQueryVariables> & ({ variables: GetProfileConnectionProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileConnectionProjectsQuery, GetProfileConnectionProjectsQueryVariables>(GetProfileConnectionProjectsDocument, options);
      }
export function useGetProfileConnectionProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileConnectionProjectsQuery, GetProfileConnectionProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileConnectionProjectsQuery, GetProfileConnectionProjectsQueryVariables>(GetProfileConnectionProjectsDocument, options);
        }
export function useGetProfileConnectionProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileConnectionProjectsQuery, GetProfileConnectionProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileConnectionProjectsQuery, GetProfileConnectionProjectsQueryVariables>(GetProfileConnectionProjectsDocument, options);
        }
export type GetProfileConnectionProjectsQueryHookResult = ReturnType<typeof useGetProfileConnectionProjectsQuery>;
export type GetProfileConnectionProjectsLazyQueryHookResult = ReturnType<typeof useGetProfileConnectionProjectsLazyQuery>;
export type GetProfileConnectionProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProfileConnectionProjectsSuspenseQuery>;
export type GetProfileConnectionProjectsQueryResult = Apollo.QueryResult<GetProfileConnectionProjectsQuery, GetProfileConnectionProjectsQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($data: UpdateUserInput!) {
  updateMe(data: $data) {
    ...ProfileEditDetails
  }
}
    ${ProfileEditDetailsFragmentDoc}`;
export function useUpdateMeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const GetProfileEventsDocument = gql`
    query GetProfileEvents($id: String!, $take: Int, $orderBy: [UserEventOrderByWithRelationInput!], $where: UserEventWhereInput, $skip: Int) {
  user(id: $id) {
    id
    events(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...ProfileEvent
      }
      count
    }
  }
}
    ${ProfileEventFragmentDoc}`;
export function useGetProfileEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfileEventsQuery, GetProfileEventsQueryVariables> & ({ variables: GetProfileEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileEventsQuery, GetProfileEventsQueryVariables>(GetProfileEventsDocument, options);
      }
export function useGetProfileEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileEventsQuery, GetProfileEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileEventsQuery, GetProfileEventsQueryVariables>(GetProfileEventsDocument, options);
        }
export function useGetProfileEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileEventsQuery, GetProfileEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileEventsQuery, GetProfileEventsQueryVariables>(GetProfileEventsDocument, options);
        }
export type GetProfileEventsQueryHookResult = ReturnType<typeof useGetProfileEventsQuery>;
export type GetProfileEventsLazyQueryHookResult = ReturnType<typeof useGetProfileEventsLazyQuery>;
export type GetProfileEventsSuspenseQueryHookResult = ReturnType<typeof useGetProfileEventsSuspenseQuery>;
export type GetProfileEventsQueryResult = Apollo.QueryResult<GetProfileEventsQuery, GetProfileEventsQueryVariables>;
export const GetProfilePostsDocument = gql`
    query GetProfilePosts($id: String!, $isNotCurrentUser: Boolean!) {
  user(id: $id) {
    id
    posts {
      ...ProfilePost
    }
    commentedOnPosts @skip(if: $isNotCurrentUser) {
      ...ProfilePost
    }
    matchedOnPosts @skip(if: $isNotCurrentUser) {
      ...ProfilePost
    }
  }
}
    ${ProfilePostFragmentDoc}`;
export function useGetProfilePostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfilePostsQuery, GetProfilePostsQueryVariables> & ({ variables: GetProfilePostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfilePostsQuery, GetProfilePostsQueryVariables>(GetProfilePostsDocument, options);
      }
export function useGetProfilePostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfilePostsQuery, GetProfilePostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfilePostsQuery, GetProfilePostsQueryVariables>(GetProfilePostsDocument, options);
        }
export function useGetProfilePostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfilePostsQuery, GetProfilePostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfilePostsQuery, GetProfilePostsQueryVariables>(GetProfilePostsDocument, options);
        }
export type GetProfilePostsQueryHookResult = ReturnType<typeof useGetProfilePostsQuery>;
export type GetProfilePostsLazyQueryHookResult = ReturnType<typeof useGetProfilePostsLazyQuery>;
export type GetProfilePostsSuspenseQueryHookResult = ReturnType<typeof useGetProfilePostsSuspenseQuery>;
export type GetProfilePostsQueryResult = Apollo.QueryResult<GetProfilePostsQuery, GetProfilePostsQueryVariables>;
export const GetProfileProjectsDocument = gql`
    query GetProfileProjects($id: String!, $take: Int, $orderBy: [ProjectOrderByWithRelationInput!], $where: ProjectWhereInput, $skip: Int) {
  user(id: $id) {
    id
    projects(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...ProfileProject
      }
      count
    }
  }
}
    ${ProfileProjectFragmentDoc}`;
export function useGetProfileProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfileProjectsQuery, GetProfileProjectsQueryVariables> & ({ variables: GetProfileProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileProjectsQuery, GetProfileProjectsQueryVariables>(GetProfileProjectsDocument, options);
      }
export function useGetProfileProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileProjectsQuery, GetProfileProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileProjectsQuery, GetProfileProjectsQueryVariables>(GetProfileProjectsDocument, options);
        }
export function useGetProfileProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileProjectsQuery, GetProfileProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileProjectsQuery, GetProfileProjectsQueryVariables>(GetProfileProjectsDocument, options);
        }
export type GetProfileProjectsQueryHookResult = ReturnType<typeof useGetProfileProjectsQuery>;
export type GetProfileProjectsLazyQueryHookResult = ReturnType<typeof useGetProfileProjectsLazyQuery>;
export type GetProfileProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProfileProjectsSuspenseQuery>;
export type GetProfileProjectsQueryResult = Apollo.QueryResult<GetProfileProjectsQuery, GetProfileProjectsQueryVariables>;
export const DestroyProjectDocument = gql`
    mutation DestroyProject($id: String!) {
  destroyProject(id: $id) {
    creatorId
  }
}
    `;
export function useDestroyProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyProjectMutation, DestroyProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyProjectMutation, DestroyProjectMutationVariables>(DestroyProjectDocument, options);
      }
export type DestroyProjectMutationHookResult = ReturnType<typeof useDestroyProjectMutation>;
export type DestroyProjectMutationResult = Apollo.MutationResult<DestroyProjectMutation>;
export type DestroyProjectMutationOptions = Apollo.BaseMutationOptions<DestroyProjectMutation, DestroyProjectMutationVariables>;
export const GetProfileTutorialsDocument = gql`
    query GetProfileTutorials($id: String!, $take: Int, $orderBy: [UserTutorialOrderByWithRelationInput!], $where: UserTutorialWhereInput, $skip: Int) {
  user(id: $id) {
    id
    tutorials(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
      items {
        ...TutorialItem
      }
      count
    }
  }
}
    ${TutorialItemFragmentDoc}`;
export function useGetProfileTutorialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfileTutorialsQuery, GetProfileTutorialsQueryVariables> & ({ variables: GetProfileTutorialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileTutorialsQuery, GetProfileTutorialsQueryVariables>(GetProfileTutorialsDocument, options);
      }
export function useGetProfileTutorialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileTutorialsQuery, GetProfileTutorialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileTutorialsQuery, GetProfileTutorialsQueryVariables>(GetProfileTutorialsDocument, options);
        }
export function useGetProfileTutorialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileTutorialsQuery, GetProfileTutorialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileTutorialsQuery, GetProfileTutorialsQueryVariables>(GetProfileTutorialsDocument, options);
        }
export type GetProfileTutorialsQueryHookResult = ReturnType<typeof useGetProfileTutorialsQuery>;
export type GetProfileTutorialsLazyQueryHookResult = ReturnType<typeof useGetProfileTutorialsLazyQuery>;
export type GetProfileTutorialsSuspenseQueryHookResult = ReturnType<typeof useGetProfileTutorialsSuspenseQuery>;
export type GetProfileTutorialsQueryResult = Apollo.QueryResult<GetProfileTutorialsQuery, GetProfileTutorialsQueryVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($data: ProjectCreateInput!) {
  createProject(data: $data) {
    ...EditProject
  }
}
    ${EditProjectFragmentDoc}`;
export function useCreateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const GetConnectionsForProjectsDocument = gql`
    query GetConnectionsForProjects {
  me {
    id
    connections {
      ...ProjectUserConnection
    }
  }
}
    ${ProjectUserConnectionFragmentDoc}`;
export function useGetConnectionsForProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetConnectionsForProjectsQuery, GetConnectionsForProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetConnectionsForProjectsQuery, GetConnectionsForProjectsQueryVariables>(GetConnectionsForProjectsDocument, options);
      }
export function useGetConnectionsForProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetConnectionsForProjectsQuery, GetConnectionsForProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetConnectionsForProjectsQuery, GetConnectionsForProjectsQueryVariables>(GetConnectionsForProjectsDocument, options);
        }
export function useGetConnectionsForProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetConnectionsForProjectsQuery, GetConnectionsForProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetConnectionsForProjectsQuery, GetConnectionsForProjectsQueryVariables>(GetConnectionsForProjectsDocument, options);
        }
export type GetConnectionsForProjectsQueryHookResult = ReturnType<typeof useGetConnectionsForProjectsQuery>;
export type GetConnectionsForProjectsLazyQueryHookResult = ReturnType<typeof useGetConnectionsForProjectsLazyQuery>;
export type GetConnectionsForProjectsSuspenseQueryHookResult = ReturnType<typeof useGetConnectionsForProjectsSuspenseQuery>;
export type GetConnectionsForProjectsQueryResult = Apollo.QueryResult<GetConnectionsForProjectsQuery, GetConnectionsForProjectsQueryVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($data: UpdateProjectInput!, $id: String!) {
  updateProject(data: $data, id: $id) {
    ...EditProject
  }
}
    ${EditProjectFragmentDoc}`;
export function useUpdateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectStep2Document = gql`
    mutation UpdateProjectStep2($data: UpdateProjectInput!, $id: String!) {
  updateProject(data: $data, id: $id) {
    ...EditProject
  }
}
    ${EditProjectFragmentDoc}`;
export function useUpdateProjectStep2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectStep2Mutation, UpdateProjectStep2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectStep2Mutation, UpdateProjectStep2MutationVariables>(UpdateProjectStep2Document, options);
      }
export type UpdateProjectStep2MutationHookResult = ReturnType<typeof useUpdateProjectStep2Mutation>;
export type UpdateProjectStep2MutationResult = Apollo.MutationResult<UpdateProjectStep2Mutation>;
export type UpdateProjectStep2MutationOptions = Apollo.BaseMutationOptions<UpdateProjectStep2Mutation, UpdateProjectStep2MutationVariables>;
export const UpdateProjectStep3Document = gql`
    mutation UpdateProjectStep3($data: UpdateProjectInput!, $id: String!) {
  updateProject(data: $data, id: $id) {
    ...EditProject
  }
}
    ${EditProjectFragmentDoc}`;
export function useUpdateProjectStep3Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectStep3Mutation, UpdateProjectStep3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectStep3Mutation, UpdateProjectStep3MutationVariables>(UpdateProjectStep3Document, options);
      }
export type UpdateProjectStep3MutationHookResult = ReturnType<typeof useUpdateProjectStep3Mutation>;
export type UpdateProjectStep3MutationResult = Apollo.MutationResult<UpdateProjectStep3Mutation>;
export type UpdateProjectStep3MutationOptions = Apollo.BaseMutationOptions<UpdateProjectStep3Mutation, UpdateProjectStep3MutationVariables>;
export const RegisterDocument = gql`
    mutation Register($data: RegisterInput!) {
  register(data: $data) {
    user {
      ...Me
    }
    token
    refreshToken
  }
}
    ${MeFragmentDoc}`;
export function useRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RegisterFromInviteDocument = gql`
    mutation RegisterFromInvite($id: String!, $data: RegisterFromInviteInput!) {
  updateUserFromInvite(id: $id, data: $data) {
    user {
      ...Me
    }
    token
    refreshToken
  }
}
    ${MeFragmentDoc}`;
export function useRegisterFromInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterFromInviteMutation, RegisterFromInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterFromInviteMutation, RegisterFromInviteMutationVariables>(RegisterFromInviteDocument, options);
      }
export type RegisterFromInviteMutationHookResult = ReturnType<typeof useRegisterFromInviteMutation>;
export type RegisterFromInviteMutationResult = Apollo.MutationResult<RegisterFromInviteMutation>;
export type RegisterFromInviteMutationOptions = Apollo.BaseMutationOptions<RegisterFromInviteMutation, RegisterFromInviteMutationVariables>;
export const GetUpcomingFinalDateDocument = gql`
    query GetUpcomingFinalDate {
  upcomingFinalDate
}
    `;
export function useGetUpcomingFinalDateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUpcomingFinalDateQuery, GetUpcomingFinalDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUpcomingFinalDateQuery, GetUpcomingFinalDateQueryVariables>(GetUpcomingFinalDateDocument, options);
      }
export function useGetUpcomingFinalDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUpcomingFinalDateQuery, GetUpcomingFinalDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUpcomingFinalDateQuery, GetUpcomingFinalDateQueryVariables>(GetUpcomingFinalDateDocument, options);
        }
export function useGetUpcomingFinalDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUpcomingFinalDateQuery, GetUpcomingFinalDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUpcomingFinalDateQuery, GetUpcomingFinalDateQueryVariables>(GetUpcomingFinalDateDocument, options);
        }
export type GetUpcomingFinalDateQueryHookResult = ReturnType<typeof useGetUpcomingFinalDateQuery>;
export type GetUpcomingFinalDateLazyQueryHookResult = ReturnType<typeof useGetUpcomingFinalDateLazyQuery>;
export type GetUpcomingFinalDateSuspenseQueryHookResult = ReturnType<typeof useGetUpcomingFinalDateSuspenseQuery>;
export type GetUpcomingFinalDateQueryResult = Apollo.QueryResult<GetUpcomingFinalDateQuery, GetUpcomingFinalDateQueryVariables>;
export const ReviewEventDocument = gql`
    mutation ReviewEvent($eventId: String!, $data: UpdateUserEventInput!) {
  reviewEvent(eventId: $eventId, data: $data)
}
    `;
export function useReviewEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReviewEventMutation, ReviewEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReviewEventMutation, ReviewEventMutationVariables>(ReviewEventDocument, options);
      }
export type ReviewEventMutationHookResult = ReturnType<typeof useReviewEventMutation>;
export type ReviewEventMutationResult = Apollo.MutationResult<ReviewEventMutation>;
export type ReviewEventMutationOptions = Apollo.BaseMutationOptions<ReviewEventMutation, ReviewEventMutationVariables>;
export const ShortRegisterDocument = gql`
    mutation ShortRegister($data: ShortRegisterInput!) {
  shortRegister(data: $data) {
    user {
      ...Me
    }
    token
    refreshToken
  }
}
    ${MeFragmentDoc}`;
export function useShortRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShortRegisterMutation, ShortRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShortRegisterMutation, ShortRegisterMutationVariables>(ShortRegisterDocument, options);
      }
export type ShortRegisterMutationHookResult = ReturnType<typeof useShortRegisterMutation>;
export type ShortRegisterMutationResult = Apollo.MutationResult<ShortRegisterMutation>;
export type ShortRegisterMutationOptions = Apollo.BaseMutationOptions<ShortRegisterMutation, ShortRegisterMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($data: CreateCommentInput!) {
  createComment(data: $data) {
    id
  }
}
    `;
export function useCreateCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const RequestConnectionDocument = gql`
    mutation RequestConnection($userId: String!) {
  requestConnection(userId: $userId)
}
    `;
export function useRequestConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestConnectionMutation, RequestConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestConnectionMutation, RequestConnectionMutationVariables>(RequestConnectionDocument, options);
      }
export type RequestConnectionMutationHookResult = ReturnType<typeof useRequestConnectionMutation>;
export type RequestConnectionMutationResult = Apollo.MutationResult<RequestConnectionMutation>;
export type RequestConnectionMutationOptions = Apollo.BaseMutationOptions<RequestConnectionMutation, RequestConnectionMutationVariables>;
export const RemoveConnectionDocument = gql`
    mutation RemoveConnection($userId: String!) {
  removeConnection(userId: $userId)
}
    `;
export function useRemoveConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveConnectionMutation, RemoveConnectionMutationVariables>(RemoveConnectionDocument, options);
      }
export type RemoveConnectionMutationHookResult = ReturnType<typeof useRemoveConnectionMutation>;
export type RemoveConnectionMutationResult = Apollo.MutationResult<RemoveConnectionMutation>;
export type RemoveConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($take: Int, $orderBy: [UserOrderByWithRelationInput!], $where: UserWhereInput, $skip: Int) {
  publicUsers(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...UserItem
    }
    count
  }
}
    ${UserItemFragmentDoc}`;
export function useSearchUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetSignedUrlForPutDocument = gql`
    mutation GetSignedUrlForPut($data: S3SignedUrlInput!) {
  getSignedS3UrlForPut(data: $data) {
    url
    uploadUrl
  }
}
    `;
export function useGetSignedUrlForPutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetSignedUrlForPutMutation, GetSignedUrlForPutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetSignedUrlForPutMutation, GetSignedUrlForPutMutationVariables>(GetSignedUrlForPutDocument, options);
      }
export type GetSignedUrlForPutMutationHookResult = ReturnType<typeof useGetSignedUrlForPutMutation>;
export type GetSignedUrlForPutMutationResult = Apollo.MutationResult<GetSignedUrlForPutMutation>;
export type GetSignedUrlForPutMutationOptions = Apollo.BaseMutationOptions<GetSignedUrlForPutMutation, GetSignedUrlForPutMutationVariables>;
export const GetBulkSignedUrlForPutDocument = gql`
    mutation GetBulkSignedUrlForPut($data: S3BulkSignedUrlInput!) {
  getBulkSignedS3UrlForPut(data: $data) {
    url
    uploadUrl
    key
  }
}
    `;
export function useGetBulkSignedUrlForPutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetBulkSignedUrlForPutMutation, GetBulkSignedUrlForPutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetBulkSignedUrlForPutMutation, GetBulkSignedUrlForPutMutationVariables>(GetBulkSignedUrlForPutDocument, options);
      }
export type GetBulkSignedUrlForPutMutationHookResult = ReturnType<typeof useGetBulkSignedUrlForPutMutation>;
export type GetBulkSignedUrlForPutMutationResult = Apollo.MutationResult<GetBulkSignedUrlForPutMutation>;
export type GetBulkSignedUrlForPutMutationOptions = Apollo.BaseMutationOptions<GetBulkSignedUrlForPutMutation, GetBulkSignedUrlForPutMutationVariables>;
export const GetPageDocument = gql`
    query GetPage($slug: String!) {
  page(slug: $slug) {
    ...PageDetail
  }
}
    ${PageDetailFragmentDoc}`;
export function useGetPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPageQuery, GetPageQueryVariables> & ({ variables: GetPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
      }
export function useGetPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
export function useGetPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>;
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>;
export type GetPageSuspenseQueryHookResult = ReturnType<typeof useGetPageSuspenseQuery>;
export type GetPageQueryResult = Apollo.QueryResult<GetPageQuery, GetPageQueryVariables>;
export const GetActInvitationDocument = gql`
    query GetActInvitation($id: String!) {
  actInvitation(id: $id) {
    ...ActInvitation
  }
}
    ${ActInvitationFragmentDoc}`;
export function useGetActInvitationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActInvitationQuery, GetActInvitationQueryVariables> & ({ variables: GetActInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActInvitationQuery, GetActInvitationQueryVariables>(GetActInvitationDocument, options);
      }
export function useGetActInvitationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActInvitationQuery, GetActInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActInvitationQuery, GetActInvitationQueryVariables>(GetActInvitationDocument, options);
        }
export function useGetActInvitationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActInvitationQuery, GetActInvitationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActInvitationQuery, GetActInvitationQueryVariables>(GetActInvitationDocument, options);
        }
export type GetActInvitationQueryHookResult = ReturnType<typeof useGetActInvitationQuery>;
export type GetActInvitationLazyQueryHookResult = ReturnType<typeof useGetActInvitationLazyQuery>;
export type GetActInvitationSuspenseQueryHookResult = ReturnType<typeof useGetActInvitationSuspenseQuery>;
export type GetActInvitationQueryResult = Apollo.QueryResult<GetActInvitationQuery, GetActInvitationQueryVariables>;
export const AcceptActInviteDocument = gql`
    mutation AcceptActInvite($id: String!) {
  acceptActInvite(id: $id)
}
    `;
export function useAcceptActInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptActInviteMutation, AcceptActInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptActInviteMutation, AcceptActInviteMutationVariables>(AcceptActInviteDocument, options);
      }
export type AcceptActInviteMutationHookResult = ReturnType<typeof useAcceptActInviteMutation>;
export type AcceptActInviteMutationResult = Apollo.MutationResult<AcceptActInviteMutation>;
export type AcceptActInviteMutationOptions = Apollo.BaseMutationOptions<AcceptActInviteMutation, AcceptActInviteMutationVariables>;
export const RejectActInviteDocument = gql`
    mutation RejectActInvite($id: String!) {
  rejectActInvite(id: $id)
}
    `;
export function useRejectActInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectActInviteMutation, RejectActInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectActInviteMutation, RejectActInviteMutationVariables>(RejectActInviteDocument, options);
      }
export type RejectActInviteMutationHookResult = ReturnType<typeof useRejectActInviteMutation>;
export type RejectActInviteMutationResult = Apollo.MutationResult<RejectActInviteMutation>;
export type RejectActInviteMutationOptions = Apollo.BaseMutationOptions<RejectActInviteMutation, RejectActInviteMutationVariables>;
export const GetAdminActDocument = gql`
    query GetAdminAct($id: String!) {
  act(id: $id) {
    ...AdminActDetail
  }
}
    ${AdminActDetailFragmentDoc}`;
export function useGetAdminActQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminActQuery, GetAdminActQueryVariables> & ({ variables: GetAdminActQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminActQuery, GetAdminActQueryVariables>(GetAdminActDocument, options);
      }
export function useGetAdminActLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminActQuery, GetAdminActQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminActQuery, GetAdminActQueryVariables>(GetAdminActDocument, options);
        }
export function useGetAdminActSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminActQuery, GetAdminActQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminActQuery, GetAdminActQueryVariables>(GetAdminActDocument, options);
        }
export type GetAdminActQueryHookResult = ReturnType<typeof useGetAdminActQuery>;
export type GetAdminActLazyQueryHookResult = ReturnType<typeof useGetAdminActLazyQuery>;
export type GetAdminActSuspenseQueryHookResult = ReturnType<typeof useGetAdminActSuspenseQuery>;
export type GetAdminActQueryResult = Apollo.QueryResult<GetAdminActQuery, GetAdminActQueryVariables>;
export const GetAdminActsDocument = gql`
    query GetAdminActs($take: Int, $orderBy: [ActOrderByWithRelationInput!], $where: ActWhereInput, $skip: Int) {
  acts(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminActItem
    }
    count
  }
}
    ${AdminActItemFragmentDoc}`;
export function useGetAdminActsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminActsQuery, GetAdminActsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminActsQuery, GetAdminActsQueryVariables>(GetAdminActsDocument, options);
      }
export function useGetAdminActsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminActsQuery, GetAdminActsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminActsQuery, GetAdminActsQueryVariables>(GetAdminActsDocument, options);
        }
export function useGetAdminActsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminActsQuery, GetAdminActsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminActsQuery, GetAdminActsQueryVariables>(GetAdminActsDocument, options);
        }
export type GetAdminActsQueryHookResult = ReturnType<typeof useGetAdminActsQuery>;
export type GetAdminActsLazyQueryHookResult = ReturnType<typeof useGetAdminActsLazyQuery>;
export type GetAdminActsSuspenseQueryHookResult = ReturnType<typeof useGetAdminActsSuspenseQuery>;
export type GetAdminActsQueryResult = Apollo.QueryResult<GetAdminActsQuery, GetAdminActsQueryVariables>;
export const GetAdminCustomFeedDocument = gql`
    query GetAdminCustomFeed {
  customFeed {
    ...AdminCustomFeedItem
  }
}
    ${AdminCustomFeedItemFragmentDoc}`;
export function useGetAdminCustomFeedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminCustomFeedQuery, GetAdminCustomFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCustomFeedQuery, GetAdminCustomFeedQueryVariables>(GetAdminCustomFeedDocument, options);
      }
export function useGetAdminCustomFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCustomFeedQuery, GetAdminCustomFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCustomFeedQuery, GetAdminCustomFeedQueryVariables>(GetAdminCustomFeedDocument, options);
        }
export function useGetAdminCustomFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCustomFeedQuery, GetAdminCustomFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCustomFeedQuery, GetAdminCustomFeedQueryVariables>(GetAdminCustomFeedDocument, options);
        }
export type GetAdminCustomFeedQueryHookResult = ReturnType<typeof useGetAdminCustomFeedQuery>;
export type GetAdminCustomFeedLazyQueryHookResult = ReturnType<typeof useGetAdminCustomFeedLazyQuery>;
export type GetAdminCustomFeedSuspenseQueryHookResult = ReturnType<typeof useGetAdminCustomFeedSuspenseQuery>;
export type GetAdminCustomFeedQueryResult = Apollo.QueryResult<GetAdminCustomFeedQuery, GetAdminCustomFeedQueryVariables>;
export const CreateCustomFeedDocument = gql`
    mutation CreateCustomFeed($data: CustomFeedCreateInput!) {
  createCustomFeed(data: $data) {
    ...AdminCustomFeedItem
  }
}
    ${AdminCustomFeedItemFragmentDoc}`;
export function useCreateCustomFeedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomFeedMutation, CreateCustomFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomFeedMutation, CreateCustomFeedMutationVariables>(CreateCustomFeedDocument, options);
      }
export type CreateCustomFeedMutationHookResult = ReturnType<typeof useCreateCustomFeedMutation>;
export type CreateCustomFeedMutationResult = Apollo.MutationResult<CreateCustomFeedMutation>;
export type CreateCustomFeedMutationOptions = Apollo.BaseMutationOptions<CreateCustomFeedMutation, CreateCustomFeedMutationVariables>;
export const GetAdminUserDocument = gql`
    query GetAdminUser($id: String!) {
  user(id: $id) {
    ...AdminUserDetail
  }
}
    ${AdminUserDetailFragmentDoc}`;
export function useGetAdminUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables> & ({ variables: GetAdminUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
      }
export function useGetAdminUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
        }
export function useGetAdminUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
        }
export type GetAdminUserQueryHookResult = ReturnType<typeof useGetAdminUserQuery>;
export type GetAdminUserLazyQueryHookResult = ReturnType<typeof useGetAdminUserLazyQuery>;
export type GetAdminUserSuspenseQueryHookResult = ReturnType<typeof useGetAdminUserSuspenseQuery>;
export type GetAdminUserQueryResult = Apollo.QueryResult<GetAdminUserQuery, GetAdminUserQueryVariables>;
export const GetAdminProjectDocument = gql`
    query GetAdminProject($id: String!) {
  project(id: $id) {
    ...AdminProjectDetail
  }
}
    ${AdminProjectDetailFragmentDoc}`;
export function useGetAdminProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminProjectQuery, GetAdminProjectQueryVariables> & ({ variables: GetAdminProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminProjectQuery, GetAdminProjectQueryVariables>(GetAdminProjectDocument, options);
      }
export function useGetAdminProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminProjectQuery, GetAdminProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminProjectQuery, GetAdminProjectQueryVariables>(GetAdminProjectDocument, options);
        }
export function useGetAdminProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminProjectQuery, GetAdminProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminProjectQuery, GetAdminProjectQueryVariables>(GetAdminProjectDocument, options);
        }
export type GetAdminProjectQueryHookResult = ReturnType<typeof useGetAdminProjectQuery>;
export type GetAdminProjectLazyQueryHookResult = ReturnType<typeof useGetAdminProjectLazyQuery>;
export type GetAdminProjectSuspenseQueryHookResult = ReturnType<typeof useGetAdminProjectSuspenseQuery>;
export type GetAdminProjectQueryResult = Apollo.QueryResult<GetAdminProjectQuery, GetAdminProjectQueryVariables>;
export const GetAdminUsersDocument = gql`
    query GetAdminUsers($take: Int, $orderBy: [UserOrderByWithRelationInput!], $where: UserWhereInput, $skip: Int) {
  users(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminUserItem
    }
    count
  }
}
    ${AdminUserItemFragmentDoc}`;
export function useGetAdminUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
      }
export function useGetAdminUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export function useGetAdminUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersSuspenseQueryHookResult = ReturnType<typeof useGetAdminUsersSuspenseQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const GetAdminPageDocument = gql`
    query GetAdminPage($slug: String!) {
  page(slug: $slug) {
    ...AdminPageDetail
  }
}
    ${AdminPageDetailFragmentDoc}`;
export function useGetAdminPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminPageQuery, GetAdminPageQueryVariables> & ({ variables: GetAdminPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminPageQuery, GetAdminPageQueryVariables>(GetAdminPageDocument, options);
      }
export function useGetAdminPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminPageQuery, GetAdminPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminPageQuery, GetAdminPageQueryVariables>(GetAdminPageDocument, options);
        }
export function useGetAdminPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminPageQuery, GetAdminPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminPageQuery, GetAdminPageQueryVariables>(GetAdminPageDocument, options);
        }
export type GetAdminPageQueryHookResult = ReturnType<typeof useGetAdminPageQuery>;
export type GetAdminPageLazyQueryHookResult = ReturnType<typeof useGetAdminPageLazyQuery>;
export type GetAdminPageSuspenseQueryHookResult = ReturnType<typeof useGetAdminPageSuspenseQuery>;
export type GetAdminPageQueryResult = Apollo.QueryResult<GetAdminPageQuery, GetAdminPageQueryVariables>;
export const CreatePageDocument = gql`
    mutation CreatePage($data: PageCreateInput!) {
  createPage(data: $data) {
    id
    slug
  }
}
    `;
export function useCreatePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const GetAdminPagesDocument = gql`
    query GetAdminPages($take: Int, $orderBy: [PageOrderByWithRelationInput!], $where: PageWhereInput, $skip: Int) {
  pages(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminPageItem
    }
    count
  }
}
    ${AdminPageItemFragmentDoc}`;
export function useGetAdminPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminPagesQuery, GetAdminPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminPagesQuery, GetAdminPagesQueryVariables>(GetAdminPagesDocument, options);
      }
export function useGetAdminPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminPagesQuery, GetAdminPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminPagesQuery, GetAdminPagesQueryVariables>(GetAdminPagesDocument, options);
        }
export function useGetAdminPagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminPagesQuery, GetAdminPagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminPagesQuery, GetAdminPagesQueryVariables>(GetAdminPagesDocument, options);
        }
export type GetAdminPagesQueryHookResult = ReturnType<typeof useGetAdminPagesQuery>;
export type GetAdminPagesLazyQueryHookResult = ReturnType<typeof useGetAdminPagesLazyQuery>;
export type GetAdminPagesSuspenseQueryHookResult = ReturnType<typeof useGetAdminPagesSuspenseQuery>;
export type GetAdminPagesQueryResult = Apollo.QueryResult<GetAdminPagesQuery, GetAdminPagesQueryVariables>;
export const GetAdminPostDocument = gql`
    query GetAdminPost($id: String!) {
  post(id: $id) {
    ...AdminPostDetail
  }
}
    ${AdminPostDetailFragmentDoc}`;
export function useGetAdminPostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminPostQuery, GetAdminPostQueryVariables> & ({ variables: GetAdminPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminPostQuery, GetAdminPostQueryVariables>(GetAdminPostDocument, options);
      }
export function useGetAdminPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminPostQuery, GetAdminPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminPostQuery, GetAdminPostQueryVariables>(GetAdminPostDocument, options);
        }
export function useGetAdminPostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminPostQuery, GetAdminPostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminPostQuery, GetAdminPostQueryVariables>(GetAdminPostDocument, options);
        }
export type GetAdminPostQueryHookResult = ReturnType<typeof useGetAdminPostQuery>;
export type GetAdminPostLazyQueryHookResult = ReturnType<typeof useGetAdminPostLazyQuery>;
export type GetAdminPostSuspenseQueryHookResult = ReturnType<typeof useGetAdminPostSuspenseQuery>;
export type GetAdminPostQueryResult = Apollo.QueryResult<GetAdminPostQuery, GetAdminPostQueryVariables>;
export const CreatePostAdminDocument = gql`
    mutation CreatePostAdmin($data: CreatePostInput!) {
  createPost(data: $data) {
    id
    title
  }
}
    `;
export function useCreatePostAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePostAdminMutation, CreatePostAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePostAdminMutation, CreatePostAdminMutationVariables>(CreatePostAdminDocument, options);
      }
export type CreatePostAdminMutationHookResult = ReturnType<typeof useCreatePostAdminMutation>;
export type CreatePostAdminMutationResult = Apollo.MutationResult<CreatePostAdminMutation>;
export type CreatePostAdminMutationOptions = Apollo.BaseMutationOptions<CreatePostAdminMutation, CreatePostAdminMutationVariables>;
export const GetAdminPostsDocument = gql`
    query GetAdminPosts($take: Int, $orderBy: [PostOrderByWithRelationInput!], $where: PostWhereInput, $skip: Int) {
  posts(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminPostItem
    }
    count
  }
}
    ${AdminPostItemFragmentDoc}`;
export function useGetAdminPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminPostsQuery, GetAdminPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminPostsQuery, GetAdminPostsQueryVariables>(GetAdminPostsDocument, options);
      }
export function useGetAdminPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminPostsQuery, GetAdminPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminPostsQuery, GetAdminPostsQueryVariables>(GetAdminPostsDocument, options);
        }
export function useGetAdminPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminPostsQuery, GetAdminPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminPostsQuery, GetAdminPostsQueryVariables>(GetAdminPostsDocument, options);
        }
export type GetAdminPostsQueryHookResult = ReturnType<typeof useGetAdminPostsQuery>;
export type GetAdminPostsLazyQueryHookResult = ReturnType<typeof useGetAdminPostsLazyQuery>;
export type GetAdminPostsSuspenseQueryHookResult = ReturnType<typeof useGetAdminPostsSuspenseQuery>;
export type GetAdminPostsQueryResult = Apollo.QueryResult<GetAdminPostsQuery, GetAdminPostsQueryVariables>;
export const GetAdminProjectsDocument = gql`
    query GetAdminProjects($take: Int, $orderBy: [ProjectOrderByWithRelationInput!], $where: ProjectWhereInput, $skip: Int) {
  projects(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminProjectItem
    }
    count
  }
}
    ${AdminProjectItemFragmentDoc}`;
export function useGetAdminProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminProjectsQuery, GetAdminProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminProjectsQuery, GetAdminProjectsQueryVariables>(GetAdminProjectsDocument, options);
      }
export function useGetAdminProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminProjectsQuery, GetAdminProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminProjectsQuery, GetAdminProjectsQueryVariables>(GetAdminProjectsDocument, options);
        }
export function useGetAdminProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminProjectsQuery, GetAdminProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminProjectsQuery, GetAdminProjectsQueryVariables>(GetAdminProjectsDocument, options);
        }
export type GetAdminProjectsQueryHookResult = ReturnType<typeof useGetAdminProjectsQuery>;
export type GetAdminProjectsLazyQueryHookResult = ReturnType<typeof useGetAdminProjectsLazyQuery>;
export type GetAdminProjectsSuspenseQueryHookResult = ReturnType<typeof useGetAdminProjectsSuspenseQuery>;
export type GetAdminProjectsQueryResult = Apollo.QueryResult<GetAdminProjectsQuery, GetAdminProjectsQueryVariables>;
export const GetAdminRegionPageDocument = gql`
    query GetAdminRegionPage($slug: String!) {
  regionPage(slug: $slug) {
    ...AdminRegionPageDetail
  }
}
    ${AdminRegionPageDetailFragmentDoc}`;
export function useGetAdminRegionPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminRegionPageQuery, GetAdminRegionPageQueryVariables> & ({ variables: GetAdminRegionPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminRegionPageQuery, GetAdminRegionPageQueryVariables>(GetAdminRegionPageDocument, options);
      }
export function useGetAdminRegionPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegionPageQuery, GetAdminRegionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminRegionPageQuery, GetAdminRegionPageQueryVariables>(GetAdminRegionPageDocument, options);
        }
export function useGetAdminRegionPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminRegionPageQuery, GetAdminRegionPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminRegionPageQuery, GetAdminRegionPageQueryVariables>(GetAdminRegionPageDocument, options);
        }
export type GetAdminRegionPageQueryHookResult = ReturnType<typeof useGetAdminRegionPageQuery>;
export type GetAdminRegionPageLazyQueryHookResult = ReturnType<typeof useGetAdminRegionPageLazyQuery>;
export type GetAdminRegionPageSuspenseQueryHookResult = ReturnType<typeof useGetAdminRegionPageSuspenseQuery>;
export type GetAdminRegionPageQueryResult = Apollo.QueryResult<GetAdminRegionPageQuery, GetAdminRegionPageQueryVariables>;
export const CreateRegionPageDocument = gql`
    mutation CreateRegionPage($data: RegionPageCreateInput!) {
  createRegionPage(data: $data) {
    id
    slug
    name
    description
    image
    address
    phone
    email
    instagram
    facebook
    tiktok
    whatsapp
    youtube
    twitter
    linkedin
  }
}
    `;
export function useCreateRegionPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegionPageMutation, CreateRegionPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegionPageMutation, CreateRegionPageMutationVariables>(CreateRegionPageDocument, options);
      }
export type CreateRegionPageMutationHookResult = ReturnType<typeof useCreateRegionPageMutation>;
export type CreateRegionPageMutationResult = Apollo.MutationResult<CreateRegionPageMutation>;
export type CreateRegionPageMutationOptions = Apollo.BaseMutationOptions<CreateRegionPageMutation, CreateRegionPageMutationVariables>;
export const GetAdminRegionPagesDocument = gql`
    query GetAdminRegionPages($take: Int, $orderBy: [RegionPageOrderByWithRelationInput!], $where: RegionPageWhereInput, $skip: Int) {
  regionPages(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminRegionPageItem
    }
    count
  }
}
    ${AdminRegionPageItemFragmentDoc}`;
export function useGetAdminRegionPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminRegionPagesQuery, GetAdminRegionPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminRegionPagesQuery, GetAdminRegionPagesQueryVariables>(GetAdminRegionPagesDocument, options);
      }
export function useGetAdminRegionPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegionPagesQuery, GetAdminRegionPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminRegionPagesQuery, GetAdminRegionPagesQueryVariables>(GetAdminRegionPagesDocument, options);
        }
export function useGetAdminRegionPagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminRegionPagesQuery, GetAdminRegionPagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminRegionPagesQuery, GetAdminRegionPagesQueryVariables>(GetAdminRegionPagesDocument, options);
        }
export type GetAdminRegionPagesQueryHookResult = ReturnType<typeof useGetAdminRegionPagesQuery>;
export type GetAdminRegionPagesLazyQueryHookResult = ReturnType<typeof useGetAdminRegionPagesLazyQuery>;
export type GetAdminRegionPagesSuspenseQueryHookResult = ReturnType<typeof useGetAdminRegionPagesSuspenseQuery>;
export type GetAdminRegionPagesQueryResult = Apollo.QueryResult<GetAdminRegionPagesQuery, GetAdminRegionPagesQueryVariables>;
export const GetAdminEventDocument = gql`
    query GetAdminEvent($slug: String!) {
  event(slug: $slug) {
    ...AdminEventInfo
  }
}
    ${AdminEventInfoFragmentDoc}`;
export function useGetAdminEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminEventQuery, GetAdminEventQueryVariables> & ({ variables: GetAdminEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminEventQuery, GetAdminEventQueryVariables>(GetAdminEventDocument, options);
      }
export function useGetAdminEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminEventQuery, GetAdminEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminEventQuery, GetAdminEventQueryVariables>(GetAdminEventDocument, options);
        }
export function useGetAdminEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminEventQuery, GetAdminEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminEventQuery, GetAdminEventQueryVariables>(GetAdminEventDocument, options);
        }
export type GetAdminEventQueryHookResult = ReturnType<typeof useGetAdminEventQuery>;
export type GetAdminEventLazyQueryHookResult = ReturnType<typeof useGetAdminEventLazyQuery>;
export type GetAdminEventSuspenseQueryHookResult = ReturnType<typeof useGetAdminEventSuspenseQuery>;
export type GetAdminEventQueryResult = Apollo.QueryResult<GetAdminEventQuery, GetAdminEventQueryVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($data: EventCreateInput!) {
  createEvent(data: $data) {
    id
    slug
  }
}
    `;
export function useCreateEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const GetAdminEventsDocument = gql`
    query GetAdminEvents($take: Int, $orderBy: [EventOrderByWithRelationInput!], $where: EventWhereInput, $skip: Int) {
  events(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminEventItem
    }
    count
  }
}
    ${AdminEventItemFragmentDoc}`;
export function useGetAdminEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminEventsQuery, GetAdminEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminEventsQuery, GetAdminEventsQueryVariables>(GetAdminEventsDocument, options);
      }
export function useGetAdminEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminEventsQuery, GetAdminEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminEventsQuery, GetAdminEventsQueryVariables>(GetAdminEventsDocument, options);
        }
export function useGetAdminEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminEventsQuery, GetAdminEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminEventsQuery, GetAdminEventsQueryVariables>(GetAdminEventsDocument, options);
        }
export type GetAdminEventsQueryHookResult = ReturnType<typeof useGetAdminEventsQuery>;
export type GetAdminEventsLazyQueryHookResult = ReturnType<typeof useGetAdminEventsLazyQuery>;
export type GetAdminEventsSuspenseQueryHookResult = ReturnType<typeof useGetAdminEventsSuspenseQuery>;
export type GetAdminEventsQueryResult = Apollo.QueryResult<GetAdminEventsQuery, GetAdminEventsQueryVariables>;
export const GetAdminTutorialDocument = gql`
    query GetAdminTutorial($id: String!) {
  tutorial(id: $id) {
    ...AdminTutorialDetail
  }
}
    ${AdminTutorialDetailFragmentDoc}`;
export function useGetAdminTutorialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminTutorialQuery, GetAdminTutorialQueryVariables> & ({ variables: GetAdminTutorialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminTutorialQuery, GetAdminTutorialQueryVariables>(GetAdminTutorialDocument, options);
      }
export function useGetAdminTutorialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminTutorialQuery, GetAdminTutorialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminTutorialQuery, GetAdminTutorialQueryVariables>(GetAdminTutorialDocument, options);
        }
export function useGetAdminTutorialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminTutorialQuery, GetAdminTutorialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminTutorialQuery, GetAdminTutorialQueryVariables>(GetAdminTutorialDocument, options);
        }
export type GetAdminTutorialQueryHookResult = ReturnType<typeof useGetAdminTutorialQuery>;
export type GetAdminTutorialLazyQueryHookResult = ReturnType<typeof useGetAdminTutorialLazyQuery>;
export type GetAdminTutorialSuspenseQueryHookResult = ReturnType<typeof useGetAdminTutorialSuspenseQuery>;
export type GetAdminTutorialQueryResult = Apollo.QueryResult<GetAdminTutorialQuery, GetAdminTutorialQueryVariables>;
export const CreateTutorialAdminDocument = gql`
    mutation CreateTutorialAdmin($data: CreateTutorialInput!) {
  createTutorial(data: $data) {
    id
    title
  }
}
    `;
export function useCreateTutorialAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTutorialAdminMutation, CreateTutorialAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTutorialAdminMutation, CreateTutorialAdminMutationVariables>(CreateTutorialAdminDocument, options);
      }
export type CreateTutorialAdminMutationHookResult = ReturnType<typeof useCreateTutorialAdminMutation>;
export type CreateTutorialAdminMutationResult = Apollo.MutationResult<CreateTutorialAdminMutation>;
export type CreateTutorialAdminMutationOptions = Apollo.BaseMutationOptions<CreateTutorialAdminMutation, CreateTutorialAdminMutationVariables>;
export const GetAdminTutorialsDocument = gql`
    query GetAdminTutorials($take: Int, $orderBy: [TutorialOrderByWithRelationInput!], $where: TutorialWhereInput, $skip: Int) {
  tutorials(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminTutorialItem
    }
    count
  }
}
    ${AdminTutorialItemFragmentDoc}`;
export function useGetAdminTutorialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminTutorialsQuery, GetAdminTutorialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminTutorialsQuery, GetAdminTutorialsQueryVariables>(GetAdminTutorialsDocument, options);
      }
export function useGetAdminTutorialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminTutorialsQuery, GetAdminTutorialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminTutorialsQuery, GetAdminTutorialsQueryVariables>(GetAdminTutorialsDocument, options);
        }
export function useGetAdminTutorialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminTutorialsQuery, GetAdminTutorialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminTutorialsQuery, GetAdminTutorialsQueryVariables>(GetAdminTutorialsDocument, options);
        }
export type GetAdminTutorialsQueryHookResult = ReturnType<typeof useGetAdminTutorialsQuery>;
export type GetAdminTutorialsLazyQueryHookResult = ReturnType<typeof useGetAdminTutorialsLazyQuery>;
export type GetAdminTutorialsSuspenseQueryHookResult = ReturnType<typeof useGetAdminTutorialsSuspenseQuery>;
export type GetAdminTutorialsQueryResult = Apollo.QueryResult<GetAdminTutorialsQuery, GetAdminTutorialsQueryVariables>;
export const GetAdminCompetitionDocument = gql`
    query GetAdminCompetition($slug: String!) {
  competition(slug: $slug) {
    ...AdminCompetitionInfo
  }
}
    ${AdminCompetitionInfoFragmentDoc}`;
export function useGetAdminCompetitionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionQuery, GetAdminCompetitionQueryVariables> & ({ variables: GetAdminCompetitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionQuery, GetAdminCompetitionQueryVariables>(GetAdminCompetitionDocument, options);
      }
export function useGetAdminCompetitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionQuery, GetAdminCompetitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionQuery, GetAdminCompetitionQueryVariables>(GetAdminCompetitionDocument, options);
        }
export function useGetAdminCompetitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionQuery, GetAdminCompetitionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionQuery, GetAdminCompetitionQueryVariables>(GetAdminCompetitionDocument, options);
        }
export type GetAdminCompetitionQueryHookResult = ReturnType<typeof useGetAdminCompetitionQuery>;
export type GetAdminCompetitionLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionLazyQuery>;
export type GetAdminCompetitionSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionSuspenseQuery>;
export type GetAdminCompetitionQueryResult = Apollo.QueryResult<GetAdminCompetitionQuery, GetAdminCompetitionQueryVariables>;
export const CreateCompetitionDocument = gql`
    mutation CreateCompetition($data: CompetitionCreateInput!) {
  createCompetition(data: $data) {
    id
    slug
  }
}
    `;
export function useCreateCompetitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCompetitionMutation, CreateCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCompetitionMutation, CreateCompetitionMutationVariables>(CreateCompetitionDocument, options);
      }
export type CreateCompetitionMutationHookResult = ReturnType<typeof useCreateCompetitionMutation>;
export type CreateCompetitionMutationResult = Apollo.MutationResult<CreateCompetitionMutation>;
export type CreateCompetitionMutationOptions = Apollo.BaseMutationOptions<CreateCompetitionMutation, CreateCompetitionMutationVariables>;
export const GetAdminCompetitionsDocument = gql`
    query GetAdminCompetitions($take: Int, $orderBy: [CompetitionOrderByWithRelationInput!], $where: CompetitionWhereInput, $skip: Int) {
  competitions(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...AdminCompetitionItem
    }
    count
  }
}
    ${AdminCompetitionItemFragmentDoc}`;
export function useGetAdminCompetitionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminCompetitionsQuery, GetAdminCompetitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdminCompetitionsQuery, GetAdminCompetitionsQueryVariables>(GetAdminCompetitionsDocument, options);
      }
export function useGetAdminCompetitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminCompetitionsQuery, GetAdminCompetitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdminCompetitionsQuery, GetAdminCompetitionsQueryVariables>(GetAdminCompetitionsDocument, options);
        }
export function useGetAdminCompetitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdminCompetitionsQuery, GetAdminCompetitionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdminCompetitionsQuery, GetAdminCompetitionsQueryVariables>(GetAdminCompetitionsDocument, options);
        }
export type GetAdminCompetitionsQueryHookResult = ReturnType<typeof useGetAdminCompetitionsQuery>;
export type GetAdminCompetitionsLazyQueryHookResult = ReturnType<typeof useGetAdminCompetitionsLazyQuery>;
export type GetAdminCompetitionsSuspenseQueryHookResult = ReturnType<typeof useGetAdminCompetitionsSuspenseQuery>;
export type GetAdminCompetitionsQueryResult = Apollo.QueryResult<GetAdminCompetitionsQuery, GetAdminCompetitionsQueryVariables>;
export const RefreshTokenDocument = gql`
    query RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    token
    refreshToken
  }
}
    `;
export function useRefreshTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RefreshTokenQuery, RefreshTokenQueryVariables> & ({ variables: RefreshTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RefreshTokenQuery, RefreshTokenQueryVariables>(RefreshTokenDocument, options);
      }
export function useRefreshTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RefreshTokenQuery, RefreshTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RefreshTokenQuery, RefreshTokenQueryVariables>(RefreshTokenDocument, options);
        }
export function useRefreshTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RefreshTokenQuery, RefreshTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RefreshTokenQuery, RefreshTokenQueryVariables>(RefreshTokenDocument, options);
        }
export type RefreshTokenQueryHookResult = ReturnType<typeof useRefreshTokenQuery>;
export type RefreshTokenLazyQueryHookResult = ReturnType<typeof useRefreshTokenLazyQuery>;
export type RefreshTokenSuspenseQueryHookResult = ReturnType<typeof useRefreshTokenSuspenseQuery>;
export type RefreshTokenQueryResult = Apollo.QueryResult<RefreshTokenQuery, RefreshTokenQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export function useForgotPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetPostDocument = gql`
    query GetPost($id: String!) {
  post(id: $id) {
    ...PostDetail
  }
}
    ${PostDetailFragmentDoc}`;
export function useGetPostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostQuery, GetPostQueryVariables> & ({ variables: GetPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
      }
export function useGetPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
        }
export function useGetPostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
        }
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostSuspenseQueryHookResult = ReturnType<typeof useGetPostSuspenseQuery>;
export type GetPostQueryResult = Apollo.QueryResult<GetPostQuery, GetPostQueryVariables>;
export const CreateUserPostDocument = gql`
    mutation CreateUserPost($postId: String!, $userId: String!) {
  createUserPost(postId: $postId, userId: $userId)
}
    `;
export function useCreateUserPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserPostMutation, CreateUserPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserPostMutation, CreateUserPostMutationVariables>(CreateUserPostDocument, options);
      }
export type CreateUserPostMutationHookResult = ReturnType<typeof useCreateUserPostMutation>;
export type CreateUserPostMutationResult = Apollo.MutationResult<CreateUserPostMutation>;
export type CreateUserPostMutationOptions = Apollo.BaseMutationOptions<CreateUserPostMutation, CreateUserPostMutationVariables>;
export const DestroyCommentDocument = gql`
    mutation DestroyComment($id: String!) {
  destroyComment(id: $id) {
    id
  }
}
    `;
export function useDestroyCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyCommentMutation, DestroyCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyCommentMutation, DestroyCommentMutationVariables>(DestroyCommentDocument, options);
      }
export type DestroyCommentMutationHookResult = ReturnType<typeof useDestroyCommentMutation>;
export type DestroyCommentMutationResult = Apollo.MutationResult<DestroyCommentMutation>;
export type DestroyCommentMutationOptions = Apollo.BaseMutationOptions<DestroyCommentMutation, DestroyCommentMutationVariables>;
export const GetPostsDocument = gql`
    query GetPosts($take: Int, $orderBy: [PostOrderByWithRelationInput!], $where: PostWhereInput, $skip: Int) {
  posts(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...PostItem
    }
    count
  }
}
    ${PostItemFragmentDoc}`;
export function useGetPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
      }
export function useGetPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
        }
export function useGetPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
        }
export type GetPostsQueryHookResult = ReturnType<typeof useGetPostsQuery>;
export type GetPostsLazyQueryHookResult = ReturnType<typeof useGetPostsLazyQuery>;
export type GetPostsSuspenseQueryHookResult = ReturnType<typeof useGetPostsSuspenseQuery>;
export type GetPostsQueryResult = Apollo.QueryResult<GetPostsQuery, GetPostsQueryVariables>;
export const GetProjectsDocument = gql`
    query GetProjects($take: Int, $where: ProjectWhereInput, $skip: Int) {
  projects(take: $take, where: $where, skip: $skip) {
    items {
      ...ProjectItem
    }
    count
  }
}
    ${ProjectItemFragmentDoc}`;
export function useGetProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export function useGetProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsSuspenseQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetRegionPageDocument = gql`
    query GetRegionPage($slug: String!) {
  regionPage(slug: $slug) {
    ...RegionPageDetail
  }
}
    ${RegionPageDetailFragmentDoc}`;
export function useGetRegionPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRegionPageQuery, GetRegionPageQueryVariables> & ({ variables: GetRegionPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRegionPageQuery, GetRegionPageQueryVariables>(GetRegionPageDocument, options);
      }
export function useGetRegionPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegionPageQuery, GetRegionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRegionPageQuery, GetRegionPageQueryVariables>(GetRegionPageDocument, options);
        }
export function useGetRegionPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRegionPageQuery, GetRegionPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRegionPageQuery, GetRegionPageQueryVariables>(GetRegionPageDocument, options);
        }
export type GetRegionPageQueryHookResult = ReturnType<typeof useGetRegionPageQuery>;
export type GetRegionPageLazyQueryHookResult = ReturnType<typeof useGetRegionPageLazyQuery>;
export type GetRegionPageSuspenseQueryHookResult = ReturnType<typeof useGetRegionPageSuspenseQuery>;
export type GetRegionPageQueryResult = Apollo.QueryResult<GetRegionPageQuery, GetRegionPageQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($data: ResetPasswordInput!) {
  resetPassword(data: $data)
}
    `;
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const GetEventDocument = gql`
    query GetEvent($slug: String!, $take: Int, $orderBy: [UserEventOrderByWithRelationInput!], $where: UserEventWhereInput, $skip: Int) {
  event(slug: $slug) {
    ...EventDetail
  }
}
    ${EventDetailFragmentDoc}`;
export function useGetEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEventQuery, GetEventQueryVariables> & ({ variables: GetEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export function useGetEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventSuspenseQueryHookResult = ReturnType<typeof useGetEventSuspenseQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventForReviewDocument = gql`
    query GetEventForReview($slug: String!) {
  eventForReview(slug: $slug) {
    id
    name
  }
}
    `;
export function useGetEventForReviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEventForReviewQuery, GetEventForReviewQueryVariables> & ({ variables: GetEventForReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEventForReviewQuery, GetEventForReviewQueryVariables>(GetEventForReviewDocument, options);
      }
export function useGetEventForReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventForReviewQuery, GetEventForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEventForReviewQuery, GetEventForReviewQueryVariables>(GetEventForReviewDocument, options);
        }
export function useGetEventForReviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEventForReviewQuery, GetEventForReviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEventForReviewQuery, GetEventForReviewQueryVariables>(GetEventForReviewDocument, options);
        }
export type GetEventForReviewQueryHookResult = ReturnType<typeof useGetEventForReviewQuery>;
export type GetEventForReviewLazyQueryHookResult = ReturnType<typeof useGetEventForReviewLazyQuery>;
export type GetEventForReviewSuspenseQueryHookResult = ReturnType<typeof useGetEventForReviewSuspenseQuery>;
export type GetEventForReviewQueryResult = Apollo.QueryResult<GetEventForReviewQuery, GetEventForReviewQueryVariables>;
export const GetEventsDocument = gql`
    query GetEvents($take: Int, $orderBy: [EventOrderByWithRelationInput!], $where: EventWhereInput, $skip: Int) {
  events(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...EventItem
    }
    count
  }
}
    ${EventItemFragmentDoc}`;
export function useGetEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
      }
export function useGetEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export function useGetEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsSuspenseQueryHookResult = ReturnType<typeof useGetEventsSuspenseQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetTutorialDocument = gql`
    query GetTutorial($id: String!, $take: Int, $orderBy: [CommentOrderByWithRelationInput!], $where: CommentWhereInput, $skip: Int) {
  tutorial(id: $id) {
    ...TutorialDetail
  }
}
    ${TutorialDetailFragmentDoc}`;
export function useGetTutorialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTutorialQuery, GetTutorialQueryVariables> & ({ variables: GetTutorialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTutorialQuery, GetTutorialQueryVariables>(GetTutorialDocument, options);
      }
export function useGetTutorialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTutorialQuery, GetTutorialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTutorialQuery, GetTutorialQueryVariables>(GetTutorialDocument, options);
        }
export function useGetTutorialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTutorialQuery, GetTutorialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTutorialQuery, GetTutorialQueryVariables>(GetTutorialDocument, options);
        }
export type GetTutorialQueryHookResult = ReturnType<typeof useGetTutorialQuery>;
export type GetTutorialLazyQueryHookResult = ReturnType<typeof useGetTutorialLazyQuery>;
export type GetTutorialSuspenseQueryHookResult = ReturnType<typeof useGetTutorialSuspenseQuery>;
export type GetTutorialQueryResult = Apollo.QueryResult<GetTutorialQuery, GetTutorialQueryVariables>;
export const DestroyUserTutorialDocument = gql`
    mutation DestroyUserTutorial($tutorialId: String!) {
  destroyUserTutorial(tutorialId: $tutorialId)
}
    `;
export function useDestroyUserTutorialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DestroyUserTutorialMutation, DestroyUserTutorialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DestroyUserTutorialMutation, DestroyUserTutorialMutationVariables>(DestroyUserTutorialDocument, options);
      }
export type DestroyUserTutorialMutationHookResult = ReturnType<typeof useDestroyUserTutorialMutation>;
export type DestroyUserTutorialMutationResult = Apollo.MutationResult<DestroyUserTutorialMutation>;
export type DestroyUserTutorialMutationOptions = Apollo.BaseMutationOptions<DestroyUserTutorialMutation, DestroyUserTutorialMutationVariables>;
export const CreateUserTutorialDocument = gql`
    mutation CreateUserTutorial($tutorialId: String!) {
  createUserTutorial(tutorialId: $tutorialId)
}
    `;
export function useCreateUserTutorialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserTutorialMutation, CreateUserTutorialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserTutorialMutation, CreateUserTutorialMutationVariables>(CreateUserTutorialDocument, options);
      }
export type CreateUserTutorialMutationHookResult = ReturnType<typeof useCreateUserTutorialMutation>;
export type CreateUserTutorialMutationResult = Apollo.MutationResult<CreateUserTutorialMutation>;
export type CreateUserTutorialMutationOptions = Apollo.BaseMutationOptions<CreateUserTutorialMutation, CreateUserTutorialMutationVariables>;
export const GetTutorialsDocument = gql`
    query GetTutorials($take: Int, $orderBy: [TutorialOrderByWithRelationInput!], $where: TutorialWhereInput, $skip: Int) {
  tutorials(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...TutorialItem
    }
    count
  }
}
    ${TutorialItemFragmentDoc}`;
export function useGetTutorialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTutorialsQuery, GetTutorialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTutorialsQuery, GetTutorialsQueryVariables>(GetTutorialsDocument, options);
      }
export function useGetTutorialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTutorialsQuery, GetTutorialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTutorialsQuery, GetTutorialsQueryVariables>(GetTutorialsDocument, options);
        }
export function useGetTutorialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTutorialsQuery, GetTutorialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTutorialsQuery, GetTutorialsQueryVariables>(GetTutorialsDocument, options);
        }
export type GetTutorialsQueryHookResult = ReturnType<typeof useGetTutorialsQuery>;
export type GetTutorialsLazyQueryHookResult = ReturnType<typeof useGetTutorialsLazyQuery>;
export type GetTutorialsSuspenseQueryHookResult = ReturnType<typeof useGetTutorialsSuspenseQuery>;
export type GetTutorialsQueryResult = Apollo.QueryResult<GetTutorialsQuery, GetTutorialsQueryVariables>;
export const GetProfileEditDetailsDocument = gql`
    query GetProfileEditDetails {
  me {
    ...ProfileEditDetails
  }
}
    ${ProfileEditDetailsFragmentDoc}`;
export function useGetProfileEditDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileEditDetailsQuery, GetProfileEditDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileEditDetailsQuery, GetProfileEditDetailsQueryVariables>(GetProfileEditDetailsDocument, options);
      }
export function useGetProfileEditDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileEditDetailsQuery, GetProfileEditDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileEditDetailsQuery, GetProfileEditDetailsQueryVariables>(GetProfileEditDetailsDocument, options);
        }
export function useGetProfileEditDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileEditDetailsQuery, GetProfileEditDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileEditDetailsQuery, GetProfileEditDetailsQueryVariables>(GetProfileEditDetailsDocument, options);
        }
export type GetProfileEditDetailsQueryHookResult = ReturnType<typeof useGetProfileEditDetailsQuery>;
export type GetProfileEditDetailsLazyQueryHookResult = ReturnType<typeof useGetProfileEditDetailsLazyQuery>;
export type GetProfileEditDetailsSuspenseQueryHookResult = ReturnType<typeof useGetProfileEditDetailsSuspenseQuery>;
export type GetProfileEditDetailsQueryResult = Apollo.QueryResult<GetProfileEditDetailsQuery, GetProfileEditDetailsQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: String!) {
  user(id: $id) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export function useGetUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetProfileStatsDocument = gql`
    query GetProfileStats($userId: String!) {
  profileStats(userId: $userId) {
    events
    competitions
    tutorials
    posts
    projects
  }
}
    `;
export function useGetProfileStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables> & ({ variables: GetProfileStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileStatsQuery, GetProfileStatsQueryVariables>(GetProfileStatsDocument, options);
      }
export function useGetProfileStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileStatsQuery, GetProfileStatsQueryVariables>(GetProfileStatsDocument, options);
        }
export function useGetProfileStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileStatsQuery, GetProfileStatsQueryVariables>(GetProfileStatsDocument, options);
        }
export type GetProfileStatsQueryHookResult = ReturnType<typeof useGetProfileStatsQuery>;
export type GetProfileStatsLazyQueryHookResult = ReturnType<typeof useGetProfileStatsLazyQuery>;
export type GetProfileStatsSuspenseQueryHookResult = ReturnType<typeof useGetProfileStatsSuspenseQuery>;
export type GetProfileStatsQueryResult = Apollo.QueryResult<GetProfileStatsQuery, GetProfileStatsQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($id: String!, $take: Int, $orderBy: [CommentOrderByWithRelationInput!], $where: CommentWhereInput, $skip: Int) {
  project(id: $id) {
    ...ProjectDetail
  }
}
    ${ProjectDetailFragmentDoc}`;
export function useGetProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export function useGetProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetEditProjectDocument = gql`
    query GetEditProject($id: String!) {
  project(id: $id) {
    ...EditProject
  }
}
    ${EditProjectFragmentDoc}`;
export function useGetEditProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEditProjectQuery, GetEditProjectQueryVariables> & ({ variables: GetEditProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEditProjectQuery, GetEditProjectQueryVariables>(GetEditProjectDocument, options);
      }
export function useGetEditProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEditProjectQuery, GetEditProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEditProjectQuery, GetEditProjectQueryVariables>(GetEditProjectDocument, options);
        }
export function useGetEditProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEditProjectQuery, GetEditProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEditProjectQuery, GetEditProjectQueryVariables>(GetEditProjectDocument, options);
        }
export type GetEditProjectQueryHookResult = ReturnType<typeof useGetEditProjectQuery>;
export type GetEditProjectLazyQueryHookResult = ReturnType<typeof useGetEditProjectLazyQuery>;
export type GetEditProjectSuspenseQueryHookResult = ReturnType<typeof useGetEditProjectSuspenseQuery>;
export type GetEditProjectQueryResult = Apollo.QueryResult<GetEditProjectQuery, GetEditProjectQueryVariables>;
export const GetPublicUsersDocument = gql`
    query GetPublicUsers($take: Int, $orderBy: [UserOrderByWithRelationInput!], $where: UserWhereInput, $skip: Int) {
  publicUsers(take: $take, orderBy: $orderBy, where: $where, skip: $skip) {
    items {
      ...UserItem
    }
    count
  }
}
    ${UserItemFragmentDoc}`;
export function useGetPublicUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPublicUsersQuery, GetPublicUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPublicUsersQuery, GetPublicUsersQueryVariables>(GetPublicUsersDocument, options);
      }
export function useGetPublicUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPublicUsersQuery, GetPublicUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPublicUsersQuery, GetPublicUsersQueryVariables>(GetPublicUsersDocument, options);
        }
export function useGetPublicUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPublicUsersQuery, GetPublicUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPublicUsersQuery, GetPublicUsersQueryVariables>(GetPublicUsersDocument, options);
        }
export type GetPublicUsersQueryHookResult = ReturnType<typeof useGetPublicUsersQuery>;
export type GetPublicUsersLazyQueryHookResult = ReturnType<typeof useGetPublicUsersLazyQuery>;
export type GetPublicUsersSuspenseQueryHookResult = ReturnType<typeof useGetPublicUsersSuspenseQuery>;
export type GetPublicUsersQueryResult = Apollo.QueryResult<GetPublicUsersQuery, GetPublicUsersQueryVariables>;
export const GetApplyCompetitionDocument = gql`
    query GetApplyCompetition($slug: String!) {
  competition(slug: $slug) {
    ...ApplyCompetition
  }
}
    ${ApplyCompetitionFragmentDoc}`;
export function useGetApplyCompetitionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApplyCompetitionQuery, GetApplyCompetitionQueryVariables> & ({ variables: GetApplyCompetitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApplyCompetitionQuery, GetApplyCompetitionQueryVariables>(GetApplyCompetitionDocument, options);
      }
export function useGetApplyCompetitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApplyCompetitionQuery, GetApplyCompetitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApplyCompetitionQuery, GetApplyCompetitionQueryVariables>(GetApplyCompetitionDocument, options);
        }
export function useGetApplyCompetitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetApplyCompetitionQuery, GetApplyCompetitionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetApplyCompetitionQuery, GetApplyCompetitionQueryVariables>(GetApplyCompetitionDocument, options);
        }
export type GetApplyCompetitionQueryHookResult = ReturnType<typeof useGetApplyCompetitionQuery>;
export type GetApplyCompetitionLazyQueryHookResult = ReturnType<typeof useGetApplyCompetitionLazyQuery>;
export type GetApplyCompetitionSuspenseQueryHookResult = ReturnType<typeof useGetApplyCompetitionSuspenseQuery>;
export type GetApplyCompetitionQueryResult = Apollo.QueryResult<GetApplyCompetitionQuery, GetApplyCompetitionQueryVariables>;
export const GetApplyMyActsDocument = gql`
    query GetApplyMyActs($where: ActWhereInput) {
  me {
    id
    createdActs(where: $where) {
      id
      name
      category
      competition {
        id
        year
      }
    }
  }
}
    `;
export function useGetApplyMyActsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetApplyMyActsQuery, GetApplyMyActsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApplyMyActsQuery, GetApplyMyActsQueryVariables>(GetApplyMyActsDocument, options);
      }
export function useGetApplyMyActsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApplyMyActsQuery, GetApplyMyActsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApplyMyActsQuery, GetApplyMyActsQueryVariables>(GetApplyMyActsDocument, options);
        }
export function useGetApplyMyActsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetApplyMyActsQuery, GetApplyMyActsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetApplyMyActsQuery, GetApplyMyActsQueryVariables>(GetApplyMyActsDocument, options);
        }
export type GetApplyMyActsQueryHookResult = ReturnType<typeof useGetApplyMyActsQuery>;
export type GetApplyMyActsLazyQueryHookResult = ReturnType<typeof useGetApplyMyActsLazyQuery>;
export type GetApplyMyActsSuspenseQueryHookResult = ReturnType<typeof useGetApplyMyActsSuspenseQuery>;
export type GetApplyMyActsQueryResult = Apollo.QueryResult<GetApplyMyActsQuery, GetApplyMyActsQueryVariables>;
export const GetActDocument = gql`
    query GetAct($id: String!) {
  act(id: $id) {
    ...ApplyAct
  }
}
    ${ApplyActFragmentDoc}`;
export function useGetActQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActQuery, GetActQueryVariables> & ({ variables: GetActQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActQuery, GetActQueryVariables>(GetActDocument, options);
      }
export function useGetActLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActQuery, GetActQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActQuery, GetActQueryVariables>(GetActDocument, options);
        }
export function useGetActSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActQuery, GetActQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActQuery, GetActQueryVariables>(GetActDocument, options);
        }
export type GetActQueryHookResult = ReturnType<typeof useGetActQuery>;
export type GetActLazyQueryHookResult = ReturnType<typeof useGetActLazyQuery>;
export type GetActSuspenseQueryHookResult = ReturnType<typeof useGetActSuspenseQuery>;
export type GetActQueryResult = Apollo.QueryResult<GetActQuery, GetActQueryVariables>;
export const CopyActDocument = gql`
    mutation CopyAct($id: String!, $competitionId: String!) {
  copyAct(id: $id, competitionId: $competitionId) {
    id
  }
}
    `;
export function useCopyActMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyActMutation, CopyActMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyActMutation, CopyActMutationVariables>(CopyActDocument, options);
      }
export type CopyActMutationHookResult = ReturnType<typeof useCopyActMutation>;
export type CopyActMutationResult = Apollo.MutationResult<CopyActMutation>;
export type CopyActMutationOptions = Apollo.BaseMutationOptions<CopyActMutation, CopyActMutationVariables>;
export const GetCompetitionDocument = gql`
    query GetCompetition($slug: String!, $take: Int, $orderBy: [ActOrderByWithRelationInput!], $where: ActWhereInput, $skip: Int) {
  competition(slug: $slug) {
    ...CompetitionDetail
  }
}
    ${CompetitionDetailFragmentDoc}`;
export function useGetCompetitionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCompetitionQuery, GetCompetitionQueryVariables> & ({ variables: GetCompetitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompetitionQuery, GetCompetitionQueryVariables>(GetCompetitionDocument, options);
      }
export function useGetCompetitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompetitionQuery, GetCompetitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompetitionQuery, GetCompetitionQueryVariables>(GetCompetitionDocument, options);
        }
export function useGetCompetitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompetitionQuery, GetCompetitionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompetitionQuery, GetCompetitionQueryVariables>(GetCompetitionDocument, options);
        }
export type GetCompetitionQueryHookResult = ReturnType<typeof useGetCompetitionQuery>;
export type GetCompetitionLazyQueryHookResult = ReturnType<typeof useGetCompetitionLazyQuery>;
export type GetCompetitionSuspenseQueryHookResult = ReturnType<typeof useGetCompetitionSuspenseQuery>;
export type GetCompetitionQueryResult = Apollo.QueryResult<GetCompetitionQuery, GetCompetitionQueryVariables>;
export const GetCompetitionsDocument = gql`
    query GetCompetitions($where: CompetitionWhereInput) {
  competitions(where: $where) {
    items {
      ...CompetitionItem
    }
    count
  }
}
    ${CompetitionItemFragmentDoc}`;
export function useGetCompetitionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompetitionsQuery, GetCompetitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompetitionsQuery, GetCompetitionsQueryVariables>(GetCompetitionsDocument, options);
      }
export function useGetCompetitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompetitionsQuery, GetCompetitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompetitionsQuery, GetCompetitionsQueryVariables>(GetCompetitionsDocument, options);
        }
export function useGetCompetitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompetitionsQuery, GetCompetitionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompetitionsQuery, GetCompetitionsQueryVariables>(GetCompetitionsDocument, options);
        }
export type GetCompetitionsQueryHookResult = ReturnType<typeof useGetCompetitionsQuery>;
export type GetCompetitionsLazyQueryHookResult = ReturnType<typeof useGetCompetitionsLazyQuery>;
export type GetCompetitionsSuspenseQueryHookResult = ReturnType<typeof useGetCompetitionsSuspenseQuery>;
export type GetCompetitionsQueryResult = Apollo.QueryResult<GetCompetitionsQuery, GetCompetitionsQueryVariables>;